/* eslint-disable */
import type {DocumentNode} from 'graphql';
import type * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@jimmyn/apollo-client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends {[key: string]: unknown}> = {[K in keyof T]: T[K]};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]?: Maybe<T[SubKey]>};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]: Maybe<T[SubKey]>};
export type MakeEmpty<T extends {[key: string]: unknown}, K extends keyof T> = {[_ in K]?: never};
export type Incremental<T> =
  | T
  | {[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: {input: string; output: string};
  String: {input: string; output: string};
  Boolean: {input: boolean; output: boolean};
  Int: {input: number; output: number};
  Float: {input: number; output: number};
  /** The `AWSEmail` scalar type provided by AWS AppSync, represents an Email address string that complies with [RFC 822](https://www.ietf.org/rfc/rfc822.txt). For example, "**username@example.com**" is a valid Email address. */
  AWSEmail: {input: string; output: string};
  /** The `AWSIPAddress` scalar type provided by AWS AppSync, represents a valid [IPv4](https://en.wikipedia.org/wiki/IPv4#Addressing) or [IPv6](https://en.wikipedia.org/wiki/IPv6_address) address string.  IP addresses with subnet masks are considered valid. However, subnet masks are not necessary. For example, "**127.0.0.1**" and "**127.0.0.1/8**" are both considered valid IP Addresses. */
  AWSIPAddress: {input: string; output: string};
  /** The `AWSPhone` scalar type provided by AWS AppSync, represents a valid Phone Number. Phone numbers are serialized and deserialized as Strings. Segments of the phone number may be whitespace delimited or hyphenated.  The number can specify a country code at the beginning. However, United States numbers without country codes are still considered to be valid. */
  AWSPhone: {input: string; output: string};
  /** The `AWSTimestamp` scalar type provided by AWS AppSync, represents the number of seconds that have elapsed since `1970-01-01T00:00Z`. Negative values are also accepted and these represent the number of seconds till `1970-01-01T00:00Z`.  Timestamps are serialized and deserialized as integers. The minimum supported timestamp value is **`-31557014167219200`** which corresponds to `-1000000000-01-01T00:00Z`. The maximum supported timestamp value is **`31556889864403199`** which corresponds to `1000000000-12-31T23:59:59.999999999Z`. */
  AWSTimestamp: {input: number; output: number};
  /** Long type */
  Long: {input: any; output: any};
};

export type Account = {
  __typename?: 'Account';
  accountExecutive?: Maybe<SalesExecutive>;
  accountInvoicePaymentMethod?: Maybe<AccountInvoicePaymentMethod>;
  acquirer?: Maybe<Acquirer>;
  activatedAt?: Maybe<Scalars['String']['output']>;
  adminEmail?: Maybe<Scalars['String']['output']>;
  allowCreateApiKey?: Maybe<Scalars['Boolean']['output']>;
  allowRefunds?: Maybe<Scalars['Boolean']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  approvalRequestedAt?: Maybe<Scalars['String']['output']>;
  approvedAt?: Maybe<Scalars['String']['output']>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingPlan?: Maybe<BillingPlans>;
  billingVatPercent?: Maybe<Scalars['Int']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  branding?: Maybe<AccountBranding>;
  business?: Maybe<BusinessData>;
  churnNote?: Maybe<Scalars['String']['output']>;
  churnReason?: Maybe<ChurnReason>;
  churnReasonOption?: Maybe<Scalars['String']['output']>;
  churned?: Maybe<Scalars['Boolean']['output']>;
  contactPerson?: Maybe<ContactPerson>;
  contract?: Maybe<AccountContract>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customAccountInvoiceNotes?: Maybe<Array<Scalars['String']['output']>>;
  customDomain?: Maybe<Scalars['String']['output']>;
  dataUpdatedAt?: Maybe<Scalars['String']['output']>;
  defaultCurrency?: Maybe<Currencies>;
  defaultTransactionType?: Maybe<TransactionTypes>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  dynamicBilling?: Maybe<Scalars['Boolean']['output']>;
  fees?: Maybe<AccountFees>;
  fraudDetectorEnabled?: Maybe<Scalars['Boolean']['output']>;
  fraudDetectorThreshold?: Maybe<Scalars['Int']['output']>;
  fraudRulesEnabled?: Maybe<Scalars['Boolean']['output']>;
  groupInvoicesByStore?: Maybe<Scalars['Boolean']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  manualApproval?: Maybe<Scalars['Boolean']['output']>;
  masterAccountId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<AccountNotifications>;
  partner?: Maybe<Partner>;
  paymentMethods?: Maybe<AccountPaymentMethods>;
  payoutTerms?: Maybe<AccountPayoutTerms>;
  previewFeatures?: Maybe<Array<Scalars['String']['output']>>;
  prodAccountId?: Maybe<Scalars['ID']['output']>;
  progressiveBilling?: Maybe<Scalars['Boolean']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  publicBusinessDetails?: Maybe<AccountPublicBusinessDetails>;
  reason?: Maybe<Scalars['String']['output']>;
  refAccountId?: Maybe<Scalars['ID']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['String']['output']>;
  representatives?: Maybe<Array<RepresentativeData>>;
  reviewConfirmed?: Maybe<Scalars['Boolean']['output']>;
  riskIgnoredKeywords?: Maybe<Array<Scalars['String']['output']>>;
  riskLabels?: Maybe<Array<RiskLabel>>;
  riskProcessing?: Maybe<Scalars['Boolean']['output']>;
  riskProfile?: Maybe<RiskProfile>;
  riskProfileNote?: Maybe<Scalars['String']['output']>;
  riskScore?: Maybe<Scalars['Int']['output']>;
  riskUpdatedAt?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<Scalars['String']['output']>;
  sepblacId?: Maybe<Scalars['String']['output']>;
  status: AccountStatus;
  statusNote?: Maybe<Scalars['String']['output']>;
  statusReason?: Maybe<StatusReason>;
  suspendedAt?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  test?: Maybe<Scalars['Boolean']['output']>;
  testAccountId?: Maybe<Scalars['ID']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  tokenizationMethods?: Maybe<AccountTokenizationMethods>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  upsell?: Maybe<Upsell>;
  userNote?: Maybe<Scalars['String']['output']>;
};

export type AccountActualFees = {
  __typename?: 'AccountActualFees';
  cardPresentTrxFee: Scalars['Float']['output'];
  cardPresentTrxFlatFee: Scalars['Int']['output'];
  dailyExtraSeatsFee: Scalars['Int']['output'];
  dailyPlatformFee: Scalars['Int']['output'];
  extra?: Maybe<Array<AccountExtraFee>>;
  fraudDetectorTrxFlatFee: Scalars['Int']['output'];
  highRiskFee: Scalars['Float']['output'];
  steps: Array<AccountSteps>;
  weeklyCustomDomainFee: Scalars['Int']['output'];
  weeklySftpConfigUnitFee: Scalars['Int']['output'];
};

export type AccountBalances = {
  __typename?: 'AccountBalances';
  accountId?: Maybe<Scalars['ID']['output']>;
  clearedAmount: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  outstandingAmount: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type AccountBalancesConnection = {
  __typename?: 'AccountBalancesConnection';
  items: Array<AccountBalances>;
};

export type AccountBranding = {
  __typename?: 'AccountBranding';
  accentColor?: Maybe<Scalars['String']['output']>;
  bgColor?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
};

export type AccountBrandingInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  bgColor?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AccountContract = {
  __typename?: 'AccountContract';
  envelopeId?: Maybe<Scalars['ID']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  signedDate?: Maybe<Scalars['String']['output']>;
  status: ContractStatus;
};

export type AccountDefaults = {
  __typename?: 'AccountDefaults';
  billingPlan?: Maybe<BillingPlans>;
  business?: Maybe<BusinessDefault>;
  fees?: Maybe<AccountFees>;
  iban?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<AccountNotifications>;
  payoutTerms?: Maybe<AccountPayoutTerms>;
};

export type AccountDefaultsInput = {
  billingPlan?: InputMaybe<BillingPlans>;
  business?: InputMaybe<BusinessDefaultInput>;
  fees?: InputMaybe<AccountFeesInput>;
  iban?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<AccountNotificationsInput>;
  payoutTerms?: InputMaybe<AccountPayoutTermsInput>;
};

export type AccountEvent = {
  __typename?: 'AccountEvent';
  accountId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  id: Scalars['ID']['output'];
  livemode?: Maybe<Scalars['Boolean']['output']>;
  masterAccountId?: Maybe<Scalars['ID']['output']>;
  object: AccountEventObject;
  objectId: Scalars['ID']['output'];
  objectType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AccountEventObject = {
  __typename?: 'AccountEventObject';
  accountExecutive?: Maybe<Scalars['String']['output']>;
  acquirer?: Maybe<Acquirer>;
  activatedAt?: Maybe<Scalars['String']['output']>;
  adminEmail?: Maybe<Scalars['String']['output']>;
  allowCreateApiKey?: Maybe<Scalars['Boolean']['output']>;
  allowRefunds?: Maybe<Scalars['Boolean']['output']>;
  approvalRequestedAt?: Maybe<Scalars['String']['output']>;
  approvedAt?: Maybe<Scalars['String']['output']>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingPlan?: Maybe<BillingPlans>;
  billingVatPercent?: Maybe<Scalars['Int']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  branding?: Maybe<AccountBranding>;
  business?: Maybe<BusinessData>;
  churnNote?: Maybe<Scalars['String']['output']>;
  churnReason?: Maybe<ChurnReason>;
  churnReasonOption?: Maybe<Scalars['String']['output']>;
  churned?: Maybe<Scalars['Boolean']['output']>;
  contract?: Maybe<AccountContract>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customDomain?: Maybe<Scalars['String']['output']>;
  dataUpdatedAt?: Maybe<Scalars['String']['output']>;
  defaultCurrency?: Maybe<Currencies>;
  defaultTransactionType?: Maybe<TransactionTypes>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  dynamicBilling?: Maybe<Scalars['Boolean']['output']>;
  fees?: Maybe<AccountFees>;
  fraudDetectorEnabled?: Maybe<Scalars['Boolean']['output']>;
  fraudDetectorThreshold?: Maybe<Scalars['Int']['output']>;
  fraudRulesEnabled?: Maybe<Scalars['Boolean']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  manualApproval?: Maybe<Scalars['Boolean']['output']>;
  masterAccountId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<AccountNotifications>;
  partner?: Maybe<Partner>;
  paymentMethods?: Maybe<AccountPaymentMethods>;
  payoutTerms?: Maybe<AccountPayoutTerms>;
  previewFeatures?: Maybe<Array<Scalars['String']['output']>>;
  prodAccountId?: Maybe<Scalars['ID']['output']>;
  progressiveBilling?: Maybe<Scalars['Boolean']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  publicBusinessDetails?: Maybe<AccountPublicBusinessDetails>;
  reason?: Maybe<Scalars['String']['output']>;
  refAccountId?: Maybe<Scalars['ID']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['String']['output']>;
  representatives?: Maybe<Array<RepresentativeData>>;
  reviewConfirmed?: Maybe<Scalars['Boolean']['output']>;
  riskIgnoredKeywords?: Maybe<Array<Scalars['String']['output']>>;
  riskLabels?: Maybe<Array<RiskLabel>>;
  riskProfile?: Maybe<RiskProfile>;
  riskProfileNote?: Maybe<Scalars['String']['output']>;
  riskScore?: Maybe<Scalars['Int']['output']>;
  riskUpdatedAt?: Maybe<Scalars['String']['output']>;
  sepblacId?: Maybe<Scalars['String']['output']>;
  status: AccountStatus;
  statusNote?: Maybe<Scalars['String']['output']>;
  statusReason?: Maybe<StatusReason>;
  suspendedAt?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  test?: Maybe<Scalars['Boolean']['output']>;
  testAccountId?: Maybe<Scalars['ID']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  tokenizationMethods?: Maybe<AccountTokenizationMethods>;
  traceDetails?: Maybe<TraceDetails>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  upsell?: Maybe<Upsell>;
  userNote?: Maybe<Scalars['String']['output']>;
};

export type AccountEventsConnection = {
  __typename?: 'AccountEventsConnection';
  items: Array<AccountEvent>;
  total: Scalars['Int']['output'];
};

export type AccountExtraFee = {
  __typename?: 'AccountExtraFee';
  amount: Scalars['Float']['output'];
  masterAccountFee?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  paymentMethods?: Maybe<Array<PaymentMethods>>;
  region?: Maybe<AccountExtraFeeRegion>;
  type: AccountExtraFeeType;
};

export type AccountExtraFeeInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  masterAccountFee?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<Array<InputMaybe<PaymentMethods>>>;
  region?: InputMaybe<AccountExtraFeeRegion>;
  type?: InputMaybe<AccountExtraFeeType>;
};

export enum AccountExtraFeeRegion {
  ALL = 'all',
  DOMESTIC = 'domestic',
  NON_DOMESTIC = 'non_domestic'
}

export enum AccountExtraFeeType {
  DAILY = 'daily',
  MONEY = 'money',
  MONTHLY = 'monthly',
  ONE_TIME = 'one_time',
  PERCENT = 'percent'
}

export type AccountFees = {
  __typename?: 'AccountFees';
  cardPresentTrxFee?: Maybe<Scalars['Float']['output']>;
  cardPresentTrxFlatFee?: Maybe<Scalars['Int']['output']>;
  dailyExtraSeatsFee?: Maybe<Scalars['Int']['output']>;
  dailyPlatformFee?: Maybe<Scalars['Int']['output']>;
  extra?: Maybe<Array<AccountExtraFee>>;
  fraudDetectorTrxFlatFee?: Maybe<Scalars['Int']['output']>;
  highRiskFee?: Maybe<Scalars['Float']['output']>;
  steps?: Maybe<Array<AccountSteps>>;
  trxFee?: Maybe<Scalars['Float']['output']>;
  trxFlatFee?: Maybe<Scalars['Int']['output']>;
  weeklyCustomDomainFee?: Maybe<Scalars['Int']['output']>;
  weeklySftpConfigUnitFee?: Maybe<Scalars['Int']['output']>;
};

export type AccountFeesInput = {
  cardPresentTrxFee?: InputMaybe<Scalars['Float']['input']>;
  cardPresentTrxFlatFee?: InputMaybe<Scalars['Int']['input']>;
  dailyExtraSeatsFee?: InputMaybe<Scalars['Int']['input']>;
  dailyPlatformFee?: InputMaybe<Scalars['Int']['input']>;
  extra?: InputMaybe<Array<AccountExtraFeeInput>>;
  fraudDetectorTrxFlatFee?: InputMaybe<Scalars['Int']['input']>;
  highRiskFee?: InputMaybe<Scalars['Float']['input']>;
  steps?: InputMaybe<Array<InputMaybe<AccountStepsInput>>>;
  trxFee?: InputMaybe<Scalars['Float']['input']>;
  trxFlatFee?: InputMaybe<Scalars['Int']['input']>;
  weeklyCustomDomainFee?: InputMaybe<Scalars['Int']['input']>;
  weeklySftpConfigUnitFee?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountInvoice = {
  __typename?: 'AccountInvoice';
  accountId: Scalars['ID']['output'];
  amount: Scalars['Int']['output'];
  business?: Maybe<InvoiceBusinessData>;
  createdAt: Scalars['AWSTimestamp']['output'];
  currency: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  lineItems: Array<AccountInvoiceLineItem>;
  number?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<AccountInvoicePaymentMethod>;
  period: AccountInvoicePeriod;
  status?: Maybe<AccountInvoiceStatus>;
  tax: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type AccountInvoiceInput = {
  accountId: Scalars['ID']['input'];
  from: Scalars['AWSTimestamp']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['AWSTimestamp']['input'];
};

export type AccountInvoiceLineItem = {
  __typename?: 'AccountInvoiceLineItem';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  unitAmount: Scalars['Float']['output'];
  unitType: InvoiceLineItemUnitType;
};

export enum AccountInvoicePaymentMethod {
  BANK_TRANSFER = 'bank_transfer',
  DIRECT_DEBIT = 'direct_debit'
}

export type AccountInvoicePeriod = {
  __typename?: 'AccountInvoicePeriod';
  from?: Maybe<Scalars['AWSTimestamp']['output']>;
  to?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export enum AccountInvoiceStatus {
  PAID = 'PAID',
  PAST_DUE = 'PAST_DUE',
  PENDING = 'PENDING',
  UNPAID = 'UNPAID'
}

export type AccountLevelUpdate = {
  __typename?: 'AccountLevelUpdate';
  accountId?: Maybe<Scalars['ID']['output']>;
};

export type AccountNotifications = {
  __typename?: 'AccountNotifications';
  adminEmails?: Maybe<Array<Scalars['String']['output']>>;
  emailAdminOnSubscription?: Maybe<Scalars['Boolean']['output']>;
  emailAdminOnSuccess?: Maybe<Scalars['Boolean']['output']>;
  emailCustomerOnRefund?: Maybe<Scalars['Boolean']['output']>;
  emailCustomerOnSubscription?: Maybe<Scalars['Boolean']['output']>;
  emailCustomerOnSuccess?: Maybe<Scalars['Boolean']['output']>;
  emailOnAccountInvoice?: Maybe<Scalars['Boolean']['output']>;
};

export type AccountNotificationsInput = {
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  emailAdminOnSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  emailAdminOnSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  emailCustomerOnRefund?: InputMaybe<Scalars['Boolean']['input']>;
  emailCustomerOnSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  emailCustomerOnSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  emailOnAccountInvoice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountPaymentMethods = {
  __typename?: 'AccountPaymentMethods';
  BIZUM?: Maybe<AccountPaymentMethodsBizum>;
  CREDITCARD?: Maybe<AccountPaymentMethodsCreditCard>;
};

export type AccountPaymentMethodsBizum = {
  __typename?: 'AccountPaymentMethodsBizum';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type AccountPaymentMethodsBizumInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountPaymentMethodsCreditCard = {
  __typename?: 'AccountPaymentMethodsCreditCard';
  allowPaymentDetails?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  preauthorization?: Maybe<Scalars['Boolean']['output']>;
};

export type AccountPaymentMethodsCreditCardInput = {
  allowPaymentDetails?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  preauthorization?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountPaymentMethodsInput = {
  BIZUM?: InputMaybe<AccountPaymentMethodsBizumInput>;
  CREDITCARD?: InputMaybe<AccountPaymentMethodsCreditCardInput>;
};

export type AccountPayoutTerms = {
  __typename?: 'AccountPayoutTerms';
  bankTransferConceptPrefix?: Maybe<Scalars['String']['output']>;
  firstPeriod?: Maybe<Scalars['Int']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  releaseReserve?: Maybe<Scalars['Boolean']['output']>;
  reservePercent?: Maybe<Scalars['Float']['output']>;
  settleGross?: Maybe<Scalars['Boolean']['output']>;
  settleIndividually?: Maybe<Scalars['Boolean']['output']>;
  settleToStores?: Maybe<Scalars['Boolean']['output']>;
  suspended?: Maybe<Scalars['Boolean']['output']>;
};

export type AccountPayoutTermsInput = {
  bankTransferConceptPrefix?: InputMaybe<Scalars['String']['input']>;
  firstPeriod?: InputMaybe<Scalars['Int']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
  releaseReserve?: InputMaybe<Scalars['Boolean']['input']>;
  reservePercent?: InputMaybe<Scalars['Float']['input']>;
  settleGross?: InputMaybe<Scalars['Boolean']['input']>;
  settleToStores?: InputMaybe<Scalars['Boolean']['input']>;
  suspended?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountPublicBusinessDetails = {
  __typename?: 'AccountPublicBusinessDetails';
  address?: Maybe<Address>;
  companyName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  supportPhone?: Maybe<Scalars['String']['output']>;
  supportWebsite?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type AccountPublicBusinessDetailsInput = {
  address?: InputMaybe<AddressInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  supportPhone?: InputMaybe<Scalars['String']['input']>;
  supportWebsite?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type AccountStats = {
  __typename?: 'AccountStats';
  accountId: Scalars['ID']['output'];
  stats?: Maybe<Stats>;
};

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  APPROVED = 'APPROVED',
  DELETED = 'DELETED',
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  PENDING_CONTRACT = 'PENDING_CONTRACT',
  PENDING_REVIEW = 'PENDING_REVIEW',
  REJECTED = 'REJECTED',
  SUSPENDED = 'SUSPENDED'
}

export type AccountSteps = {
  __typename?: 'AccountSteps';
  bizumTrxFee?: Maybe<Scalars['Float']['output']>;
  bizumTrxFlatFee?: Maybe<Scalars['Int']['output']>;
  from: Scalars['Float']['output'];
  multibancoTrxFee?: Maybe<Scalars['Float']['output']>;
  multibancoTrxFlatFee?: Maybe<Scalars['Int']['output']>;
  trxFee: Scalars['Float']['output'];
  trxFlatFee: Scalars['Int']['output'];
};

export type AccountStepsInput = {
  bizumTrxFee?: InputMaybe<Scalars['Float']['input']>;
  bizumTrxFlatFee?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Float']['input']>;
  multibancoTrxFee?: InputMaybe<Scalars['Float']['input']>;
  multibancoTrxFlatFee?: InputMaybe<Scalars['Int']['input']>;
  trxFee?: InputMaybe<Scalars['Float']['input']>;
  trxFlatFee?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountTokenizationMethods = {
  __typename?: 'AccountTokenizationMethods';
  applePay?: Maybe<AccountTokenizationMethodsItem>;
  clickToPay?: Maybe<AccountTokenizationMethodsClickToPayItem>;
  googlePay?: Maybe<AccountTokenizationMethodsItem>;
};

export type AccountTokenizationMethodsClickToPayItem = {
  __typename?: 'AccountTokenizationMethodsClickToPayItem';
  dpaId?: Maybe<Scalars['ID']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type AccountTokenizationMethodsItem = {
  __typename?: 'AccountTokenizationMethodsItem';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type AccountsConnection = {
  __typename?: 'AccountsConnection';
  items: Array<Account>;
  total: Scalars['Int']['output'];
};

export enum Acquirer {
  ABANCA = 'ABANCA',
  ADYEN = 'ADYEN',
  BANCAMARCH = 'BANCAMARCH',
  BANKIA = 'BANKIA',
  BANKINTER = 'BANKINTER',
  BBVA = 'BBVA',
  CAJALABORAL = 'CAJALABORAL',
  CAJAMAR = 'CAJAMAR',
  CAJARURAL = 'CAJARURAL',
  CAJASUR = 'CAJASUR',
  COFIDIS = 'COFIDIS',
  COMERCIAGLOBALPAY = 'COMERCIAGLOBALPAY',
  CREDITANDORRA = 'CREDITANDORRA',
  CUSTOM = 'CUSTOM',
  DEUTSCHE_BANK = 'DEUTSCHE_BANK',
  GETNET = 'GETNET',
  KUTXABANK = 'KUTXABANK',
  MONEI_X = 'MONEI_X',
  PAYCOMET = 'PAYCOMET',
  PAYPAL = 'PAYPAL',
  SABADELL = 'SABADELL',
  SANTANDER = 'SANTANDER',
  STRIPE = 'STRIPE',
  UNICAJA = 'UNICAJA'
}

export type ActivateSubscriptionInput = {
  accountId: Scalars['ID']['input'];
  addAmount?: InputMaybe<Scalars['Int']['input']>;
  allowedPaymentMethods?: InputMaybe<Array<InputMaybe<SubscriptionPaymentMethods>>>;
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  completeUrl?: InputMaybe<Scalars['String']['input']>;
  expireAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  failUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Array<KeyValueInput>>;
  paymentToken?: InputMaybe<Scalars['String']['input']>;
  sequenceId?: InputMaybe<Scalars['ID']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type AdminUserEvent = {
  __typename?: 'AdminUserEvent';
  accountId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Array<KeyValueItem>>;
  objectId?: Maybe<Scalars['ID']['output']>;
  objectType: Scalars['String']['output'];
  sessionDetails?: Maybe<SessionDetails>;
  type: Scalars['String']['output'];
};

export type AdminUserEventsConnection = {
  __typename?: 'AdminUserEventsConnection';
  items: Array<AdminUserEvent>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type AdminUserEventsInput = {
  nextToken?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type AdminUsersConnection = {
  __typename?: 'AdminUsersConnection';
  items: Array<AdminUser>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type Affiliate = {
  __typename?: 'Affiliate';
  address?: Maybe<AffiliateAddress>;
  affiliate_group_id?: Maybe<Scalars['String']['output']>;
  company?: Maybe<AffiliateCompany>;
  created_at?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  meta_data?: Maybe<AffiliateMetaData>;
  payout_methods?: Maybe<Array<AffiliatePayoutMethod>>;
  referral_link?: Maybe<AffiliateReferralLink>;
};

export type AffiliateAddress = {
  __typename?: 'AffiliateAddress';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<AffiliateCountry>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AffiliateCompany = {
  __typename?: 'AffiliateCompany';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AffiliateConnection = {
  __typename?: 'AffiliateConnection';
  items: Array<Affiliate>;
  links?: Maybe<Scalars['String']['output']>;
};

export type AffiliateCountry = {
  __typename?: 'AffiliateCountry';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AffiliateInput = {
  affiliateGroupId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliateInvoice = {
  __typename?: 'AffiliateInvoice';
  amount?: Maybe<Scalars['Float']['output']>;
  dueAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issuedAt?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AffiliateInvoiceConnection = {
  __typename?: 'AffiliateInvoiceConnection';
  items: Array<AffiliateInvoice>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AffiliateMerchant = {
  __typename?: 'AffiliateMerchant';
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  meta_data?: Maybe<AffiliateMerchantMetaData>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AffiliateMerchantConnection = {
  __typename?: 'AffiliateMerchantConnection';
  items: Array<AffiliateMerchant>;
  links?: Maybe<Scalars['String']['output']>;
};

export type AffiliateMerchantInput = {
  affiliateId: Scalars['ID']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliateMerchantMetaData = {
  __typename?: 'AffiliateMerchantMetaData';
  account_id?: Maybe<Scalars['String']['output']>;
  account_status?: Maybe<Scalars['String']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  first_conversion_date?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type AffiliateMetaData = {
  __typename?: 'AffiliateMetaData';
  tier?: Maybe<Scalars['String']['output']>;
};

export type AffiliatePayoutMethod = {
  __typename?: 'AffiliatePayoutMethod';
  details?: Maybe<AffiliatePayoutMethodDetails>;
  id?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AffiliatePayoutMethodDetails = {
  __typename?: 'AffiliatePayoutMethodDetails';
  iban?: Maybe<Scalars['String']['output']>;
  nif?: Maybe<Scalars['String']['output']>;
};

export type AffiliatePayoutMethodDetailsInput = {
  iban?: InputMaybe<Scalars['String']['input']>;
  nif?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliateReferralLink = {
  __typename?: 'AffiliateReferralLink';
  link?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsChange = {
  __typename?: 'AnalyticsChange';
  all?: Maybe<Scalars['Boolean']['output']>;
};

export enum AuthPaymentMethodKlarna {
  B2B_INVOICE = 'b2b_invoice',
  BASE_ACCOUNT = 'base_account',
  CARD = 'card',
  DEFERRED_INTEREST = 'deferred_interest',
  DIRECT_BANK_TRANSFER = 'direct_bank_transfer',
  DIRECT_DEBIT = 'direct_debit',
  FIXED_AMOUNT = 'fixed_amount',
  INVOICE = 'invoice',
  PIX = 'pix',
  SLICE_IT_BY_CARD = 'slice_it_by_card'
}

export type AuthorizedUser = {
  __typename?: 'AuthorizedUser';
  accessLevel: AuthorizedUserAccessLevel;
  accountId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastLoginAt?: Maybe<Scalars['String']['output']>;
  masterAccount?: Maybe<Scalars['Boolean']['output']>;
  pointOfSaleId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<AuthorizedUserStatus>;
  storeId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userEmail: Scalars['String']['output'];
};

export enum AuthorizedUserAccessLevel {
  ADMIN_ACCESS = 'ADMIN_ACCESS',
  READ_ACCESS = 'READ_ACCESS',
  WRITE_ACCESS = 'WRITE_ACCESS'
}

export enum AuthorizedUserStatus {
  ARCHIVED = 'ARCHIVED',
  COMPROMISED = 'COMPROMISED',
  CONFIRMED = 'CONFIRMED',
  FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
  RESET_REQUIRED = 'RESET_REQUIRED',
  UNCONFIRMED = 'UNCONFIRMED',
  UNKNOWN = 'UNKNOWN'
}

export type AuthorizedUsersConnection = {
  __typename?: 'AuthorizedUsersConnection';
  items: Array<AuthorizedUser>;
};

export type AvailablePaymentMethod = {
  __typename?: 'AvailablePaymentMethod';
  configured?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  paymentMethod?: Maybe<PaymentMethods>;
};

export type AvailableProcessor = {
  __typename?: 'AvailableProcessor';
  configurable?: Maybe<Scalars['Boolean']['output']>;
  configured?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  paymentMethod?: Maybe<PaymentMethods>;
  processor?: Maybe<Processor>;
};

export enum BillingCategoryKlarna {
  PAY_IN_PARTS = 'PAY_IN_PARTS',
  PAY_LATER = 'PAY_LATER',
  PAY_NOW = 'PAY_NOW',
  SLICE_IT = 'SLICE_IT',
  SLICE_IT_BY_CARD = 'SLICE_IT_BY_CARD'
}

export enum BillingPlans {
  MONEI_PLUS = 'MONEI_PLUS',
  MONEI_POS = 'MONEI_POS',
  MONEI_X = 'MONEI_X'
}

export type BlacklistItem = {
  __typename?: 'BlacklistItem';
  accountId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  matches?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  type: BlacklistItemType;
  updatedAt?: Maybe<Scalars['String']['output']>;
  validUntil?: Maybe<Scalars['AWSTimestamp']['output']>;
  value: Scalars['String']['output'];
};

export type BlacklistItemInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type: BlacklistItemType;
  validUntil?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  value: Scalars['String']['input'];
};

export enum BlacklistItemType {
  CARD = 'card',
  CARD_FINGERPRINT = 'card_fingerprint',
  COUNTRY = 'country',
  EMAIL = 'email',
  IP = 'ip',
  PHONE = 'phone',
  SESSION_FINGERPRINT = 'session_fingerprint'
}

export type BlacklistItemsConnection = {
  __typename?: 'BlacklistItemsConnection';
  items: Array<BlacklistItem>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type BusinessData = {
  __typename?: 'BusinessData';
  address?: Maybe<Address>;
  capital?: Maybe<Scalars['Long']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  confirmServicesDescription?: Maybe<Scalars['Boolean']['output']>;
  confirmWebsite?: Maybe<Scalars['Boolean']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['String']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Industries>;
  lastUpdateDate?: Maybe<Scalars['String']['output']>;
  legalAddress?: Maybe<Scalars['String']['output']>;
  legalDescription?: Maybe<Scalars['String']['output']>;
  legalForm?: Maybe<LegalForm>;
  legalName?: Maybe<Scalars['String']['output']>;
  mcc?: Maybe<Scalars['String']['output']>;
  monthlyVolume?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pibisi?: Maybe<Pibisi>;
  positions?: Maybe<Array<BusinessPosition>>;
  previousNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  registryRecords?: Maybe<Array<RegistryRecord>>;
  servicesDescription?: Maybe<Scalars['String']['output']>;
  startActivityDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BusinessStatus>;
  verificationAttempts?: Maybe<Scalars['Int']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type BusinessDataInput = {
  address?: InputMaybe<AddressInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['String']['input']>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Industries>;
  legalForm?: InputMaybe<LegalForm>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  mcc?: InputMaybe<Scalars['String']['input']>;
  monthlyVolume?: InputMaybe<Scalars['Long']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pibisi?: InputMaybe<PibisiInput>;
  servicesDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BusinessStatus>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessDefault = {
  __typename?: 'BusinessDefault';
  confirmServicesDescription?: Maybe<Scalars['Boolean']['output']>;
  confirmWebsite?: Maybe<Scalars['Boolean']['output']>;
  mcc?: Maybe<Scalars['String']['output']>;
  servicesDescription?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type BusinessDefaultInput = {
  confirmServicesDescription?: InputMaybe<Scalars['Boolean']['input']>;
  confirmWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  mcc?: InputMaybe<Scalars['String']['input']>;
  servicesDescription?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessPosition = {
  __typename?: 'BusinessPosition';
  fromDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export enum BusinessStatus {
  ACTIVE = 'active',
  DISSOLVED = 'dissolved',
  IN_FORMATION = 'in_formation',
  INACTIVE = 'inactive',
  NOT_FOUND = 'not_found',
  PROCESSING = 'processing',
  RENAMED = 'renamed',
  RESUBMISSION_REQUESTED = 'resubmission_requested',
  TRANSFORMED = 'transformed',
  UNDER_REVIEW = 'under_review'
}

export type CalculateRiskScoreInput = {
  accountId: Scalars['ID']['input'];
  ignoredKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CallbackData = {
  __typename?: 'CallbackData';
  status: Array<CallbackStatus>;
  statusCode?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
};

export enum CallbackStatus {
  EXECUTED = 'EXECUTED',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export type CancelPaymentInput = {
  accountId: Scalars['ID']['input'];
  cancellationReason?: InputMaybe<CancellationReason>;
  paymentId: Scalars['ID']['input'];
};

export type CancelSubscriptionInput = {
  accountId: Scalars['ID']['input'];
  cancelAtPeriodEnd?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export enum CancellationReason {
  DUPLICATED = 'duplicated',
  FRAUDULENT = 'fraudulent',
  ORDER_CANCELED = 'order_canceled',
  REQUESTED_BY_CUSTOMER = 'requested_by_customer'
}

/**  MONEI Capital account data containing offer and optional lead information */
export type CapitalAccountData = {
  __typename?: 'CapitalAccountData';
  /**  MONEI Capital lead if user has applied */
  lead?: Maybe<CapitalLead>;
  /**  MONEI Capital offer if available and not expired */
  offer?: Maybe<CapitalOffer>;
};

/**  MONEI Capital lead information */
export type CapitalLead = {
  __typename?: 'CapitalLead';
  /**  Onboarding status */
  onboardingStatus: CapitalOnboardingStatus;
  /**  Signup URL */
  signUpUrl: Scalars['String']['output'];
};

/**  MONEI Capital loan information */
export type CapitalLoan = {
  __typename?: 'CapitalLoan';
  aheadBehindPercentage: Scalars['Float']['output'];
  aheadBehindValue: Scalars['Float']['output'];
  autoRepaymentSweep: Scalars['Boolean']['output'];
  borrowerName?: Maybe<Scalars['String']['output']>;
  creditRating?: Maybe<Scalars['String']['output']>;
  currencyISOCode: Currencies;
  currentAmount: Scalars['Float']['output'];
  currentAmountAtDelete: Scalars['Float']['output'];
  currentAmountAtRepay: Scalars['Float']['output'];
  currentAmountAtWriteOff: Scalars['Float']['output'];
  fundedAmount: Scalars['Float']['output'];
  fundingDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  loanNumber: Scalars['Int']['output'];
  loanType: CapitalLoanType;
  maturityDate: Scalars['String']['output'];
  merchantIds?: Maybe<Array<Scalars['String']['output']>>;
  originalAmount: Scalars['Float']['output'];
  partnerLoanType: CapitalLoanType;
  status: CapitalLoanStatus;
  sweep: Scalars['Float']['output'];
};

/**  MONEI Capital loan default details */
export type CapitalLoanDefaultDetails = {
  __typename?: 'CapitalLoanDefaultDetails';
  currentAmountAtTimeOfDefault: Scalars['Float']['output'];
  dateDefaulted: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  reasonDetails?: Maybe<Scalars['String']['output']>;
};

/**  MONEI Capital loan details */
export type CapitalLoanDetails = {
  __typename?: 'CapitalLoanDetails';
  approvalDate?: Maybe<Scalars['String']['output']>;
  autoRepaymentSweep: Scalars['Boolean']['output'];
  borrowerId: Scalars['ID']['output'];
  borrowerName?: Maybe<Scalars['String']['output']>;
  creditRating?: Maybe<Scalars['String']['output']>;
  currencyISOCode?: Maybe<Currencies>;
  currentAmount: Scalars['Float']['output'];
  currentServiceChargeRate?: Maybe<Scalars['Float']['output']>;
  defaultDetails?: Maybe<CapitalLoanDefaultDetails>;
  discount: Scalars['Float']['output'];
  documents?: Maybe<Array<CapitalLoanDocumentItem>>;
  earlyRenewalDetails?: Maybe<CapitalLoanEarlyRenewalDetails>;
  expectedRepayment: Scalars['Float']['output'];
  fundingDetails?: Maybe<CapitalLoanFundingDetails>;
  id: Scalars['ID']['output'];
  lead?: Maybe<CapitalLoanLead>;
  loanNumber: Scalars['Int']['output'];
  loanType?: Maybe<CapitalLoanType>;
  maturityDate: Scalars['String']['output'];
  originalAmount: Scalars['Float']['output'];
  originalServiceChargeRate?: Maybe<Scalars['Float']['output']>;
  partnerLoanType?: Maybe<CapitalLoanType>;
  projectedRepaymentDate: Scalars['String']['output'];
  repaymentFrequency?: Maybe<Scalars['String']['output']>;
  repaymentMethod?: Maybe<Scalars['String']['output']>;
  securityAndGuarantees?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<CapitalLoanStatus>;
  sweep: Scalars['Float']['output'];
  thirdPartyReferences?: Maybe<Array<CapitalLoanThirdPartyReference>>;
  writeOffDetails?: Maybe<CapitalLoanWriteOffDetails>;
};

/**  MONEI Capital loan document item */
export type CapitalLoanDocumentItem = {
  __typename?: 'CapitalLoanDocumentItem';
  document: CapitalLoanDocumentReference;
  documentType?: Maybe<Scalars['String']['output']>;
};

/**  MONEI Capital loan document reference */
export type CapitalLoanDocumentReference = {
  __typename?: 'CapitalLoanDocumentReference';
  dateUploaded: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  documentName?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
};

/**  MONEI Capital loan early renewal details */
export type CapitalLoanEarlyRenewalDetails = {
  __typename?: 'CapitalLoanEarlyRenewalDetails';
  isOldLoanRepaid: Scalars['Boolean']['output'];
  newLoanId: Scalars['ID']['output'];
  newLoanNumber: Scalars['Int']['output'];
  oldLoanId: Scalars['ID']['output'];
  oldLoanNumber: Scalars['Int']['output'];
};

/**  MONEI Capital loan funding details */
export type CapitalLoanFundingDetails = {
  __typename?: 'CapitalLoanFundingDetails';
  amountFunded: Scalars['Float']['output'];
  fundingAmount: Scalars['Float']['output'];
  fundingDate: Scalars['String']['output'];
  fundingPayments?: Maybe<Array<CapitalLoanFundingPayment>>;
};

/**  MONEI Capital loan funding payment */
export type CapitalLoanFundingPayment = {
  __typename?: 'CapitalLoanFundingPayment';
  paymentAmount: Scalars['Float']['output'];
  paymentDate: Scalars['String']['output'];
};

/**  MONEI Capital loan lead information */
export type CapitalLoanLead = {
  __typename?: 'CapitalLoanLead';
  countryISOCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
};

/**  MONEI Capital loan repayment information */
export type CapitalLoanRepayment = {
  __typename?: 'CapitalLoanRepayment';
  loanBalance: Scalars['Float']['output'];
  paymentDate: Scalars['String']['output'];
  payments?: Maybe<Array<Scalars['Float']['output']>>;
  repaymentAmount: Scalars['Float']['output'];
  sweep?: Maybe<Scalars['Float']['output']>;
  totalCardTransactions?: Maybe<Scalars['Float']['output']>;
};

/**  MONEI Capital loan repayments connection */
export type CapitalLoanRepaymentsConnection = {
  __typename?: 'CapitalLoanRepaymentsConnection';
  /**  List of MONEI Capital loan repayments */
  items: Array<CapitalLoanRepayment>;
};

/**  MONEI Capital loan status */
export enum CapitalLoanStatus {
  DEFAULTED = 'Defaulted',
  DISCOUNTEDSETTLEMENT = 'DiscountedSettlement',
  FUNDED = 'Funded',
  FUNDEDPENDINGSETTLEMENT = 'FundedPendingSettlement',
  PARTIALLYFUNDED = 'PartiallyFunded',
  REPAID = 'Repaid',
  REQUESTEDFUNDING = 'RequestedFunding',
  UNFUNDED = 'Unfunded',
  WRITTENOFF = 'WrittenOff'
}

/**  MONEI Capital loan third party reference */
export type CapitalLoanThirdPartyReference = {
  __typename?: 'CapitalLoanThirdPartyReference';
  thirdPartyId: Scalars['ID']['output'];
  thirdPartyReference?: Maybe<Scalars['String']['output']>;
};

/**  MONEI Capital loan type */
export enum CapitalLoanType {
  EARLYRENEWAL = 'EarlyRenewal',
  INITIAL = 'Initial',
  RENEWAL = 'Renewal'
}

/**  MONEI Capital loan write off details */
export type CapitalLoanWriteOffDetails = {
  __typename?: 'CapitalLoanWriteOffDetails';
  paymentAmount: Scalars['Float']['output'];
  paymentDate: Scalars['String']['output'];
};

/**  MONEI Capital loans connection */
export type CapitalLoansConnection = {
  __typename?: 'CapitalLoansConnection';
  /**  List of MONEI Capital loans */
  items: Array<CapitalLoan>;
};

/**  MONEI Capital offer information */
export type CapitalOffer = {
  __typename?: 'CapitalOffer';
  /**  Currency ISO code */
  currencyISOCode: Currencies;
  /**  Fee amount */
  fee: Scalars['Float']['output'];
  /**  Funded amount */
  fundedAmount: Scalars['Float']['output'];
  /**  Loan amount */
  loanAmount: Scalars['Float']['output'];
};

/**  MONEI Capital onboarding details for dashboard */
export type CapitalOnboardingDetailsDashboard = {
  __typename?: 'CapitalOnboardingDetailsDashboard';
  companyName?: Maybe<Scalars['String']['output']>;
  kycDocumentsStepComplete: Scalars['Boolean']['output'];
  leadId: Scalars['String']['output'];
  offerStepComplete: Scalars['Boolean']['output'];
  onboardingStateReason?: Maybe<Scalars['String']['output']>;
  organisationDetailsStepComplete: Scalars['Boolean']['output'];
  paymentDataStepComplete: Scalars['Boolean']['output'];
  stateUpdated?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/**  MONEI Capital onboarding status */
export enum CapitalOnboardingStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED'
}

export type CapturePaymentInput = {
  accountId: Scalars['ID']['input'];
  amount?: InputMaybe<Scalars['Int']['input']>;
  paymentId: Scalars['ID']['input'];
};

export enum CardBrand {
  AMEX = 'amex',
  DINERS = 'diners',
  DISCOVER = 'discover',
  JCB = 'jcb',
  MASTERCARD = 'mastercard',
  UNIONPAY = 'unionpay',
  UNKNOWN = 'unknown',
  VISA = 'visa'
}

export enum CardType {
  CREDIT = 'credit',
  DEBIT = 'debit'
}

export type Charge = {
  __typename?: 'Charge';
  accountId: Scalars['ID']['output'];
  acquirer?: Maybe<Acquirer>;
  amount?: Maybe<Scalars['Int']['output']>;
  amountEUR?: Maybe<Scalars['Int']['output']>;
  authorizationCode?: Maybe<Scalars['String']['output']>;
  billingDetails?: Maybe<ContactDetails>;
  billingPlan?: Maybe<BillingPlans>;
  callbackUrl?: Maybe<Scalars['String']['output']>;
  cancelUrl?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<CancellationReason>;
  checkoutId: Scalars['ID']['output'];
  completeUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  currency: Scalars['String']['output'];
  customer?: Maybe<Customer>;
  description?: Maybe<Scalars['String']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  failUrl?: Maybe<Scalars['String']['output']>;
  fraudDetectorScore?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  issuerStatusCode?: Maybe<Scalars['String']['output']>;
  issuerStatusMessage?: Maybe<Scalars['String']['output']>;
  lastRefundAmount?: Maybe<Scalars['Int']['output']>;
  lastRefundReason?: Maybe<RefundReason>;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  masterAccountId?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Array<KeyValueItem>>;
  orderId?: Maybe<Scalars['ID']['output']>;
  pageOpenedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  pointOfSaleId?: Maybe<Scalars['ID']['output']>;
  processor?: Maybe<Processor>;
  providerId?: Maybe<Scalars['ID']['output']>;
  providerInternalId?: Maybe<Scalars['ID']['output']>;
  providerReferenceId?: Maybe<Scalars['ID']['output']>;
  providerStatusCode?: Maybe<Scalars['String']['output']>;
  providerStatusMessage?: Maybe<Scalars['String']['output']>;
  refundedAmount?: Maybe<Scalars['Int']['output']>;
  sequenceId?: Maybe<Scalars['ID']['output']>;
  sessionDetails?: Maybe<SessionDetails>;
  shippingDetails?: Maybe<ContactDetails>;
  shop?: Maybe<Shop>;
  status: ChargeStatus;
  statusCode?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  storeId?: Maybe<Scalars['ID']['output']>;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  terminalId?: Maybe<Scalars['String']['output']>;
  traceDetails?: Maybe<TraceDetails>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type ChargeEvent = {
  __typename?: 'ChargeEvent';
  accountId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  id: Scalars['ID']['output'];
  livemode?: Maybe<Scalars['Boolean']['output']>;
  masterAccountId?: Maybe<Scalars['ID']['output']>;
  object: ChargeEventObject;
  objectId: Scalars['ID']['output'];
  objectType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ChargeEventObject = {
  __typename?: 'ChargeEventObject';
  accountId: Scalars['ID']['output'];
  amount?: Maybe<Scalars['Int']['output']>;
  amountEUR?: Maybe<Scalars['Int']['output']>;
  authorizationCode?: Maybe<Scalars['String']['output']>;
  billingDetails?: Maybe<ContactDetails>;
  billingPlan?: Maybe<BillingPlans>;
  callbackUrl?: Maybe<Scalars['String']['output']>;
  cancelUrl?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<CancellationReason>;
  checkoutId: Scalars['ID']['output'];
  completeUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  currency: Scalars['String']['output'];
  customer?: Maybe<Customer>;
  description?: Maybe<Scalars['String']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  failUrl?: Maybe<Scalars['String']['output']>;
  fraudDetectorScore?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  issuerStatusCode?: Maybe<Scalars['String']['output']>;
  issuerStatusMessage?: Maybe<Scalars['String']['output']>;
  lastRefundAmount?: Maybe<Scalars['Int']['output']>;
  lastRefundReason?: Maybe<RefundReason>;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  masterAccountId?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Array<KeyValueItem>>;
  orderId?: Maybe<Scalars['ID']['output']>;
  pageOpenedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  pointOfSaleId?: Maybe<Scalars['ID']['output']>;
  providerId?: Maybe<Scalars['ID']['output']>;
  providerInternalId?: Maybe<Scalars['ID']['output']>;
  providerReferenceId?: Maybe<Scalars['ID']['output']>;
  providerStatusCode?: Maybe<Scalars['String']['output']>;
  providerStatusMessage?: Maybe<Scalars['String']['output']>;
  refundedAmount?: Maybe<Scalars['Int']['output']>;
  sequenceId?: Maybe<Scalars['ID']['output']>;
  sessionDetails?: Maybe<SessionDetails>;
  shippingDetails?: Maybe<ContactDetails>;
  shop?: Maybe<Shop>;
  status: ChargeStatus;
  statusCode?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  storeId?: Maybe<Scalars['ID']['output']>;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  terminalId?: Maybe<Scalars['String']['output']>;
  traceDetails?: Maybe<TraceDetails>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type ChargeEventsConnection = {
  __typename?: 'ChargeEventsConnection';
  items: Array<ChargeEvent>;
  total: Scalars['Int']['output'];
};

export enum ChargeStatus {
  AUTHORIZED = 'AUTHORIZED',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  PAID_OUT = 'PAID_OUT',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  PENDING = 'PENDING',
  PENDING_PROCESSING = 'PENDING_PROCESSING',
  REFUNDED = 'REFUNDED',
  SUCCEEDED = 'SUCCEEDED'
}

export type ChargesConnection = {
  __typename?: 'ChargesConnection';
  items: Array<Charge>;
  total: Scalars['Int']['output'];
};

export type ChargesDateRangeKpi = {
  __typename?: 'ChargesDateRangeKPI';
  currency: Currencies;
  data: Array<ChargesDateRangeKpiRow>;
  total: ChargesDateRangeKpiTotal;
};

export type ChargesDateRangeKpiRow = {
  __typename?: 'ChargesDateRangeKPIRow';
  canceledAmount: Scalars['Long']['output'];
  canceledCount: Scalars['Long']['output'];
  capturedAmount: Scalars['Long']['output'];
  capturedCount: Scalars['Long']['output'];
  cuCapturedAmount: Scalars['Long']['output'];
  cuCapturedCount: Scalars['Long']['output'];
  cuDirectAmount: Scalars['Long']['output'];
  cuDirectCount: Scalars['Long']['output'];
  cuSucceededAmount: Scalars['Long']['output'];
  cuSucceededCount: Scalars['Long']['output'];
  cuSucceededPayoutAmount: Scalars['Long']['output'];
  cuSucceededPayoutCount: Scalars['Long']['output'];
  directAmount: Scalars['Long']['output'];
  directCount: Scalars['Long']['output'];
  failedAmount: Scalars['Long']['output'];
  failedCount: Scalars['Long']['output'];
  refundedAmount: Scalars['Long']['output'];
  refundedCount: Scalars['Long']['output'];
  succeededAmount: Scalars['Long']['output'];
  succeededCount: Scalars['Long']['output'];
  succeededPayoutAmount: Scalars['Long']['output'];
  succeededPayoutCount: Scalars['Long']['output'];
  timestamp: Scalars['AWSTimestamp']['output'];
};

export type ChargesDateRangeKpiTotal = {
  __typename?: 'ChargesDateRangeKPITotal';
  canceledAmount: Scalars['Long']['output'];
  canceledCount: Scalars['Long']['output'];
  capturedAmount: Scalars['Long']['output'];
  capturedCount: Scalars['Long']['output'];
  directAmount: Scalars['Long']['output'];
  directCount: Scalars['Long']['output'];
  failedAmount: Scalars['Long']['output'];
  failedCount: Scalars['Long']['output'];
  refundedAmount: Scalars['Long']['output'];
  refundedCount: Scalars['Long']['output'];
  succeededAmount: Scalars['Long']['output'];
  succeededCount: Scalars['Long']['output'];
  succeededPayoutAmount: Scalars['Long']['output'];
  succeededPayoutCount: Scalars['Long']['output'];
};

export type ChargesExport = {
  __typename?: 'ChargesExport';
  accountId: Scalars['ID']['output'];
  expireAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: ExportStatus;
  statusCode?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
};

export type ChargesExportsConnection = {
  __typename?: 'ChargesExportsConnection';
  items: Array<ChargesExport>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export enum ChurnReason {
  CLOSED_BUSINESS = 'CLOSED_BUSINESS',
  ECONOMIC_CONDITIONS = 'ECONOMIC_CONDITIONS',
  LACK_SUPPORT = 'LACK_SUPPORT',
  OTHER = 'OTHER',
  PROBLEM_WITH_PLATFORM = 'PROBLEM_WITH_PLATFORM',
  PROBLEM_WITH_WEBSITE = 'PROBLEM_WITH_WEBSITE',
  SALES_DROP = 'SALES_DROP',
  SWITCHED = 'SWITCHED'
}

export type Code = {
  __typename?: 'Code';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  pointOfSaleId?: Maybe<Scalars['String']['output']>;
  type: CodeTypes;
};

export enum CodeTypes {
  POINT_OF_SALE = 'POINT_OF_SALE'
}

export type ColumnsInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  authorizationCode?: InputMaybe<Scalars['String']['input']>;
  commission?: InputMaybe<Scalars['String']['input']>;
};

export type ContactDetails = {
  __typename?: 'ContactDetails';
  address?: Maybe<Address>;
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type ContactDetailsInput = {
  address?: InputMaybe<AddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPerson = {
  __typename?: 'ContactPerson';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type ContactPersonInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export enum ContractStatus {
  COMPLETED = 'completed',
  CREATED = 'created',
  DECLINED = 'declined',
  DELIVERED = 'delivered',
  SENT = 'sent',
  SIGNED = 'signed',
  VOIDED = 'voided'
}

export type Countries = {
  __typename?: 'Countries';
  currentCountry?: Maybe<Country>;
  currentCountryCode?: Maybe<Scalars['String']['output']>;
  isSupported: Scalars['Boolean']['output'];
  supportedCountries: Array<Country>;
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneCode: Scalars['String']['output'];
};

export type CreateAuthorizedUserInput = {
  accessLevel?: InputMaybe<AuthorizedUserAccessLevel>;
  accountId: Scalars['ID']['input'];
  pointOfSaleId?: InputMaybe<Scalars['ID']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  userEmail: Scalars['String']['input'];
};

export type CreateCodeInput = {
  accountId: Scalars['ID']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  pointOfSaleId?: InputMaybe<Scalars['String']['input']>;
  type: CodeTypes;
};

export type CreateDocumentInput = {
  accountId: Scalars['ID']['input'];
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type: DocumentType;
};

export type CreateExportSftpConfigInput = {
  accountId: Scalars['ID']['input'];
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  host: Scalars['String']['input'];
  password: Scalars['String']['input'];
  path: Scalars['String']['input'];
  port: Scalars['Int']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type CreateIdentityInput = {
  address?: InputMaybe<AddressInput>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<IdDocumentInput>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  hasNoPublicActivity?: InputMaybe<Scalars['Boolean']['input']>;
  idSession?: InputMaybe<Scalars['String']['input']>;
  idSessionUrl?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pibisiId?: InputMaybe<Scalars['ID']['input']>;
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  sepblacRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<IdVerificationStatus>;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  statusMessage?: InputMaybe<Scalars['String']['input']>;
  yearOfBirth?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMasterAccountApiKeyInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  livemode: Scalars['Boolean']['input'];
  masterAccountId: Scalars['ID']['input'];
};

export type CreateMasterAccountInput = {
  accountDefaults?: InputMaybe<AccountDefaultsInput>;
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  allowCreateApiKey?: InputMaybe<Scalars['Boolean']['input']>;
  allowedIPs?: InputMaybe<Array<Scalars['String']['input']>>;
  business?: InputMaybe<BusinessDataInput>;
  churnedEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  contractTemplateId?: InputMaybe<Scalars['ID']['input']>;
  dynamicBilling?: InputMaybe<Scalars['Boolean']['input']>;
  extraFees?: InputMaybe<Array<InputMaybe<AccountExtraFeeInput>>>;
  fees?: InputMaybe<MasterAccountFeesInput>;
  iban?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payoutTerms?: InputMaybe<AccountPayoutTermsInput>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AccountStatus>;
  webhookEmails?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateMasterAccountUserInput = {
  accountId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaymentInput = {
  accountId: Scalars['ID']['input'];
  allowedPaymentMethods?: InputMaybe<Array<InputMaybe<PaymentMethods>>>;
  amount: Scalars['Int']['input'];
  billingDetails?: InputMaybe<ContactDetailsInput>;
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  completeUrl?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currencies>;
  customer?: InputMaybe<CustomerInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  expireAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  failUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Array<KeyValueInput>>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  pointOfSaleId?: InputMaybe<Scalars['ID']['input']>;
  shippingDetails?: InputMaybe<ContactDetailsInput>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  transactionType?: InputMaybe<TransactionTypes>;
};

export type CreatePibisiUserInput = {
  accountId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  legalForm: LegalForm;
};

export type CreatePointOfSaleInput = {
  accountId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fixedAmount?: InputMaybe<Scalars['Int']['input']>;
  fixedCurrency?: InputMaybe<Currencies>;
  includeQRCode?: InputMaybe<Scalars['Boolean']['input']>;
  manualAmount?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentCallbackUrl?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<Array<PaymentMethods>>;
  pendingSetup?: InputMaybe<Scalars['Boolean']['input']>;
  qrCodeText?: InputMaybe<Scalars['String']['input']>;
  requireEmail?: InputMaybe<Scalars['Boolean']['input']>;
  requireTaxId?: InputMaybe<Scalars['Boolean']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  terminalId?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<TransactionTypes>;
  type?: InputMaybe<PointOfSaleType>;
};

export type CreateProviderInput = {
  accountId: Scalars['ID']['input'];
  acquirer: Acquirer;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<MetadataItemInput>>;
  nativeHostedPayment?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod?: InputMaybe<PaymentMethods>;
  processor?: InputMaybe<Processor>;
  rules?: InputMaybe<ProviderRulesInput>;
  test?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateRepresentativeInput = {
  accountId: Scalars['ID']['input'];
  identityId: Scalars['ID']['input'];
  interventionType?: InputMaybe<Array<InterventionType>>;
  main?: InputMaybe<Scalars['Boolean']['input']>;
  stocksPercentage?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateShortLinkInput = {
  accountId: Scalars['ID']['input'];
  expireAt?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  memorableId?: InputMaybe<Scalars['Boolean']['input']>;
  url: Scalars['String']['input'];
};

export type CreateStoreInput = {
  accountId: Scalars['ID']['input'];
  address?: InputMaybe<AddressInput>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<MetadataItemInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSubscriptionInput = {
  accountId: Scalars['ID']['input'];
  allowedPaymentMethods?: InputMaybe<Array<InputMaybe<SubscriptionPaymentMethods>>>;
  amount: Scalars['Int']['input'];
  billingDetails?: InputMaybe<ContactDetailsInput>;
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currencies>;
  customer?: InputMaybe<CustomerInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<IntervalInput>;
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
  masterAccountId?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Array<KeyValueInput>>;
  paymentCallbackUrl?: InputMaybe<Scalars['String']['input']>;
  retrySchedule?: InputMaybe<Array<RetryScheduleInput>>;
  shippingDetails?: InputMaybe<ContactDetailsInput>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  trialAmount?: InputMaybe<Scalars['Int']['input']>;
  trialPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  trialPeriodEnd?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type CreateWebhookInput = {
  accountId: Scalars['ID']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventTypes: Array<WebhookEventType>;
  masterAccount?: InputMaybe<Scalars['Boolean']['input']>;
  url: Scalars['String']['input'];
};

export enum Currencies {
  CHF = 'CHF',
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  JOD = 'JOD',
  JPY = 'JPY',
  PLN = 'PLN',
  SEK = 'SEK',
  USD = 'USD'
}

export type Customer = {
  __typename?: 'Customer';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type CustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCodeInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteMasterAccountApiKeyInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  masterAccountId: Scalars['ID']['input'];
};

export type DeleteRepresentativeInput = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type DeleteShortLinkInput = {
  accountId: Scalars['ID']['input'];
  id: Scalars['String']['input'];
};

export enum DeviceType {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
  SMARTTV = 'smartTV',
  TABLET = 'tablet'
}

export type Document = {
  __typename?: 'Document';
  accountId: Scalars['ID']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internal?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Array<DocumentMetadataItem>>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  status: DocumentStatus;
  statusCode?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  traceDetails?: Maybe<TraceDetails>;
  type: DocumentType;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type DocumentEvent = {
  __typename?: 'DocumentEvent';
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  object: DocumentEventObject;
  objectId: Scalars['ID']['output'];
  objectType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DocumentEventObject = {
  __typename?: 'DocumentEventObject';
  accountId: Scalars['ID']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  internal?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Array<DocumentMetadataItem>>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  status: DocumentStatus;
  statusCode?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  traceDetails?: Maybe<TraceDetails>;
  type: DocumentType;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type DocumentEventsConnection = {
  __typename?: 'DocumentEventsConnection';
  items: Array<DocumentEvent>;
  total: Scalars['Int']['output'];
};

export type DocumentMetadataItem = {
  __typename?: 'DocumentMetadataItem';
  key: Scalars['String']['output'];
  value?: Maybe<Array<Scalars['String']['output']>>;
};

export enum DocumentStatus {
  APPROVAL_REQUIRED = 'APPROVAL_REQUIRED',
  APPROVED = 'APPROVED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  REJECTED = 'REJECTED'
}

export enum DocumentType {
  ALAVA_CENSUS_CERT = 'ALAVA_CENSUS_CERT',
  BANK_OWNERSHIP_CERT = 'BANK_OWNERSHIP_CERT',
  BENEFICIAL_OWNERSHIP_REPORT = 'BENEFICIAL_OWNERSHIP_REPORT',
  BIZKAIA_CENSUS_CERT = 'BIZKAIA_CENSUS_CERT',
  CENSUS_CERT = 'CENSUS_CERT',
  COMPANY_TAX_ID = 'COMPANY_TAX_ID',
  CONTRACT = 'CONTRACT',
  DEED_OF_COMPANY_REPRESENTATIVE = 'DEED_OF_COMPANY_REPRESENTATIVE',
  DEED_OF_INCORPORATION = 'DEED_OF_INCORPORATION',
  DRIVERS_LICENSE = 'DRIVERS_LICENSE',
  GIPUZKOA_CENSUS_CERT = 'GIPUZKOA_CENSUS_CERT',
  ID_CARD = 'ID_CARD',
  MERCANTILE_REGISTRY_NOTE = 'MERCANTILE_REGISTRY_NOTE',
  NAVARRA_CENSUS_CERT = 'NAVARRA_CENSUS_CERT',
  OTHER = 'OTHER',
  PASSPORT = 'PASSPORT',
  PIBISI_REPORT = 'PIBISI_REPORT',
  POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
  RESIDENCE_PERMIT = 'RESIDENCE_PERMIT',
  VERIFF_REPORT = 'VERIFF_REPORT'
}

export type DocumentsConnection = {
  __typename?: 'DocumentsConnection';
  items: Array<Document>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type DownloadFile = {
  __typename?: 'DownloadFile';
  downloadUrl: Scalars['String']['output'];
  expiresAt: Scalars['AWSTimestamp']['output'];
};

export enum ExportStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export enum Gender {
  F = 'F',
  M = 'M'
}

export type GenerateSettlementReportInput = {
  accountId: Scalars['ID']['input'];
  columns?: InputMaybe<ColumnsInput>;
  file: S3ObjectInput;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type IdDocument = {
  __typename?: 'IdDocument';
  country?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  type?: Maybe<IdDocumentType>;
  validFrom?: Maybe<Scalars['String']['output']>;
  validUntil?: Maybe<Scalars['String']['output']>;
};

export type IdDocumentInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IdDocumentType>;
  validFrom?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['String']['input']>;
};

export enum IdDocumentType {
  DRIVERS_LICENSE = 'DRIVERS_LICENSE',
  ID_CARD = 'ID_CARD',
  PASSPORT = 'PASSPORT',
  RESIDENCE_PERMIT = 'RESIDENCE_PERMIT'
}

export enum IdVerificationStatus {
  ABANDONED = 'abandoned',
  APPROVED = 'approved',
  DECLINED = 'declined',
  EXPIRED = 'expired',
  RESUBMISSION_REQUESTED = 'resubmission_requested',
  SUBMITTED = 'submitted'
}

export type IdentitiesConnection = {
  __typename?: 'IdentitiesConnection';
  items: Array<Identity>;
  total: Scalars['Int']['output'];
};

export type Identity = {
  __typename?: 'Identity';
  address?: Maybe<Address>;
  citizenship?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  document?: Maybe<IdDocument>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  hasNoPublicActivity?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  idSession?: Maybe<Scalars['String']['output']>;
  idSessionUrl?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pibisiId?: Maybe<Scalars['ID']['output']>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  registeredAt?: Maybe<Scalars['String']['output']>;
  riskLabels?: Maybe<Array<RiskLabel>>;
  sepblacRegistered?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<IdVerificationStatus>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  traceDetails?: Maybe<TraceDetails>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  yearOfBirth?: Maybe<Scalars['String']['output']>;
};

export type ImpersonateInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  adminEmail: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};

export enum Industries {
  ECOMMERCE = 'ECOMMERCE'
}

export enum Interval {
  DAY = 'day',
  HOUR = 'hour',
  MINUTE = 'minute',
  MONTH = 'month',
  QUARTER = 'quarter',
  WEEK = 'week',
  YEAR = 'year'
}

/**  Subscription interval can only be set to minute and hour in test mode */
export enum IntervalInput {
  DAY = 'day',
  HOUR = 'hour',
  MINUTE = 'minute',
  MONTH = 'month',
  QUARTER = 'quarter',
  WEEK = 'week',
  YEAR = 'year'
}

export enum InterventionType {
  AUT = 'AUT',
  OTR = 'OTR',
  REP = 'REP',
  TIT = 'TIT',
  TRE = 'TRE'
}

export type InvoiceBusinessData = {
  __typename?: 'InvoiceBusinessData';
  documentNumber?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  mandateSignatureTimestamp?: Maybe<Scalars['String']['output']>;
};

export enum InvoiceLineItemUnitType {
  MONEY = 'money',
  PERCENT = 'percent'
}

export type InvoicesConnection = {
  __typename?: 'InvoicesConnection';
  items: Array<AccountInvoice>;
  total: Scalars['Int']['output'];
};

export type ItemLevelUpdate = {
  __typename?: 'ItemLevelUpdate';
  accountId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type KeyValueInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type KeyValueItem = {
  __typename?: 'KeyValueItem';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type LastPayment = {
  __typename?: 'LastPayment';
  id: Scalars['ID']['output'];
  status: PaymentStatus;
  statusCode?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
};

export enum LegalForm {
  COMPANY = 'COMPANY',
  FREELANCE = 'FREELANCE',
  INDIVIDUAL = 'INDIVIDUAL'
}

export type MasterAccount = {
  __typename?: 'MasterAccount';
  accountCallbackUrl?: Maybe<Scalars['String']['output']>;
  accountDefaults?: Maybe<AccountDefaults>;
  adminEmail?: Maybe<Scalars['String']['output']>;
  allowCreateApiKey?: Maybe<Scalars['Boolean']['output']>;
  allowedDomains?: Maybe<Array<Scalars['String']['output']>>;
  allowedIPs?: Maybe<Array<Scalars['String']['output']>>;
  apiKey?: Maybe<Scalars['String']['output']>;
  autoApprove?: Maybe<Scalars['Boolean']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  branding?: Maybe<AccountBranding>;
  business?: Maybe<BusinessData>;
  churnedEmails?: Maybe<Array<Scalars['String']['output']>>;
  contract?: Maybe<AccountContract>;
  contractTemplateId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  dynamicBilling?: Maybe<Scalars['Boolean']['output']>;
  extraFees?: Maybe<Array<Maybe<AccountExtraFee>>>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  payoutTerms?: Maybe<AccountPayoutTerms>;
  prodAccountId?: Maybe<Scalars['ID']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  publicBusinessDetails?: Maybe<AccountPublicBusinessDetails>;
  requireExternalId?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<AccountStatus>;
  test?: Maybe<Scalars['Boolean']['output']>;
  testAccountId?: Maybe<Scalars['ID']['output']>;
  traceDetails?: Maybe<TraceDetails>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  webhookEmails?: Maybe<Array<Scalars['String']['output']>>;
};

export type MasterAccountActualFees = {
  __typename?: 'MasterAccountActualFees';
  approvedAccountFee: Scalars['Int']['output'];
  extra?: Maybe<Array<MasterAccountExtraFee>>;
};

export type MasterAccountEvent = {
  __typename?: 'MasterAccountEvent';
  accountId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  id: Scalars['ID']['output'];
  livemode?: Maybe<Scalars['Boolean']['output']>;
  object: MasterAccountEventObject;
  objectId: Scalars['ID']['output'];
  objectType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type MasterAccountEventObject = {
  __typename?: 'MasterAccountEventObject';
  accountCallbackUrl?: Maybe<Scalars['String']['output']>;
  accountDefaults?: Maybe<AccountDefaults>;
  activatedAt?: Maybe<Scalars['String']['output']>;
  adminEmail?: Maybe<Scalars['String']['output']>;
  allowedDomains?: Maybe<Array<Scalars['String']['output']>>;
  allowedIPs?: Maybe<Array<Scalars['String']['output']>>;
  apiKey?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  business?: Maybe<BusinessData>;
  churnedEmails?: Maybe<Array<Scalars['String']['output']>>;
  contract?: Maybe<AccountContract>;
  contractTemplateId?: Maybe<Scalars['String']['output']>;
  dynamicBilling?: Maybe<Scalars['Boolean']['output']>;
  fees?: Maybe<MasterAccountActualFees>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  payoutTerms?: Maybe<AccountPayoutTerms>;
  prodAccountId?: Maybe<Scalars['ID']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AccountStatus>;
  test: Scalars['Boolean']['output'];
  testAccountId?: Maybe<Scalars['ID']['output']>;
  traceDetails?: Maybe<TraceDetails>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  webhookEmails?: Maybe<Array<Scalars['String']['output']>>;
};

export type MasterAccountEventsConnection = {
  __typename?: 'MasterAccountEventsConnection';
  items: Array<MasterAccountEvent>;
  total: Scalars['Int']['output'];
};

export type MasterAccountExtraFee = {
  __typename?: 'MasterAccountExtraFee';
  amount: Scalars['Float']['output'];
  masterAccountFee?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  paymentMethods?: Maybe<Array<PaymentMethods>>;
  region?: Maybe<AccountExtraFeeRegion>;
  type: AccountExtraFeeType;
};

export type MasterAccountExtraFeeInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  masterAccountFee?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<Array<InputMaybe<PaymentMethods>>>;
  region?: InputMaybe<AccountExtraFeeRegion>;
  type?: InputMaybe<AccountExtraFeeType>;
};

export type MasterAccountFeesInput = {
  approvedAccountFee?: InputMaybe<Scalars['Int']['input']>;
  extra?: InputMaybe<Array<MasterAccountExtraFeeInput>>;
};

export type MasterAccountInvoice = {
  __typename?: 'MasterAccountInvoice';
  amount: Scalars['Int']['output'];
  business?: Maybe<InvoiceBusinessData>;
  createdAt: Scalars['AWSTimestamp']['output'];
  currency: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  lineItems: Array<AccountInvoiceLineItem>;
  masterAccountId: Scalars['ID']['output'];
  number?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<AccountInvoicePaymentMethod>;
  period: AccountInvoicePeriod;
  status?: Maybe<AccountInvoiceStatus>;
  tax: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type MasterAccountInvoicesConnection = {
  __typename?: 'MasterAccountInvoicesConnection';
  items: Array<MasterAccountInvoice>;
};

export type MasterAccountsConnection = {
  __typename?: 'MasterAccountsConnection';
  items: Array<MasterAccount>;
  total: Scalars['Int']['output'];
};

export enum MessageChannel {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP'
}

export type MetadataConfigItem = {
  __typename?: 'MetadataConfigItem';
  default?: Maybe<Scalars['String']['output']>;
  example?: Maybe<Scalars['String']['output']>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  possibleValues?: Maybe<Array<Scalars['String']['output']>>;
  regex?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  secret?: Maybe<Scalars['Boolean']['output']>;
  type: MetadataItemType;
};

export type MetadataItem = {
  __typename?: 'MetadataItem';
  default?: Maybe<Scalars['String']['output']>;
  example?: Maybe<Scalars['String']['output']>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  possibleValues?: Maybe<Array<Scalars['String']['output']>>;
  regex?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  secret?: Maybe<Scalars['Boolean']['output']>;
  type: MetadataItemType;
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataItemInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum MetadataItemType {
  BOOLEAN = 'BOOLEAN',
  NUMBER = 'NUMBER',
  NUMBER_ARRAY = 'NUMBER_ARRAY',
  STRING = 'STRING',
  STRING_ARRAY = 'STRING_ARRAY'
}

export type Mutation = {
  __typename?: 'Mutation';
  activateMasterAccount: MasterAccount;
  activateSubscription?: Maybe<Payment>;
  addBlacklistItem: BlacklistItem;
  approveAccount: Account;
  calculateRiskScore?: Maybe<Account>;
  cancelPayment?: Maybe<Payment>;
  cancelSubscription?: Maybe<Subscription>;
  capturePayment?: Maybe<Payment>;
  connectMasterAccount: Account;
  createAccountInvoice: AccountInvoice;
  createAuthorizedUser?: Maybe<AuthorizedUser>;
  createCode: Code;
  createDocument: Document;
  createExportSftpConfig: SftpConfigExport;
  createIdentity: Identity;
  createMasterAccount: MasterAccount;
  createMasterAccountApiKey: MasterAccount;
  createMasterAccountUser: AuthorizedUser;
  createPayment?: Maybe<Payment>;
  createPibisiUser: Account;
  createPointOfSale: PointOfSale;
  createProvider: Provider;
  createRepresentative: Representative;
  createShortLink: ShortLink;
  createStore: Store;
  createSubscription?: Maybe<Subscription>;
  createWebhook: Webhook;
  deleteAccount: Account;
  deleteAuthorizedUser: Scalars['Boolean']['output'];
  deleteBlacklistItem: Scalars['Boolean']['output'];
  deleteCode: Scalars['Boolean']['output'];
  deleteDocument: Scalars['Boolean']['output'];
  deleteExportSftpConfig: Scalars['Boolean']['output'];
  deleteIdentity: Identity;
  deleteMasterAccountApiKey: MasterAccount;
  deleteMasterAccountUser: Scalars['Boolean']['output'];
  deletePointOfSale: Scalars['Boolean']['output'];
  deleteProvider: Provider;
  deleteRepresentative: Representative;
  deleteShortLink: Scalars['Boolean']['output'];
  deleteStore: Scalars['Boolean']['output'];
  deleteWebhook: Scalars['Boolean']['output'];
  disableAffiliateProcessing: Affiliate;
  disableTokenizationMethod: Account;
  disableUser: User;
  disconnectMasterAccount: Account;
  downloadAccountInvoice: DownloadFile;
  downloadAffiliateInvoice: DownloadFile;
  /**  Get a presigned download URL for a MONEI Capital loan document */
  downloadCapitalLoanDocument: DownloadFile;
  downloadContract?: Maybe<DownloadFile>;
  downloadDocument: DownloadFile;
  downloadExport: DownloadFile;
  downloadOperationsFile: DownloadFile;
  enableAffiliateProcessing: Affiliate;
  enableTokenizationMethod: Account;
  enableUser: User;
  exportCharges: DownloadFile;
  generateOffersByAccount?: Maybe<CapitalOffer>;
  generateSettlementReport: DownloadFile;
  getRepresentatives: Array<RepresentativeData>;
  impersonate?: Maybe<Scalars['Boolean']['output']>;
  pauseSubscription?: Maybe<Subscription>;
  publishUpdateAccount?: Maybe<AccountLevelUpdate>;
  /** @deprecated Use publishUpdateAnalyticsV2 instead */
  publishUpdateAnalytics?: Maybe<AnalyticsChange>;
  publishUpdateAnalyticsV2: Scalars['Boolean']['output'];
  publishUpdateCharge?: Maybe<ItemLevelUpdate>;
  publishUpdateChargeEvents?: Maybe<ItemLevelUpdate>;
  publishUpdateCharges?: Maybe<AccountLevelUpdate>;
  publishUpdateDocuments?: Maybe<AccountLevelUpdate>;
  publishUpdateEvents?: Maybe<AccountLevelUpdate>;
  publishUpdateSubscription?: Maybe<ItemLevelUpdate>;
  publishUpdateSubscriptionEvents?: Maybe<ItemLevelUpdate>;
  publishUpdateSubscriptions?: Maybe<AccountLevelUpdate>;
  refundPayment?: Maybe<Payment>;
  registerMoneiXMerchant: SuccessResult;
  registerMoneiXPMerchant: SuccessResult;
  resetUserPassword: Scalars['String']['output'];
  resolvePibisiAlert: Pibisi;
  resolvePibisiMatch: Pibisi;
  restoreAccount: Account;
  resumeSubscription?: Maybe<Subscription>;
  retrieveAffiliateHistory?: Maybe<Scalars['Boolean']['output']>;
  sendPaymentLink?: Maybe<Payment>;
  sendPaymentReceipt?: Maybe<Payment>;
  sendPaymentRequest?: Maybe<Payment>;
  sendSubscriptionLink?: Maybe<Subscription>;
  sendSubscriptionStatus?: Maybe<Subscription>;
  startCompanyLookup: Account;
  startExportCharges: ChargesExport;
  updateAccount: Account;
  updateAccountInvoice: AccountInvoice;
  updateAffiliatePayoutMethod: Affiliate;
  updateAffiliateTier: Affiliate;
  updateAuthorizedUser?: Maybe<AuthorizedUser>;
  updateCode: Code;
  updateDocument: Document;
  updateExportSftpConfig: SftpConfigExport;
  updateIdentity: Identity;
  updateMasterAccount: MasterAccount;
  updatePibisiStatus: Pibisi;
  updatePointOfSale: PointOfSale;
  updateProvider: Provider;
  updateRepresentative: Representative;
  updateStore: Store;
  updateSubscription?: Maybe<Subscription>;
  updateUser: User;
  updateUserMasterAccount: MasterAccount;
  updateWebKeyword?: Maybe<WebKeyword>;
  updateWebhook: Webhook;
  uploadDocument: UploadFile;
  verifyId: Account;
};

export type MutationActivateSubscriptionArgs = {
  input: ActivateSubscriptionInput;
};

export type MutationAddBlacklistItemArgs = {
  input: BlacklistItemInput;
};

export type MutationApproveAccountArgs = {
  id: Scalars['ID']['input'];
  processor?: InputMaybe<Processor>;
};

export type MutationCalculateRiskScoreArgs = {
  input: CalculateRiskScoreInput;
};

export type MutationCancelPaymentArgs = {
  input: CancelPaymentInput;
};

export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};

export type MutationCapturePaymentArgs = {
  input: CapturePaymentInput;
};

export type MutationConnectMasterAccountArgs = {
  accountId: Scalars['ID']['input'];
  externalHash?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  promoCode: Scalars['String']['input'];
};

export type MutationCreateAccountInvoiceArgs = {
  input: AccountInvoiceInput;
};

export type MutationCreateAuthorizedUserArgs = {
  input: CreateAuthorizedUserInput;
};

export type MutationCreateCodeArgs = {
  input: CreateCodeInput;
};

export type MutationCreateDocumentArgs = {
  input: CreateDocumentInput;
};

export type MutationCreateExportSftpConfigArgs = {
  input: CreateExportSftpConfigInput;
};

export type MutationCreateIdentityArgs = {
  input: CreateIdentityInput;
};

export type MutationCreateMasterAccountArgs = {
  input: CreateMasterAccountInput;
};

export type MutationCreateMasterAccountApiKeyArgs = {
  input: CreateMasterAccountApiKeyInput;
};

export type MutationCreateMasterAccountUserArgs = {
  input: CreateMasterAccountUserInput;
};

export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};

export type MutationCreatePibisiUserArgs = {
  input?: InputMaybe<CreatePibisiUserInput>;
};

export type MutationCreatePointOfSaleArgs = {
  input: CreatePointOfSaleInput;
};

export type MutationCreateProviderArgs = {
  input: CreateProviderInput;
};

export type MutationCreateRepresentativeArgs = {
  input: CreateRepresentativeInput;
};

export type MutationCreateShortLinkArgs = {
  input: CreateShortLinkInput;
};

export type MutationCreateStoreArgs = {
  input: CreateStoreInput;
};

export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};

export type MutationCreateWebhookArgs = {
  input: CreateWebhookInput;
};

export type MutationDeleteAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteAuthorizedUserArgs = {
  accountId: Scalars['ID']['input'];
  userEmail: Scalars['String']['input'];
};

export type MutationDeleteBlacklistItemArgs = {
  accountId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type MutationDeleteCodeArgs = {
  input: DeleteCodeInput;
};

export type MutationDeleteDocumentArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDeleteExportSftpConfigArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDeleteIdentityArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteMasterAccountApiKeyArgs = {
  input: DeleteMasterAccountApiKeyInput;
};

export type MutationDeleteMasterAccountUserArgs = {
  accountId: Scalars['ID']['input'];
  userEmail: Scalars['String']['input'];
};

export type MutationDeletePointOfSaleArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationDeleteProviderArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteRepresentativeArgs = {
  input: DeleteRepresentativeInput;
};

export type MutationDeleteShortLinkArgs = {
  input: DeleteShortLinkInput;
};

export type MutationDeleteStoreArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDeleteWebhookArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDisableAffiliateProcessingArgs = {
  affiliateId: Scalars['ID']['input'];
};

export type MutationDisableTokenizationMethodArgs = {
  accountId: Scalars['ID']['input'];
  method: TokenizationMethods;
};

export type MutationDisableUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDisconnectMasterAccountArgs = {
  accountId: Scalars['ID']['input'];
};

export type MutationDownloadAccountInvoiceArgs = {
  accountId: Scalars['ID']['input'];
  invoiceId: Scalars['ID']['input'];
};

export type MutationDownloadAffiliateInvoiceArgs = {
  affiliateId: Scalars['String']['input'];
  invoiceNumber: Scalars['String']['input'];
  year?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDownloadCapitalLoanDocumentArgs = {
  accountId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  loanId: Scalars['ID']['input'];
};

export type MutationDownloadContractArgs = {
  accountId: Scalars['ID']['input'];
};

export type MutationDownloadDocumentArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDownloadExportArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDownloadOperationsFileArgs = {
  accountId: Scalars['ID']['input'];
  settlementId: Scalars['ID']['input'];
};

export type MutationEnableAffiliateProcessingArgs = {
  affiliateId: Scalars['ID']['input'];
};

export type MutationEnableTokenizationMethodArgs = {
  accountId: Scalars['ID']['input'];
  method: TokenizationMethods;
};

export type MutationEnableUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationExportChargesArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<SearchableChargeFilterInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type MutationGenerateOffersByAccountArgs = {
  accountId: Scalars['ID']['input'];
};

export type MutationGenerateSettlementReportArgs = {
  input: GenerateSettlementReportInput;
};

export type MutationGetRepresentativesArgs = {
  accountId: Scalars['ID']['input'];
};

export type MutationImpersonateArgs = {
  input: ImpersonateInput;
};

export type MutationPauseSubscriptionArgs = {
  input: PauseSubscriptionInput;
};

export type MutationPublishUpdateAccountArgs = {
  accountId: Scalars['ID']['input'];
};

export type MutationPublishUpdateAnalyticsArgs = {
  all: Scalars['Boolean']['input'];
};

export type MutationPublishUpdateChargeArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationPublishUpdateChargeEventsArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationPublishUpdateChargesArgs = {
  accountId: Scalars['ID']['input'];
};

export type MutationPublishUpdateDocumentsArgs = {
  accountId: Scalars['ID']['input'];
};

export type MutationPublishUpdateEventsArgs = {
  accountId: Scalars['ID']['input'];
};

export type MutationPublishUpdateSubscriptionArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationPublishUpdateSubscriptionEventsArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationPublishUpdateSubscriptionsArgs = {
  accountId: Scalars['ID']['input'];
};

export type MutationRefundPaymentArgs = {
  input: RefundPaymentInput;
};

export type MutationRegisterMoneiXMerchantArgs = {
  cardPresent?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationRegisterMoneiXpMerchantArgs = {
  accountId: Scalars['ID']['input'];
  paymentMethods?: InputMaybe<Array<InputMaybe<PaymentMethods>>>;
};

export type MutationResetUserPasswordArgs = {
  temporalPassword?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type MutationResolvePibisiAlertArgs = {
  input?: InputMaybe<ResolvePibisiAlertInput>;
};

export type MutationResolvePibisiMatchArgs = {
  input?: InputMaybe<ResolvePibisiMatchInput>;
};

export type MutationRestoreAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationResumeSubscriptionArgs = {
  input: ResumeSubscriptionInput;
};

export type MutationRetrieveAffiliateHistoryArgs = {
  affiliateId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSendPaymentLinkArgs = {
  input: SendPaymentMessageInput;
};

export type MutationSendPaymentReceiptArgs = {
  input: SendPaymentMessageInput;
};

export type MutationSendPaymentRequestArgs = {
  input: SendPaymentRequestInput;
};

export type MutationSendSubscriptionLinkArgs = {
  input: SendSubscriptionMessageInput;
};

export type MutationSendSubscriptionStatusArgs = {
  input: SendSubscriptionMessageInput;
};

export type MutationStartCompanyLookupArgs = {
  accountId: Scalars['ID']['input'];
  documentNumber: Scalars['String']['input'];
};

export type MutationStartExportChargesArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<SearchableChargeFilterInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};

export type MutationUpdateAccountInvoiceArgs = {
  input: UpdateAccountInvoiceInput;
};

export type MutationUpdateAffiliatePayoutMethodArgs = {
  input: UpdateAffiliatePayoutMethodInput;
};

export type MutationUpdateAffiliateTierArgs = {
  input: UpdateAffiliateTierInput;
};

export type MutationUpdateAuthorizedUserArgs = {
  input: UpdateAuthorizedUserInput;
};

export type MutationUpdateCodeArgs = {
  input: UpdateCodeInput;
};

export type MutationUpdateDocumentArgs = {
  input: UpdateDocumentInput;
};

export type MutationUpdateExportSftpConfigArgs = {
  input: UpdateExportSftpConfigInput;
};

export type MutationUpdateIdentityArgs = {
  input: UpdateIdentityInput;
};

export type MutationUpdateMasterAccountArgs = {
  input: UpdateMasterAccountInput;
};

export type MutationUpdatePibisiStatusArgs = {
  input?: InputMaybe<UpdatePibisiStatusInput>;
};

export type MutationUpdatePointOfSaleArgs = {
  input: UpdatePointOfSaleInput;
};

export type MutationUpdateProviderArgs = {
  input: UpdateProviderInput;
};

export type MutationUpdateRepresentativeArgs = {
  input: UpdateRepresentativeInput;
};

export type MutationUpdateStoreArgs = {
  input: UpdateStoreInput;
};

export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};

export type MutationUpdateUserArgs = {
  input: UserInput;
};

export type MutationUpdateUserMasterAccountArgs = {
  input: UpdateUserMasterAccountInput;
};

export type MutationUpdateWebKeywordArgs = {
  input: UpdateWebKeywordInput;
};

export type MutationUpdateWebhookArgs = {
  input: UpdateWebhookInput;
};

export type MutationUploadDocumentArgs = {
  accountId: Scalars['ID']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationVerifyIdArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['Int']['input'];
};

export type NextAction = {
  __typename?: 'NextAction';
  mustRedirect?: Maybe<Scalars['Boolean']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<NextActionTypes>;
};

export enum NextActionTypes {
  BIZUM_CHALLENGE = 'BIZUM_CHALLENGE',
  CHALLENGE = 'CHALLENGE',
  COMPLETE = 'COMPLETE',
  CONFIRM = 'CONFIRM',
  FRICTIONLESS_CHALLENGE = 'FRICTIONLESS_CHALLENGE'
}

export enum Partner {
  ACTIVE_MERCHANT = 'ACTIVE_MERCHANT',
  SHOPIFY = 'SHOPIFY',
  V1 = 'V1'
}

export type PauseSubscriptionInput = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  pauseAtPeriodEnd?: InputMaybe<Scalars['Boolean']['input']>;
  pauseIntervalCount: Scalars['Int']['input'];
};

export type Payment = {
  __typename?: 'Payment';
  accountId: Scalars['ID']['output'];
  amount?: Maybe<Scalars['Int']['output']>;
  amountEUR?: Maybe<Scalars['Int']['output']>;
  authorizationCode?: Maybe<Scalars['String']['output']>;
  billingDetails?: Maybe<ContactDetails>;
  cancellationReason?: Maybe<CancellationReason>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  currency: Scalars['String']['output'];
  customer?: Maybe<Customer>;
  description?: Maybe<Scalars['String']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastRefundAmount?: Maybe<Scalars['Int']['output']>;
  lastRefundReason?: Maybe<RefundReason>;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  masterAccountId?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Array<KeyValueItem>>;
  nextAction?: Maybe<NextAction>;
  orderId?: Maybe<Scalars['ID']['output']>;
  pageOpenedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentToken?: Maybe<Scalars['String']['output']>;
  pointOfSaleId?: Maybe<Scalars['ID']['output']>;
  refundedAmount?: Maybe<Scalars['Int']['output']>;
  sequenceId?: Maybe<Scalars['ID']['output']>;
  sessionDetails?: Maybe<SessionDetails>;
  shippingDetails?: Maybe<ContactDetails>;
  shop?: Maybe<Shop>;
  status: PaymentStatus;
  statusCode?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  storeId?: Maybe<Scalars['ID']['output']>;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  traceDetails?: Maybe<TraceDetails>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export enum PaymentEmailType {
  PAYMENT_LINK = 'PAYMENT_LINK',
  RECEIPT = 'RECEIPT'
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  bizum?: Maybe<PaymentMethodBizum>;
  card?: Maybe<PaymentMethodCard>;
  cardPresent?: Maybe<PaymentMethodCardPresent>;
  cofidis?: Maybe<PaymentMethodCofidis>;
  cofidisLoan?: Maybe<PaymentMethodCofidisLoan>;
  klarna?: Maybe<PaymentMethodKlarna>;
  mbway?: Maybe<PaymentMethodMbWay>;
  method?: Maybe<PaymentMethods>;
  paypal?: Maybe<PaymentMethodPaypal>;
  sepa?: Maybe<PaymentMethodSepa>;
  trustly?: Maybe<PaymentMethodTrustly>;
};

export type PaymentMethodBizum = {
  __typename?: 'PaymentMethodBizum';
  ibanLast4?: Maybe<Scalars['String']['output']>;
  idBizum?: Maybe<Scalars['String']['output']>;
  integrationType?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  remember?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentMethodCard = {
  __typename?: 'PaymentMethodCard';
  bank?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<CardBrand>;
  cardholderEmail?: Maybe<Scalars['String']['output']>;
  cardholderName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  expiration?: Maybe<Scalars['Long']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  srcCorrelationId?: Maybe<Scalars['ID']['output']>;
  srcDpaId?: Maybe<Scalars['ID']['output']>;
  srciTransactionId?: Maybe<Scalars['ID']['output']>;
  threeDSecure?: Maybe<Scalars['Boolean']['output']>;
  threeDSecureFlow?: Maybe<ThreeDSecureFlow>;
  threeDSecureStatus?: Maybe<ThreeDsStatus>;
  threeDSecureVersion?: Maybe<Scalars['String']['output']>;
  tokenizationMethod?: Maybe<TokenizationMethods>;
  type?: Maybe<CardType>;
};

export type PaymentMethodCardPresent = {
  __typename?: 'PaymentMethodCardPresent';
  bin?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<CardBrand>;
  cardholderEmail?: Maybe<Scalars['String']['output']>;
  cardholderName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  expiration?: Maybe<Scalars['Long']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CardType>;
  verificationMethod?: Maybe<VerificationMethod>;
};

export type PaymentMethodCofidis = {
  __typename?: 'PaymentMethodCofidis';
  orderId?: Maybe<Scalars['ID']['output']>;
};

export type PaymentMethodCofidisLoan = {
  __typename?: 'PaymentMethodCofidisLoan';
  orderId?: Maybe<Scalars['ID']['output']>;
};

export type PaymentMethodKlarna = {
  __typename?: 'PaymentMethodKlarna';
  authPaymentMethod?: Maybe<AuthPaymentMethodKlarna>;
  billingCategory?: Maybe<BillingCategoryKlarna>;
};

export type PaymentMethodMbWay = {
  __typename?: 'PaymentMethodMBWay';
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodPaypal = {
  __typename?: 'PaymentMethodPaypal';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  payerId?: Maybe<Scalars['ID']['output']>;
};

export type PaymentMethodSepa = {
  __typename?: 'PaymentMethodSepa';
  accountholderAddress?: Maybe<Address>;
  accountholderEmail?: Maybe<Scalars['String']['output']>;
  accountholderName?: Maybe<Scalars['String']['output']>;
  bankAddress?: Maybe<Scalars['String']['output']>;
  bankCode?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodTrustly = {
  __typename?: 'PaymentMethodTrustly';
  customerId?: Maybe<Scalars['ID']['output']>;
};

export enum PaymentMethods {
  ALIPAY = 'alipay',
  APPLEPAY = 'applePay',
  BANCONTACT = 'bancontact',
  BIZUM = 'bizum',
  BLIK = 'blik',
  CARD = 'card',
  CARDPRESENT = 'cardPresent',
  CLICKTOPAY = 'clickToPay',
  COFIDIS = 'cofidis',
  COFIDISLOAN = 'cofidisLoan',
  EPS = 'eps',
  GIROPAY = 'giropay',
  GOOGLEPAY = 'googlePay',
  IDEAL = 'iDeal',
  KLARNA = 'klarna',
  MBWAY = 'mbway',
  MULTIBANCO = 'multibanco',
  PAYPAL = 'paypal',
  SEPA = 'sepa',
  SOFORT = 'sofort',
  SRTP = 'srtp',
  TRUSTLY = 'trustly'
}

export enum PaymentStatus {
  AUTHORIZED = 'AUTHORIZED',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  PAID_OUT = 'PAID_OUT',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  PENDING = 'PENDING',
  PENDING_PROCESSING = 'PENDING_PROCESSING',
  REFUNDED = 'REFUNDED',
  SUCCEEDED = 'SUCCEEDED'
}

export type Pibisi = {
  __typename?: 'Pibisi';
  alerts?: Maybe<Array<Maybe<PibisiAlert>>>;
  alertsId?: Maybe<Scalars['String']['output']>;
  alertsStatus?: Maybe<PibisiMatchStatus>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  matches?: Maybe<Array<Maybe<PibisiMatch>>>;
  status?: Maybe<PibisiStatus>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PibisiAccount = {
  __typename?: 'PibisiAccount';
  alerts?: Maybe<Array<Maybe<PibisiAlert>>>;
  alertsId?: Maybe<Scalars['String']['output']>;
  alertsStatus?: Maybe<PibisiMatchStatus>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  matches?: Maybe<Array<Maybe<PibisiMatch>>>;
  status?: Maybe<PibisiStatus>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum PibisiAction {
  ACCEPT = 'accept',
  REJECT = 'reject'
}

export type PibisiAlert = {
  __typename?: 'PibisiAlert';
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  status: PibisiAlertStatus;
  type?: Maybe<PibisiAlertTypes>;
};

export type PibisiAlertInput = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PibisiAlertStatus>;
  type?: InputMaybe<PibisiAlertTypes>;
};

export enum PibisiAlertStatus {
  ACCEPTED = 'accepted',
  MONITORED = 'monitored',
  PENDING = 'pending',
  REJECTED = 'rejected'
}

export enum PibisiAlertTypes {
  HAS_MATCHES = 'has_matches',
  HAS_MEDIA = 'has_media',
  INFO_ID_EXPIRED = 'info_id_expired',
  INFO_ID_EXPIRED_NOTICE = 'info_id_expired_notice',
  IS_HIGH_RISK = 'is_high_risk',
  IS_PEP = 'is_pep',
  IS_SANCTIONED = 'is_sanctioned',
  IS_TERRORIST = 'is_terrorist',
  POSSIBLY_INCOMPLETE_NAME = 'possibly_incomplete_name',
  WAS_HIGH_RISK = 'was_high_risk',
  WAS_PEP = 'was_pep'
}

export type PibisiContent = {
  __typename?: 'PibisiContent';
  action?: Maybe<Scalars['String']['output']>;
  charge?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  issue?: Maybe<Scalars['String']['output']>;
  issuer?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PibisiContentInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  charge?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  issue?: InputMaybe<Scalars['String']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PibisiEvent = {
  __typename?: 'PibisiEvent';
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  object: PibisiEventObject;
  objectId: Scalars['ID']['output'];
  objectType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PibisiEventObject = {
  __typename?: 'PibisiEventObject';
  createdAt: Scalars['AWSTimestamp']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  status: PibisiStatus;
  traceDetails?: Maybe<TraceDetails>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type PibisiEventsConnection = {
  __typename?: 'PibisiEventsConnection';
  items: Array<PibisiEvent>;
  total: Scalars['Int']['output'];
};

export type PibisiFlag = {
  __typename?: 'PibisiFlag';
  content?: Maybe<PibisiContent>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PibisiFlagInput = {
  content?: InputMaybe<PibisiContentInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PibisiInput = {
  alerts?: InputMaybe<Array<InputMaybe<PibisiAlertInput>>>;
  alertsId?: InputMaybe<Scalars['String']['input']>;
  alertsStatus?: InputMaybe<PibisiMatchStatus>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  matches?: InputMaybe<Array<InputMaybe<PibisiMatchInput>>>;
  status?: InputMaybe<PibisiStatus>;
};

export type PibisiMatch = {
  __typename?: 'PibisiMatch';
  adverseInfo?: Maybe<Array<Maybe<PibisiFlag>>>;
  highRisk?: Maybe<Array<Maybe<PibisiFlag>>>;
  id: Scalars['ID']['output'];
  matches?: Maybe<Array<Maybe<PibisiFlag>>>;
  media?: Maybe<Array<Maybe<PibisiFlag>>>;
  pep?: Maybe<Array<Maybe<PibisiFlag>>>;
  sanctioned?: Maybe<Array<Maybe<PibisiFlag>>>;
  status: PibisiMatchStatus;
  terrorist?: Maybe<Array<Maybe<PibisiFlag>>>;
};

export type PibisiMatchInput = {
  adverseInfo?: InputMaybe<Array<InputMaybe<PibisiFlagInput>>>;
  highRisk?: InputMaybe<Array<InputMaybe<PibisiFlagInput>>>;
  id: Scalars['ID']['input'];
  matches?: InputMaybe<Array<InputMaybe<PibisiFlagInput>>>;
  media?: InputMaybe<Array<InputMaybe<PibisiFlagInput>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  pep?: InputMaybe<Array<InputMaybe<PibisiFlagInput>>>;
  sanction?: InputMaybe<Array<InputMaybe<PibisiFlagInput>>>;
  status?: InputMaybe<PibisiMatchStatus>;
  terrorist?: InputMaybe<Array<InputMaybe<PibisiFlagInput>>>;
};

export enum PibisiMatchStatus {
  ACCEPTED = 'accepted',
  PENDING = 'pending',
  REJECTED = 'rejected'
}

export enum PibisiStatus {
  PENDING_TO_VERIFY = 'PENDING_TO_VERIFY',
  REJECTED = 'REJECTED',
  UNDER_REVIEW = 'UNDER_REVIEW',
  VERIFIED = 'VERIFIED'
}

export type PointOfSale = {
  __typename?: 'PointOfSale';
  accountId: Scalars['ID']['output'];
  currentPaymentId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fixedAmount?: Maybe<Scalars['Int']['output']>;
  fixedCurrency?: Maybe<Currencies>;
  id: Scalars['ID']['output'];
  includeQRCode?: Maybe<Scalars['Boolean']['output']>;
  manualAmount?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  paymentCallbackUrl?: Maybe<Scalars['String']['output']>;
  paymentMethods?: Maybe<Array<PaymentMethods>>;
  pendingSetup?: Maybe<Scalars['Boolean']['output']>;
  qrCodeText?: Maybe<Scalars['String']['output']>;
  requireEmail?: Maybe<Scalars['Boolean']['output']>;
  requireTaxId?: Maybe<Scalars['Boolean']['output']>;
  storeId?: Maybe<Scalars['ID']['output']>;
  terminalId?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<TransactionTypes>;
  type?: Maybe<PointOfSaleType>;
};

/**
 *  Type of Point of Sale determining its capabilities and purpose.
 * - `VIRTUAL` - **Default**. For grouping transactions and restricting user access. No payment hardware required. Payments inherit this POS ID when created by assigned users via API or MONEI Pay app.
 * - `QR_CODE` - Generates QR codes for accepting payments at physical locations. Supports fixed or manual amounts, custom payment methods, and customer requirements.
 * - `MONEI_PAY` - Tap-to-phone payments using the MONEI Pay app on Android or iOS devices.
 * - `MONEI_POD` - Bizum MONEI POD physical device for Bizum QR payments.
 */
export enum PointOfSaleType {
  MONEI_PAY = 'MONEI_PAY',
  MONEI_POD = 'MONEI_POD',
  QR_CODE = 'QR_CODE',
  VIRTUAL = 'VIRTUAL'
}

export type PointsOfSaleConnection = {
  __typename?: 'PointsOfSaleConnection';
  items: Array<PointOfSale>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export enum Processor {
  ADYEN = 'ADYEN',
  COFIDIS = 'COFIDIS',
  MONEIX_F = 'MONEIX_F',
  MONEIX_G = 'MONEIX_G',
  MONEIX_GNET = 'MONEIX_GNET',
  MONEIX_P = 'MONEIX_P',
  MONEIX_S = 'MONEIX_S',
  MONEI_REDSYS = 'MONEI_REDSYS',
  MONEI_X = 'MONEI_X',
  PAYPAL = 'PAYPAL',
  REDSYS = 'REDSYS',
  STRIPE = 'STRIPE',
  TEST_BIZUM = 'TEST_BIZUM',
  TEST_CARD = 'TEST_CARD'
}

export type Provider = {
  __typename?: 'Provider';
  acquirer?: Maybe<Acquirer>;
  configurable?: Maybe<Scalars['Boolean']['output']>;
  currencies?: Maybe<Array<Currencies>>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Array<MetadataItem>>;
  nativeHostedPayment?: Maybe<Scalars['Boolean']['output']>;
  paymentMethod?: Maybe<PaymentMethods>;
  processor?: Maybe<Processor>;
  rules?: Maybe<ProviderRules>;
  test?: Maybe<Scalars['Boolean']['output']>;
};

export type ProviderConfig = {
  __typename?: 'ProviderConfig';
  acquirers?: Maybe<Array<Acquirer>>;
  metadataConfig?: Maybe<Array<MetadataConfigItem>>;
  paymentMethod?: Maybe<PaymentMethods>;
  processor?: Maybe<Processor>;
};

export type ProviderEvent = {
  __typename?: 'ProviderEvent';
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  object: ProviderEventObject;
  objectId: Scalars['ID']['output'];
  objectType: Scalars['String']['output'];
  traceDetails?: Maybe<TraceDetails>;
  type: Scalars['String']['output'];
};

export type ProviderEventObject = {
  __typename?: 'ProviderEventObject';
  acquirer?: Maybe<Acquirer>;
  configurable?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  internalId?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Array<ProviderMetadataItem>>;
  nativeHostedPayment?: Maybe<Scalars['Boolean']['output']>;
  paymentMethod?: Maybe<PaymentMethods>;
  processor?: Maybe<Processor>;
  rules?: Maybe<ProviderRules>;
  test?: Maybe<Scalars['Boolean']['output']>;
  traceDetails?: Maybe<TraceDetails>;
};

export type ProviderEventsConnection = {
  __typename?: 'ProviderEventsConnection';
  items: Array<ProviderEvent>;
  total: Scalars['Int']['output'];
};

export type ProviderMetadataItem = {
  __typename?: 'ProviderMetadataItem';
  key: Scalars['String']['output'];
  value?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProviderRules = {
  __typename?: 'ProviderRules';
  descriptionLike?: Maybe<Scalars['String']['output']>;
  maxAmount?: Maybe<Scalars['Int']['output']>;
  minAmount?: Maybe<Scalars['Int']['output']>;
  shopNameLike?: Maybe<Scalars['String']['output']>;
};

export type ProviderRulesInput = {
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  maxAmount?: InputMaybe<Scalars['Int']['input']>;
  minAmount?: InputMaybe<Scalars['Int']['input']>;
  shopNameLike?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  accountActualFees?: Maybe<AccountActualFees>;
  accountBalances: AccountBalancesConnection;
  accountEvents: AccountEventsConnection;
  accountInvoices: InvoicesConnection;
  accountStats: AccountStats;
  accountTags: Array<Scalars['String']['output']>;
  accounts: AccountsConnection;
  adminUser: AdminUser;
  adminUserEvents: AdminUserEventsConnection;
  adminUsers: AdminUsersConnection;
  affiliate: Affiliate;
  affiliateInvoices: AffiliateInvoiceConnection;
  affiliateMerchants: AffiliateMerchantConnection;
  affiliatePayoutMethods: Array<AffiliatePayoutMethod>;
  affiliates: AffiliateConnection;
  authorizedUsers: AuthorizedUsersConnection;
  availablePaymentMethods?: Maybe<Array<AvailablePaymentMethod>>;
  availableProcessors?: Maybe<Array<AvailableProcessor>>;
  blacklistItem?: Maybe<BlacklistItem>;
  blacklistItems: BlacklistItemsConnection;
  /**  Get MONEI Capital data (offer and lead) for an account */
  capitalDataByAccount?: Maybe<CapitalAccountData>;
  /**  Get a specific MONEI Capital loan by ID */
  capitalLoan?: Maybe<CapitalLoanDetails>;
  /**
   *  Get a MONEI Capital loan document URL (deprecated alias)
   * @deprecated Use downloadCapitalLoanDocument mutation; will be removed after migration window
   */
  capitalLoanDocument: DownloadFile;
  /**  Get MONEI Capital loan repayments */
  capitalLoanRepayments: CapitalLoanRepaymentsConnection;
  /**  Get MONEI Capital loans for an account */
  capitalLoans: CapitalLoansConnection;
  /**  Get MONEI Capital onboarding details for an account */
  capitalOnboardingDetails?: Maybe<CapitalOnboardingDetailsDashboard>;
  charge?: Maybe<Charge>;
  chargeEvents: ChargeEventsConnection;
  chargeSources: Array<Scalars['String']['output']>;
  charges: ChargesConnection;
  chargesDateRangeKPI: ChargesDateRangeKpi;
  chargesExport?: Maybe<ChargesExport>;
  chargesExports: ChargesExportsConnection;
  code?: Maybe<Code>;
  codes: Array<Code>;
  countries: Countries;
  document?: Maybe<Document>;
  documentEvents: DocumentEventsConnection;
  documents: DocumentsConnection;
  events: ChargeEventsConnection;
  exportSftpConfig: SftpConfigExport;
  exportSftpConfigs: SftpConfigExportsConnection;
  identities: IdentitiesConnection;
  identity?: Maybe<Identity>;
  identityDocuments: DocumentsConnection;
  masterAccount?: Maybe<MasterAccount>;
  masterAccountActualFees?: Maybe<MasterAccountActualFees>;
  masterAccountEvents: MasterAccountEventsConnection;
  masterAccountInvoices: MasterAccountInvoicesConnection;
  masterAccounts: MasterAccountsConnection;
  notificationsPortalUrl?: Maybe<Redirect>;
  pibisiEvents: PibisiEventsConnection;
  pibisiUsers: Array<PibisiAccount>;
  pointOfSale?: Maybe<PointOfSale>;
  pointsOfSale: PointsOfSaleConnection;
  previewPaymentEmail?: Maybe<Scalars['String']['output']>;
  previewSubscriptionEmail?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  providerConfig?: Maybe<ProviderConfig>;
  providerEvents: ProviderEventsConnection;
  providers?: Maybe<Array<Provider>>;
  representative?: Maybe<Representative>;
  representatives: RepresentativesConnection;
  restrictedKeywords?: Maybe<Array<Scalars['String']['output']>>;
  settlementEvents: SettlementEventsConnection;
  settlements: SettlementsConnection;
  shortLink?: Maybe<ShortLink>;
  store?: Maybe<Store>;
  storeEvents: StoreEventsConnection;
  stores: StoresConnection;
  subscription?: Maybe<Subscription>;
  subscriptionEvents: SubscriptionEventsConnection;
  subscriptions: SubscriptionsConnection;
  user?: Maybe<User>;
  userMasterAccount?: Maybe<MasterAccount>;
  users: UsersConnection;
  webKeywords: WebKeywordsConnection;
  webReport?: Maybe<WebReport>;
  webhooks: WebhooksConnection;
};

export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAccountActualFeesArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAccountBalancesArgs = {
  accountId: Scalars['ID']['input'];
};

export type QueryAccountEventsArgs = {
  accountId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryAccountInvoicesArgs = {
  filter?: InputMaybe<SearchableInvoiceFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryAccountStatsArgs = {
  accountId: Scalars['ID']['input'];
};

export type QueryAccountsArgs = {
  filter?: InputMaybe<SearchableAccountFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryAdminUserArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAdminUserEventsArgs = {
  input: AdminUserEventsInput;
};

export type QueryAdminUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAffiliateArgs = {
  affiliateId: Scalars['ID']['input'];
};

export type QueryAffiliateInvoicesArgs = {
  taxId: Scalars['String']['input'];
};

export type QueryAffiliateMerchantsArgs = {
  input?: InputMaybe<AffiliateMerchantInput>;
};

export type QueryAffiliatePayoutMethodsArgs = {
  affiliateId: Scalars['ID']['input'];
};

export type QueryAffiliatesArgs = {
  input?: InputMaybe<AffiliateInput>;
};

export type QueryAuthorizedUsersArgs = {
  accountId: Scalars['ID']['input'];
};

export type QueryAvailablePaymentMethodsArgs = {
  accountId: Scalars['ID']['input'];
};

export type QueryAvailableProcessorsArgs = {
  accountId: Scalars['ID']['input'];
  paymentMethod: PaymentMethods;
};

export type QueryBlacklistItemArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  value: Scalars['String']['input'];
};

export type QueryBlacklistItemsArgs = {
  accountId: Scalars['ID']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BlacklistItemType>;
};

export type QueryCapitalDataByAccountArgs = {
  accountId: Scalars['ID']['input'];
};

export type QueryCapitalLoanArgs = {
  accountId: Scalars['ID']['input'];
  loanId: Scalars['ID']['input'];
};

export type QueryCapitalLoanDocumentArgs = {
  accountId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  loanId: Scalars['ID']['input'];
};

export type QueryCapitalLoanRepaymentsArgs = {
  accountId: Scalars['ID']['input'];
  loanId: Scalars['ID']['input'];
};

export type QueryCapitalLoansArgs = {
  accountId: Scalars['ID']['input'];
};

export type QueryCapitalOnboardingDetailsArgs = {
  accountId: Scalars['ID']['input'];
};

export type QueryChargeArgs = {
  id: Scalars['ID']['input'];
};

export type QueryChargeEventsArgs = {
  chargeId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryChargesArgs = {
  filter?: InputMaybe<SearchableChargeFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryChargesDateRangeKpiArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  acquirer?: InputMaybe<Acquirer>;
  billingPlan?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currencies>;
  end?: InputMaybe<Scalars['Int']['input']>;
  interval?: InputMaybe<Interval>;
  masterAccountId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod?: InputMaybe<PaymentMethods>;
  source?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type QueryChargesExportArgs = {
  id: Scalars['ID']['input'];
};

export type QueryChargesExportsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCodeArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCodesArgs = {
  accountId: Scalars['ID']['input'];
  pointOfSaleId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDocumentArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type QueryDocumentEventsArgs = {
  documentId: Scalars['ID']['input'];
};

export type QueryDocumentsArgs = {
  accountId: Scalars['ID']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEventsArgs = {
  filter?: InputMaybe<SearchableEventFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryExportSftpConfigArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type QueryExportSftpConfigsArgs = {
  accountId: Scalars['ID']['input'];
};

export type QueryIdentitiesArgs = {
  filter?: InputMaybe<SearchableIdentityFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryIdentityArgs = {
  id: Scalars['ID']['input'];
};

export type QueryIdentityDocumentsArgs = {
  identityId: Scalars['ID']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMasterAccountArgs = {
  id: Scalars['ID']['input'];
};

export type QueryMasterAccountActualFeesArgs = {
  id: Scalars['ID']['input'];
};

export type QueryMasterAccountEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  masterAccountId: Scalars['ID']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryMasterAccountInvoicesArgs = {
  masterAccountId: Scalars['ID']['input'];
};

export type QueryMasterAccountsArgs = {
  filter?: InputMaybe<SearchableMasterAccountFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryNotificationsPortalUrlArgs = {
  accountId: Scalars['ID']['input'];
};

export type QueryPibisiEventsArgs = {
  pibisiId: Scalars['ID']['input'];
};

export type QueryPibisiUsersArgs = {
  accountId: Scalars['ID']['input'];
};

export type QueryPointOfSaleArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type QueryPointsOfSaleArgs = {
  accountId: Scalars['ID']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPreviewPaymentEmailArgs = {
  accountId: Scalars['ID']['input'];
  emailType?: InputMaybe<PaymentEmailType>;
  language?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['ID']['input'];
};

export type QueryPreviewSubscriptionEmailArgs = {
  accountId: Scalars['ID']['input'];
  emailType?: InputMaybe<SubscriptionEmailType>;
  language?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type QueryProviderArgs = {
  id: Scalars['ID']['input'];
};

export type QueryProviderConfigArgs = {
  paymentMethod: PaymentMethods;
  processor: Processor;
};

export type QueryProviderEventsArgs = {
  accountId: Scalars['ID']['input'];
  providerId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryProvidersArgs = {
  accountId: Scalars['ID']['input'];
};

export type QueryRepresentativeArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type QueryRepresentativesArgs = {
  accountId: Scalars['ID']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySettlementEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  settlementId: Scalars['ID']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySettlementsArgs = {
  filter?: InputMaybe<SearchableSettlementFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryShortLinkArgs = {
  accountId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};

export type QueryStoreArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type QueryStoreEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  storeId: Scalars['ID']['input'];
};

export type QueryStoresArgs = {
  accountId: Scalars['ID']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySubscriptionArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySubscriptionEventsArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type QuerySubscriptionsArgs = {
  filter?: InputMaybe<SearchableSubscriptionFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};

export type QueryUsersArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type QueryWebKeywordsArgs = {
  baseUrl: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type QueryWebReportArgs = {
  baseUrl: Scalars['String']['input'];
};

export type QueryWebhooksArgs = {
  accountId: Scalars['ID']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type Redirect = {
  __typename?: 'Redirect';
  redirectUrl: Scalars['String']['output'];
};

export type RefundPaymentInput = {
  accountId: Scalars['ID']['input'];
  amount: Scalars['Int']['input'];
  paymentId: Scalars['ID']['input'];
  refundReason?: InputMaybe<RefundReason>;
};

export enum RefundReason {
  DUPLICATED = 'duplicated',
  FRAUDULENT = 'fraudulent',
  ORDER_CANCELED = 'order_canceled',
  REQUESTED_BY_CUSTOMER = 'requested_by_customer'
}

export type RegistryRecord = {
  __typename?: 'RegistryRecord';
  date?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Representative = {
  __typename?: 'Representative';
  accountId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identityId?: Maybe<Scalars['ID']['output']>;
  interventionType?: Maybe<Array<InterventionType>>;
  main?: Maybe<Scalars['Boolean']['output']>;
  sepblacRegistered?: Maybe<Scalars['Boolean']['output']>;
  stocksPercentage?: Maybe<Scalars['Int']['output']>;
  traceDetails?: Maybe<TraceDetails>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type RepresentativeData = {
  __typename?: 'RepresentativeData';
  address?: Maybe<Address>;
  citizenship?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  document?: Maybe<IdDocument>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  hasNoPublicActivity?: Maybe<Scalars['Boolean']['output']>;
  idSession?: Maybe<Scalars['String']['output']>;
  idSessionUrl?: Maybe<Scalars['String']['output']>;
  interventionType?: Maybe<Array<InterventionType>>;
  lastName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pibisi?: Maybe<Pibisi>;
  pibisiId?: Maybe<Scalars['ID']['output']>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  registeredAt?: Maybe<Scalars['String']['output']>;
  riskLabels?: Maybe<Array<RiskLabel>>;
  status?: Maybe<IdVerificationStatus>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  stocksPercentage?: Maybe<Scalars['Float']['output']>;
  yearOfBirth?: Maybe<Scalars['String']['output']>;
};

export type RepresentativeDataInput = {
  address?: InputMaybe<AddressInput>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['String']['input']>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  interventionType?: InputMaybe<Array<InterventionType>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pibisi?: InputMaybe<PibisiInput>;
  registeredAt?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<IdVerificationStatus>;
  stocksPercentage?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth?: InputMaybe<Scalars['String']['input']>;
};

export type RepresentativesConnection = {
  __typename?: 'RepresentativesConnection';
  items: Array<Representative>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ResolvePibisiAlertInput = {
  accountId: Scalars['ID']['input'];
  action: PibisiAction;
  alertId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type ResolvePibisiMatchInput = {
  accountId: Scalars['ID']['input'];
  action: PibisiAction;
  customerId: Scalars['ID']['input'];
  matchId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type ResumeSubscriptionInput = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

/**  Subscription retry interval can only be set to minute and hour in test mode */
export enum RetryIntervalInput {
  DAY = 'day',
  HOUR = 'hour',
  MINUTE = 'minute',
  MONTH = 'month',
  QUARTER = 'quarter',
  WEEK = 'week',
  YEAR = 'year'
}

export type RetrySchedule = {
  __typename?: 'RetrySchedule';
  interval: Interval;
  intervalCount: Scalars['Int']['output'];
};

export type RetryScheduleInput = {
  interval: RetryIntervalInput;
  intervalCount: Scalars['Int']['input'];
};

export type RiskLabel = {
  __typename?: 'RiskLabel';
  category?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  riskScore?: Maybe<Scalars['Int']['output']>;
};

export enum RiskProfile {
  HIGH_RISK = 'HIGH_RISK',
  LOW_RISK = 'LOW_RISK',
  MEDIUM_RISK = 'MEDIUM_RISK',
  PROCESSING = 'PROCESSING'
}

export type S3ObjectInput = {
  bucket: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
};

export enum SalesExecutive {
  ALEX_SAIZ = 'ALEX_SAIZ',
  BERTA_GIRBAU = 'BERTA_GIRBAU',
  CARLA_GIRBAU = 'CARLA_GIRBAU',
  GERARD_HERNANDEZ = 'GERARD_HERNANDEZ',
  JOAN_ASENSIO = 'JOAN_ASENSIO',
  SELF_SERVED = 'SELF_SERVED'
}

export type SearchableAccountFilterInput = {
  accountExecutive?: InputMaybe<SearchableStringFilterInput>;
  adminEmail?: InputMaybe<SearchableStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableAccountFilterInput>>>;
  apiKey?: InputMaybe<SearchableStringFilterInput>;
  billingPlan?: InputMaybe<SearchableStringFilterInput>;
  blocked?: InputMaybe<SearchableBooleanFilterInput>;
  businessCompanyName?: InputMaybe<SearchableStringFilterInput>;
  businessCountry?: InputMaybe<SearchableStringFilterInput>;
  businessDocumentNumber?: InputMaybe<SearchableStringFilterInput>;
  businessEmail?: InputMaybe<SearchableStringFilterInput>;
  businessLegalName?: InputMaybe<SearchableStringFilterInput>;
  businessWebsite?: InputMaybe<SearchableStringFilterInput>;
  churned?: InputMaybe<SearchableBooleanFilterInput>;
  dynamicBilling?: InputMaybe<SearchableBooleanFilterInput>;
  fraudDetectorEnabled?: InputMaybe<SearchableBooleanFilterInput>;
  fraudRulesEnabled?: InputMaybe<SearchableBooleanFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  masterAccountId?: InputMaybe<SearchableStringFilterInput>;
  name?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableAccountFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableAccountFilterInput>>>;
  payoutTermsSuspended?: InputMaybe<SearchableBooleanFilterInput>;
  progressiveBilling?: InputMaybe<SearchableBooleanFilterInput>;
  promoCode?: InputMaybe<SearchableStringFilterInput>;
  referralCode?: InputMaybe<SearchableStringFilterInput>;
  representativeDocumentNumber?: InputMaybe<SearchableStringFilterInput>;
  representativeName?: InputMaybe<SearchableStringFilterInput>;
  riskProfile?: InputMaybe<SearchableStringFilterInput>;
  secret?: InputMaybe<SearchableStringFilterInput>;
  sepblacId?: InputMaybe<SearchableStringFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  tags?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchableBooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchableChargeFilterInput = {
  accountId?: InputMaybe<SearchableIdFilterInput>;
  acquirer?: InputMaybe<SearchableStringFilterInput>;
  amount?: InputMaybe<SearchableIntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableChargeFilterInput>>>;
  authorizationCode?: InputMaybe<SearchableStringFilterInput>;
  billingPlan?: InputMaybe<SearchableStringFilterInput>;
  checkoutId?: InputMaybe<SearchableIdFilterInput>;
  createdAt?: InputMaybe<SearchableIntFilterInput>;
  currency?: InputMaybe<SearchableStringFilterInput>;
  customerEmail?: InputMaybe<SearchableStringFilterInput>;
  customerName?: InputMaybe<SearchableStringFilterInput>;
  customerPhone?: InputMaybe<SearchableStringFilterInput>;
  description?: InputMaybe<SearchableStringFilterInput>;
  descriptor?: InputMaybe<SearchableStringFilterInput>;
  fraudDetectorScore?: InputMaybe<SearchableIntFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  masterAccountId?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableChargeFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableChargeFilterInput>>>;
  orderId?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodBizumIntegrationType?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardBrand?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardFingerprint?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardLast4?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardThreeDSecure?: InputMaybe<SearchableBooleanFilterInput>;
  paymentMethodCardThreeDSecureFlow?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardThreeDSecureVersion?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardTokenizationMethod?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardType?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodMethod?: InputMaybe<SearchableStringFilterInput>;
  pointOfSaleId?: InputMaybe<SearchableStringFilterInput>;
  processor?: InputMaybe<SearchableStringFilterInput>;
  providerReferenceId?: InputMaybe<SearchableStringFilterInput>;
  refundedAmount?: InputMaybe<SearchableIntFilterInput>;
  sequenceId?: InputMaybe<SearchableStringFilterInput>;
  sessionCountry?: InputMaybe<SearchableStringFilterInput>;
  sessionFingerprint?: InputMaybe<SearchableStringFilterInput>;
  sessionIp?: InputMaybe<SearchableStringFilterInput>;
  shopCountry?: InputMaybe<SearchableStringFilterInput>;
  shopName?: InputMaybe<SearchableStringFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  statusCode?: InputMaybe<SearchableStringFilterInput>;
  statusMessage?: InputMaybe<SearchableStringFilterInput>;
  storeId?: InputMaybe<SearchableStringFilterInput>;
  subscriptionId?: InputMaybe<SearchableStringFilterInput>;
  traceDetailsSource?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableIntFilterInput>;
};

export type SearchableEventFilterInput = {
  accountId?: InputMaybe<SearchableIdFilterInput>;
  acquirer?: InputMaybe<SearchableStringFilterInput>;
  amount?: InputMaybe<SearchableIntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableEventFilterInput>>>;
  authorizationCode?: InputMaybe<SearchableStringFilterInput>;
  billingPlan?: InputMaybe<SearchableStringFilterInput>;
  checkoutId?: InputMaybe<SearchableIdFilterInput>;
  createdAt?: InputMaybe<SearchableIntFilterInput>;
  currency?: InputMaybe<SearchableStringFilterInput>;
  customerEmail?: InputMaybe<SearchableStringFilterInput>;
  customerName?: InputMaybe<SearchableStringFilterInput>;
  description?: InputMaybe<SearchableStringFilterInput>;
  descriptor?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  masterAccountId?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableEventFilterInput>;
  objectId?: InputMaybe<SearchableIdFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableEventFilterInput>>>;
  orderId?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardBrand?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardLast4?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardThreeDSecure?: InputMaybe<SearchableBooleanFilterInput>;
  paymentMethodCardThreeDSecureFlow?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardThreeDSecureVersion?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardTokenizationMethod?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardType?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodMethod?: InputMaybe<SearchableStringFilterInput>;
  pointOfSaleId?: InputMaybe<SearchableStringFilterInput>;
  processor?: InputMaybe<SearchableStringFilterInput>;
  providerReferenceId?: InputMaybe<SearchableStringFilterInput>;
  refundedAmount?: InputMaybe<SearchableIntFilterInput>;
  sequenceId?: InputMaybe<SearchableStringFilterInput>;
  sessionCountry?: InputMaybe<SearchableStringFilterInput>;
  sessionFingerprint?: InputMaybe<SearchableStringFilterInput>;
  sessionIp?: InputMaybe<SearchableStringFilterInput>;
  shopCountry?: InputMaybe<SearchableStringFilterInput>;
  shopName?: InputMaybe<SearchableStringFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  statusCode?: InputMaybe<SearchableStringFilterInput>;
  statusMessage?: InputMaybe<SearchableStringFilterInput>;
  storeId?: InputMaybe<SearchableStringFilterInput>;
  subscriptionId?: InputMaybe<SearchableStringFilterInput>;
  type?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchableFloatFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type SearchableIdFilterInput = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<Scalars['ID']['input']>;
  matchPhrase?: InputMaybe<Scalars['ID']['input']>;
  matchPhrasePrefix?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  regexp?: InputMaybe<Scalars['ID']['input']>;
  wildcard?: InputMaybe<Scalars['ID']['input']>;
};

export type SearchableIdentityFilterInput = {
  documentNumber?: InputMaybe<SearchableStringFilterInput>;
  email?: InputMaybe<SearchableStringFilterInput>;
  firstName?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  lastName?: InputMaybe<SearchableStringFilterInput>;
  phone?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchableIntFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SearchableInvoiceFilterInput = {
  accountId?: InputMaybe<SearchableIdFilterInput>;
  amount?: InputMaybe<SearchableIntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableInvoiceFilterInput>>>;
  currency?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableInvoiceFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableInvoiceFilterInput>>>;
  tax?: InputMaybe<SearchableIntFilterInput>;
  totalAmount?: InputMaybe<SearchableIntFilterInput>;
};

export type SearchableMasterAccountFilterInput = {
  adminEmail?: InputMaybe<SearchableStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableMasterAccountFilterInput>>>;
  dynamicBilling?: InputMaybe<SearchableBooleanFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  name?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableMasterAccountFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableMasterAccountFilterInput>>>;
  promoCode?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchableSettlementFilterInput = {
  accountId?: InputMaybe<SearchableIdFilterInput>;
  acquirer?: InputMaybe<SearchableStringFilterInput>;
  acquirerFees?: InputMaybe<SearchableIntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableSettlementFilterInput>>>;
  createdAt?: InputMaybe<SearchableIntFilterInput>;
  currency?: InputMaybe<SearchableStringFilterInput>;
  grossVolume?: InputMaybe<SearchableIntFilterInput>;
  iban?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  legalName?: InputMaybe<SearchableStringFilterInput>;
  masterAccountId?: InputMaybe<SearchableIdFilterInput>;
  netVolume?: InputMaybe<SearchableIntFilterInput>;
  not?: InputMaybe<SearchableSettlementFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableSettlementFilterInput>>>;
  payMethod?: InputMaybe<SearchableStringFilterInput>;
  period?: InputMaybe<SearchableIntFilterInput>;
  periodEndAt?: InputMaybe<SearchableIntFilterInput>;
  periodStartAt?: InputMaybe<SearchableIntFilterInput>;
  previousNegative?: InputMaybe<SearchableBooleanFilterInput>;
  releasedAmount?: InputMaybe<SearchableIntFilterInput>;
  reservePercent?: InputMaybe<SearchableIntFilterInput>;
  reservedAmount?: InputMaybe<SearchableIntFilterInput>;
  scheduledAt?: InputMaybe<SearchableIntFilterInput>;
  settleGross?: InputMaybe<SearchableBooleanFilterInput>;
  settleIndividually?: InputMaybe<SearchableBooleanFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  storeId?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableIntFilterInput>;
};

export type SearchableStringFilterInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<Scalars['String']['input']>;
  matchPhrase?: InputMaybe<Scalars['String']['input']>;
  matchPhrasePrefix?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  regexp?: InputMaybe<Scalars['String']['input']>;
  wildcard?: InputMaybe<Scalars['String']['input']>;
};

export type SearchableSubscriptionFilterInput = {
  accountId?: InputMaybe<SearchableIdFilterInput>;
  amount?: InputMaybe<SearchableIntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableSubscriptionFilterInput>>>;
  createdAt?: InputMaybe<SearchableIntFilterInput>;
  currency?: InputMaybe<SearchableStringFilterInput>;
  customerEmail?: InputMaybe<SearchableStringFilterInput>;
  customerName?: InputMaybe<SearchableStringFilterInput>;
  customerPhone?: InputMaybe<SearchableStringFilterInput>;
  description?: InputMaybe<SearchableStringFilterInput>;
  descriptor?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  interval?: InputMaybe<SearchableStringFilterInput>;
  intervalCount?: InputMaybe<SearchableIntFilterInput>;
  lastOrderId?: InputMaybe<SearchableStringFilterInput>;
  lastPaymentId?: InputMaybe<SearchableIdFilterInput>;
  lastPaymentStatus?: InputMaybe<SearchableStringFilterInput>;
  lastPaymentStatusCode?: InputMaybe<SearchableStringFilterInput>;
  masterAccountId?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableSubscriptionFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableSubscriptionFilterInput>>>;
  paymentMethodCardBrand?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardLast4?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardThreeDSecure?: InputMaybe<SearchableBooleanFilterInput>;
  paymentMethodCardThreeDSecureFlow?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardThreeDSecureVersion?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardTokenizationMethod?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardType?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodMethod?: InputMaybe<SearchableStringFilterInput>;
  sequenceId?: InputMaybe<SearchableStringFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  storeId?: InputMaybe<SearchableStringFilterInput>;
  traceDetailsSource?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableIntFilterInput>;
};

export type SendPaymentMessageInput = {
  accountId: Scalars['ID']['input'];
  channel?: InputMaybe<MessageChannel>;
  customerEmail?: InputMaybe<Scalars['AWSEmail']['input']>;
  customerPhone?: InputMaybe<Scalars['AWSPhone']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['ID']['input'];
};

export type SendPaymentRequestInput = {
  language?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type SendSubscriptionMessageInput = {
  accountId: Scalars['ID']['input'];
  channel?: InputMaybe<MessageChannel>;
  customerEmail?: InputMaybe<Scalars['AWSEmail']['input']>;
  customerPhone?: InputMaybe<Scalars['AWSPhone']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type SessionDetails = {
  __typename?: 'SessionDetails';
  browser?: Maybe<Scalars['String']['output']>;
  browserAccept?: Maybe<Scalars['String']['output']>;
  browserColorDepth?: Maybe<Scalars['String']['output']>;
  browserScreenHeight?: Maybe<Scalars['String']['output']>;
  browserScreenWidth?: Maybe<Scalars['String']['output']>;
  browserTimezoneOffset?: Maybe<Scalars['String']['output']>;
  browserVersion?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<DeviceType>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['AWSIPAddress']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceVersion?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type Settlement = {
  __typename?: 'Settlement';
  accountId: Scalars['ID']['output'];
  acquirer: SettlementAcquirer;
  acquirerFees: Scalars['Int']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  grossVolume: Scalars['Int']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  masterAccountId?: Maybe<Scalars['ID']['output']>;
  netVolume: Scalars['Int']['output'];
  payMethod?: Maybe<SettlementPayMethods>;
  period: Scalars['Int']['output'];
  periodEndAt: Scalars['AWSTimestamp']['output'];
  periodStartAt: Scalars['AWSTimestamp']['output'];
  previousNegative?: Maybe<Scalars['Boolean']['output']>;
  releasedAmount?: Maybe<Scalars['Int']['output']>;
  reservePercent: Scalars['Int']['output'];
  reservedAmount?: Maybe<Scalars['Int']['output']>;
  scheduledAt: Scalars['AWSTimestamp']['output'];
  settleGross?: Maybe<Scalars['Boolean']['output']>;
  settleIndividually?: Maybe<Scalars['Boolean']['output']>;
  status: SettlementStatus;
  storeId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export enum SettlementAcquirer {
  COMERCIA_GLOBAL_PAY = 'COMERCIA_GLOBAL_PAY',
  CREDORAX = 'CREDORAX',
  GETNET = 'GETNET'
}

export type SettlementEvent = {
  __typename?: 'SettlementEvent';
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  object: SettlementEventObject;
  objectId: Scalars['ID']['output'];
  objectType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SettlementEventObject = {
  __typename?: 'SettlementEventObject';
  accountId: Scalars['ID']['output'];
  acquirer: SettlementAcquirer;
  acquirerFees: Scalars['Int']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  grossVolume: Scalars['Int']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  masterAccountId?: Maybe<Scalars['ID']['output']>;
  netVolume: Scalars['Int']['output'];
  payMethod?: Maybe<SettlementPayMethods>;
  period: Scalars['Int']['output'];
  periodEndAt: Scalars['AWSTimestamp']['output'];
  periodStartAt: Scalars['AWSTimestamp']['output'];
  previousNegative?: Maybe<Scalars['Boolean']['output']>;
  releasedAmount?: Maybe<Scalars['Int']['output']>;
  reservePercent: Scalars['Int']['output'];
  reservedAmount?: Maybe<Scalars['Int']['output']>;
  scheduledAt: Scalars['AWSTimestamp']['output'];
  settleGross?: Maybe<Scalars['Boolean']['output']>;
  settleIndividually?: Maybe<Scalars['Boolean']['output']>;
  status: SettlementStatus;
  storeId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type SettlementEventsConnection = {
  __typename?: 'SettlementEventsConnection';
  items: Array<SettlementEvent>;
  total: Scalars['Int']['output'];
};

export enum SettlementPayMethods {
  BIZUM = 'bizum',
  CARD = 'card'
}

export enum SettlementStatus {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  SUSPENDED = 'SUSPENDED'
}

export type SettlementsConnection = {
  __typename?: 'SettlementsConnection';
  items: Array<Settlement>;
  total: Scalars['Int']['output'];
};

export type SftpConfigExport = {
  __typename?: 'SftpConfigExport';
  accountId: Scalars['ID']['output'];
  columns?: Maybe<Array<Scalars['String']['output']>>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  host: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  port: Scalars['Int']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type SftpConfigExportsConnection = {
  __typename?: 'SftpConfigExportsConnection';
  /**  List of SFTP config exports */
  items: Array<SftpConfigExport>;
};

export type Shop = {
  __typename?: 'Shop';
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ShortLink = {
  __typename?: 'ShortLink';
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  expireAt?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  openCount?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

export type ShortLinksConnection = {
  __typename?: 'ShortLinksConnection';
  items: Array<ShortLink>;
  total: Scalars['Int']['output'];
};

export type Stats = {
  __typename?: 'Stats';
  activeMonths?: Maybe<Scalars['Int']['output']>;
  avgMonthlyTransactions?: Maybe<Scalars['Int']['output']>;
  avgMonthlyVolume?: Maybe<Scalars['Float']['output']>;
  churned?: Maybe<Scalars['Boolean']['output']>;
  firstTransactionAt?: Maybe<Scalars['Long']['output']>;
  lastTransactionAt?: Maybe<Scalars['Long']['output']>;
  totalSucceededAmount?: Maybe<Scalars['Float']['output']>;
  totalSucceededCount?: Maybe<Scalars['Int']['output']>;
};

export enum StatusReason {
  BANK_OWNERSHIP_CERT_REQUIRED = 'BANK_OWNERSHIP_CERT_REQUIRED',
  CBD_PRODUCTS = 'CBD_PRODUCTS',
  CENSUS_CERT_REQUIRED = 'CENSUS_CERT_REQUIRED',
  CHARGEBACKS = 'CHARGEBACKS',
  CUSTOMER_COMPLAINTS = 'CUSTOMER_COMPLAINTS',
  CUSTOMER_REQUEST = 'CUSTOMER_REQUEST',
  DOMAIN_MISMATCH = 'DOMAIN_MISMATCH',
  HIGH_RISK_GOODS = 'HIGH_RISK_GOODS',
  ID_VERIFICATION_REQUIRED = 'ID_VERIFICATION_REQUIRED',
  INCOMPLETE_DOCS = 'INCOMPLETE_DOCS',
  JOINT_OWNERSHIP = 'JOINT_OWNERSHIP',
  NON_COMMERCIAL_COMPANY_DOCS = 'NON_COMMERCIAL_COMPANY_DOCS',
  NON_COMPLIANT_WEBSITE = 'NON_COMPLIANT_WEBSITE',
  NOT_COMPLIANT_BUSINESS = 'NOT_COMPLIANT_BUSINESS',
  OTHER = 'OTHER',
  OTHER_COMPANY_WEBSITE = 'OTHER_COMPANY_WEBSITE',
  REAL_HOLDERS_DOCS = 'REAL_HOLDERS_DOCS',
  REPEAT_ONBOARDING = 'REPEAT_ONBOARDING',
  RESTRICTED_CATEGORY = 'RESTRICTED_CATEGORY',
  SUSPICIOUS_ACTIVITY = 'SUSPICIOUS_ACTIVITY',
  UPDATE_BILLING_INFO = 'UPDATE_BILLING_INFO'
}

export type Store = {
  __typename?: 'Store';
  accountId: Scalars['ID']['output'];
  address?: Maybe<Address>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Array<MetadataItem>>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type StoreEvent = {
  __typename?: 'StoreEvent';
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  object: StoreEventObject;
  objectId: Scalars['ID']['output'];
  objectType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StoreEventObject = {
  __typename?: 'StoreEventObject';
  accountId: Scalars['ID']['output'];
  address?: Maybe<Address>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Array<MetadataItem>>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  traceDetails?: Maybe<TraceDetails>;
  website?: Maybe<Scalars['String']['output']>;
};

export type StoreEventsConnection = {
  __typename?: 'StoreEventsConnection';
  items: Array<StoreEvent>;
  total: Scalars['Int']['output'];
};

export type StoresConnection = {
  __typename?: 'StoresConnection';
  items: Array<Store>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  accountId: Scalars['ID']['output'];
  allowedPaymentMethods?: Maybe<Array<Maybe<SubscriptionPaymentMethods>>>;
  amount: Scalars['Int']['output'];
  billingDetails?: Maybe<ContactDetails>;
  callbackUrl?: Maybe<Scalars['String']['output']>;
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Currencies>;
  currentPeriodEnd?: Maybe<Scalars['Int']['output']>;
  currentPeriodStart?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ID']['output']>;
  defaultTokenId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interval: Interval;
  intervalCount: Scalars['Int']['output'];
  lastInvoiceId?: Maybe<Scalars['ID']['output']>;
  lastOrderId?: Maybe<Scalars['ID']['output']>;
  lastPayment?: Maybe<LastPayment>;
  livemode: Scalars['Boolean']['output'];
  masterAccountId?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Array<KeyValueItem>>;
  nextPaymentAt?: Maybe<Scalars['Int']['output']>;
  pauseAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  pauseIntervalCount?: Maybe<Scalars['Int']['output']>;
  paymentCallbackUrl?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  planVariantId?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  retryCount?: Maybe<Scalars['Int']['output']>;
  retrySchedule?: Maybe<Array<RetrySchedule>>;
  sequenceId?: Maybe<Scalars['ID']['output']>;
  sessionDetails?: Maybe<SessionDetails>;
  shippingDetails?: Maybe<ContactDetails>;
  skipIntervalCount?: Maybe<Scalars['Int']['output']>;
  status: SubscriptionStatus;
  storeId?: Maybe<Scalars['ID']['output']>;
  traceDetails?: Maybe<TraceDetails>;
  trialAmount?: Maybe<Scalars['Int']['output']>;
  trialPeriodDays?: Maybe<Scalars['Int']['output']>;
  trialPeriodEnd?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
};

export enum SubscriptionEmailType {
  SUBSCRIPTION_LINK = 'SUBSCRIPTION_LINK',
  SUBSCRIPTION_STATUS = 'SUBSCRIPTION_STATUS'
}

export type SubscriptionEvent = {
  __typename?: 'SubscriptionEvent';
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  masterAccountId?: Maybe<Scalars['ID']['output']>;
  object: SubscriptionEventObject;
  objectId: Scalars['ID']['output'];
  objectType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SubscriptionEventObject = {
  __typename?: 'SubscriptionEventObject';
  accountId: Scalars['ID']['output'];
  allowedPaymentMethods?: Maybe<Array<Maybe<SubscriptionPaymentMethods>>>;
  amount?: Maybe<Scalars['Int']['output']>;
  billingDetails?: Maybe<ContactDetails>;
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  currency: Scalars['String']['output'];
  currentPeriodEnd?: Maybe<Scalars['Int']['output']>;
  currentPeriodStart?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<Customer>;
  description?: Maybe<Scalars['String']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interval: Interval;
  intervalCount: Scalars['Int']['output'];
  lastInvoiceId?: Maybe<Scalars['ID']['output']>;
  lastOrderId?: Maybe<Scalars['ID']['output']>;
  lastPayment?: Maybe<LastPayment>;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  masterAccountId?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Array<KeyValueItem>>;
  pageOpenedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  pauseAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  pauseIntervalCount?: Maybe<Scalars['Int']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  planVariantId?: Maybe<Scalars['ID']['output']>;
  pointOfSaleId?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  retryCount?: Maybe<Scalars['Int']['output']>;
  sequenceId?: Maybe<Scalars['ID']['output']>;
  shippingDetails?: Maybe<ContactDetails>;
  skipIntervalCount?: Maybe<Scalars['Int']['output']>;
  status: SubscriptionStatus;
  storeId?: Maybe<Scalars['ID']['output']>;
  traceDetails?: Maybe<TraceDetails>;
  trialPeriodDays?: Maybe<Scalars['Int']['output']>;
  trialPeriodEnd?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type SubscriptionEventsConnection = {
  __typename?: 'SubscriptionEventsConnection';
  items: Array<SubscriptionEvent>;
  total: Scalars['Int']['output'];
};

export enum SubscriptionPaymentMethods {
  BIZUM = 'bizum',
  CARD = 'card'
}

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  PAST_DUE = 'PAST_DUE',
  PAUSED = 'PAUSED',
  PENDING = 'PENDING',
  TRIALING = 'TRIALING'
}

export type Subscriptions = {
  __typename?: 'Subscriptions';
  onUpdateAccount?: Maybe<AccountLevelUpdate>;
  /** @deprecated Use publishUpdateAnalyticsV2 instead */
  onUpdateAnalytics?: Maybe<AnalyticsChange>;
  onUpdateAnalyticsV2: Scalars['Boolean']['output'];
  onUpdateCharge?: Maybe<ItemLevelUpdate>;
  onUpdateChargeEvents?: Maybe<ItemLevelUpdate>;
  onUpdateCharges?: Maybe<AccountLevelUpdate>;
  onUpdateDocuments?: Maybe<AccountLevelUpdate>;
  onUpdateEvents?: Maybe<AccountLevelUpdate>;
  onUpdateSubscription?: Maybe<ItemLevelUpdate>;
  onUpdateSubscriptionEvents?: Maybe<ItemLevelUpdate>;
  onUpdateSubscriptions?: Maybe<AccountLevelUpdate>;
};

export type SubscriptionsOnUpdateAccountArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsOnUpdateAnalyticsArgs = {
  all: Scalars['Boolean']['input'];
};

export type SubscriptionsOnUpdateChargeArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type SubscriptionsOnUpdateChargeEventsArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type SubscriptionsOnUpdateChargesArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsOnUpdateDocumentsArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsOnUpdateEventsArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsOnUpdateSubscriptionArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type SubscriptionsOnUpdateSubscriptionEventsArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type SubscriptionsOnUpdateSubscriptionsArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsConnection = {
  __typename?: 'SubscriptionsConnection';
  items: Array<Subscription>;
  total: Scalars['Int']['output'];
};

export type SuccessResult = {
  __typename?: 'SuccessResult';
  success: Scalars['Boolean']['output'];
};

export enum ThreeDsStatus {
  A = 'A',
  I = 'I',
  N = 'N',
  R = 'R',
  U = 'U',
  Y = 'Y'
}

export enum ThreeDSecureFlow {
  CHALLENGE = 'CHALLENGE',
  DIRECT = 'DIRECT',
  FRICTIONLESS = 'FRICTIONLESS',
  FRICTIONLESS_CHALLENGE = 'FRICTIONLESS_CHALLENGE'
}

export enum TokenizationMethods {
  APPLEPAY = 'applePay',
  CLICKTOPAY = 'clickToPay',
  GOOGLEPAY = 'googlePay'
}

export type TraceDetails = {
  __typename?: 'TraceDetails';
  apiKey?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  browserAccept?: Maybe<Scalars['String']['output']>;
  browserVersion?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<DeviceType>;
  ip?: Maybe<Scalars['AWSIPAddress']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  masterApiKey?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceVersion?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export enum TransactionTypes {
  AUTH = 'AUTH',
  CANCEL = 'CANCEL',
  CAPTURE = 'CAPTURE',
  PAYOUT = 'PAYOUT',
  REFUND = 'REFUND',
  SALE = 'SALE',
  VERIF = 'VERIF'
}

export type UpdateAccountInput = {
  accountExecutive?: InputMaybe<Scalars['String']['input']>;
  accountInvoicePaymentMethod?: InputMaybe<AccountInvoicePaymentMethod>;
  acquirer?: InputMaybe<Acquirer>;
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  allowCreateApiKey?: InputMaybe<Scalars['Boolean']['input']>;
  allowRefunds?: InputMaybe<Scalars['Boolean']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingPlan?: InputMaybe<BillingPlans>;
  billingVatPercent?: InputMaybe<Scalars['Int']['input']>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  branding?: InputMaybe<AccountBrandingInput>;
  business?: InputMaybe<BusinessDataInput>;
  churnNote?: InputMaybe<Scalars['String']['input']>;
  churnReason?: InputMaybe<ChurnReason>;
  churnReasonOption?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<ContactPersonInput>;
  customAccountInvoiceNotes?: InputMaybe<Array<Scalars['String']['input']>>;
  customDomain?: InputMaybe<Scalars['String']['input']>;
  defaultCurrency?: InputMaybe<Currencies>;
  defaultTransactionType?: InputMaybe<TransactionTypes>;
  dynamicBilling?: InputMaybe<Scalars['Boolean']['input']>;
  fees?: InputMaybe<AccountFeesInput>;
  fraudDetectorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  fraudDetectorThreshold?: InputMaybe<Scalars['Int']['input']>;
  fraudRulesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupInvoicesByStore?: InputMaybe<Scalars['Boolean']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  manualApproval?: InputMaybe<Scalars['Boolean']['input']>;
  masterAccountId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<AccountNotificationsInput>;
  partner?: InputMaybe<Partner>;
  paymentMethods?: InputMaybe<AccountPaymentMethodsInput>;
  payoutTerms?: InputMaybe<AccountPayoutTermsInput>;
  progressiveBilling?: InputMaybe<Scalars['Boolean']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  publicBusinessDetails?: InputMaybe<AccountPublicBusinessDetailsInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  refAccountId?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  representatives?: InputMaybe<Array<InputMaybe<RepresentativeDataInput>>>;
  reviewConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  riskIgnoredKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  riskProfile?: InputMaybe<RiskProfile>;
  riskProfileNote?: InputMaybe<Scalars['String']['input']>;
  riskScore?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<AccountStatus>;
  statusNote?: InputMaybe<Scalars['String']['input']>;
  statusReason?: InputMaybe<StatusReason>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  upsell?: InputMaybe<UpsellInput>;
};

export type UpdateAccountInvoiceInput = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  status: AccountInvoiceStatus;
};

export type UpdateAffiliatePayoutMethodInput = {
  affiliateId: Scalars['ID']['input'];
  details?: InputMaybe<AffiliatePayoutMethodDetailsInput>;
};

export type UpdateAffiliateTierInput = {
  affiliateId: Scalars['ID']['input'];
  tier?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAuthorizedUserInput = {
  accessLevel?: InputMaybe<AuthorizedUserAccessLevel>;
  accountId: Scalars['ID']['input'];
  pointOfSaleId?: InputMaybe<Scalars['ID']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  userEmail: Scalars['String']['input'];
};

export type UpdateCodeInput = {
  accountId: Scalars['ID']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  pointOfSaleId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDocumentInput = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentStatus>;
  statusCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExportSftpConfigInput = {
  accountId: Scalars['ID']['input'];
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIdentityInput = {
  address?: InputMaybe<AddressInput>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<IdDocumentInput>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  hasNoPublicActivity?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  idSession?: InputMaybe<Scalars['String']['input']>;
  idSessionUrl?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pibisiId?: InputMaybe<Scalars['ID']['input']>;
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  sepblacRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<IdVerificationStatus>;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  statusMessage?: InputMaybe<Scalars['String']['input']>;
  yearOfBirth?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMasterAccountInput = {
  accountDefaults?: InputMaybe<AccountDefaultsInput>;
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  allowCreateApiKey?: InputMaybe<Scalars['Boolean']['input']>;
  allowedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedIPs?: InputMaybe<Array<Scalars['String']['input']>>;
  autoApprove?: InputMaybe<Scalars['Boolean']['input']>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  branding?: InputMaybe<AccountBrandingInput>;
  business?: InputMaybe<BusinessDataInput>;
  churnedEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  contractTemplateId?: InputMaybe<Scalars['ID']['input']>;
  dynamicBilling?: InputMaybe<Scalars['Boolean']['input']>;
  extraFees?: InputMaybe<Array<InputMaybe<AccountExtraFeeInput>>>;
  fees?: InputMaybe<MasterAccountFeesInput>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  payoutTerms?: InputMaybe<AccountPayoutTermsInput>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  publicBusinessDetails?: InputMaybe<AccountPublicBusinessDetailsInput>;
  requireExternalId?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AccountStatus>;
  webhookEmails?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdatePibisiStatusInput = {
  pibisiId: Scalars['ID']['input'];
  status: PibisiStatus;
};

export type UpdatePointOfSaleInput = {
  accountId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fixedAmount?: InputMaybe<Scalars['Int']['input']>;
  fixedCurrency?: InputMaybe<Currencies>;
  id: Scalars['ID']['input'];
  includeQRCode?: InputMaybe<Scalars['Boolean']['input']>;
  manualAmount?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentCallbackUrl?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<Array<PaymentMethods>>;
  pendingSetup?: InputMaybe<Scalars['Boolean']['input']>;
  qrCodeText?: InputMaybe<Scalars['String']['input']>;
  requireEmail?: InputMaybe<Scalars['Boolean']['input']>;
  requireTaxId?: InputMaybe<Scalars['Boolean']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  terminalId?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<TransactionTypes>;
};

export type UpdateProviderInput = {
  acquirer?: InputMaybe<Acquirer>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Array<MetadataItemInput>>;
  nativeHostedPayment?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<ProviderRulesInput>;
  test?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRepresentativeInput = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  identityId?: InputMaybe<Scalars['ID']['input']>;
  interventionType?: InputMaybe<Array<InterventionType>>;
  sepblacRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  stocksPercentage?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateStoreInput = {
  accountId: Scalars['ID']['input'];
  address?: InputMaybe<AddressInput>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Array<MetadataItemInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionInput = {
  accountId: Scalars['ID']['input'];
  allowedPaymentMethods?: InputMaybe<Array<InputMaybe<SubscriptionPaymentMethods>>>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  billingDetails?: InputMaybe<ContactDetailsInput>;
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  cancelAtPeriodEnd?: InputMaybe<Scalars['Boolean']['input']>;
  customer?: InputMaybe<CustomerInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  interval?: InputMaybe<IntervalInput>;
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Array<KeyValueInput>>;
  nextPaymentAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  pauseAtPeriodEnd?: InputMaybe<Scalars['Boolean']['input']>;
  pauseIntervalCount?: InputMaybe<Scalars['Int']['input']>;
  paymentCallbackUrl?: InputMaybe<Scalars['String']['input']>;
  retrySchedule?: InputMaybe<Array<RetryScheduleInput>>;
  shippingDetails?: InputMaybe<ContactDetailsInput>;
  skipIntervalCount?: InputMaybe<Scalars['Int']['input']>;
  trialPeriodEnd?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type UpdateUserMasterAccountInput = {
  accountCallbackUrl?: InputMaybe<Scalars['String']['input']>;
  allowedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedIPs?: InputMaybe<Array<Scalars['String']['input']>>;
  branding?: InputMaybe<AccountBrandingInput>;
  churnedEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  publicBusinessDetails?: InputMaybe<AccountPublicBusinessDetailsInput>;
  requireExternalId?: InputMaybe<Scalars['Boolean']['input']>;
  webhookEmails?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateWebKeywordInput = {
  baseUrl: Scalars['String']['input'];
  incorrect: Scalars['Boolean']['input'];
  urlKeyword: Scalars['String']['input'];
};

export type UpdateWebhookInput = {
  accountId: Scalars['ID']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventTypes?: InputMaybe<Array<WebhookEventType>>;
  id: Scalars['ID']['input'];
  masterAccount?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  expiresAt: Scalars['AWSTimestamp']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type Upsell = {
  __typename?: 'Upsell';
  date?: Maybe<Scalars['String']['output']>;
  executive?: Maybe<SalesExecutive>;
  note?: Maybe<Scalars['String']['output']>;
  paymentMethods?: Maybe<Array<PaymentMethods>>;
};

export type UpsellInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  executive?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<Array<PaymentMethods>>;
};

export type User = {
  __typename?: 'User';
  accountId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberVerified?: Maybe<Scalars['Boolean']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  smsMfaEnabled?: Maybe<Scalars['Boolean']['output']>;
  status: UserStatus;
  testAccountId?: Maybe<Scalars['ID']['output']>;
};

export type UserInput = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum UserStatus {
  ARCHIVED = 'ARCHIVED',
  COMPROMISED = 'COMPROMISED',
  CONFIRMED = 'CONFIRMED',
  EXTERNAL_PROVIDER = 'EXTERNAL_PROVIDER',
  FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
  RESET_REQUIRED = 'RESET_REQUIRED',
  UNCONFIRMED = 'UNCONFIRMED',
  UNKNOWN = 'UNKNOWN'
}

export type UsersConnection = {
  __typename?: 'UsersConnection';
  items: Array<User>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export enum VerificationMethod {
  OFFLINEPIN = 'offlinePin',
  ONLINEPIN = 'onlinePin'
}

export type WebKeyword = {
  __typename?: 'WebKeyword';
  accountId: Scalars['ID']['output'];
  baseUrl: Scalars['String']['output'];
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['AWSTimestamp']['output'];
  explanation?: Maybe<Scalars['String']['output']>;
  incorrect?: Maybe<Scalars['Boolean']['output']>;
  keyword: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  url: Scalars['String']['output'];
  urlKeyword: Scalars['String']['output'];
};

export type WebKeywordsConnection = {
  __typename?: 'WebKeywordsConnection';
  items: Array<WebKeyword>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type WebReport = {
  __typename?: 'WebReport';
  accountId: Scalars['ID']['output'];
  baseUrl: Scalars['String']['output'];
  confirmedKeywords: Array<Maybe<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['AWSTimestamp']['output'];
  failedPageCount?: Maybe<Scalars['Int']['output']>;
  legalDetailsUrl?: Maybe<Scalars['String']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  platform?: Maybe<WebReportPlatform>;
  riskCategory?: Maybe<Scalars['String']['output']>;
  status?: Maybe<WebReportStatus>;
  statusCode?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uncheckedPageCount?: Maybe<Scalars['Int']['output']>;
  unconfirmedKeywords: Array<Maybe<Scalars['String']['output']>>;
  underConstruction?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export enum WebReportPlatform {
  MAGENTO2 = 'Magento2',
  OTHER = 'Other',
  PRESTASHOP = 'Prestashop',
  SHOPIFY = 'Shopify',
  WIX = 'Wix',
  WOOCOMMERCE = 'WooCommerce'
}

export enum WebReportStatus {
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  SUCCEEDED = 'SUCCEEDED'
}

export type Webhook = {
  __typename?: 'Webhook';
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  eventTypes: Array<WebhookEventType>;
  id: Scalars['ID']['output'];
  lastResponse?: Maybe<CallbackData>;
  secret?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export enum WebhookEventType {
  ACCOUNT_ACTIVATED = 'ACCOUNT_ACTIVATED',
  ACCOUNT_APPROVAL_REQUESTED = 'ACCOUNT_APPROVAL_REQUESTED',
  ACCOUNT_APPROVED = 'ACCOUNT_APPROVED',
  ACCOUNT_BLOCKED = 'ACCOUNT_BLOCKED',
  ACCOUNT_CHURNED = 'ACCOUNT_CHURNED',
  ACCOUNT_DATA_REQUESTED = 'ACCOUNT_DATA_REQUESTED',
  ACCOUNT_DATA_UPDATED = 'ACCOUNT_DATA_UPDATED',
  ACCOUNT_DELETED = 'ACCOUNT_DELETED',
  ACCOUNT_INVOICE_PAID = 'ACCOUNT_INVOICE_PAID',
  ACCOUNT_INVOICE_PAST_DUE = 'ACCOUNT_INVOICE_PAST_DUE',
  ACCOUNT_INVOICE_PENDING = 'ACCOUNT_INVOICE_PENDING',
  ACCOUNT_INVOICE_UNPAID = 'ACCOUNT_INVOICE_UNPAID',
  ACCOUNT_PENDING = 'ACCOUNT_PENDING',
  ACCOUNT_REACTIVATED = 'ACCOUNT_REACTIVATED',
  ACCOUNT_REJECTED = 'ACCOUNT_REJECTED',
  ACCOUNT_SUSPENDED = 'ACCOUNT_SUSPENDED',
  ACCOUNT_UNBLOCKED = 'ACCOUNT_UNBLOCKED',
  CHARGE_AUTHORIZED = 'CHARGE_AUTHORIZED',
  CHARGE_CANCELED = 'CHARGE_CANCELED',
  CHARGE_CAPTURED = 'CHARGE_CAPTURED',
  CHARGE_CHARGEBACK = 'CHARGE_CHARGEBACK',
  CHARGE_EXPIRED = 'CHARGE_EXPIRED',
  CHARGE_FAILED = 'CHARGE_FAILED',
  CHARGE_PAID_OUT = 'CHARGE_PAID_OUT',
  CHARGE_PARTIALLY_REFUNDED = 'CHARGE_PARTIALLY_REFUNDED',
  CHARGE_PENDING = 'CHARGE_PENDING',
  CHARGE_PENDING_PROCESSING = 'CHARGE_PENDING_PROCESSING',
  CHARGE_REFUNDED = 'CHARGE_REFUNDED',
  CHARGE_SUCCEEDED = 'CHARGE_SUCCEEDED',
  CHARGE_UPDATED = 'CHARGE_UPDATED',
  PROVIDER_CREATED = 'PROVIDER_CREATED',
  PROVIDER_DISABLED = 'PROVIDER_DISABLED',
  PROVIDER_ENABLED = 'PROVIDER_ENABLED',
  PROVIDER_UPDATED = 'PROVIDER_UPDATED',
  SETTLEMENT_COMPLETED = 'SETTLEMENT_COMPLETED',
  SETTLEMENT_PENDING = 'SETTLEMENT_PENDING',
  SETTLEMENT_SUSPENDED = 'SETTLEMENT_SUSPENDED',
  SUBSCRIPTION_ACTIVATED = 'SUBSCRIPTION_ACTIVATED',
  SUBSCRIPTION_CANCELED = 'SUBSCRIPTION_CANCELED',
  SUBSCRIPTION_EXPIRED = 'SUBSCRIPTION_EXPIRED',
  SUBSCRIPTION_PAST_DUE = 'SUBSCRIPTION_PAST_DUE',
  SUBSCRIPTION_PAUSED = 'SUBSCRIPTION_PAUSED',
  SUBSCRIPTION_PENDING = 'SUBSCRIPTION_PENDING',
  SUBSCRIPTION_TRIALING = 'SUBSCRIPTION_TRIALING',
  SUBSCRIPTION_UPDATED = 'SUBSCRIPTION_UPDATED'
}

export type WebhooksConnection = {
  __typename?: 'WebhooksConnection';
  items: Array<Maybe<Webhook>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type AddressFieldsFragment = {
  __typename?: 'Address';
  city?: string | null;
  country?: string | null;
  line1?: string | null;
  line2?: string | null;
  zip?: string | null;
  state?: string | null;
};

export type PibisiFlagFieldsFragment = {
  __typename?: 'PibisiFlag';
  id?: string | null;
  content?: {
    __typename?: 'PibisiContent';
    action?: string | null;
    charge?: string | null;
    country?: string | null;
    from?: string | null;
    issue?: string | null;
    issuer?: string | null;
    organization?: string | null;
    reason?: string | null;
    scope?: string | null;
    to?: string | null;
    types?: Array<string | null> | null;
    url?: string | null;
  } | null;
};

export type PibisiFieldsFragment = {
  __typename?: 'Pibisi';
  id?: string | null;
  entityId?: string | null;
  status?: PibisiStatus | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  deletedAt?: string | null;
};

export type PibisiAccountFieldsFragment = {
  __typename?: 'PibisiAccount';
  id?: string | null;
  entityId?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  deletedAt?: string | null;
  deleted?: boolean | null;
  status?: PibisiStatus | null;
  customerId?: string | null;
  legalName?: string | null;
  alertsId?: string | null;
  alertsStatus?: PibisiMatchStatus | null;
  matches?: Array<{
    __typename?: 'PibisiMatch';
    id: string;
    status: PibisiMatchStatus;
    adverseInfo?: Array<{
      __typename?: 'PibisiFlag';
      id?: string | null;
      content?: {
        __typename?: 'PibisiContent';
        action?: string | null;
        charge?: string | null;
        country?: string | null;
        from?: string | null;
        issue?: string | null;
        issuer?: string | null;
        organization?: string | null;
        reason?: string | null;
        scope?: string | null;
        to?: string | null;
        types?: Array<string | null> | null;
        url?: string | null;
      } | null;
    } | null> | null;
    highRisk?: Array<{
      __typename?: 'PibisiFlag';
      id?: string | null;
      content?: {
        __typename?: 'PibisiContent';
        action?: string | null;
        charge?: string | null;
        country?: string | null;
        from?: string | null;
        issue?: string | null;
        issuer?: string | null;
        organization?: string | null;
        reason?: string | null;
        scope?: string | null;
        to?: string | null;
        types?: Array<string | null> | null;
        url?: string | null;
      } | null;
    } | null> | null;
    media?: Array<{
      __typename?: 'PibisiFlag';
      id?: string | null;
      content?: {
        __typename?: 'PibisiContent';
        action?: string | null;
        charge?: string | null;
        country?: string | null;
        from?: string | null;
        issue?: string | null;
        issuer?: string | null;
        organization?: string | null;
        reason?: string | null;
        scope?: string | null;
        to?: string | null;
        types?: Array<string | null> | null;
        url?: string | null;
      } | null;
    } | null> | null;
    pep?: Array<{
      __typename?: 'PibisiFlag';
      id?: string | null;
      content?: {
        __typename?: 'PibisiContent';
        action?: string | null;
        charge?: string | null;
        country?: string | null;
        from?: string | null;
        issue?: string | null;
        issuer?: string | null;
        organization?: string | null;
        reason?: string | null;
        scope?: string | null;
        to?: string | null;
        types?: Array<string | null> | null;
        url?: string | null;
      } | null;
    } | null> | null;
    sanctioned?: Array<{
      __typename?: 'PibisiFlag';
      id?: string | null;
      content?: {
        __typename?: 'PibisiContent';
        action?: string | null;
        charge?: string | null;
        country?: string | null;
        from?: string | null;
        issue?: string | null;
        issuer?: string | null;
        organization?: string | null;
        reason?: string | null;
        scope?: string | null;
        to?: string | null;
        types?: Array<string | null> | null;
        url?: string | null;
      } | null;
    } | null> | null;
    terrorist?: Array<{
      __typename?: 'PibisiFlag';
      id?: string | null;
      content?: {
        __typename?: 'PibisiContent';
        action?: string | null;
        charge?: string | null;
        country?: string | null;
        from?: string | null;
        issue?: string | null;
        issuer?: string | null;
        organization?: string | null;
        reason?: string | null;
        scope?: string | null;
        to?: string | null;
        types?: Array<string | null> | null;
        url?: string | null;
      } | null;
    } | null> | null;
    matches?: Array<{
      __typename?: 'PibisiFlag';
      id?: string | null;
      content?: {
        __typename?: 'PibisiContent';
        action?: string | null;
        charge?: string | null;
        country?: string | null;
        from?: string | null;
        issue?: string | null;
        issuer?: string | null;
        organization?: string | null;
        reason?: string | null;
        scope?: string | null;
        to?: string | null;
        types?: Array<string | null> | null;
        url?: string | null;
      } | null;
    } | null> | null;
  } | null> | null;
  alerts?: Array<{
    __typename?: 'PibisiAlert';
    id: string;
    status: PibisiAlertStatus;
    type?: PibisiAlertTypes | null;
    note?: string | null;
  } | null> | null;
};

export type SessionDetailsFieldsFragment = {
  __typename?: 'SessionDetails';
  ip?: string | null;
  fingerprint?: string | null;
  userAgent?: string | null;
  countryCode?: string | null;
  lang?: string | null;
  deviceType?: DeviceType | null;
  deviceModel?: string | null;
  browser?: string | null;
  browserVersion?: string | null;
  browserAccept?: string | null;
  browserColorDepth?: string | null;
  browserScreenHeight?: string | null;
  browserScreenWidth?: string | null;
  browserTimezoneOffset?: string | null;
  os?: string | null;
  osVersion?: string | null;
  source?: string | null;
  sourceVersion?: string | null;
};

export type TraceDetailsFieldsFragment = {
  __typename?: 'TraceDetails';
  ip?: string | null;
  userAgent?: string | null;
  countryCode?: string | null;
  lang?: string | null;
  deviceType?: DeviceType | null;
  deviceModel?: string | null;
  browser?: string | null;
  browserVersion?: string | null;
  browserAccept?: string | null;
  os?: string | null;
  osVersion?: string | null;
  source?: string | null;
  sourceVersion?: string | null;
  userId?: string | null;
  userEmail?: string | null;
  userName?: string | null;
};

export type PaymentMethodFieldsFragment = {
  __typename?: 'PaymentMethod';
  method?: PaymentMethods | null;
  bizum?: {
    __typename?: 'PaymentMethodBizum';
    phoneNumber?: string | null;
    integrationType?: string | null;
    ibanLast4?: string | null;
    idBizum?: string | null;
  } | null;
  card?: {
    __typename?: 'PaymentMethodCard';
    brand?: CardBrand | null;
    country?: string | null;
    type?: CardType | null;
    threeDSecure?: boolean | null;
    threeDSecureVersion?: string | null;
    threeDSecureFlow?: ThreeDSecureFlow | null;
    threeDSecureStatus?: ThreeDsStatus | null;
    last4?: string | null;
    fingerprint?: string | null;
    cardholderName?: string | null;
    cardholderEmail?: string | null;
    expiration?: any | null;
    bank?: string | null;
    tokenizationMethod?: TokenizationMethods | null;
    srcCorrelationId?: string | null;
    srciTransactionId?: string | null;
    srcDpaId?: string | null;
  } | null;
  cardPresent?: {
    __typename?: 'PaymentMethodCardPresent';
    bin?: string | null;
    brand?: CardBrand | null;
    cardholderEmail?: string | null;
    cardholderName?: string | null;
    country?: string | null;
    expiration?: any | null;
    last4?: string | null;
    fingerprint?: string | null;
    type?: CardType | null;
    verificationMethod?: VerificationMethod | null;
  } | null;
  mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
  paypal?: {
    __typename?: 'PaymentMethodPaypal';
    orderId?: string | null;
    payerId?: string | null;
    email?: string | null;
    name?: string | null;
  } | null;
  sepa?: {
    __typename?: 'PaymentMethodSepa';
    accountholderEmail?: string | null;
    accountholderName?: string | null;
    countryCode?: string | null;
    bankAddress?: string | null;
    bankCode?: string | null;
    bankName?: string | null;
    bic?: string | null;
    last4?: string | null;
    fingerprint?: string | null;
    accountholderAddress?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  } | null;
  trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
  klarna?: {
    __typename?: 'PaymentMethodKlarna';
    billingCategory?: BillingCategoryKlarna | null;
    authPaymentMethod?: AuthPaymentMethodKlarna | null;
  } | null;
};

export type ProviderFieldsFragment = {
  __typename?: 'Provider';
  id: string;
  processor?: Processor | null;
  enabled?: boolean | null;
  test?: boolean | null;
  paymentMethod?: PaymentMethods | null;
  acquirer?: Acquirer | null;
  currencies?: Array<Currencies> | null;
  nativeHostedPayment?: boolean | null;
  metadata?: Array<{
    __typename?: 'MetadataItem';
    key: string;
    value?: string | null;
    type: MetadataItemType;
    label?: string | null;
    possibleValues?: Array<string> | null;
    regex?: string | null;
    example?: string | null;
    secret?: boolean | null;
  }> | null;
  rules?: {
    __typename?: 'ProviderRules';
    minAmount?: number | null;
    maxAmount?: number | null;
    shopNameLike?: string | null;
    descriptionLike?: string | null;
  } | null;
};

export type ChargeFieldsFragment = {
  __typename?: 'Charge';
  id: string;
  accountId: string;
  providerId?: string | null;
  checkoutId: string;
  sequenceId?: string | null;
  processor?: Processor | null;
  subscriptionId?: string | null;
  pointOfSaleId?: string | null;
  providerReferenceId?: string | null;
  providerInternalId?: string | null;
  masterAccountId?: string | null;
  billingPlan?: BillingPlans | null;
  createdAt: number;
  updatedAt?: number | null;
  amount?: number | null;
  acquirer?: Acquirer | null;
  authorizationCode?: string | null;
  storeId?: string | null;
  currency: string;
  description?: string | null;
  descriptor?: string | null;
  livemode?: boolean | null;
  orderId?: string | null;
  refundedAmount?: number | null;
  lastRefundAmount?: number | null;
  lastRefundReason?: RefundReason | null;
  cancellationReason?: CancellationReason | null;
  status: ChargeStatus;
  statusCode?: string | null;
  statusMessage?: string | null;
  providerStatusCode?: string | null;
  providerStatusMessage?: string | null;
  issuerStatusCode?: string | null;
  issuerStatusMessage?: string | null;
  fraudDetectorScore?: number | null;
  callbackUrl?: string | null;
  completeUrl?: string | null;
  failUrl?: string | null;
  cancelUrl?: string | null;
  billingDetails?: {
    __typename?: 'ContactDetails';
    email?: string | null;
    name?: string | null;
    company?: string | null;
    phone?: string | null;
    taxId?: string | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  } | null;
  customer?: {
    __typename?: 'Customer';
    email?: string | null;
    name?: string | null;
    phone?: string | null;
  } | null;
  paymentMethod?: {
    __typename?: 'PaymentMethod';
    method?: PaymentMethods | null;
    bizum?: {
      __typename?: 'PaymentMethodBizum';
      phoneNumber?: string | null;
      integrationType?: string | null;
      ibanLast4?: string | null;
      idBizum?: string | null;
    } | null;
    card?: {
      __typename?: 'PaymentMethodCard';
      brand?: CardBrand | null;
      country?: string | null;
      type?: CardType | null;
      threeDSecure?: boolean | null;
      threeDSecureVersion?: string | null;
      threeDSecureFlow?: ThreeDSecureFlow | null;
      threeDSecureStatus?: ThreeDsStatus | null;
      last4?: string | null;
      fingerprint?: string | null;
      cardholderName?: string | null;
      cardholderEmail?: string | null;
      expiration?: any | null;
      bank?: string | null;
      tokenizationMethod?: TokenizationMethods | null;
      srcCorrelationId?: string | null;
      srciTransactionId?: string | null;
      srcDpaId?: string | null;
    } | null;
    cardPresent?: {
      __typename?: 'PaymentMethodCardPresent';
      bin?: string | null;
      brand?: CardBrand | null;
      cardholderEmail?: string | null;
      cardholderName?: string | null;
      country?: string | null;
      expiration?: any | null;
      last4?: string | null;
      fingerprint?: string | null;
      type?: CardType | null;
      verificationMethod?: VerificationMethod | null;
    } | null;
    mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
    paypal?: {
      __typename?: 'PaymentMethodPaypal';
      orderId?: string | null;
      payerId?: string | null;
      email?: string | null;
      name?: string | null;
    } | null;
    sepa?: {
      __typename?: 'PaymentMethodSepa';
      accountholderEmail?: string | null;
      accountholderName?: string | null;
      countryCode?: string | null;
      bankAddress?: string | null;
      bankCode?: string | null;
      bankName?: string | null;
      bic?: string | null;
      last4?: string | null;
      fingerprint?: string | null;
      accountholderAddress?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
    klarna?: {
      __typename?: 'PaymentMethodKlarna';
      billingCategory?: BillingCategoryKlarna | null;
      authPaymentMethod?: AuthPaymentMethodKlarna | null;
    } | null;
  } | null;
  shippingDetails?: {
    __typename?: 'ContactDetails';
    email?: string | null;
    name?: string | null;
    company?: string | null;
    phone?: string | null;
    taxId?: string | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  } | null;
  shop?: {__typename?: 'Shop'; name?: string | null; country?: string | null} | null;
  sessionDetails?: {
    __typename?: 'SessionDetails';
    ip?: string | null;
    fingerprint?: string | null;
    userAgent?: string | null;
    countryCode?: string | null;
    lang?: string | null;
    deviceType?: DeviceType | null;
    deviceModel?: string | null;
    browser?: string | null;
    browserVersion?: string | null;
    browserAccept?: string | null;
    browserColorDepth?: string | null;
    browserScreenHeight?: string | null;
    browserScreenWidth?: string | null;
    browserTimezoneOffset?: string | null;
    os?: string | null;
    osVersion?: string | null;
    source?: string | null;
    sourceVersion?: string | null;
  } | null;
  traceDetails?: {
    __typename?: 'TraceDetails';
    ip?: string | null;
    userAgent?: string | null;
    countryCode?: string | null;
    lang?: string | null;
    deviceType?: DeviceType | null;
    deviceModel?: string | null;
    browser?: string | null;
    browserVersion?: string | null;
    browserAccept?: string | null;
    os?: string | null;
    osVersion?: string | null;
    source?: string | null;
    sourceVersion?: string | null;
    userId?: string | null;
    userEmail?: string | null;
    userName?: string | null;
  } | null;
  metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
};

export type ChargeEventObjectFieldsFragment = {
  __typename?: 'ChargeEventObject';
  id: string;
  accountId: string;
  providerId?: string | null;
  checkoutId: string;
  sequenceId?: string | null;
  billingPlan?: BillingPlans | null;
  subscriptionId?: string | null;
  storeId?: string | null;
  pointOfSaleId?: string | null;
  providerReferenceId?: string | null;
  providerInternalId?: string | null;
  createdAt?: number | null;
  updatedAt?: number | null;
  amount?: number | null;
  amountEUR?: number | null;
  authorizationCode?: string | null;
  currency: string;
  description?: string | null;
  descriptor?: string | null;
  livemode?: boolean | null;
  orderId?: string | null;
  terminalId?: string | null;
  masterAccountId?: string | null;
  refundedAmount?: number | null;
  lastRefundAmount?: number | null;
  lastRefundReason?: RefundReason | null;
  cancellationReason?: CancellationReason | null;
  status: ChargeStatus;
  statusCode?: string | null;
  statusMessage?: string | null;
  providerStatusCode?: string | null;
  providerStatusMessage?: string | null;
  issuerStatusCode?: string | null;
  issuerStatusMessage?: string | null;
  pageOpenedAt?: number | null;
  fraudDetectorScore?: number | null;
  callbackUrl?: string | null;
  completeUrl?: string | null;
  failUrl?: string | null;
  cancelUrl?: string | null;
  billingDetails?: {
    __typename?: 'ContactDetails';
    email?: string | null;
    name?: string | null;
    company?: string | null;
    phone?: string | null;
    taxId?: string | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  } | null;
  customer?: {
    __typename?: 'Customer';
    email?: string | null;
    name?: string | null;
    phone?: string | null;
  } | null;
  paymentMethod?: {
    __typename?: 'PaymentMethod';
    method?: PaymentMethods | null;
    bizum?: {
      __typename?: 'PaymentMethodBizum';
      phoneNumber?: string | null;
      integrationType?: string | null;
      ibanLast4?: string | null;
      idBizum?: string | null;
    } | null;
    card?: {
      __typename?: 'PaymentMethodCard';
      brand?: CardBrand | null;
      country?: string | null;
      type?: CardType | null;
      threeDSecure?: boolean | null;
      threeDSecureVersion?: string | null;
      threeDSecureFlow?: ThreeDSecureFlow | null;
      threeDSecureStatus?: ThreeDsStatus | null;
      last4?: string | null;
      fingerprint?: string | null;
      cardholderName?: string | null;
      cardholderEmail?: string | null;
      expiration?: any | null;
      bank?: string | null;
      tokenizationMethod?: TokenizationMethods | null;
      srcCorrelationId?: string | null;
      srciTransactionId?: string | null;
      srcDpaId?: string | null;
    } | null;
    cardPresent?: {
      __typename?: 'PaymentMethodCardPresent';
      bin?: string | null;
      brand?: CardBrand | null;
      cardholderEmail?: string | null;
      cardholderName?: string | null;
      country?: string | null;
      expiration?: any | null;
      last4?: string | null;
      fingerprint?: string | null;
      type?: CardType | null;
      verificationMethod?: VerificationMethod | null;
    } | null;
    mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
    paypal?: {
      __typename?: 'PaymentMethodPaypal';
      orderId?: string | null;
      payerId?: string | null;
      email?: string | null;
      name?: string | null;
    } | null;
    sepa?: {
      __typename?: 'PaymentMethodSepa';
      accountholderEmail?: string | null;
      accountholderName?: string | null;
      countryCode?: string | null;
      bankAddress?: string | null;
      bankCode?: string | null;
      bankName?: string | null;
      bic?: string | null;
      last4?: string | null;
      fingerprint?: string | null;
      accountholderAddress?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
    klarna?: {
      __typename?: 'PaymentMethodKlarna';
      billingCategory?: BillingCategoryKlarna | null;
      authPaymentMethod?: AuthPaymentMethodKlarna | null;
    } | null;
  } | null;
  shippingDetails?: {
    __typename?: 'ContactDetails';
    email?: string | null;
    name?: string | null;
    company?: string | null;
    taxId?: string | null;
    phone?: string | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  } | null;
  shop?: {__typename?: 'Shop'; name?: string | null; country?: string | null} | null;
  sessionDetails?: {
    __typename?: 'SessionDetails';
    ip?: string | null;
    fingerprint?: string | null;
    userAgent?: string | null;
    countryCode?: string | null;
    lang?: string | null;
    deviceType?: DeviceType | null;
    deviceModel?: string | null;
    browser?: string | null;
    browserVersion?: string | null;
    browserAccept?: string | null;
    browserColorDepth?: string | null;
    browserScreenHeight?: string | null;
    browserScreenWidth?: string | null;
    browserTimezoneOffset?: string | null;
    os?: string | null;
    osVersion?: string | null;
    source?: string | null;
    sourceVersion?: string | null;
  } | null;
  traceDetails?: {
    __typename?: 'TraceDetails';
    ip?: string | null;
    userAgent?: string | null;
    countryCode?: string | null;
    lang?: string | null;
    deviceType?: DeviceType | null;
    deviceModel?: string | null;
    browser?: string | null;
    browserVersion?: string | null;
    browserAccept?: string | null;
    os?: string | null;
    osVersion?: string | null;
    source?: string | null;
    sourceVersion?: string | null;
    userId?: string | null;
    userEmail?: string | null;
    userName?: string | null;
  } | null;
  metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
};

export type UserFieldsFragment = {
  __typename?: 'User';
  id: string;
  email: string;
  emailVerified?: boolean | null;
  phoneNumber?: string | null;
  phoneNumberVerified?: boolean | null;
  smsMfaEnabled?: boolean | null;
  status: UserStatus;
  enabled: boolean;
  accountId?: string | null;
  testAccountId?: string | null;
  referralCode?: string | null;
  promoCode?: string | null;
  createdAt: string;
};

export type AccountFieldsFragment = {
  __typename?: 'Account';
  id: string;
  refAccountId?: string | null;
  testAccountId?: string | null;
  prodAccountId?: string | null;
  name?: string | null;
  status: AccountStatus;
  note?: string | null;
  userNote?: string | null;
  partner?: Partner | null;
  acquirer?: Acquirer | null;
  adminEmail?: string | null;
  allowCreateApiKey?: boolean | null;
  allowRefunds?: boolean | null;
  defaultCurrency?: Currencies | null;
  defaultTransactionType?: TransactionTypes | null;
  referralCode?: string | null;
  promoCode?: string | null;
  language?: string | null;
  reviewConfirmed?: boolean | null;
  progressiveBilling?: boolean | null;
  billingEmail?: string | null;
  billingPlan?: BillingPlans | null;
  riskScore?: number | null;
  riskProfile?: RiskProfile | null;
  riskProcessing?: boolean | null;
  riskProfileNote?: string | null;
  riskIgnoredKeywords?: Array<string> | null;
  riskUpdatedAt?: string | null;
  iban?: string | null;
  dynamicBilling?: boolean | null;
  test?: boolean | null;
  secret?: string | null;
  apiKey?: string | null;
  customDomain?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  deletedAt?: string | null;
  approvedAt?: string | null;
  rejectedAt?: string | null;
  activatedAt?: string | null;
  sepblacId?: string | null;
  approvalRequestedAt?: string | null;
  suspendedAt?: string | null;
  dataUpdatedAt?: string | null;
  accountExecutive?: SalesExecutive | null;
  billingVatPercent?: number | null;
  churned?: boolean | null;
  blocked?: boolean | null;
  statusReason?: StatusReason | null;
  statusNote?: string | null;
  churnReason?: ChurnReason | null;
  churnReasonOption?: string | null;
  churnNote?: string | null;
  previewFeatures?: Array<string> | null;
  tags?: Array<string> | null;
  masterAccountId?: string | null;
  accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null;
  customAccountInvoiceNotes?: Array<string> | null;
  groupInvoicesByStore?: boolean | null;
  fraudDetectorEnabled?: boolean | null;
  fraudDetectorThreshold?: number | null;
  fraudRulesEnabled?: boolean | null;
  contactPerson?: {
    __typename?: 'ContactPerson';
    name: string;
    email: string;
    phone?: string | null;
  } | null;
  branding?: {
    __typename?: 'AccountBranding';
    accentColor?: string | null;
    bgColor?: string | null;
    logoUrl?: string | null;
    iconUrl?: string | null;
  } | null;
  tokenizationMethods?: {
    __typename?: 'AccountTokenizationMethods';
    googlePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
    applePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
    clickToPay?: {
      __typename?: 'AccountTokenizationMethodsClickToPayItem';
      enabled?: boolean | null;
    } | null;
  } | null;
  notifications?: {
    __typename?: 'AccountNotifications';
    emailCustomerOnRefund?: boolean | null;
    emailCustomerOnSuccess?: boolean | null;
    emailAdminOnSuccess?: boolean | null;
    emailCustomerOnSubscription?: boolean | null;
    emailAdminOnSubscription?: boolean | null;
    emailOnAccountInvoice?: boolean | null;
  } | null;
  fees?: {
    __typename?: 'AccountFees';
    highRiskFee?: number | null;
    dailyExtraSeatsFee?: number | null;
    dailyPlatformFee?: number | null;
    weeklyCustomDomainFee?: number | null;
    fraudDetectorTrxFlatFee?: number | null;
    cardPresentTrxFee?: number | null;
    cardPresentTrxFlatFee?: number | null;
    steps?: Array<{
      __typename?: 'AccountSteps';
      trxFee: number;
      bizumTrxFee?: number | null;
      bizumTrxFlatFee?: number | null;
      trxFlatFee: number;
      from: number;
    }> | null;
    extra?: Array<{
      __typename?: 'AccountExtraFee';
      name: string;
      amount: number;
      type: AccountExtraFeeType;
      masterAccountFee?: boolean | null;
      paymentMethods?: Array<PaymentMethods> | null;
    }> | null;
  } | null;
  riskLabels?: Array<{
    __typename?: 'RiskLabel';
    label?: string | null;
    category?: string | null;
    riskScore?: number | null;
  }> | null;
  business?: {
    __typename?: 'BusinessData';
    country?: string | null;
    legalForm?: LegalForm | null;
    legalName?: string | null;
    companyName?: string | null;
    mcc?: string | null;
    documentNumber?: string | null;
    status?: BusinessStatus | null;
    email?: string | null;
    phone?: string | null;
    website?: string | null;
    monthlyVolume?: number | null;
    confirmWebsite?: boolean | null;
    industry?: Industries | null;
    servicesDescription?: string | null;
    confirmServicesDescription?: boolean | null;
    legalAddress?: string | null;
    legalDescription?: string | null;
    creationDate?: string | null;
    lastUpdateDate?: string | null;
    startActivityDate?: string | null;
    capital?: any | null;
    previousNames?: Array<string | null> | null;
    verificationAttempts?: number | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
    registryRecords?: Array<{
      __typename?: 'RegistryRecord';
      name?: string | null;
      url?: string | null;
      province?: string | null;
      date?: string | null;
    }> | null;
    positions?: Array<{
      __typename?: 'BusinessPosition';
      fromDate?: string | null;
      role?: string | null;
      name?: string | null;
    }> | null;
    pibisi?: {
      __typename?: 'Pibisi';
      id?: string | null;
      entityId?: string | null;
      status?: PibisiStatus | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      deletedAt?: string | null;
    } | null;
  } | null;
  representatives?: Array<{
    __typename?: 'RepresentativeData';
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
    documentNumber?: string | null;
    stocksPercentage?: number | null;
    gender?: Gender | null;
    citizenship?: string | null;
    dateOfBirth?: string | null;
    nationality?: string | null;
    yearOfBirth?: string | null;
    placeOfBirth?: string | null;
    idSession?: string | null;
    interventionType?: Array<InterventionType> | null;
    status?: IdVerificationStatus | null;
    statusCode?: number | null;
    hasNoPublicActivity?: boolean | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
    document?: {
      __typename?: 'IdDocument';
      type?: IdDocumentType | null;
      number?: string | null;
      country?: string | null;
      validFrom?: string | null;
      validUntil?: string | null;
    } | null;
    riskLabels?: Array<{
      __typename?: 'RiskLabel';
      label?: string | null;
      category?: string | null;
    }> | null;
    pibisi?: {
      __typename?: 'Pibisi';
      id?: string | null;
      entityId?: string | null;
      status?: PibisiStatus | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      deletedAt?: string | null;
    } | null;
  }> | null;
  payoutTerms?: {
    __typename?: 'AccountPayoutTerms';
    iban?: string | null;
    period?: number | null;
    firstPeriod?: number | null;
    reservePercent?: number | null;
    suspended?: boolean | null;
    releaseReserve?: boolean | null;
    settleGross?: boolean | null;
    bankTransferConceptPrefix?: string | null;
    settleToStores?: boolean | null;
  } | null;
  publicBusinessDetails?: {
    __typename?: 'AccountPublicBusinessDetails';
    companyName?: string | null;
    website?: string | null;
    phone?: string | null;
    supportWebsite?: string | null;
    supportPhone?: string | null;
    supportEmail?: string | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  } | null;
  contract?: {
    __typename?: 'AccountContract';
    envelopeId?: string | null;
    status: ContractStatus;
    path?: string | null;
    signedDate?: string | null;
  } | null;
  upsell?: {
    __typename?: 'Upsell';
    executive?: SalesExecutive | null;
    paymentMethods?: Array<PaymentMethods> | null;
    date?: string | null;
    note?: string | null;
  } | null;
};

export type AuthorizedUserFieldsFragment = {
  __typename?: 'AuthorizedUser';
  id?: string | null;
  accountId?: string | null;
  userEmail: string;
  accessLevel: AuthorizedUserAccessLevel;
  storeId?: string | null;
  pointOfSaleId?: string | null;
  status?: AuthorizedUserStatus | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  lastLoginAt?: string | null;
};

export type AccountEventObjectFieldsFragment = {
  __typename?: 'AccountEventObject';
  id: string;
  refAccountId?: string | null;
  name?: string | null;
  status: AccountStatus;
  note?: string | null;
  userNote?: string | null;
  partner?: Partner | null;
  acquirer?: Acquirer | null;
  adminEmail?: string | null;
  defaultCurrency?: Currencies | null;
  tags?: Array<string> | null;
  defaultTransactionType?: TransactionTypes | null;
  referralCode?: string | null;
  promoCode?: string | null;
  reviewConfirmed?: boolean | null;
  billingPlan?: BillingPlans | null;
  riskScore?: number | null;
  iban?: string | null;
  dynamicBilling?: boolean | null;
  test?: boolean | null;
  customDomain?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  deletedAt?: string | null;
  approvedAt?: string | null;
  rejectedAt?: string | null;
  activatedAt?: string | null;
  approvalRequestedAt?: string | null;
  riskProfile?: RiskProfile | null;
  riskProfileNote?: string | null;
  riskIgnoredKeywords?: Array<string> | null;
  riskUpdatedAt?: string | null;
  suspendedAt?: string | null;
  dataUpdatedAt?: string | null;
  fraudDetectorEnabled?: boolean | null;
  fraudDetectorThreshold?: number | null;
  fraudRulesEnabled?: boolean | null;
  churnReason?: ChurnReason | null;
  churnReasonOption?: string | null;
  churnNote?: string | null;
  statusReason?: StatusReason | null;
  statusNote?: string | null;
  accountExecutive?: string | null;
  tokenizationMethods?: {
    __typename?: 'AccountTokenizationMethods';
    googlePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
    applePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
    clickToPay?: {
      __typename?: 'AccountTokenizationMethodsClickToPayItem';
      enabled?: boolean | null;
    } | null;
  } | null;
  notifications?: {
    __typename?: 'AccountNotifications';
    emailCustomerOnRefund?: boolean | null;
    emailCustomerOnSuccess?: boolean | null;
    emailAdminOnSuccess?: boolean | null;
  } | null;
  fees?: {
    __typename?: 'AccountFees';
    highRiskFee?: number | null;
    dailyExtraSeatsFee?: number | null;
    dailyPlatformFee?: number | null;
    weeklyCustomDomainFee?: number | null;
    fraudDetectorTrxFlatFee?: number | null;
    cardPresentTrxFee?: number | null;
    cardPresentTrxFlatFee?: number | null;
    steps?: Array<{
      __typename?: 'AccountSteps';
      trxFee: number;
      bizumTrxFee?: number | null;
      bizumTrxFlatFee?: number | null;
      trxFlatFee: number;
      from: number;
    }> | null;
    extra?: Array<{
      __typename?: 'AccountExtraFee';
      name: string;
      amount: number;
      type: AccountExtraFeeType;
      paymentMethods?: Array<PaymentMethods> | null;
      region?: AccountExtraFeeRegion | null;
    }> | null;
  } | null;
  business?: {
    __typename?: 'BusinessData';
    country?: string | null;
    legalForm?: LegalForm | null;
    legalName?: string | null;
    companyName?: string | null;
    mcc?: string | null;
    documentNumber?: string | null;
    status?: BusinessStatus | null;
    email?: string | null;
    phone?: string | null;
    website?: string | null;
    monthlyVolume?: number | null;
    confirmWebsite?: boolean | null;
    industry?: Industries | null;
    servicesDescription?: string | null;
    confirmServicesDescription?: boolean | null;
    legalAddress?: string | null;
    legalDescription?: string | null;
    creationDate?: string | null;
    lastUpdateDate?: string | null;
    startActivityDate?: string | null;
    capital?: any | null;
    previousNames?: Array<string | null> | null;
    verificationAttempts?: number | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
    registryRecords?: Array<{
      __typename?: 'RegistryRecord';
      name?: string | null;
      url?: string | null;
      province?: string | null;
      date?: string | null;
    }> | null;
    positions?: Array<{
      __typename?: 'BusinessPosition';
      fromDate?: string | null;
      role?: string | null;
      name?: string | null;
    }> | null;
  } | null;
  representatives?: Array<{
    __typename?: 'RepresentativeData';
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
    documentNumber?: string | null;
    stocksPercentage?: number | null;
    gender?: Gender | null;
    citizenship?: string | null;
    dateOfBirth?: string | null;
    nationality?: string | null;
    yearOfBirth?: string | null;
    placeOfBirth?: string | null;
    idSession?: string | null;
    interventionType?: Array<InterventionType> | null;
    status?: IdVerificationStatus | null;
    statusCode?: number | null;
    hasNoPublicActivity?: boolean | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
    document?: {
      __typename?: 'IdDocument';
      type?: IdDocumentType | null;
      number?: string | null;
      country?: string | null;
      validFrom?: string | null;
      validUntil?: string | null;
    } | null;
    riskLabels?: Array<{
      __typename?: 'RiskLabel';
      label?: string | null;
      category?: string | null;
    }> | null;
  }> | null;
  payoutTerms?: {
    __typename?: 'AccountPayoutTerms';
    iban?: string | null;
    period?: number | null;
    firstPeriod?: number | null;
    reservePercent?: number | null;
    suspended?: boolean | null;
    releaseReserve?: boolean | null;
  } | null;
  publicBusinessDetails?: {
    __typename?: 'AccountPublicBusinessDetails';
    companyName?: string | null;
    website?: string | null;
    phone?: string | null;
    supportWebsite?: string | null;
    supportPhone?: string | null;
    supportEmail?: string | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  } | null;
  branding?: {
    __typename?: 'AccountBranding';
    accentColor?: string | null;
    bgColor?: string | null;
    logoUrl?: string | null;
    iconUrl?: string | null;
  } | null;
  contract?: {
    __typename?: 'AccountContract';
    envelopeId?: string | null;
    status: ContractStatus;
    path?: string | null;
    signedDate?: string | null;
  } | null;
  riskLabels?: Array<{
    __typename?: 'RiskLabel';
    label?: string | null;
    category?: string | null;
    riskScore?: number | null;
  }> | null;
  traceDetails?: {
    __typename?: 'TraceDetails';
    ip?: string | null;
    userAgent?: string | null;
    countryCode?: string | null;
    lang?: string | null;
    deviceType?: DeviceType | null;
    deviceModel?: string | null;
    browser?: string | null;
    browserVersion?: string | null;
    browserAccept?: string | null;
    os?: string | null;
    osVersion?: string | null;
    source?: string | null;
    sourceVersion?: string | null;
    userId?: string | null;
    userEmail?: string | null;
    userName?: string | null;
  } | null;
  upsell?: {
    __typename?: 'Upsell';
    executive?: SalesExecutive | null;
    paymentMethods?: Array<PaymentMethods> | null;
    date?: string | null;
    note?: string | null;
  } | null;
};

export type MasterAccountEventObjectFieldsFragment = {
  __typename?: 'MasterAccountEventObject';
  id: string;
  accountCallbackUrl?: string | null;
  apiKey?: string | null;
  adminEmail?: string | null;
  test: boolean;
  testAccountId?: string | null;
  prodAccountId?: string | null;
  contractTemplateId?: string | null;
  churnedEmails?: Array<string> | null;
  allowedDomains?: Array<string> | null;
  allowedIPs?: Array<string> | null;
  blocked?: boolean | null;
  iban?: string | null;
  note?: string | null;
  name?: string | null;
  promoCode?: string | null;
  status?: AccountStatus | null;
  updatedAt?: string | null;
  webhookEmails?: Array<string> | null;
  business?: {
    __typename?: 'BusinessData';
    mcc?: string | null;
    legalName?: string | null;
    website?: string | null;
    documentNumber?: string | null;
    servicesDescription?: string | null;
  } | null;
  contract?: {
    __typename?: 'AccountContract';
    envelopeId?: string | null;
    status: ContractStatus;
    path?: string | null;
    signedDate?: string | null;
  } | null;
  payoutTerms?: {
    __typename?: 'AccountPayoutTerms';
    iban?: string | null;
    period?: number | null;
    firstPeriod?: number | null;
    reservePercent?: number | null;
    suspended?: boolean | null;
    releaseReserve?: boolean | null;
  } | null;
  traceDetails?: {
    __typename?: 'TraceDetails';
    ip?: string | null;
    userAgent?: string | null;
    countryCode?: string | null;
    lang?: string | null;
    deviceType?: DeviceType | null;
    deviceModel?: string | null;
    browser?: string | null;
    browserVersion?: string | null;
    browserAccept?: string | null;
    os?: string | null;
    osVersion?: string | null;
    source?: string | null;
    sourceVersion?: string | null;
    userId?: string | null;
    userEmail?: string | null;
    userName?: string | null;
  } | null;
};

export type SettlementFieldsFragment = {
  __typename?: 'Settlement';
  accountId: string;
  acquirer: SettlementAcquirer;
  acquirerFees: number;
  grossVolume: number;
  iban?: string | null;
  id: string;
  payMethod?: SettlementPayMethods | null;
  netVolume: number;
  periodEndAt: number;
  periodStartAt: number;
  releasedAmount?: number | null;
  reservedAmount?: number | null;
  scheduledAt: number;
  status: SettlementStatus;
  legalName?: string | null;
  storeId?: string | null;
  settleGross?: boolean | null;
  currency?: string | null;
};

export type AccountInvoiceFieldsFragment = {
  __typename?: 'AccountInvoice';
  id?: string | null;
  number?: string | null;
  accountId: string;
  currency: string;
  amount: number;
  tax: number;
  totalAmount: number;
  status?: AccountInvoiceStatus | null;
  paymentMethod?: AccountInvoicePaymentMethod | null;
  period: {__typename?: 'AccountInvoicePeriod'; from?: number | null; to?: number | null};
  lineItems: Array<{
    __typename?: 'AccountInvoiceLineItem';
    name: string;
    quantity: number;
    unitAmount: number;
    unitType: InvoiceLineItemUnitType;
    currency: string;
    amount: number;
  }>;
  business?: {__typename?: 'InvoiceBusinessData'; iban?: string | null} | null;
};

export type PaymentFieldsFragment = {
  __typename?: 'Payment';
  id: string;
  accountId: string;
  sequenceId?: string | null;
  subscriptionId?: string | null;
  pointOfSaleId?: string | null;
  masterAccountId?: string | null;
  createdAt?: number | null;
  updatedAt?: number | null;
  amount?: number | null;
  authorizationCode?: string | null;
  storeId?: string | null;
  currency: string;
  description?: string | null;
  descriptor?: string | null;
  livemode?: boolean | null;
  orderId?: string | null;
  refundedAmount?: number | null;
  lastRefundAmount?: number | null;
  lastRefundReason?: RefundReason | null;
  cancellationReason?: CancellationReason | null;
  status: PaymentStatus;
  statusCode?: string | null;
  statusMessage?: string | null;
  billingDetails?: {
    __typename?: 'ContactDetails';
    email?: string | null;
    name?: string | null;
    company?: string | null;
    phone?: string | null;
    taxId?: string | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  } | null;
  customer?: {
    __typename?: 'Customer';
    email?: string | null;
    name?: string | null;
    phone?: string | null;
  } | null;
  paymentMethod?: {
    __typename?: 'PaymentMethod';
    method?: PaymentMethods | null;
    bizum?: {
      __typename?: 'PaymentMethodBizum';
      phoneNumber?: string | null;
      integrationType?: string | null;
      ibanLast4?: string | null;
      idBizum?: string | null;
    } | null;
    card?: {
      __typename?: 'PaymentMethodCard';
      brand?: CardBrand | null;
      country?: string | null;
      type?: CardType | null;
      threeDSecure?: boolean | null;
      threeDSecureVersion?: string | null;
      threeDSecureFlow?: ThreeDSecureFlow | null;
      threeDSecureStatus?: ThreeDsStatus | null;
      last4?: string | null;
      fingerprint?: string | null;
      cardholderName?: string | null;
      cardholderEmail?: string | null;
      expiration?: any | null;
      bank?: string | null;
      tokenizationMethod?: TokenizationMethods | null;
      srcCorrelationId?: string | null;
      srciTransactionId?: string | null;
      srcDpaId?: string | null;
    } | null;
    cardPresent?: {
      __typename?: 'PaymentMethodCardPresent';
      bin?: string | null;
      brand?: CardBrand | null;
      cardholderEmail?: string | null;
      cardholderName?: string | null;
      country?: string | null;
      expiration?: any | null;
      last4?: string | null;
      fingerprint?: string | null;
      type?: CardType | null;
      verificationMethod?: VerificationMethod | null;
    } | null;
    mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
    paypal?: {
      __typename?: 'PaymentMethodPaypal';
      orderId?: string | null;
      payerId?: string | null;
      email?: string | null;
      name?: string | null;
    } | null;
    sepa?: {
      __typename?: 'PaymentMethodSepa';
      accountholderEmail?: string | null;
      accountholderName?: string | null;
      countryCode?: string | null;
      bankAddress?: string | null;
      bankCode?: string | null;
      bankName?: string | null;
      bic?: string | null;
      last4?: string | null;
      fingerprint?: string | null;
      accountholderAddress?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
    klarna?: {
      __typename?: 'PaymentMethodKlarna';
      billingCategory?: BillingCategoryKlarna | null;
      authPaymentMethod?: AuthPaymentMethodKlarna | null;
    } | null;
  } | null;
  shippingDetails?: {
    __typename?: 'ContactDetails';
    email?: string | null;
    name?: string | null;
    company?: string | null;
    phone?: string | null;
    taxId?: string | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  } | null;
  shop?: {__typename?: 'Shop'; name?: string | null; country?: string | null} | null;
  sessionDetails?: {
    __typename?: 'SessionDetails';
    ip?: string | null;
    fingerprint?: string | null;
    userAgent?: string | null;
    countryCode?: string | null;
    lang?: string | null;
    deviceType?: DeviceType | null;
    deviceModel?: string | null;
    browser?: string | null;
    browserVersion?: string | null;
    browserAccept?: string | null;
    browserColorDepth?: string | null;
    browserScreenHeight?: string | null;
    browserScreenWidth?: string | null;
    browserTimezoneOffset?: string | null;
    os?: string | null;
    osVersion?: string | null;
    source?: string | null;
    sourceVersion?: string | null;
  } | null;
  traceDetails?: {
    __typename?: 'TraceDetails';
    ip?: string | null;
    userAgent?: string | null;
    countryCode?: string | null;
    lang?: string | null;
    deviceType?: DeviceType | null;
    deviceModel?: string | null;
    browser?: string | null;
    browserVersion?: string | null;
    browserAccept?: string | null;
    os?: string | null;
    osVersion?: string | null;
    source?: string | null;
    sourceVersion?: string | null;
    userId?: string | null;
    userEmail?: string | null;
    userName?: string | null;
  } | null;
  nextAction?: {
    __typename?: 'NextAction';
    type?: NextActionTypes | null;
    redirectUrl?: string | null;
    mustRedirect?: boolean | null;
  } | null;
};

export type MasterAccountFieldsFragment = {
  __typename?: 'MasterAccount';
  id: string;
  testAccountId?: string | null;
  prodAccountId?: string | null;
  name?: string | null;
  adminEmail?: string | null;
  iban?: string | null;
  apiKey?: string | null;
  test?: boolean | null;
  status?: AccountStatus | null;
  promoCode?: string | null;
  allowedIPs?: Array<string> | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  webhookEmails?: Array<string> | null;
  churnedEmails?: Array<string> | null;
  allowedDomains?: Array<string> | null;
  accountCallbackUrl?: string | null;
  requireExternalId?: boolean | null;
  contractTemplateId?: string | null;
  autoApprove?: boolean | null;
  blocked?: boolean | null;
  note?: string | null;
  allowCreateApiKey?: boolean | null;
  payoutTerms?: {
    __typename?: 'AccountPayoutTerms';
    iban?: string | null;
    firstPeriod?: number | null;
    period?: number | null;
    reservePercent?: number | null;
    suspended?: boolean | null;
    releaseReserve?: boolean | null;
  } | null;
  accountDefaults?: {
    __typename?: 'AccountDefaults';
    billingPlan?: BillingPlans | null;
    language?: string | null;
    fees?: {
      __typename?: 'AccountFees';
      trxFee?: number | null;
      trxFlatFee?: number | null;
      highRiskFee?: number | null;
      dailyPlatformFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      steps?: Array<{
        __typename?: 'AccountSteps';
        trxFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        trxFlatFee: number;
        from: number;
      }> | null;
      extra?: Array<{
        __typename?: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        region?: AccountExtraFeeRegion | null;
        masterAccountFee?: boolean | null;
        paymentMethods?: Array<PaymentMethods> | null;
      }> | null;
    } | null;
    business?: {
      __typename?: 'BusinessDefault';
      mcc?: string | null;
      website?: string | null;
      servicesDescription?: string | null;
    } | null;
  } | null;
  business?: {
    __typename?: 'BusinessData';
    mcc?: string | null;
    legalName?: string | null;
    website?: string | null;
    documentNumber?: string | null;
    servicesDescription?: string | null;
  } | null;
  contract?: {
    __typename?: 'AccountContract';
    envelopeId?: string | null;
    status: ContractStatus;
    path?: string | null;
    signedDate?: string | null;
  } | null;
  branding?: {
    __typename?: 'AccountBranding';
    accentColor?: string | null;
    bgColor?: string | null;
    logoUrl?: string | null;
    iconUrl?: string | null;
  } | null;
};

export type UserMasterAccountFieldsFragment = {
  __typename?: 'MasterAccount';
  id: string;
  name?: string | null;
  status?: AccountStatus | null;
  promoCode?: string | null;
  allowedIPs?: Array<string> | null;
  webhookEmails?: Array<string> | null;
  churnedEmails?: Array<string> | null;
  allowedDomains?: Array<string> | null;
  accountCallbackUrl?: string | null;
  requireExternalId?: boolean | null;
  apiKey?: string | null;
  test?: boolean | null;
  publicBusinessDetails?: {
    __typename?: 'AccountPublicBusinessDetails';
    companyName?: string | null;
    website?: string | null;
    phone?: string | null;
    supportWebsite?: string | null;
    supportPhone?: string | null;
    supportEmail?: string | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  } | null;
  branding?: {
    __typename?: 'AccountBranding';
    accentColor?: string | null;
    bgColor?: string | null;
    logoUrl?: string | null;
    iconUrl?: string | null;
  } | null;
};

export type DocumentFieldsFragment = {
  __typename?: 'Document';
  id: string;
  accountId: string;
  type: DocumentType;
  status: DocumentStatus;
  statusMessage?: string | null;
  statusCode?: string | null;
  contentType?: string | null;
  createdAt: string;
  updatedAt?: string | null;
  name?: string | null;
  note?: string | null;
  internal?: boolean | null;
  metadata?: Array<{
    __typename?: 'DocumentMetadataItem';
    key: string;
    value?: Array<string> | null;
  }> | null;
  traceDetails?: {
    __typename?: 'TraceDetails';
    ip?: string | null;
    userAgent?: string | null;
    countryCode?: string | null;
    lang?: string | null;
    deviceType?: DeviceType | null;
    deviceModel?: string | null;
    browser?: string | null;
    browserVersion?: string | null;
    browserAccept?: string | null;
    os?: string | null;
    osVersion?: string | null;
    source?: string | null;
    sourceVersion?: string | null;
    userId?: string | null;
    userEmail?: string | null;
    userName?: string | null;
  } | null;
};

export type DocumentEventFieldsFragment = {
  __typename?: 'DocumentEvent';
  id: string;
  type: string;
  accountId: string;
  objectId: string;
  objectType: string;
  createdAt: number;
  object: {
    __typename?: 'DocumentEventObject';
    id: string;
    accountId: string;
    type: DocumentType;
    status: DocumentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    contentType?: string | null;
    createdAt: number;
    updatedAt?: number | null;
    note?: string | null;
    name?: string | null;
    internal?: boolean | null;
    metadata?: Array<{
      __typename?: 'DocumentMetadataItem';
      key: string;
      value?: Array<string> | null;
    }> | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
  };
};

export type ContactFieldsFragment = {
  __typename?: 'ContactDetails';
  email?: string | null;
  name?: string | null;
  company?: string | null;
  phone?: string | null;
  address?: {
    __typename?: 'Address';
    city?: string | null;
    country?: string | null;
    line1?: string | null;
    line2?: string | null;
    zip?: string | null;
    state?: string | null;
  } | null;
};

export type SubscriptionFieldsFragment = {
  __typename?: 'Subscription';
  id: string;
  accountId: string;
  livemode: boolean;
  amount: number;
  currency?: Currencies | null;
  description?: string | null;
  planVariantId?: string | null;
  productId?: string | null;
  cancelAtPeriodEnd?: boolean | null;
  pauseIntervalCount?: number | null;
  pauseAtPeriodEnd?: boolean | null;
  skipIntervalCount?: number | null;
  currentPeriodStart?: number | null;
  currentPeriodEnd?: number | null;
  trialPeriodDays?: number | null;
  trialPeriodEnd?: number | null;
  customerId?: string | null;
  defaultTokenId?: string | null;
  sequenceId?: string | null;
  lastInvoiceId?: string | null;
  lastOrderId?: string | null;
  nextPaymentAt?: number | null;
  createdAt?: number | null;
  updatedAt?: number | null;
  interval: Interval;
  intervalCount: number;
  retryCount?: number | null;
  status: SubscriptionStatus;
  callbackUrl?: string | null;
  paymentCallbackUrl?: string | null;
  storeId?: string | null;
  masterAccountId?: string | null;
  allowedPaymentMethods?: Array<SubscriptionPaymentMethods | null> | null;
  customer?: {
    __typename?: 'Customer';
    email?: string | null;
    name?: string | null;
    phone?: string | null;
  } | null;
  billingDetails?: {
    __typename?: 'ContactDetails';
    email?: string | null;
    name?: string | null;
    company?: string | null;
    phone?: string | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  } | null;
  shippingDetails?: {
    __typename?: 'ContactDetails';
    email?: string | null;
    name?: string | null;
    company?: string | null;
    phone?: string | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  } | null;
  lastPayment?: {
    __typename?: 'LastPayment';
    id: string;
    status: PaymentStatus;
    statusMessage?: string | null;
    statusCode?: string | null;
  } | null;
  paymentMethod?: {
    __typename?: 'PaymentMethod';
    method?: PaymentMethods | null;
    bizum?: {
      __typename?: 'PaymentMethodBizum';
      phoneNumber?: string | null;
      integrationType?: string | null;
      ibanLast4?: string | null;
      idBizum?: string | null;
    } | null;
    card?: {
      __typename?: 'PaymentMethodCard';
      brand?: CardBrand | null;
      country?: string | null;
      type?: CardType | null;
      threeDSecure?: boolean | null;
      threeDSecureVersion?: string | null;
      threeDSecureFlow?: ThreeDSecureFlow | null;
      threeDSecureStatus?: ThreeDsStatus | null;
      last4?: string | null;
      fingerprint?: string | null;
      cardholderName?: string | null;
      cardholderEmail?: string | null;
      expiration?: any | null;
      bank?: string | null;
      tokenizationMethod?: TokenizationMethods | null;
      srcCorrelationId?: string | null;
      srciTransactionId?: string | null;
      srcDpaId?: string | null;
    } | null;
    cardPresent?: {
      __typename?: 'PaymentMethodCardPresent';
      bin?: string | null;
      brand?: CardBrand | null;
      cardholderEmail?: string | null;
      cardholderName?: string | null;
      country?: string | null;
      expiration?: any | null;
      last4?: string | null;
      fingerprint?: string | null;
      type?: CardType | null;
      verificationMethod?: VerificationMethod | null;
    } | null;
    mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
    paypal?: {
      __typename?: 'PaymentMethodPaypal';
      orderId?: string | null;
      payerId?: string | null;
      email?: string | null;
      name?: string | null;
    } | null;
    sepa?: {
      __typename?: 'PaymentMethodSepa';
      accountholderEmail?: string | null;
      accountholderName?: string | null;
      countryCode?: string | null;
      bankAddress?: string | null;
      bankCode?: string | null;
      bankName?: string | null;
      bic?: string | null;
      last4?: string | null;
      fingerprint?: string | null;
      accountholderAddress?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
    klarna?: {
      __typename?: 'PaymentMethodKlarna';
      billingCategory?: BillingCategoryKlarna | null;
      authPaymentMethod?: AuthPaymentMethodKlarna | null;
    } | null;
  } | null;
  metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
  sessionDetails?: {
    __typename?: 'SessionDetails';
    ip?: string | null;
    fingerprint?: string | null;
    userAgent?: string | null;
    countryCode?: string | null;
    lang?: string | null;
    deviceType?: DeviceType | null;
    deviceModel?: string | null;
    browser?: string | null;
    browserVersion?: string | null;
    browserAccept?: string | null;
    browserColorDepth?: string | null;
    browserScreenHeight?: string | null;
    browserScreenWidth?: string | null;
    browserTimezoneOffset?: string | null;
    os?: string | null;
    osVersion?: string | null;
    source?: string | null;
    sourceVersion?: string | null;
  } | null;
  traceDetails?: {
    __typename?: 'TraceDetails';
    ip?: string | null;
    userAgent?: string | null;
    countryCode?: string | null;
    lang?: string | null;
    deviceType?: DeviceType | null;
    deviceModel?: string | null;
    browser?: string | null;
    browserVersion?: string | null;
    browserAccept?: string | null;
    os?: string | null;
    osVersion?: string | null;
    source?: string | null;
    sourceVersion?: string | null;
    userId?: string | null;
    userEmail?: string | null;
    userName?: string | null;
  } | null;
};

export type LastPaymentFieldsFragment = {
  __typename?: 'LastPayment';
  id: string;
  status: PaymentStatus;
  statusMessage?: string | null;
  statusCode?: string | null;
};

export type SubscriptionEventObjectFieldsFragment = {
  __typename?: 'SubscriptionEventObject';
  id: string;
  accountId: string;
  amount?: number | null;
  cancelAtPeriodEnd?: boolean | null;
  createdAt?: number | null;
  currency: string;
  currentPeriodEnd?: number | null;
  currentPeriodStart?: number | null;
  description?: string | null;
  interval: Interval;
  intervalCount: number;
  lastOrderId?: string | null;
  livemode?: boolean | null;
  pauseAtPeriodEnd?: boolean | null;
  pauseIntervalCount?: number | null;
  pointOfSaleId?: string | null;
  retryCount?: number | null;
  sequenceId?: string | null;
  status: SubscriptionStatus;
  storeId?: string | null;
  trialPeriodDays?: number | null;
  trialPeriodEnd?: number | null;
  updatedAt?: number | null;
  billingDetails?: {
    __typename?: 'ContactDetails';
    email?: string | null;
    name?: string | null;
    company?: string | null;
    phone?: string | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  } | null;
  customer?: {
    __typename?: 'Customer';
    email?: string | null;
    name?: string | null;
    phone?: string | null;
  } | null;
  lastPayment?: {
    __typename?: 'LastPayment';
    id: string;
    status: PaymentStatus;
    statusMessage?: string | null;
    statusCode?: string | null;
  } | null;
  paymentMethod?: {
    __typename?: 'PaymentMethod';
    method?: PaymentMethods | null;
    bizum?: {
      __typename?: 'PaymentMethodBizum';
      phoneNumber?: string | null;
      integrationType?: string | null;
      ibanLast4?: string | null;
      idBizum?: string | null;
    } | null;
    card?: {
      __typename?: 'PaymentMethodCard';
      brand?: CardBrand | null;
      country?: string | null;
      type?: CardType | null;
      threeDSecure?: boolean | null;
      threeDSecureVersion?: string | null;
      threeDSecureFlow?: ThreeDSecureFlow | null;
      threeDSecureStatus?: ThreeDsStatus | null;
      last4?: string | null;
      fingerprint?: string | null;
      cardholderName?: string | null;
      cardholderEmail?: string | null;
      expiration?: any | null;
      bank?: string | null;
      tokenizationMethod?: TokenizationMethods | null;
      srcCorrelationId?: string | null;
      srciTransactionId?: string | null;
      srcDpaId?: string | null;
    } | null;
    cardPresent?: {
      __typename?: 'PaymentMethodCardPresent';
      bin?: string | null;
      brand?: CardBrand | null;
      cardholderEmail?: string | null;
      cardholderName?: string | null;
      country?: string | null;
      expiration?: any | null;
      last4?: string | null;
      fingerprint?: string | null;
      type?: CardType | null;
      verificationMethod?: VerificationMethod | null;
    } | null;
    mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
    paypal?: {
      __typename?: 'PaymentMethodPaypal';
      orderId?: string | null;
      payerId?: string | null;
      email?: string | null;
      name?: string | null;
    } | null;
    sepa?: {
      __typename?: 'PaymentMethodSepa';
      accountholderEmail?: string | null;
      accountholderName?: string | null;
      countryCode?: string | null;
      bankAddress?: string | null;
      bankCode?: string | null;
      bankName?: string | null;
      bic?: string | null;
      last4?: string | null;
      fingerprint?: string | null;
      accountholderAddress?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
    klarna?: {
      __typename?: 'PaymentMethodKlarna';
      billingCategory?: BillingCategoryKlarna | null;
      authPaymentMethod?: AuthPaymentMethodKlarna | null;
    } | null;
  } | null;
  shippingDetails?: {
    __typename?: 'ContactDetails';
    email?: string | null;
    name?: string | null;
    company?: string | null;
    phone?: string | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  } | null;
  traceDetails?: {
    __typename?: 'TraceDetails';
    ip?: string | null;
    userAgent?: string | null;
    countryCode?: string | null;
    lang?: string | null;
    deviceType?: DeviceType | null;
    deviceModel?: string | null;
    browser?: string | null;
    browserVersion?: string | null;
    browserAccept?: string | null;
    os?: string | null;
    osVersion?: string | null;
    source?: string | null;
    sourceVersion?: string | null;
    userId?: string | null;
    userEmail?: string | null;
    userName?: string | null;
  } | null;
};

export type ProviderEventObjectFieldsFragment = {
  __typename?: 'ProviderEventObject';
  id: string;
  internalId?: string | null;
  processor?: Processor | null;
  enabled?: boolean | null;
  test?: boolean | null;
  paymentMethod?: PaymentMethods | null;
  acquirer?: Acquirer | null;
  configurable?: boolean | null;
  nativeHostedPayment?: boolean | null;
  metadata?: Array<{
    __typename?: 'ProviderMetadataItem';
    key: string;
    value?: Array<string> | null;
  }> | null;
  rules?: {
    __typename?: 'ProviderRules';
    minAmount?: number | null;
    maxAmount?: number | null;
    shopNameLike?: string | null;
    descriptionLike?: string | null;
  } | null;
  traceDetails?: {
    __typename?: 'TraceDetails';
    ip?: string | null;
    userAgent?: string | null;
    countryCode?: string | null;
    lang?: string | null;
    deviceType?: DeviceType | null;
    deviceModel?: string | null;
    browser?: string | null;
    browserVersion?: string | null;
    browserAccept?: string | null;
    os?: string | null;
    osVersion?: string | null;
    source?: string | null;
    sourceVersion?: string | null;
    userId?: string | null;
    userEmail?: string | null;
    userName?: string | null;
  } | null;
};

export type WebhookFieldsFragment = {
  __typename?: 'Webhook';
  id: string;
  accountId: string;
  url: string;
  enabled: boolean;
  eventTypes: Array<WebhookEventType>;
  secret?: string | null;
  createdAt: string;
  updatedAt?: string | null;
};

export type ChargesExportFieldsFragment = {
  __typename?: 'ChargesExport';
  id: string;
  accountId: string;
  status: ExportStatus;
  expireAt?: string | null;
  statusCode?: string | null;
  statusMessage?: string | null;
};

export type SftpConfigExportFieldsFragment = {
  __typename?: 'SftpConfigExport';
  id: string;
  accountId: string;
  host: string;
  port: number;
  username: string;
  path: string;
  columns?: Array<string> | null;
  timezone?: string | null;
  enabled?: boolean | null;
};

export type StoreFieldsFragment = {
  __typename?: 'Store';
  id: string;
  accountId: string;
  name?: string | null;
  email?: string | null;
  iban?: string | null;
  phone?: string | null;
  website?: string | null;
  documentNumber?: string | null;
  address?: {
    __typename?: 'Address';
    city?: string | null;
    country?: string | null;
    line1?: string | null;
    line2?: string | null;
    zip?: string | null;
    state?: string | null;
  } | null;
};

export type AccountBalancesFieldsFragment = {
  __typename?: 'AccountBalances';
  accountId?: string | null;
  currency: string;
  clearedAmount: number;
  createdAt: string;
  outstandingAmount: number;
  totalAmount: number;
  updatedAt?: string | null;
};

export type AdminUserFieldsFragment = {
  __typename?: 'AdminUser';
  id: string;
  email: string;
  name?: string | null;
  phoneNumber?: string | null;
};

export type PayoutMethodsFieldsFragment = {
  __typename?: 'AffiliatePayoutMethod';
  id?: string | null;
  title?: string | null;
  details?: {
    __typename?: 'AffiliatePayoutMethodDetails';
    iban?: string | null;
    nif?: string | null;
  } | null;
};

export type AffiliateFieldsFragment = {
  __typename?: 'Affiliate';
  id: string;
  firstname?: string | null;
  lastname?: string | null;
  email?: string | null;
  affiliate_group_id?: string | null;
  created_at?: string | null;
  company?: {
    __typename?: 'AffiliateCompany';
    name?: string | null;
    description?: string | null;
  } | null;
  address?: {
    __typename?: 'AffiliateAddress';
    address?: string | null;
    postal_code?: string | null;
    city?: string | null;
    state?: string | null;
    country?: {__typename?: 'AffiliateCountry'; name?: string | null; code?: string | null} | null;
  } | null;
  meta_data?: {__typename?: 'AffiliateMetaData'; tier?: string | null} | null;
  referral_link?: {__typename?: 'AffiliateReferralLink'; link?: string | null} | null;
  payout_methods?: Array<{
    __typename?: 'AffiliatePayoutMethod';
    id?: string | null;
    title?: string | null;
    details?: {
      __typename?: 'AffiliatePayoutMethodDetails';
      iban?: string | null;
      nif?: string | null;
    } | null;
  }> | null;
};

export type AffiliateMerchantFieldsFragment = {
  __typename?: 'AffiliateMerchant';
  id: string;
  status?: string | null;
  created_at?: string | null;
  meta_data?: {
    __typename?: 'AffiliateMerchantMetaData';
    account_id?: string | null;
    account_status?: string | null;
    company_name?: string | null;
    website?: string | null;
    first_conversion_date?: string | null;
  } | null;
};

export type AffiliateInvoiceFieldsFragment = {
  __typename?: 'AffiliateInvoice';
  id: string;
  number?: string | null;
  amount?: number | null;
  issuedAt?: string | null;
  status?: string | null;
  dueAt?: string | null;
};

export type BlacklistItemFieldsFragment = {
  __typename?: 'BlacklistItem';
  value: string;
  type: BlacklistItemType;
  note?: string | null;
  accountId?: string | null;
  createdAt: string;
  updatedAt?: string | null;
  validUntil?: number | null;
};

export type PointOfSaleFieldsFragment = {
  __typename?: 'PointOfSale';
  id: string;
  accountId: string;
  storeId?: string | null;
  number: number;
  name?: string | null;
  currentPaymentId?: string | null;
  manualAmount?: boolean | null;
  type?: PointOfSaleType | null;
  deviceId?: string | null;
  terminalId?: string | null;
  description?: string | null;
  requireEmail?: boolean | null;
  requireTaxId?: boolean | null;
  includeQRCode?: boolean | null;
  qrCodeText?: string | null;
  fixedAmount?: number | null;
  fixedCurrency?: Currencies | null;
  transactionType?: TransactionTypes | null;
  paymentMethods?: Array<PaymentMethods> | null;
  enabled?: boolean | null;
  pendingSetup?: boolean | null;
  paymentCallbackUrl?: string | null;
};

export type AdminUserEventFieldsFragment = {
  __typename?: 'AdminUserEvent';
  id: string;
  type: string;
  objectType: string;
  accountId?: string | null;
  objectId?: string | null;
  createdAt: number;
  metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
  sessionDetails?: {
    __typename?: 'SessionDetails';
    ip?: string | null;
    fingerprint?: string | null;
    userAgent?: string | null;
    countryCode?: string | null;
    lang?: string | null;
    deviceType?: DeviceType | null;
    deviceModel?: string | null;
    browser?: string | null;
    browserVersion?: string | null;
    browserAccept?: string | null;
    browserColorDepth?: string | null;
    browserScreenHeight?: string | null;
    browserScreenWidth?: string | null;
    browserTimezoneOffset?: string | null;
    os?: string | null;
    osVersion?: string | null;
    source?: string | null;
    sourceVersion?: string | null;
  } | null;
};

export type CodeFieldsFragment = {
  __typename?: 'Code';
  id: string;
  type: CodeTypes;
  enabled?: boolean | null;
  pointOfSaleId?: string | null;
};

export type PibisiEventFieldsFragment = {
  __typename?: 'PibisiEvent';
  id: string;
  type: string;
  objectId: string;
  objectType: string;
  createdAt: number;
  object: {
    __typename?: 'PibisiEventObject';
    id: string;
    entityId?: string | null;
    status: PibisiStatus;
    customerId?: string | null;
    createdAt: number;
    updatedAt?: number | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
  };
};

export type ExportChargesMutationVariables = Exact<{
  filter?: InputMaybe<SearchableChargeFilterInput>;
  columns?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;

export type ExportChargesMutation = {
  __typename?: 'Mutation';
  exportCharges: {__typename?: 'DownloadFile'; downloadUrl: string; expiresAt: number};
};

export type UpdateAccountMutationVariables = Exact<{
  input: UpdateAccountInput;
}>;

export type UpdateAccountMutation = {
  __typename?: 'Mutation';
  updateAccount: {
    __typename?: 'Account';
    id: string;
    refAccountId?: string | null;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    status: AccountStatus;
    note?: string | null;
    userNote?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    allowCreateApiKey?: boolean | null;
    allowRefunds?: boolean | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    referralCode?: string | null;
    promoCode?: string | null;
    language?: string | null;
    reviewConfirmed?: boolean | null;
    progressiveBilling?: boolean | null;
    billingEmail?: string | null;
    billingPlan?: BillingPlans | null;
    riskScore?: number | null;
    riskProfile?: RiskProfile | null;
    riskProcessing?: boolean | null;
    riskProfileNote?: string | null;
    riskIgnoredKeywords?: Array<string> | null;
    riskUpdatedAt?: string | null;
    iban?: string | null;
    dynamicBilling?: boolean | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    sepblacId?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    accountExecutive?: SalesExecutive | null;
    billingVatPercent?: number | null;
    churned?: boolean | null;
    blocked?: boolean | null;
    statusReason?: StatusReason | null;
    statusNote?: string | null;
    churnReason?: ChurnReason | null;
    churnReasonOption?: string | null;
    churnNote?: string | null;
    previewFeatures?: Array<string> | null;
    tags?: Array<string> | null;
    masterAccountId?: string | null;
    accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null;
    customAccountInvoiceNotes?: Array<string> | null;
    groupInvoicesByStore?: boolean | null;
    fraudDetectorEnabled?: boolean | null;
    fraudDetectorThreshold?: number | null;
    fraudRulesEnabled?: boolean | null;
    contactPerson?: {
      __typename?: 'ContactPerson';
      name: string;
      email: string;
      phone?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    tokenizationMethods?: {
      __typename?: 'AccountTokenizationMethods';
      googlePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      applePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      clickToPay?: {
        __typename?: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
      } | null;
    } | null;
    notifications?: {
      __typename?: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
      emailCustomerOnSubscription?: boolean | null;
      emailAdminOnSubscription?: boolean | null;
      emailOnAccountInvoice?: boolean | null;
    } | null;
    fees?: {
      __typename?: 'AccountFees';
      highRiskFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      dailyPlatformFee?: number | null;
      weeklyCustomDomainFee?: number | null;
      fraudDetectorTrxFlatFee?: number | null;
      cardPresentTrxFee?: number | null;
      cardPresentTrxFlatFee?: number | null;
      steps?: Array<{
        __typename?: 'AccountSteps';
        trxFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        trxFlatFee: number;
        from: number;
      }> | null;
      extra?: Array<{
        __typename?: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        masterAccountFee?: boolean | null;
        paymentMethods?: Array<PaymentMethods> | null;
      }> | null;
    } | null;
    riskLabels?: Array<{
      __typename?: 'RiskLabel';
      label?: string | null;
      category?: string | null;
      riskScore?: number | null;
    }> | null;
    business?: {
      __typename?: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      mcc?: string | null;
      documentNumber?: string | null;
      status?: BusinessStatus | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      servicesDescription?: string | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      capital?: any | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      registryRecords?: Array<{
        __typename?: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename?: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    representatives?: Array<{
      __typename?: 'RepresentativeData';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      citizenship?: string | null;
      dateOfBirth?: string | null;
      nationality?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      idSession?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusCode?: number | null;
      hasNoPublicActivity?: boolean | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      document?: {
        __typename?: 'IdDocument';
        type?: IdDocumentType | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      riskLabels?: Array<{
        __typename?: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    }> | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      period?: number | null;
      firstPeriod?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
      settleGross?: boolean | null;
      bankTransferConceptPrefix?: string | null;
      settleToStores?: boolean | null;
    } | null;
    publicBusinessDetails?: {
      __typename?: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      supportWebsite?: string | null;
      supportPhone?: string | null;
      supportEmail?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    upsell?: {
      __typename?: 'Upsell';
      executive?: SalesExecutive | null;
      paymentMethods?: Array<PaymentMethods> | null;
      date?: string | null;
      note?: string | null;
    } | null;
  };
};

export type UpdateMasterAccountMutationVariables = Exact<{
  input: UpdateMasterAccountInput;
}>;

export type UpdateMasterAccountMutation = {
  __typename?: 'Mutation';
  updateMasterAccount: {
    __typename?: 'MasterAccount';
    id: string;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    adminEmail?: string | null;
    iban?: string | null;
    apiKey?: string | null;
    test?: boolean | null;
    status?: AccountStatus | null;
    promoCode?: string | null;
    allowedIPs?: Array<string> | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    webhookEmails?: Array<string> | null;
    churnedEmails?: Array<string> | null;
    allowedDomains?: Array<string> | null;
    accountCallbackUrl?: string | null;
    requireExternalId?: boolean | null;
    contractTemplateId?: string | null;
    autoApprove?: boolean | null;
    blocked?: boolean | null;
    note?: string | null;
    allowCreateApiKey?: boolean | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    accountDefaults?: {
      __typename?: 'AccountDefaults';
      billingPlan?: BillingPlans | null;
      language?: string | null;
      fees?: {
        __typename?: 'AccountFees';
        trxFee?: number | null;
        trxFlatFee?: number | null;
        highRiskFee?: number | null;
        dailyPlatformFee?: number | null;
        dailyExtraSeatsFee?: number | null;
        steps?: Array<{
          __typename?: 'AccountSteps';
          trxFee: number;
          bizumTrxFee?: number | null;
          bizumTrxFlatFee?: number | null;
          trxFlatFee: number;
          from: number;
        }> | null;
        extra?: Array<{
          __typename?: 'AccountExtraFee';
          name: string;
          amount: number;
          type: AccountExtraFeeType;
          region?: AccountExtraFeeRegion | null;
          masterAccountFee?: boolean | null;
          paymentMethods?: Array<PaymentMethods> | null;
        }> | null;
      } | null;
      business?: {
        __typename?: 'BusinessDefault';
        mcc?: string | null;
        website?: string | null;
        servicesDescription?: string | null;
      } | null;
    } | null;
    business?: {
      __typename?: 'BusinessData';
      mcc?: string | null;
      legalName?: string | null;
      website?: string | null;
      documentNumber?: string | null;
      servicesDescription?: string | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
  };
};

export type UpdateUserMasterAccountMutationVariables = Exact<{
  input: UpdateUserMasterAccountInput;
}>;

export type UpdateUserMasterAccountMutation = {
  __typename?: 'Mutation';
  updateUserMasterAccount: {
    __typename?: 'MasterAccount';
    id: string;
    name?: string | null;
    status?: AccountStatus | null;
    promoCode?: string | null;
    allowedIPs?: Array<string> | null;
    webhookEmails?: Array<string> | null;
    churnedEmails?: Array<string> | null;
    allowedDomains?: Array<string> | null;
    accountCallbackUrl?: string | null;
    requireExternalId?: boolean | null;
    apiKey?: string | null;
    test?: boolean | null;
    publicBusinessDetails?: {
      __typename?: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      supportWebsite?: string | null;
      supportPhone?: string | null;
      supportEmail?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
  };
};

export type UpdateProviderMutationVariables = Exact<{
  input: UpdateProviderInput;
}>;

export type UpdateProviderMutation = {
  __typename?: 'Mutation';
  updateProvider: {
    __typename?: 'Provider';
    id: string;
    processor?: Processor | null;
    enabled?: boolean | null;
    test?: boolean | null;
    paymentMethod?: PaymentMethods | null;
    acquirer?: Acquirer | null;
    currencies?: Array<Currencies> | null;
    nativeHostedPayment?: boolean | null;
    metadata?: Array<{
      __typename?: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      example?: string | null;
      secret?: boolean | null;
    }> | null;
    rules?: {
      __typename?: 'ProviderRules';
      minAmount?: number | null;
      maxAmount?: number | null;
      shopNameLike?: string | null;
      descriptionLike?: string | null;
    } | null;
  };
};

export type CreateProviderMutationVariables = Exact<{
  input: CreateProviderInput;
}>;

export type CreateProviderMutation = {
  __typename?: 'Mutation';
  createProvider: {
    __typename?: 'Provider';
    id: string;
    processor?: Processor | null;
    enabled?: boolean | null;
    test?: boolean | null;
    paymentMethod?: PaymentMethods | null;
    acquirer?: Acquirer | null;
    currencies?: Array<Currencies> | null;
    nativeHostedPayment?: boolean | null;
    metadata?: Array<{
      __typename?: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      example?: string | null;
      secret?: boolean | null;
    }> | null;
    rules?: {
      __typename?: 'ProviderRules';
      minAmount?: number | null;
      maxAmount?: number | null;
      shopNameLike?: string | null;
      descriptionLike?: string | null;
    } | null;
  };
};

export type DeleteProviderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteProviderMutation = {
  __typename?: 'Mutation';
  deleteProvider: {
    __typename?: 'Provider';
    id: string;
    processor?: Processor | null;
    enabled?: boolean | null;
    test?: boolean | null;
    paymentMethod?: PaymentMethods | null;
    acquirer?: Acquirer | null;
    currencies?: Array<Currencies> | null;
    nativeHostedPayment?: boolean | null;
    metadata?: Array<{
      __typename?: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      example?: string | null;
      secret?: boolean | null;
    }> | null;
    rules?: {
      __typename?: 'ProviderRules';
      minAmount?: number | null;
      maxAmount?: number | null;
      shopNameLike?: string | null;
      descriptionLike?: string | null;
    } | null;
  };
};

export type ImpersonateMutationVariables = Exact<{
  input: ImpersonateInput;
}>;

export type ImpersonateMutation = {__typename?: 'Mutation'; impersonate?: boolean | null};

export type ResetUserPasswordMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  temporalPassword?: InputMaybe<Scalars['String']['input']>;
}>;

export type ResetUserPasswordMutation = {__typename?: 'Mutation'; resetUserPassword: string};

export type DisableUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DisableUserMutation = {
  __typename?: 'Mutation';
  disableUser: {
    __typename?: 'User';
    id: string;
    email: string;
    emailVerified?: boolean | null;
    phoneNumber?: string | null;
    phoneNumberVerified?: boolean | null;
    smsMfaEnabled?: boolean | null;
    status: UserStatus;
    enabled: boolean;
    accountId?: string | null;
    testAccountId?: string | null;
    referralCode?: string | null;
    promoCode?: string | null;
    createdAt: string;
  };
};

export type EnableUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type EnableUserMutation = {
  __typename?: 'Mutation';
  enableUser: {
    __typename?: 'User';
    id: string;
    email: string;
    emailVerified?: boolean | null;
    phoneNumber?: string | null;
    phoneNumberVerified?: boolean | null;
    smsMfaEnabled?: boolean | null;
    status: UserStatus;
    enabled: boolean;
    accountId?: string | null;
    testAccountId?: string | null;
    referralCode?: string | null;
    promoCode?: string | null;
    createdAt: string;
  };
};

export type DeleteAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteAccountMutation = {
  __typename?: 'Mutation';
  deleteAccount: {
    __typename?: 'Account';
    id: string;
    refAccountId?: string | null;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    status: AccountStatus;
    note?: string | null;
    userNote?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    allowCreateApiKey?: boolean | null;
    allowRefunds?: boolean | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    referralCode?: string | null;
    promoCode?: string | null;
    language?: string | null;
    reviewConfirmed?: boolean | null;
    progressiveBilling?: boolean | null;
    billingEmail?: string | null;
    billingPlan?: BillingPlans | null;
    riskScore?: number | null;
    riskProfile?: RiskProfile | null;
    riskProcessing?: boolean | null;
    riskProfileNote?: string | null;
    riskIgnoredKeywords?: Array<string> | null;
    riskUpdatedAt?: string | null;
    iban?: string | null;
    dynamicBilling?: boolean | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    sepblacId?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    accountExecutive?: SalesExecutive | null;
    billingVatPercent?: number | null;
    churned?: boolean | null;
    blocked?: boolean | null;
    statusReason?: StatusReason | null;
    statusNote?: string | null;
    churnReason?: ChurnReason | null;
    churnReasonOption?: string | null;
    churnNote?: string | null;
    previewFeatures?: Array<string> | null;
    tags?: Array<string> | null;
    masterAccountId?: string | null;
    accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null;
    customAccountInvoiceNotes?: Array<string> | null;
    groupInvoicesByStore?: boolean | null;
    fraudDetectorEnabled?: boolean | null;
    fraudDetectorThreshold?: number | null;
    fraudRulesEnabled?: boolean | null;
    contactPerson?: {
      __typename?: 'ContactPerson';
      name: string;
      email: string;
      phone?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    tokenizationMethods?: {
      __typename?: 'AccountTokenizationMethods';
      googlePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      applePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      clickToPay?: {
        __typename?: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
      } | null;
    } | null;
    notifications?: {
      __typename?: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
      emailCustomerOnSubscription?: boolean | null;
      emailAdminOnSubscription?: boolean | null;
      emailOnAccountInvoice?: boolean | null;
    } | null;
    fees?: {
      __typename?: 'AccountFees';
      highRiskFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      dailyPlatformFee?: number | null;
      weeklyCustomDomainFee?: number | null;
      fraudDetectorTrxFlatFee?: number | null;
      cardPresentTrxFee?: number | null;
      cardPresentTrxFlatFee?: number | null;
      steps?: Array<{
        __typename?: 'AccountSteps';
        trxFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        trxFlatFee: number;
        from: number;
      }> | null;
      extra?: Array<{
        __typename?: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        masterAccountFee?: boolean | null;
        paymentMethods?: Array<PaymentMethods> | null;
      }> | null;
    } | null;
    riskLabels?: Array<{
      __typename?: 'RiskLabel';
      label?: string | null;
      category?: string | null;
      riskScore?: number | null;
    }> | null;
    business?: {
      __typename?: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      mcc?: string | null;
      documentNumber?: string | null;
      status?: BusinessStatus | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      servicesDescription?: string | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      capital?: any | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      registryRecords?: Array<{
        __typename?: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename?: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    representatives?: Array<{
      __typename?: 'RepresentativeData';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      citizenship?: string | null;
      dateOfBirth?: string | null;
      nationality?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      idSession?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusCode?: number | null;
      hasNoPublicActivity?: boolean | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      document?: {
        __typename?: 'IdDocument';
        type?: IdDocumentType | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      riskLabels?: Array<{
        __typename?: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    }> | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      period?: number | null;
      firstPeriod?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
      settleGross?: boolean | null;
      bankTransferConceptPrefix?: string | null;
      settleToStores?: boolean | null;
    } | null;
    publicBusinessDetails?: {
      __typename?: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      supportWebsite?: string | null;
      supportPhone?: string | null;
      supportEmail?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    upsell?: {
      __typename?: 'Upsell';
      executive?: SalesExecutive | null;
      paymentMethods?: Array<PaymentMethods> | null;
      date?: string | null;
      note?: string | null;
    } | null;
  };
};

export type RestoreAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type RestoreAccountMutation = {
  __typename?: 'Mutation';
  restoreAccount: {
    __typename?: 'Account';
    id: string;
    refAccountId?: string | null;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    status: AccountStatus;
    note?: string | null;
    userNote?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    allowCreateApiKey?: boolean | null;
    allowRefunds?: boolean | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    referralCode?: string | null;
    promoCode?: string | null;
    language?: string | null;
    reviewConfirmed?: boolean | null;
    progressiveBilling?: boolean | null;
    billingEmail?: string | null;
    billingPlan?: BillingPlans | null;
    riskScore?: number | null;
    riskProfile?: RiskProfile | null;
    riskProcessing?: boolean | null;
    riskProfileNote?: string | null;
    riskIgnoredKeywords?: Array<string> | null;
    riskUpdatedAt?: string | null;
    iban?: string | null;
    dynamicBilling?: boolean | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    sepblacId?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    accountExecutive?: SalesExecutive | null;
    billingVatPercent?: number | null;
    churned?: boolean | null;
    blocked?: boolean | null;
    statusReason?: StatusReason | null;
    statusNote?: string | null;
    churnReason?: ChurnReason | null;
    churnReasonOption?: string | null;
    churnNote?: string | null;
    previewFeatures?: Array<string> | null;
    tags?: Array<string> | null;
    masterAccountId?: string | null;
    accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null;
    customAccountInvoiceNotes?: Array<string> | null;
    groupInvoicesByStore?: boolean | null;
    fraudDetectorEnabled?: boolean | null;
    fraudDetectorThreshold?: number | null;
    fraudRulesEnabled?: boolean | null;
    contactPerson?: {
      __typename?: 'ContactPerson';
      name: string;
      email: string;
      phone?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    tokenizationMethods?: {
      __typename?: 'AccountTokenizationMethods';
      googlePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      applePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      clickToPay?: {
        __typename?: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
      } | null;
    } | null;
    notifications?: {
      __typename?: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
      emailCustomerOnSubscription?: boolean | null;
      emailAdminOnSubscription?: boolean | null;
      emailOnAccountInvoice?: boolean | null;
    } | null;
    fees?: {
      __typename?: 'AccountFees';
      highRiskFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      dailyPlatformFee?: number | null;
      weeklyCustomDomainFee?: number | null;
      fraudDetectorTrxFlatFee?: number | null;
      cardPresentTrxFee?: number | null;
      cardPresentTrxFlatFee?: number | null;
      steps?: Array<{
        __typename?: 'AccountSteps';
        trxFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        trxFlatFee: number;
        from: number;
      }> | null;
      extra?: Array<{
        __typename?: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        masterAccountFee?: boolean | null;
        paymentMethods?: Array<PaymentMethods> | null;
      }> | null;
    } | null;
    riskLabels?: Array<{
      __typename?: 'RiskLabel';
      label?: string | null;
      category?: string | null;
      riskScore?: number | null;
    }> | null;
    business?: {
      __typename?: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      mcc?: string | null;
      documentNumber?: string | null;
      status?: BusinessStatus | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      servicesDescription?: string | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      capital?: any | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      registryRecords?: Array<{
        __typename?: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename?: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    representatives?: Array<{
      __typename?: 'RepresentativeData';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      citizenship?: string | null;
      dateOfBirth?: string | null;
      nationality?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      idSession?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusCode?: number | null;
      hasNoPublicActivity?: boolean | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      document?: {
        __typename?: 'IdDocument';
        type?: IdDocumentType | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      riskLabels?: Array<{
        __typename?: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    }> | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      period?: number | null;
      firstPeriod?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
      settleGross?: boolean | null;
      bankTransferConceptPrefix?: string | null;
      settleToStores?: boolean | null;
    } | null;
    publicBusinessDetails?: {
      __typename?: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      supportWebsite?: string | null;
      supportPhone?: string | null;
      supportEmail?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    upsell?: {
      __typename?: 'Upsell';
      executive?: SalesExecutive | null;
      paymentMethods?: Array<PaymentMethods> | null;
      date?: string | null;
      note?: string | null;
    } | null;
  };
};

export type GenerateSettlementReportMutationVariables = Exact<{
  input: GenerateSettlementReportInput;
}>;

export type GenerateSettlementReportMutation = {
  __typename?: 'Mutation';
  generateSettlementReport: {__typename?: 'DownloadFile'; downloadUrl: string; expiresAt: number};
};

export type CreateAccountInvoiceMutationVariables = Exact<{
  input: AccountInvoiceInput;
}>;

export type CreateAccountInvoiceMutation = {
  __typename?: 'Mutation';
  createAccountInvoice: {
    __typename?: 'AccountInvoice';
    id?: string | null;
    number?: string | null;
    accountId: string;
    currency: string;
    amount: number;
    tax: number;
    totalAmount: number;
    status?: AccountInvoiceStatus | null;
    paymentMethod?: AccountInvoicePaymentMethod | null;
    period: {__typename?: 'AccountInvoicePeriod'; from?: number | null; to?: number | null};
    lineItems: Array<{
      __typename?: 'AccountInvoiceLineItem';
      name: string;
      quantity: number;
      unitAmount: number;
      unitType: InvoiceLineItemUnitType;
      currency: string;
      amount: number;
    }>;
    business?: {__typename?: 'InvoiceBusinessData'; iban?: string | null} | null;
  };
};

export type DisableTokenizationMethodMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  method: TokenizationMethods;
}>;

export type DisableTokenizationMethodMutation = {
  __typename?: 'Mutation';
  disableTokenizationMethod: {
    __typename?: 'Account';
    id: string;
    refAccountId?: string | null;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    status: AccountStatus;
    note?: string | null;
    userNote?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    allowCreateApiKey?: boolean | null;
    allowRefunds?: boolean | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    referralCode?: string | null;
    promoCode?: string | null;
    language?: string | null;
    reviewConfirmed?: boolean | null;
    progressiveBilling?: boolean | null;
    billingEmail?: string | null;
    billingPlan?: BillingPlans | null;
    riskScore?: number | null;
    riskProfile?: RiskProfile | null;
    riskProcessing?: boolean | null;
    riskProfileNote?: string | null;
    riskIgnoredKeywords?: Array<string> | null;
    riskUpdatedAt?: string | null;
    iban?: string | null;
    dynamicBilling?: boolean | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    sepblacId?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    accountExecutive?: SalesExecutive | null;
    billingVatPercent?: number | null;
    churned?: boolean | null;
    blocked?: boolean | null;
    statusReason?: StatusReason | null;
    statusNote?: string | null;
    churnReason?: ChurnReason | null;
    churnReasonOption?: string | null;
    churnNote?: string | null;
    previewFeatures?: Array<string> | null;
    tags?: Array<string> | null;
    masterAccountId?: string | null;
    accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null;
    customAccountInvoiceNotes?: Array<string> | null;
    groupInvoicesByStore?: boolean | null;
    fraudDetectorEnabled?: boolean | null;
    fraudDetectorThreshold?: number | null;
    fraudRulesEnabled?: boolean | null;
    contactPerson?: {
      __typename?: 'ContactPerson';
      name: string;
      email: string;
      phone?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    tokenizationMethods?: {
      __typename?: 'AccountTokenizationMethods';
      googlePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      applePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      clickToPay?: {
        __typename?: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
      } | null;
    } | null;
    notifications?: {
      __typename?: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
      emailCustomerOnSubscription?: boolean | null;
      emailAdminOnSubscription?: boolean | null;
      emailOnAccountInvoice?: boolean | null;
    } | null;
    fees?: {
      __typename?: 'AccountFees';
      highRiskFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      dailyPlatformFee?: number | null;
      weeklyCustomDomainFee?: number | null;
      fraudDetectorTrxFlatFee?: number | null;
      cardPresentTrxFee?: number | null;
      cardPresentTrxFlatFee?: number | null;
      steps?: Array<{
        __typename?: 'AccountSteps';
        trxFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        trxFlatFee: number;
        from: number;
      }> | null;
      extra?: Array<{
        __typename?: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        masterAccountFee?: boolean | null;
        paymentMethods?: Array<PaymentMethods> | null;
      }> | null;
    } | null;
    riskLabels?: Array<{
      __typename?: 'RiskLabel';
      label?: string | null;
      category?: string | null;
      riskScore?: number | null;
    }> | null;
    business?: {
      __typename?: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      mcc?: string | null;
      documentNumber?: string | null;
      status?: BusinessStatus | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      servicesDescription?: string | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      capital?: any | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      registryRecords?: Array<{
        __typename?: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename?: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    representatives?: Array<{
      __typename?: 'RepresentativeData';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      citizenship?: string | null;
      dateOfBirth?: string | null;
      nationality?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      idSession?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusCode?: number | null;
      hasNoPublicActivity?: boolean | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      document?: {
        __typename?: 'IdDocument';
        type?: IdDocumentType | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      riskLabels?: Array<{
        __typename?: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    }> | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      period?: number | null;
      firstPeriod?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
      settleGross?: boolean | null;
      bankTransferConceptPrefix?: string | null;
      settleToStores?: boolean | null;
    } | null;
    publicBusinessDetails?: {
      __typename?: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      supportWebsite?: string | null;
      supportPhone?: string | null;
      supportEmail?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    upsell?: {
      __typename?: 'Upsell';
      executive?: SalesExecutive | null;
      paymentMethods?: Array<PaymentMethods> | null;
      date?: string | null;
      note?: string | null;
    } | null;
  };
};

export type EnableTokenizationMethodMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  method: TokenizationMethods;
}>;

export type EnableTokenizationMethodMutation = {
  __typename?: 'Mutation';
  enableTokenizationMethod: {
    __typename?: 'Account';
    id: string;
    refAccountId?: string | null;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    status: AccountStatus;
    note?: string | null;
    userNote?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    allowCreateApiKey?: boolean | null;
    allowRefunds?: boolean | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    referralCode?: string | null;
    promoCode?: string | null;
    language?: string | null;
    reviewConfirmed?: boolean | null;
    progressiveBilling?: boolean | null;
    billingEmail?: string | null;
    billingPlan?: BillingPlans | null;
    riskScore?: number | null;
    riskProfile?: RiskProfile | null;
    riskProcessing?: boolean | null;
    riskProfileNote?: string | null;
    riskIgnoredKeywords?: Array<string> | null;
    riskUpdatedAt?: string | null;
    iban?: string | null;
    dynamicBilling?: boolean | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    sepblacId?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    accountExecutive?: SalesExecutive | null;
    billingVatPercent?: number | null;
    churned?: boolean | null;
    blocked?: boolean | null;
    statusReason?: StatusReason | null;
    statusNote?: string | null;
    churnReason?: ChurnReason | null;
    churnReasonOption?: string | null;
    churnNote?: string | null;
    previewFeatures?: Array<string> | null;
    tags?: Array<string> | null;
    masterAccountId?: string | null;
    accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null;
    customAccountInvoiceNotes?: Array<string> | null;
    groupInvoicesByStore?: boolean | null;
    fraudDetectorEnabled?: boolean | null;
    fraudDetectorThreshold?: number | null;
    fraudRulesEnabled?: boolean | null;
    contactPerson?: {
      __typename?: 'ContactPerson';
      name: string;
      email: string;
      phone?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    tokenizationMethods?: {
      __typename?: 'AccountTokenizationMethods';
      googlePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      applePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      clickToPay?: {
        __typename?: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
      } | null;
    } | null;
    notifications?: {
      __typename?: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
      emailCustomerOnSubscription?: boolean | null;
      emailAdminOnSubscription?: boolean | null;
      emailOnAccountInvoice?: boolean | null;
    } | null;
    fees?: {
      __typename?: 'AccountFees';
      highRiskFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      dailyPlatformFee?: number | null;
      weeklyCustomDomainFee?: number | null;
      fraudDetectorTrxFlatFee?: number | null;
      cardPresentTrxFee?: number | null;
      cardPresentTrxFlatFee?: number | null;
      steps?: Array<{
        __typename?: 'AccountSteps';
        trxFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        trxFlatFee: number;
        from: number;
      }> | null;
      extra?: Array<{
        __typename?: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        masterAccountFee?: boolean | null;
        paymentMethods?: Array<PaymentMethods> | null;
      }> | null;
    } | null;
    riskLabels?: Array<{
      __typename?: 'RiskLabel';
      label?: string | null;
      category?: string | null;
      riskScore?: number | null;
    }> | null;
    business?: {
      __typename?: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      mcc?: string | null;
      documentNumber?: string | null;
      status?: BusinessStatus | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      servicesDescription?: string | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      capital?: any | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      registryRecords?: Array<{
        __typename?: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename?: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    representatives?: Array<{
      __typename?: 'RepresentativeData';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      citizenship?: string | null;
      dateOfBirth?: string | null;
      nationality?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      idSession?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusCode?: number | null;
      hasNoPublicActivity?: boolean | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      document?: {
        __typename?: 'IdDocument';
        type?: IdDocumentType | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      riskLabels?: Array<{
        __typename?: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    }> | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      period?: number | null;
      firstPeriod?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
      settleGross?: boolean | null;
      bankTransferConceptPrefix?: string | null;
      settleToStores?: boolean | null;
    } | null;
    publicBusinessDetails?: {
      __typename?: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      supportWebsite?: string | null;
      supportPhone?: string | null;
      supportEmail?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    upsell?: {
      __typename?: 'Upsell';
      executive?: SalesExecutive | null;
      paymentMethods?: Array<PaymentMethods> | null;
      date?: string | null;
      note?: string | null;
    } | null;
  };
};

export type DownloadContractMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type DownloadContractMutation = {
  __typename?: 'Mutation';
  downloadContract?: {__typename?: 'DownloadFile'; downloadUrl: string; expiresAt: number} | null;
};

export type ApproveAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  processor?: InputMaybe<Processor>;
}>;

export type ApproveAccountMutation = {
  __typename?: 'Mutation';
  approveAccount: {
    __typename?: 'Account';
    id: string;
    refAccountId?: string | null;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    status: AccountStatus;
    note?: string | null;
    userNote?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    allowCreateApiKey?: boolean | null;
    allowRefunds?: boolean | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    referralCode?: string | null;
    promoCode?: string | null;
    language?: string | null;
    reviewConfirmed?: boolean | null;
    progressiveBilling?: boolean | null;
    billingEmail?: string | null;
    billingPlan?: BillingPlans | null;
    riskScore?: number | null;
    riskProfile?: RiskProfile | null;
    riskProcessing?: boolean | null;
    riskProfileNote?: string | null;
    riskIgnoredKeywords?: Array<string> | null;
    riskUpdatedAt?: string | null;
    iban?: string | null;
    dynamicBilling?: boolean | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    sepblacId?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    accountExecutive?: SalesExecutive | null;
    billingVatPercent?: number | null;
    churned?: boolean | null;
    blocked?: boolean | null;
    statusReason?: StatusReason | null;
    statusNote?: string | null;
    churnReason?: ChurnReason | null;
    churnReasonOption?: string | null;
    churnNote?: string | null;
    previewFeatures?: Array<string> | null;
    tags?: Array<string> | null;
    masterAccountId?: string | null;
    accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null;
    customAccountInvoiceNotes?: Array<string> | null;
    groupInvoicesByStore?: boolean | null;
    fraudDetectorEnabled?: boolean | null;
    fraudDetectorThreshold?: number | null;
    fraudRulesEnabled?: boolean | null;
    contactPerson?: {
      __typename?: 'ContactPerson';
      name: string;
      email: string;
      phone?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    tokenizationMethods?: {
      __typename?: 'AccountTokenizationMethods';
      googlePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      applePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      clickToPay?: {
        __typename?: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
      } | null;
    } | null;
    notifications?: {
      __typename?: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
      emailCustomerOnSubscription?: boolean | null;
      emailAdminOnSubscription?: boolean | null;
      emailOnAccountInvoice?: boolean | null;
    } | null;
    fees?: {
      __typename?: 'AccountFees';
      highRiskFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      dailyPlatformFee?: number | null;
      weeklyCustomDomainFee?: number | null;
      fraudDetectorTrxFlatFee?: number | null;
      cardPresentTrxFee?: number | null;
      cardPresentTrxFlatFee?: number | null;
      steps?: Array<{
        __typename?: 'AccountSteps';
        trxFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        trxFlatFee: number;
        from: number;
      }> | null;
      extra?: Array<{
        __typename?: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        masterAccountFee?: boolean | null;
        paymentMethods?: Array<PaymentMethods> | null;
      }> | null;
    } | null;
    riskLabels?: Array<{
      __typename?: 'RiskLabel';
      label?: string | null;
      category?: string | null;
      riskScore?: number | null;
    }> | null;
    business?: {
      __typename?: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      mcc?: string | null;
      documentNumber?: string | null;
      status?: BusinessStatus | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      servicesDescription?: string | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      capital?: any | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      registryRecords?: Array<{
        __typename?: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename?: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    representatives?: Array<{
      __typename?: 'RepresentativeData';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      citizenship?: string | null;
      dateOfBirth?: string | null;
      nationality?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      idSession?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusCode?: number | null;
      hasNoPublicActivity?: boolean | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      document?: {
        __typename?: 'IdDocument';
        type?: IdDocumentType | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      riskLabels?: Array<{
        __typename?: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    }> | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      period?: number | null;
      firstPeriod?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
      settleGross?: boolean | null;
      bankTransferConceptPrefix?: string | null;
      settleToStores?: boolean | null;
    } | null;
    publicBusinessDetails?: {
      __typename?: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      supportWebsite?: string | null;
      supportPhone?: string | null;
      supportEmail?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    upsell?: {
      __typename?: 'Upsell';
      executive?: SalesExecutive | null;
      paymentMethods?: Array<PaymentMethods> | null;
      date?: string | null;
      note?: string | null;
    } | null;
  };
};

export type RegisterMoneiXMerchantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  cardPresent?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type RegisterMoneiXMerchantMutation = {
  __typename?: 'Mutation';
  registerMoneiXMerchant: {__typename?: 'SuccessResult'; success: boolean};
};

export type VerifyIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  accountId: Scalars['ID']['input'];
}>;

export type VerifyIdMutation = {
  __typename?: 'Mutation';
  verifyId: {
    __typename?: 'Account';
    id: string;
    refAccountId?: string | null;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    status: AccountStatus;
    note?: string | null;
    userNote?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    allowCreateApiKey?: boolean | null;
    allowRefunds?: boolean | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    referralCode?: string | null;
    promoCode?: string | null;
    language?: string | null;
    reviewConfirmed?: boolean | null;
    progressiveBilling?: boolean | null;
    billingEmail?: string | null;
    billingPlan?: BillingPlans | null;
    riskScore?: number | null;
    riskProfile?: RiskProfile | null;
    riskProcessing?: boolean | null;
    riskProfileNote?: string | null;
    riskIgnoredKeywords?: Array<string> | null;
    riskUpdatedAt?: string | null;
    iban?: string | null;
    dynamicBilling?: boolean | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    sepblacId?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    accountExecutive?: SalesExecutive | null;
    billingVatPercent?: number | null;
    churned?: boolean | null;
    blocked?: boolean | null;
    statusReason?: StatusReason | null;
    statusNote?: string | null;
    churnReason?: ChurnReason | null;
    churnReasonOption?: string | null;
    churnNote?: string | null;
    previewFeatures?: Array<string> | null;
    tags?: Array<string> | null;
    masterAccountId?: string | null;
    accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null;
    customAccountInvoiceNotes?: Array<string> | null;
    groupInvoicesByStore?: boolean | null;
    fraudDetectorEnabled?: boolean | null;
    fraudDetectorThreshold?: number | null;
    fraudRulesEnabled?: boolean | null;
    contactPerson?: {
      __typename?: 'ContactPerson';
      name: string;
      email: string;
      phone?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    tokenizationMethods?: {
      __typename?: 'AccountTokenizationMethods';
      googlePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      applePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      clickToPay?: {
        __typename?: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
      } | null;
    } | null;
    notifications?: {
      __typename?: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
      emailCustomerOnSubscription?: boolean | null;
      emailAdminOnSubscription?: boolean | null;
      emailOnAccountInvoice?: boolean | null;
    } | null;
    fees?: {
      __typename?: 'AccountFees';
      highRiskFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      dailyPlatformFee?: number | null;
      weeklyCustomDomainFee?: number | null;
      fraudDetectorTrxFlatFee?: number | null;
      cardPresentTrxFee?: number | null;
      cardPresentTrxFlatFee?: number | null;
      steps?: Array<{
        __typename?: 'AccountSteps';
        trxFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        trxFlatFee: number;
        from: number;
      }> | null;
      extra?: Array<{
        __typename?: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        masterAccountFee?: boolean | null;
        paymentMethods?: Array<PaymentMethods> | null;
      }> | null;
    } | null;
    riskLabels?: Array<{
      __typename?: 'RiskLabel';
      label?: string | null;
      category?: string | null;
      riskScore?: number | null;
    }> | null;
    business?: {
      __typename?: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      mcc?: string | null;
      documentNumber?: string | null;
      status?: BusinessStatus | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      servicesDescription?: string | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      capital?: any | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      registryRecords?: Array<{
        __typename?: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename?: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    representatives?: Array<{
      __typename?: 'RepresentativeData';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      citizenship?: string | null;
      dateOfBirth?: string | null;
      nationality?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      idSession?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusCode?: number | null;
      hasNoPublicActivity?: boolean | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      document?: {
        __typename?: 'IdDocument';
        type?: IdDocumentType | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      riskLabels?: Array<{
        __typename?: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    }> | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      period?: number | null;
      firstPeriod?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
      settleGross?: boolean | null;
      bankTransferConceptPrefix?: string | null;
      settleToStores?: boolean | null;
    } | null;
    publicBusinessDetails?: {
      __typename?: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      supportWebsite?: string | null;
      supportPhone?: string | null;
      supportEmail?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    upsell?: {
      __typename?: 'Upsell';
      executive?: SalesExecutive | null;
      paymentMethods?: Array<PaymentMethods> | null;
      date?: string | null;
      note?: string | null;
    } | null;
  };
};

export type CreateAuthorizedUserMutationVariables = Exact<{
  input: CreateAuthorizedUserInput;
}>;

export type CreateAuthorizedUserMutation = {
  __typename?: 'Mutation';
  createAuthorizedUser?: {
    __typename?: 'AuthorizedUser';
    id?: string | null;
    accountId?: string | null;
    userEmail: string;
    accessLevel: AuthorizedUserAccessLevel;
    storeId?: string | null;
    pointOfSaleId?: string | null;
    status?: AuthorizedUserStatus | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    lastLoginAt?: string | null;
  } | null;
};

export type CreateMasterAccountMutationVariables = Exact<{
  input: CreateMasterAccountInput;
}>;

export type CreateMasterAccountMutation = {
  __typename?: 'Mutation';
  createMasterAccount: {
    __typename?: 'MasterAccount';
    id: string;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    adminEmail?: string | null;
    iban?: string | null;
    apiKey?: string | null;
    test?: boolean | null;
    status?: AccountStatus | null;
    promoCode?: string | null;
    allowedIPs?: Array<string> | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    webhookEmails?: Array<string> | null;
    churnedEmails?: Array<string> | null;
    allowedDomains?: Array<string> | null;
    accountCallbackUrl?: string | null;
    requireExternalId?: boolean | null;
    contractTemplateId?: string | null;
    autoApprove?: boolean | null;
    blocked?: boolean | null;
    note?: string | null;
    allowCreateApiKey?: boolean | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    accountDefaults?: {
      __typename?: 'AccountDefaults';
      billingPlan?: BillingPlans | null;
      language?: string | null;
      fees?: {
        __typename?: 'AccountFees';
        trxFee?: number | null;
        trxFlatFee?: number | null;
        highRiskFee?: number | null;
        dailyPlatformFee?: number | null;
        dailyExtraSeatsFee?: number | null;
        steps?: Array<{
          __typename?: 'AccountSteps';
          trxFee: number;
          bizumTrxFee?: number | null;
          bizumTrxFlatFee?: number | null;
          trxFlatFee: number;
          from: number;
        }> | null;
        extra?: Array<{
          __typename?: 'AccountExtraFee';
          name: string;
          amount: number;
          type: AccountExtraFeeType;
          region?: AccountExtraFeeRegion | null;
          masterAccountFee?: boolean | null;
          paymentMethods?: Array<PaymentMethods> | null;
        }> | null;
      } | null;
      business?: {
        __typename?: 'BusinessDefault';
        mcc?: string | null;
        website?: string | null;
        servicesDescription?: string | null;
      } | null;
    } | null;
    business?: {
      __typename?: 'BusinessData';
      mcc?: string | null;
      legalName?: string | null;
      website?: string | null;
      documentNumber?: string | null;
      servicesDescription?: string | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
  };
};

export type CreateMasterAccountUserMutationVariables = Exact<{
  input: CreateMasterAccountUserInput;
}>;

export type CreateMasterAccountUserMutation = {
  __typename?: 'Mutation';
  createMasterAccountUser: {
    __typename?: 'AuthorizedUser';
    id?: string | null;
    accountId?: string | null;
    userEmail: string;
    accessLevel: AuthorizedUserAccessLevel;
    storeId?: string | null;
    pointOfSaleId?: string | null;
    status?: AuthorizedUserStatus | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    lastLoginAt?: string | null;
  };
};

export type DeleteMasterAccountUserMutationVariables = Exact<{
  userEmail: Scalars['String']['input'];
  accountId: Scalars['ID']['input'];
}>;

export type DeleteMasterAccountUserMutation = {
  __typename?: 'Mutation';
  deleteMasterAccountUser: boolean;
};

export type DeleteAuthorizedUserMutationVariables = Exact<{
  userEmail: Scalars['String']['input'];
  accountId: Scalars['ID']['input'];
}>;

export type DeleteAuthorizedUserMutation = {__typename?: 'Mutation'; deleteAuthorizedUser: boolean};

export type UpdateAuthorizedUserMutationVariables = Exact<{
  input: UpdateAuthorizedUserInput;
}>;

export type UpdateAuthorizedUserMutation = {
  __typename?: 'Mutation';
  updateAuthorizedUser?: {
    __typename?: 'AuthorizedUser';
    id?: string | null;
    accountId?: string | null;
    userEmail: string;
    accessLevel: AuthorizedUserAccessLevel;
    storeId?: string | null;
    pointOfSaleId?: string | null;
    status?: AuthorizedUserStatus | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    lastLoginAt?: string | null;
  } | null;
};

export type SendPaymentLinkMutationVariables = Exact<{
  input: SendPaymentMessageInput;
}>;

export type SendPaymentLinkMutation = {
  __typename?: 'Mutation';
  sendPaymentLink?: {
    __typename?: 'Payment';
    id: string;
    accountId: string;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    pointOfSaleId?: string | null;
    masterAccountId?: string | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    amount?: number | null;
    authorizationCode?: string | null;
    storeId?: string | null;
    currency: string;
    description?: string | null;
    descriptor?: string | null;
    livemode?: boolean | null;
    orderId?: string | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    status: PaymentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shop?: {__typename?: 'Shop'; name?: string | null; country?: string | null} | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    nextAction?: {
      __typename?: 'NextAction';
      type?: NextActionTypes | null;
      redirectUrl?: string | null;
      mustRedirect?: boolean | null;
    } | null;
  } | null;
};

export type SendPaymentRequestMutationVariables = Exact<{
  input: SendPaymentRequestInput;
}>;

export type SendPaymentRequestMutation = {
  __typename?: 'Mutation';
  sendPaymentRequest?: {
    __typename?: 'Payment';
    id: string;
    accountId: string;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    pointOfSaleId?: string | null;
    masterAccountId?: string | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    amount?: number | null;
    authorizationCode?: string | null;
    storeId?: string | null;
    currency: string;
    description?: string | null;
    descriptor?: string | null;
    livemode?: boolean | null;
    orderId?: string | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    status: PaymentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shop?: {__typename?: 'Shop'; name?: string | null; country?: string | null} | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    nextAction?: {
      __typename?: 'NextAction';
      type?: NextActionTypes | null;
      redirectUrl?: string | null;
      mustRedirect?: boolean | null;
    } | null;
  } | null;
};

export type CreatePaymentMutationVariables = Exact<{
  input: CreatePaymentInput;
}>;

export type CreatePaymentMutation = {
  __typename?: 'Mutation';
  createPayment?: {
    __typename?: 'Payment';
    id: string;
    accountId: string;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    pointOfSaleId?: string | null;
    masterAccountId?: string | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    amount?: number | null;
    authorizationCode?: string | null;
    storeId?: string | null;
    currency: string;
    description?: string | null;
    descriptor?: string | null;
    livemode?: boolean | null;
    orderId?: string | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    status: PaymentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shop?: {__typename?: 'Shop'; name?: string | null; country?: string | null} | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    nextAction?: {
      __typename?: 'NextAction';
      type?: NextActionTypes | null;
      redirectUrl?: string | null;
      mustRedirect?: boolean | null;
    } | null;
  } | null;
};

export type CapturePaymentMutationVariables = Exact<{
  input: CapturePaymentInput;
}>;

export type CapturePaymentMutation = {
  __typename?: 'Mutation';
  capturePayment?: {
    __typename?: 'Payment';
    id: string;
    accountId: string;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    pointOfSaleId?: string | null;
    masterAccountId?: string | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    amount?: number | null;
    authorizationCode?: string | null;
    storeId?: string | null;
    currency: string;
    description?: string | null;
    descriptor?: string | null;
    livemode?: boolean | null;
    orderId?: string | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    status: PaymentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shop?: {__typename?: 'Shop'; name?: string | null; country?: string | null} | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    nextAction?: {
      __typename?: 'NextAction';
      type?: NextActionTypes | null;
      redirectUrl?: string | null;
      mustRedirect?: boolean | null;
    } | null;
  } | null;
};

export type CancelPaymentMutationVariables = Exact<{
  input: CancelPaymentInput;
}>;

export type CancelPaymentMutation = {
  __typename?: 'Mutation';
  cancelPayment?: {
    __typename?: 'Payment';
    id: string;
    accountId: string;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    pointOfSaleId?: string | null;
    masterAccountId?: string | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    amount?: number | null;
    authorizationCode?: string | null;
    storeId?: string | null;
    currency: string;
    description?: string | null;
    descriptor?: string | null;
    livemode?: boolean | null;
    orderId?: string | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    status: PaymentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shop?: {__typename?: 'Shop'; name?: string | null; country?: string | null} | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    nextAction?: {
      __typename?: 'NextAction';
      type?: NextActionTypes | null;
      redirectUrl?: string | null;
      mustRedirect?: boolean | null;
    } | null;
  } | null;
};

export type RefundPaymentMutationVariables = Exact<{
  input: RefundPaymentInput;
}>;

export type RefundPaymentMutation = {
  __typename?: 'Mutation';
  refundPayment?: {
    __typename?: 'Payment';
    id: string;
    accountId: string;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    pointOfSaleId?: string | null;
    masterAccountId?: string | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    amount?: number | null;
    authorizationCode?: string | null;
    storeId?: string | null;
    currency: string;
    description?: string | null;
    descriptor?: string | null;
    livemode?: boolean | null;
    orderId?: string | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    status: PaymentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shop?: {__typename?: 'Shop'; name?: string | null; country?: string | null} | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    nextAction?: {
      __typename?: 'NextAction';
      type?: NextActionTypes | null;
      redirectUrl?: string | null;
      mustRedirect?: boolean | null;
    } | null;
  } | null;
};

export type SendPaymentReceiptMutationVariables = Exact<{
  input: SendPaymentMessageInput;
}>;

export type SendPaymentReceiptMutation = {
  __typename?: 'Mutation';
  sendPaymentReceipt?: {
    __typename?: 'Payment';
    id: string;
    accountId: string;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    pointOfSaleId?: string | null;
    masterAccountId?: string | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    amount?: number | null;
    authorizationCode?: string | null;
    storeId?: string | null;
    currency: string;
    description?: string | null;
    descriptor?: string | null;
    livemode?: boolean | null;
    orderId?: string | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    status: PaymentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shop?: {__typename?: 'Shop'; name?: string | null; country?: string | null} | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    nextAction?: {
      __typename?: 'NextAction';
      type?: NextActionTypes | null;
      redirectUrl?: string | null;
      mustRedirect?: boolean | null;
    } | null;
  } | null;
};

export type DeleteDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  accountId: Scalars['ID']['input'];
}>;

export type DeleteDocumentMutation = {__typename?: 'Mutation'; deleteDocument: boolean};

export type DownloadDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  accountId: Scalars['ID']['input'];
}>;

export type DownloadDocumentMutation = {
  __typename?: 'Mutation';
  downloadDocument: {__typename?: 'DownloadFile'; downloadUrl: string; expiresAt: number};
};

export type UpdateDocumentMutationVariables = Exact<{
  input: UpdateDocumentInput;
}>;

export type UpdateDocumentMutation = {
  __typename?: 'Mutation';
  updateDocument: {
    __typename?: 'Document';
    id: string;
    accountId: string;
    type: DocumentType;
    status: DocumentStatus;
    statusMessage?: string | null;
    statusCode?: string | null;
    contentType?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    name?: string | null;
    note?: string | null;
    internal?: boolean | null;
    metadata?: Array<{
      __typename?: 'DocumentMetadataItem';
      key: string;
      value?: Array<string> | null;
    }> | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
  };
};

export type UploadDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  contentType: Scalars['String']['input'];
  accountId: Scalars['ID']['input'];
}>;

export type UploadDocumentMutation = {
  __typename?: 'Mutation';
  uploadDocument: {__typename?: 'UploadFile'; uploadUrl: string; expiresAt: number};
};

export type CreateDocumentMutationVariables = Exact<{
  input: CreateDocumentInput;
}>;

export type CreateDocumentMutation = {
  __typename?: 'Mutation';
  createDocument: {
    __typename?: 'Document';
    id: string;
    accountId: string;
    type: DocumentType;
    status: DocumentStatus;
    statusMessage?: string | null;
    statusCode?: string | null;
    contentType?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    name?: string | null;
    note?: string | null;
    internal?: boolean | null;
    metadata?: Array<{
      __typename?: 'DocumentMetadataItem';
      key: string;
      value?: Array<string> | null;
    }> | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
  };
};

export type CancelSubscriptionMutationVariables = Exact<{
  input: CancelSubscriptionInput;
}>;

export type CancelSubscriptionMutation = {
  __typename?: 'Mutation';
  cancelSubscription?: {
    __typename?: 'Subscription';
    id: string;
    accountId: string;
    livemode: boolean;
    amount: number;
    currency?: Currencies | null;
    description?: string | null;
    planVariantId?: string | null;
    productId?: string | null;
    cancelAtPeriodEnd?: boolean | null;
    pauseIntervalCount?: number | null;
    pauseAtPeriodEnd?: boolean | null;
    skipIntervalCount?: number | null;
    currentPeriodStart?: number | null;
    currentPeriodEnd?: number | null;
    trialPeriodDays?: number | null;
    trialPeriodEnd?: number | null;
    customerId?: string | null;
    defaultTokenId?: string | null;
    sequenceId?: string | null;
    lastInvoiceId?: string | null;
    lastOrderId?: string | null;
    nextPaymentAt?: number | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    interval: Interval;
    intervalCount: number;
    retryCount?: number | null;
    status: SubscriptionStatus;
    callbackUrl?: string | null;
    paymentCallbackUrl?: string | null;
    storeId?: string | null;
    masterAccountId?: string | null;
    allowedPaymentMethods?: Array<SubscriptionPaymentMethods | null> | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    lastPayment?: {
      __typename?: 'LastPayment';
      id: string;
      status: PaymentStatus;
      statusMessage?: string | null;
      statusCode?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
  } | null;
};

export type PauseSubscriptionMutationVariables = Exact<{
  input: PauseSubscriptionInput;
}>;

export type PauseSubscriptionMutation = {
  __typename?: 'Mutation';
  pauseSubscription?: {
    __typename?: 'Subscription';
    id: string;
    accountId: string;
    livemode: boolean;
    amount: number;
    currency?: Currencies | null;
    description?: string | null;
    planVariantId?: string | null;
    productId?: string | null;
    cancelAtPeriodEnd?: boolean | null;
    pauseIntervalCount?: number | null;
    pauseAtPeriodEnd?: boolean | null;
    skipIntervalCount?: number | null;
    currentPeriodStart?: number | null;
    currentPeriodEnd?: number | null;
    trialPeriodDays?: number | null;
    trialPeriodEnd?: number | null;
    customerId?: string | null;
    defaultTokenId?: string | null;
    sequenceId?: string | null;
    lastInvoiceId?: string | null;
    lastOrderId?: string | null;
    nextPaymentAt?: number | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    interval: Interval;
    intervalCount: number;
    retryCount?: number | null;
    status: SubscriptionStatus;
    callbackUrl?: string | null;
    paymentCallbackUrl?: string | null;
    storeId?: string | null;
    masterAccountId?: string | null;
    allowedPaymentMethods?: Array<SubscriptionPaymentMethods | null> | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    lastPayment?: {
      __typename?: 'LastPayment';
      id: string;
      status: PaymentStatus;
      statusMessage?: string | null;
      statusCode?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
  } | null;
};

export type ResumeSubscriptionMutationVariables = Exact<{
  input: ResumeSubscriptionInput;
}>;

export type ResumeSubscriptionMutation = {
  __typename?: 'Mutation';
  resumeSubscription?: {
    __typename?: 'Subscription';
    id: string;
    accountId: string;
    livemode: boolean;
    amount: number;
    currency?: Currencies | null;
    description?: string | null;
    planVariantId?: string | null;
    productId?: string | null;
    cancelAtPeriodEnd?: boolean | null;
    pauseIntervalCount?: number | null;
    pauseAtPeriodEnd?: boolean | null;
    skipIntervalCount?: number | null;
    currentPeriodStart?: number | null;
    currentPeriodEnd?: number | null;
    trialPeriodDays?: number | null;
    trialPeriodEnd?: number | null;
    customerId?: string | null;
    defaultTokenId?: string | null;
    sequenceId?: string | null;
    lastInvoiceId?: string | null;
    lastOrderId?: string | null;
    nextPaymentAt?: number | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    interval: Interval;
    intervalCount: number;
    retryCount?: number | null;
    status: SubscriptionStatus;
    callbackUrl?: string | null;
    paymentCallbackUrl?: string | null;
    storeId?: string | null;
    masterAccountId?: string | null;
    allowedPaymentMethods?: Array<SubscriptionPaymentMethods | null> | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    lastPayment?: {
      __typename?: 'LastPayment';
      id: string;
      status: PaymentStatus;
      statusMessage?: string | null;
      statusCode?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
  } | null;
};

export type UpdateSubscriptionMutationVariables = Exact<{
  input: UpdateSubscriptionInput;
}>;

export type UpdateSubscriptionMutation = {
  __typename?: 'Mutation';
  updateSubscription?: {
    __typename?: 'Subscription';
    id: string;
    accountId: string;
    livemode: boolean;
    amount: number;
    currency?: Currencies | null;
    description?: string | null;
    planVariantId?: string | null;
    productId?: string | null;
    cancelAtPeriodEnd?: boolean | null;
    pauseIntervalCount?: number | null;
    pauseAtPeriodEnd?: boolean | null;
    skipIntervalCount?: number | null;
    currentPeriodStart?: number | null;
    currentPeriodEnd?: number | null;
    trialPeriodDays?: number | null;
    trialPeriodEnd?: number | null;
    customerId?: string | null;
    defaultTokenId?: string | null;
    sequenceId?: string | null;
    lastInvoiceId?: string | null;
    lastOrderId?: string | null;
    nextPaymentAt?: number | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    interval: Interval;
    intervalCount: number;
    retryCount?: number | null;
    status: SubscriptionStatus;
    callbackUrl?: string | null;
    paymentCallbackUrl?: string | null;
    storeId?: string | null;
    masterAccountId?: string | null;
    allowedPaymentMethods?: Array<SubscriptionPaymentMethods | null> | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    lastPayment?: {
      __typename?: 'LastPayment';
      id: string;
      status: PaymentStatus;
      statusMessage?: string | null;
      statusCode?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
  } | null;
};

export type ActivateSubscriptionMutationVariables = Exact<{
  input: ActivateSubscriptionInput;
}>;

export type ActivateSubscriptionMutation = {
  __typename?: 'Mutation';
  activateSubscription?: {
    __typename?: 'Payment';
    id: string;
    accountId: string;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    pointOfSaleId?: string | null;
    masterAccountId?: string | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    amount?: number | null;
    authorizationCode?: string | null;
    storeId?: string | null;
    currency: string;
    description?: string | null;
    descriptor?: string | null;
    livemode?: boolean | null;
    orderId?: string | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    status: PaymentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shop?: {__typename?: 'Shop'; name?: string | null; country?: string | null} | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    nextAction?: {
      __typename?: 'NextAction';
      type?: NextActionTypes | null;
      redirectUrl?: string | null;
      mustRedirect?: boolean | null;
    } | null;
  } | null;
};

export type CreateSubscriptionMutationVariables = Exact<{
  input: CreateSubscriptionInput;
}>;

export type CreateSubscriptionMutation = {
  __typename?: 'Mutation';
  createSubscription?: {
    __typename?: 'Subscription';
    id: string;
    accountId: string;
    livemode: boolean;
    amount: number;
    currency?: Currencies | null;
    description?: string | null;
    planVariantId?: string | null;
    productId?: string | null;
    cancelAtPeriodEnd?: boolean | null;
    pauseIntervalCount?: number | null;
    pauseAtPeriodEnd?: boolean | null;
    skipIntervalCount?: number | null;
    currentPeriodStart?: number | null;
    currentPeriodEnd?: number | null;
    trialPeriodDays?: number | null;
    trialPeriodEnd?: number | null;
    customerId?: string | null;
    defaultTokenId?: string | null;
    sequenceId?: string | null;
    lastInvoiceId?: string | null;
    lastOrderId?: string | null;
    nextPaymentAt?: number | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    interval: Interval;
    intervalCount: number;
    retryCount?: number | null;
    status: SubscriptionStatus;
    callbackUrl?: string | null;
    paymentCallbackUrl?: string | null;
    storeId?: string | null;
    masterAccountId?: string | null;
    allowedPaymentMethods?: Array<SubscriptionPaymentMethods | null> | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    lastPayment?: {
      __typename?: 'LastPayment';
      id: string;
      status: PaymentStatus;
      statusMessage?: string | null;
      statusCode?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
  } | null;
};

export type SendSubscriptionLinkMutationVariables = Exact<{
  input: SendSubscriptionMessageInput;
}>;

export type SendSubscriptionLinkMutation = {
  __typename?: 'Mutation';
  sendSubscriptionLink?: {
    __typename?: 'Subscription';
    id: string;
    accountId: string;
    livemode: boolean;
    amount: number;
    currency?: Currencies | null;
    description?: string | null;
    planVariantId?: string | null;
    productId?: string | null;
    cancelAtPeriodEnd?: boolean | null;
    pauseIntervalCount?: number | null;
    pauseAtPeriodEnd?: boolean | null;
    skipIntervalCount?: number | null;
    currentPeriodStart?: number | null;
    currentPeriodEnd?: number | null;
    trialPeriodDays?: number | null;
    trialPeriodEnd?: number | null;
    customerId?: string | null;
    defaultTokenId?: string | null;
    sequenceId?: string | null;
    lastInvoiceId?: string | null;
    lastOrderId?: string | null;
    nextPaymentAt?: number | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    interval: Interval;
    intervalCount: number;
    retryCount?: number | null;
    status: SubscriptionStatus;
    callbackUrl?: string | null;
    paymentCallbackUrl?: string | null;
    storeId?: string | null;
    masterAccountId?: string | null;
    allowedPaymentMethods?: Array<SubscriptionPaymentMethods | null> | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    lastPayment?: {
      __typename?: 'LastPayment';
      id: string;
      status: PaymentStatus;
      statusMessage?: string | null;
      statusCode?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
  } | null;
};

export type SendSubscriptionStatusMutationVariables = Exact<{
  input: SendSubscriptionMessageInput;
}>;

export type SendSubscriptionStatusMutation = {
  __typename?: 'Mutation';
  sendSubscriptionStatus?: {
    __typename?: 'Subscription';
    id: string;
    accountId: string;
    livemode: boolean;
    amount: number;
    currency?: Currencies | null;
    description?: string | null;
    planVariantId?: string | null;
    productId?: string | null;
    cancelAtPeriodEnd?: boolean | null;
    pauseIntervalCount?: number | null;
    pauseAtPeriodEnd?: boolean | null;
    skipIntervalCount?: number | null;
    currentPeriodStart?: number | null;
    currentPeriodEnd?: number | null;
    trialPeriodDays?: number | null;
    trialPeriodEnd?: number | null;
    customerId?: string | null;
    defaultTokenId?: string | null;
    sequenceId?: string | null;
    lastInvoiceId?: string | null;
    lastOrderId?: string | null;
    nextPaymentAt?: number | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    interval: Interval;
    intervalCount: number;
    retryCount?: number | null;
    status: SubscriptionStatus;
    callbackUrl?: string | null;
    paymentCallbackUrl?: string | null;
    storeId?: string | null;
    masterAccountId?: string | null;
    allowedPaymentMethods?: Array<SubscriptionPaymentMethods | null> | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    lastPayment?: {
      __typename?: 'LastPayment';
      id: string;
      status: PaymentStatus;
      statusMessage?: string | null;
      statusCode?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
  } | null;
};

export type StartCompanyLookupMutationVariables = Exact<{
  documentNumber: Scalars['String']['input'];
  accountId: Scalars['ID']['input'];
}>;

export type StartCompanyLookupMutation = {
  __typename?: 'Mutation';
  startCompanyLookup: {
    __typename?: 'Account';
    id: string;
    refAccountId?: string | null;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    status: AccountStatus;
    note?: string | null;
    userNote?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    allowCreateApiKey?: boolean | null;
    allowRefunds?: boolean | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    referralCode?: string | null;
    promoCode?: string | null;
    language?: string | null;
    reviewConfirmed?: boolean | null;
    progressiveBilling?: boolean | null;
    billingEmail?: string | null;
    billingPlan?: BillingPlans | null;
    riskScore?: number | null;
    riskProfile?: RiskProfile | null;
    riskProcessing?: boolean | null;
    riskProfileNote?: string | null;
    riskIgnoredKeywords?: Array<string> | null;
    riskUpdatedAt?: string | null;
    iban?: string | null;
    dynamicBilling?: boolean | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    sepblacId?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    accountExecutive?: SalesExecutive | null;
    billingVatPercent?: number | null;
    churned?: boolean | null;
    blocked?: boolean | null;
    statusReason?: StatusReason | null;
    statusNote?: string | null;
    churnReason?: ChurnReason | null;
    churnReasonOption?: string | null;
    churnNote?: string | null;
    previewFeatures?: Array<string> | null;
    tags?: Array<string> | null;
    masterAccountId?: string | null;
    accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null;
    customAccountInvoiceNotes?: Array<string> | null;
    groupInvoicesByStore?: boolean | null;
    fraudDetectorEnabled?: boolean | null;
    fraudDetectorThreshold?: number | null;
    fraudRulesEnabled?: boolean | null;
    contactPerson?: {
      __typename?: 'ContactPerson';
      name: string;
      email: string;
      phone?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    tokenizationMethods?: {
      __typename?: 'AccountTokenizationMethods';
      googlePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      applePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      clickToPay?: {
        __typename?: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
      } | null;
    } | null;
    notifications?: {
      __typename?: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
      emailCustomerOnSubscription?: boolean | null;
      emailAdminOnSubscription?: boolean | null;
      emailOnAccountInvoice?: boolean | null;
    } | null;
    fees?: {
      __typename?: 'AccountFees';
      highRiskFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      dailyPlatformFee?: number | null;
      weeklyCustomDomainFee?: number | null;
      fraudDetectorTrxFlatFee?: number | null;
      cardPresentTrxFee?: number | null;
      cardPresentTrxFlatFee?: number | null;
      steps?: Array<{
        __typename?: 'AccountSteps';
        trxFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        trxFlatFee: number;
        from: number;
      }> | null;
      extra?: Array<{
        __typename?: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        masterAccountFee?: boolean | null;
        paymentMethods?: Array<PaymentMethods> | null;
      }> | null;
    } | null;
    riskLabels?: Array<{
      __typename?: 'RiskLabel';
      label?: string | null;
      category?: string | null;
      riskScore?: number | null;
    }> | null;
    business?: {
      __typename?: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      mcc?: string | null;
      documentNumber?: string | null;
      status?: BusinessStatus | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      servicesDescription?: string | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      capital?: any | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      registryRecords?: Array<{
        __typename?: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename?: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    representatives?: Array<{
      __typename?: 'RepresentativeData';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      citizenship?: string | null;
      dateOfBirth?: string | null;
      nationality?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      idSession?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusCode?: number | null;
      hasNoPublicActivity?: boolean | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      document?: {
        __typename?: 'IdDocument';
        type?: IdDocumentType | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      riskLabels?: Array<{
        __typename?: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    }> | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      period?: number | null;
      firstPeriod?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
      settleGross?: boolean | null;
      bankTransferConceptPrefix?: string | null;
      settleToStores?: boolean | null;
    } | null;
    publicBusinessDetails?: {
      __typename?: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      supportWebsite?: string | null;
      supportPhone?: string | null;
      supportEmail?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    upsell?: {
      __typename?: 'Upsell';
      executive?: SalesExecutive | null;
      paymentMethods?: Array<PaymentMethods> | null;
      date?: string | null;
      note?: string | null;
    } | null;
  };
};

export type CreatePibisiUserMutationVariables = Exact<{
  input?: InputMaybe<CreatePibisiUserInput>;
}>;

export type CreatePibisiUserMutation = {
  __typename?: 'Mutation';
  createPibisiUser: {
    __typename?: 'Account';
    id: string;
    refAccountId?: string | null;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    status: AccountStatus;
    note?: string | null;
    userNote?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    allowCreateApiKey?: boolean | null;
    allowRefunds?: boolean | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    referralCode?: string | null;
    promoCode?: string | null;
    language?: string | null;
    reviewConfirmed?: boolean | null;
    progressiveBilling?: boolean | null;
    billingEmail?: string | null;
    billingPlan?: BillingPlans | null;
    riskScore?: number | null;
    riskProfile?: RiskProfile | null;
    riskProcessing?: boolean | null;
    riskProfileNote?: string | null;
    riskIgnoredKeywords?: Array<string> | null;
    riskUpdatedAt?: string | null;
    iban?: string | null;
    dynamicBilling?: boolean | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    sepblacId?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    accountExecutive?: SalesExecutive | null;
    billingVatPercent?: number | null;
    churned?: boolean | null;
    blocked?: boolean | null;
    statusReason?: StatusReason | null;
    statusNote?: string | null;
    churnReason?: ChurnReason | null;
    churnReasonOption?: string | null;
    churnNote?: string | null;
    previewFeatures?: Array<string> | null;
    tags?: Array<string> | null;
    masterAccountId?: string | null;
    accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null;
    customAccountInvoiceNotes?: Array<string> | null;
    groupInvoicesByStore?: boolean | null;
    fraudDetectorEnabled?: boolean | null;
    fraudDetectorThreshold?: number | null;
    fraudRulesEnabled?: boolean | null;
    contactPerson?: {
      __typename?: 'ContactPerson';
      name: string;
      email: string;
      phone?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    tokenizationMethods?: {
      __typename?: 'AccountTokenizationMethods';
      googlePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      applePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      clickToPay?: {
        __typename?: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
      } | null;
    } | null;
    notifications?: {
      __typename?: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
      emailCustomerOnSubscription?: boolean | null;
      emailAdminOnSubscription?: boolean | null;
      emailOnAccountInvoice?: boolean | null;
    } | null;
    fees?: {
      __typename?: 'AccountFees';
      highRiskFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      dailyPlatformFee?: number | null;
      weeklyCustomDomainFee?: number | null;
      fraudDetectorTrxFlatFee?: number | null;
      cardPresentTrxFee?: number | null;
      cardPresentTrxFlatFee?: number | null;
      steps?: Array<{
        __typename?: 'AccountSteps';
        trxFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        trxFlatFee: number;
        from: number;
      }> | null;
      extra?: Array<{
        __typename?: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        masterAccountFee?: boolean | null;
        paymentMethods?: Array<PaymentMethods> | null;
      }> | null;
    } | null;
    riskLabels?: Array<{
      __typename?: 'RiskLabel';
      label?: string | null;
      category?: string | null;
      riskScore?: number | null;
    }> | null;
    business?: {
      __typename?: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      mcc?: string | null;
      documentNumber?: string | null;
      status?: BusinessStatus | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      servicesDescription?: string | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      capital?: any | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      registryRecords?: Array<{
        __typename?: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename?: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    representatives?: Array<{
      __typename?: 'RepresentativeData';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      citizenship?: string | null;
      dateOfBirth?: string | null;
      nationality?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      idSession?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusCode?: number | null;
      hasNoPublicActivity?: boolean | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      document?: {
        __typename?: 'IdDocument';
        type?: IdDocumentType | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      riskLabels?: Array<{
        __typename?: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    }> | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      period?: number | null;
      firstPeriod?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
      settleGross?: boolean | null;
      bankTransferConceptPrefix?: string | null;
      settleToStores?: boolean | null;
    } | null;
    publicBusinessDetails?: {
      __typename?: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      supportWebsite?: string | null;
      supportPhone?: string | null;
      supportEmail?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    upsell?: {
      __typename?: 'Upsell';
      executive?: SalesExecutive | null;
      paymentMethods?: Array<PaymentMethods> | null;
      date?: string | null;
      note?: string | null;
    } | null;
  };
};

export type RegisterMoneiXpMerchantMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  paymentMethods?: InputMaybe<Array<InputMaybe<PaymentMethods>> | InputMaybe<PaymentMethods>>;
}>;

export type RegisterMoneiXpMerchantMutation = {
  __typename?: 'Mutation';
  registerMoneiXPMerchant: {__typename?: 'SuccessResult'; success: boolean};
};

export type ResolvePibisiAlertMutationVariables = Exact<{
  input?: InputMaybe<ResolvePibisiAlertInput>;
}>;

export type ResolvePibisiAlertMutation = {
  __typename?: 'Mutation';
  resolvePibisiAlert: {
    __typename?: 'Pibisi';
    id?: string | null;
    entityId?: string | null;
    status?: PibisiStatus | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
  };
};

export type ResolvePibisiMatchMutationVariables = Exact<{
  input?: InputMaybe<ResolvePibisiMatchInput>;
}>;

export type ResolvePibisiMatchMutation = {
  __typename?: 'Mutation';
  resolvePibisiMatch: {
    __typename?: 'Pibisi';
    id?: string | null;
    entityId?: string | null;
    status?: PibisiStatus | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
  };
};

export type UpdateAccountInvoiceMutationVariables = Exact<{
  input: UpdateAccountInvoiceInput;
}>;

export type UpdateAccountInvoiceMutation = {
  __typename?: 'Mutation';
  updateAccountInvoice: {
    __typename?: 'AccountInvoice';
    id?: string | null;
    number?: string | null;
    accountId: string;
    currency: string;
    amount: number;
    tax: number;
    totalAmount: number;
    status?: AccountInvoiceStatus | null;
    paymentMethod?: AccountInvoicePaymentMethod | null;
    period: {__typename?: 'AccountInvoicePeriod'; from?: number | null; to?: number | null};
    lineItems: Array<{
      __typename?: 'AccountInvoiceLineItem';
      name: string;
      quantity: number;
      unitAmount: number;
      unitType: InvoiceLineItemUnitType;
      currency: string;
      amount: number;
    }>;
    business?: {__typename?: 'InvoiceBusinessData'; iban?: string | null} | null;
  };
};

export type CalculateRiskScoreMutationVariables = Exact<{
  input: CalculateRiskScoreInput;
}>;

export type CalculateRiskScoreMutation = {
  __typename?: 'Mutation';
  calculateRiskScore?: {
    __typename?: 'Account';
    id: string;
    refAccountId?: string | null;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    status: AccountStatus;
    note?: string | null;
    userNote?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    allowCreateApiKey?: boolean | null;
    allowRefunds?: boolean | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    referralCode?: string | null;
    promoCode?: string | null;
    language?: string | null;
    reviewConfirmed?: boolean | null;
    progressiveBilling?: boolean | null;
    billingEmail?: string | null;
    billingPlan?: BillingPlans | null;
    riskScore?: number | null;
    riskProfile?: RiskProfile | null;
    riskProcessing?: boolean | null;
    riskProfileNote?: string | null;
    riskIgnoredKeywords?: Array<string> | null;
    riskUpdatedAt?: string | null;
    iban?: string | null;
    dynamicBilling?: boolean | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    sepblacId?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    accountExecutive?: SalesExecutive | null;
    billingVatPercent?: number | null;
    churned?: boolean | null;
    blocked?: boolean | null;
    statusReason?: StatusReason | null;
    statusNote?: string | null;
    churnReason?: ChurnReason | null;
    churnReasonOption?: string | null;
    churnNote?: string | null;
    previewFeatures?: Array<string> | null;
    tags?: Array<string> | null;
    masterAccountId?: string | null;
    accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null;
    customAccountInvoiceNotes?: Array<string> | null;
    groupInvoicesByStore?: boolean | null;
    fraudDetectorEnabled?: boolean | null;
    fraudDetectorThreshold?: number | null;
    fraudRulesEnabled?: boolean | null;
    contactPerson?: {
      __typename?: 'ContactPerson';
      name: string;
      email: string;
      phone?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    tokenizationMethods?: {
      __typename?: 'AccountTokenizationMethods';
      googlePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      applePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      clickToPay?: {
        __typename?: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
      } | null;
    } | null;
    notifications?: {
      __typename?: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
      emailCustomerOnSubscription?: boolean | null;
      emailAdminOnSubscription?: boolean | null;
      emailOnAccountInvoice?: boolean | null;
    } | null;
    fees?: {
      __typename?: 'AccountFees';
      highRiskFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      dailyPlatformFee?: number | null;
      weeklyCustomDomainFee?: number | null;
      fraudDetectorTrxFlatFee?: number | null;
      cardPresentTrxFee?: number | null;
      cardPresentTrxFlatFee?: number | null;
      steps?: Array<{
        __typename?: 'AccountSteps';
        trxFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        trxFlatFee: number;
        from: number;
      }> | null;
      extra?: Array<{
        __typename?: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        masterAccountFee?: boolean | null;
        paymentMethods?: Array<PaymentMethods> | null;
      }> | null;
    } | null;
    riskLabels?: Array<{
      __typename?: 'RiskLabel';
      label?: string | null;
      category?: string | null;
      riskScore?: number | null;
    }> | null;
    business?: {
      __typename?: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      mcc?: string | null;
      documentNumber?: string | null;
      status?: BusinessStatus | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      servicesDescription?: string | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      capital?: any | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      registryRecords?: Array<{
        __typename?: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename?: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    representatives?: Array<{
      __typename?: 'RepresentativeData';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      citizenship?: string | null;
      dateOfBirth?: string | null;
      nationality?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      idSession?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusCode?: number | null;
      hasNoPublicActivity?: boolean | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      document?: {
        __typename?: 'IdDocument';
        type?: IdDocumentType | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      riskLabels?: Array<{
        __typename?: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    }> | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      period?: number | null;
      firstPeriod?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
      settleGross?: boolean | null;
      bankTransferConceptPrefix?: string | null;
      settleToStores?: boolean | null;
    } | null;
    publicBusinessDetails?: {
      __typename?: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      supportWebsite?: string | null;
      supportPhone?: string | null;
      supportEmail?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    upsell?: {
      __typename?: 'Upsell';
      executive?: SalesExecutive | null;
      paymentMethods?: Array<PaymentMethods> | null;
      date?: string | null;
      note?: string | null;
    } | null;
  } | null;
};

export type DeleteWebhookMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  accountId: Scalars['ID']['input'];
}>;

export type DeleteWebhookMutation = {__typename?: 'Mutation'; deleteWebhook: boolean};

export type CreateWebhookMutationVariables = Exact<{
  input: CreateWebhookInput;
}>;

export type CreateWebhookMutation = {
  __typename?: 'Mutation';
  createWebhook: {
    __typename?: 'Webhook';
    id: string;
    accountId: string;
    url: string;
    enabled: boolean;
    eventTypes: Array<WebhookEventType>;
    secret?: string | null;
    createdAt: string;
    updatedAt?: string | null;
  };
};

export type UpdateWebhookMutationVariables = Exact<{
  input: UpdateWebhookInput;
}>;

export type UpdateWebhookMutation = {
  __typename?: 'Mutation';
  updateWebhook: {
    __typename?: 'Webhook';
    id: string;
    accountId: string;
    url: string;
    enabled: boolean;
    eventTypes: Array<WebhookEventType>;
    secret?: string | null;
    createdAt: string;
    updatedAt?: string | null;
  };
};

export type StartExportChargesMutationVariables = Exact<{
  filter?: InputMaybe<SearchableChargeFilterInput>;
  columns?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;

export type StartExportChargesMutation = {
  __typename?: 'Mutation';
  startExportCharges: {
    __typename?: 'ChargesExport';
    id: string;
    accountId: string;
    status: ExportStatus;
    expireAt?: string | null;
    statusCode?: string | null;
    statusMessage?: string | null;
  };
};

export type DownloadExportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DownloadExportMutation = {
  __typename?: 'Mutation';
  downloadExport: {__typename?: 'DownloadFile'; downloadUrl: string; expiresAt: number};
};

export type DownloadOperationsFileMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  settlementId: Scalars['ID']['input'];
}>;

export type DownloadOperationsFileMutation = {
  __typename?: 'Mutation';
  downloadOperationsFile: {__typename?: 'DownloadFile'; downloadUrl: string};
};

export type DownloadAccountInvoiceMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  invoiceId: Scalars['ID']['input'];
}>;

export type DownloadAccountInvoiceMutation = {
  __typename?: 'Mutation';
  downloadAccountInvoice: {__typename?: 'DownloadFile'; downloadUrl: string};
};

export type CreateStoreMutationVariables = Exact<{
  input: CreateStoreInput;
}>;

export type CreateStoreMutation = {
  __typename?: 'Mutation';
  createStore: {
    __typename?: 'Store';
    id: string;
    accountId: string;
    name?: string | null;
    email?: string | null;
    iban?: string | null;
    phone?: string | null;
    website?: string | null;
    documentNumber?: string | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  };
};

export type UpdateStoreMutationVariables = Exact<{
  input: UpdateStoreInput;
}>;

export type UpdateStoreMutation = {
  __typename?: 'Mutation';
  updateStore: {
    __typename?: 'Store';
    id: string;
    accountId: string;
    name?: string | null;
    email?: string | null;
    iban?: string | null;
    phone?: string | null;
    website?: string | null;
    documentNumber?: string | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  };
};

export type DeleteStoreMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  accountId: Scalars['ID']['input'];
}>;

export type DeleteStoreMutation = {__typename?: 'Mutation'; deleteStore: boolean};

export type UpdateWebKeywordMutationVariables = Exact<{
  input: UpdateWebKeywordInput;
}>;

export type UpdateWebKeywordMutation = {
  __typename?: 'Mutation';
  updateWebKeyword?: {__typename?: 'WebKeyword'; incorrect?: boolean | null} | null;
};

export type ConnectMasterAccountMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  promoCode: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalHash?: InputMaybe<Scalars['String']['input']>;
}>;

export type ConnectMasterAccountMutation = {
  __typename?: 'Mutation';
  connectMasterAccount: {
    __typename?: 'Account';
    id: string;
    refAccountId?: string | null;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    status: AccountStatus;
    note?: string | null;
    userNote?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    allowCreateApiKey?: boolean | null;
    allowRefunds?: boolean | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    referralCode?: string | null;
    promoCode?: string | null;
    language?: string | null;
    reviewConfirmed?: boolean | null;
    progressiveBilling?: boolean | null;
    billingEmail?: string | null;
    billingPlan?: BillingPlans | null;
    riskScore?: number | null;
    riskProfile?: RiskProfile | null;
    riskProcessing?: boolean | null;
    riskProfileNote?: string | null;
    riskIgnoredKeywords?: Array<string> | null;
    riskUpdatedAt?: string | null;
    iban?: string | null;
    dynamicBilling?: boolean | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    sepblacId?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    accountExecutive?: SalesExecutive | null;
    billingVatPercent?: number | null;
    churned?: boolean | null;
    blocked?: boolean | null;
    statusReason?: StatusReason | null;
    statusNote?: string | null;
    churnReason?: ChurnReason | null;
    churnReasonOption?: string | null;
    churnNote?: string | null;
    previewFeatures?: Array<string> | null;
    tags?: Array<string> | null;
    masterAccountId?: string | null;
    accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null;
    customAccountInvoiceNotes?: Array<string> | null;
    groupInvoicesByStore?: boolean | null;
    fraudDetectorEnabled?: boolean | null;
    fraudDetectorThreshold?: number | null;
    fraudRulesEnabled?: boolean | null;
    contactPerson?: {
      __typename?: 'ContactPerson';
      name: string;
      email: string;
      phone?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    tokenizationMethods?: {
      __typename?: 'AccountTokenizationMethods';
      googlePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      applePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      clickToPay?: {
        __typename?: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
      } | null;
    } | null;
    notifications?: {
      __typename?: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
      emailCustomerOnSubscription?: boolean | null;
      emailAdminOnSubscription?: boolean | null;
      emailOnAccountInvoice?: boolean | null;
    } | null;
    fees?: {
      __typename?: 'AccountFees';
      highRiskFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      dailyPlatformFee?: number | null;
      weeklyCustomDomainFee?: number | null;
      fraudDetectorTrxFlatFee?: number | null;
      cardPresentTrxFee?: number | null;
      cardPresentTrxFlatFee?: number | null;
      steps?: Array<{
        __typename?: 'AccountSteps';
        trxFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        trxFlatFee: number;
        from: number;
      }> | null;
      extra?: Array<{
        __typename?: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        masterAccountFee?: boolean | null;
        paymentMethods?: Array<PaymentMethods> | null;
      }> | null;
    } | null;
    riskLabels?: Array<{
      __typename?: 'RiskLabel';
      label?: string | null;
      category?: string | null;
      riskScore?: number | null;
    }> | null;
    business?: {
      __typename?: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      mcc?: string | null;
      documentNumber?: string | null;
      status?: BusinessStatus | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      servicesDescription?: string | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      capital?: any | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      registryRecords?: Array<{
        __typename?: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename?: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    representatives?: Array<{
      __typename?: 'RepresentativeData';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      citizenship?: string | null;
      dateOfBirth?: string | null;
      nationality?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      idSession?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusCode?: number | null;
      hasNoPublicActivity?: boolean | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      document?: {
        __typename?: 'IdDocument';
        type?: IdDocumentType | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      riskLabels?: Array<{
        __typename?: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    }> | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      period?: number | null;
      firstPeriod?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
      settleGross?: boolean | null;
      bankTransferConceptPrefix?: string | null;
      settleToStores?: boolean | null;
    } | null;
    publicBusinessDetails?: {
      __typename?: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      supportWebsite?: string | null;
      supportPhone?: string | null;
      supportEmail?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    upsell?: {
      __typename?: 'Upsell';
      executive?: SalesExecutive | null;
      paymentMethods?: Array<PaymentMethods> | null;
      date?: string | null;
      note?: string | null;
    } | null;
  };
};

export type DisconnectMasterAccountMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type DisconnectMasterAccountMutation = {
  __typename?: 'Mutation';
  disconnectMasterAccount: {
    __typename?: 'Account';
    id: string;
    refAccountId?: string | null;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    status: AccountStatus;
    note?: string | null;
    userNote?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    allowCreateApiKey?: boolean | null;
    allowRefunds?: boolean | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    referralCode?: string | null;
    promoCode?: string | null;
    language?: string | null;
    reviewConfirmed?: boolean | null;
    progressiveBilling?: boolean | null;
    billingEmail?: string | null;
    billingPlan?: BillingPlans | null;
    riskScore?: number | null;
    riskProfile?: RiskProfile | null;
    riskProcessing?: boolean | null;
    riskProfileNote?: string | null;
    riskIgnoredKeywords?: Array<string> | null;
    riskUpdatedAt?: string | null;
    iban?: string | null;
    dynamicBilling?: boolean | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    sepblacId?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    accountExecutive?: SalesExecutive | null;
    billingVatPercent?: number | null;
    churned?: boolean | null;
    blocked?: boolean | null;
    statusReason?: StatusReason | null;
    statusNote?: string | null;
    churnReason?: ChurnReason | null;
    churnReasonOption?: string | null;
    churnNote?: string | null;
    previewFeatures?: Array<string> | null;
    tags?: Array<string> | null;
    masterAccountId?: string | null;
    accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null;
    customAccountInvoiceNotes?: Array<string> | null;
    groupInvoicesByStore?: boolean | null;
    fraudDetectorEnabled?: boolean | null;
    fraudDetectorThreshold?: number | null;
    fraudRulesEnabled?: boolean | null;
    contactPerson?: {
      __typename?: 'ContactPerson';
      name: string;
      email: string;
      phone?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    tokenizationMethods?: {
      __typename?: 'AccountTokenizationMethods';
      googlePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      applePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      clickToPay?: {
        __typename?: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
      } | null;
    } | null;
    notifications?: {
      __typename?: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
      emailCustomerOnSubscription?: boolean | null;
      emailAdminOnSubscription?: boolean | null;
      emailOnAccountInvoice?: boolean | null;
    } | null;
    fees?: {
      __typename?: 'AccountFees';
      highRiskFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      dailyPlatformFee?: number | null;
      weeklyCustomDomainFee?: number | null;
      fraudDetectorTrxFlatFee?: number | null;
      cardPresentTrxFee?: number | null;
      cardPresentTrxFlatFee?: number | null;
      steps?: Array<{
        __typename?: 'AccountSteps';
        trxFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        trxFlatFee: number;
        from: number;
      }> | null;
      extra?: Array<{
        __typename?: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        masterAccountFee?: boolean | null;
        paymentMethods?: Array<PaymentMethods> | null;
      }> | null;
    } | null;
    riskLabels?: Array<{
      __typename?: 'RiskLabel';
      label?: string | null;
      category?: string | null;
      riskScore?: number | null;
    }> | null;
    business?: {
      __typename?: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      mcc?: string | null;
      documentNumber?: string | null;
      status?: BusinessStatus | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      servicesDescription?: string | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      capital?: any | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      registryRecords?: Array<{
        __typename?: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename?: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    representatives?: Array<{
      __typename?: 'RepresentativeData';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      citizenship?: string | null;
      dateOfBirth?: string | null;
      nationality?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      idSession?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusCode?: number | null;
      hasNoPublicActivity?: boolean | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      document?: {
        __typename?: 'IdDocument';
        type?: IdDocumentType | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      riskLabels?: Array<{
        __typename?: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    }> | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      period?: number | null;
      firstPeriod?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
      settleGross?: boolean | null;
      bankTransferConceptPrefix?: string | null;
      settleToStores?: boolean | null;
    } | null;
    publicBusinessDetails?: {
      __typename?: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      supportWebsite?: string | null;
      supportPhone?: string | null;
      supportEmail?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    upsell?: {
      __typename?: 'Upsell';
      executive?: SalesExecutive | null;
      paymentMethods?: Array<PaymentMethods> | null;
      date?: string | null;
      note?: string | null;
    } | null;
  };
};

export type CreateMasterAccountApiKeyMutationVariables = Exact<{
  input: CreateMasterAccountApiKeyInput;
}>;

export type CreateMasterAccountApiKeyMutation = {
  __typename?: 'Mutation';
  createMasterAccountApiKey: {
    __typename?: 'MasterAccount';
    id: string;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    adminEmail?: string | null;
    iban?: string | null;
    apiKey?: string | null;
    test?: boolean | null;
    status?: AccountStatus | null;
    promoCode?: string | null;
    allowedIPs?: Array<string> | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    webhookEmails?: Array<string> | null;
    churnedEmails?: Array<string> | null;
    allowedDomains?: Array<string> | null;
    accountCallbackUrl?: string | null;
    requireExternalId?: boolean | null;
    contractTemplateId?: string | null;
    autoApprove?: boolean | null;
    blocked?: boolean | null;
    note?: string | null;
    allowCreateApiKey?: boolean | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    accountDefaults?: {
      __typename?: 'AccountDefaults';
      billingPlan?: BillingPlans | null;
      language?: string | null;
      fees?: {
        __typename?: 'AccountFees';
        trxFee?: number | null;
        trxFlatFee?: number | null;
        highRiskFee?: number | null;
        dailyPlatformFee?: number | null;
        dailyExtraSeatsFee?: number | null;
        steps?: Array<{
          __typename?: 'AccountSteps';
          trxFee: number;
          bizumTrxFee?: number | null;
          bizumTrxFlatFee?: number | null;
          trxFlatFee: number;
          from: number;
        }> | null;
        extra?: Array<{
          __typename?: 'AccountExtraFee';
          name: string;
          amount: number;
          type: AccountExtraFeeType;
          region?: AccountExtraFeeRegion | null;
          masterAccountFee?: boolean | null;
          paymentMethods?: Array<PaymentMethods> | null;
        }> | null;
      } | null;
      business?: {
        __typename?: 'BusinessDefault';
        mcc?: string | null;
        website?: string | null;
        servicesDescription?: string | null;
      } | null;
    } | null;
    business?: {
      __typename?: 'BusinessData';
      mcc?: string | null;
      legalName?: string | null;
      website?: string | null;
      documentNumber?: string | null;
      servicesDescription?: string | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
  };
};

export type DeleteMasterAccountApiKeyMutationVariables = Exact<{
  input: DeleteMasterAccountApiKeyInput;
}>;

export type DeleteMasterAccountApiKeyMutation = {
  __typename?: 'Mutation';
  deleteMasterAccountApiKey: {
    __typename?: 'MasterAccount';
    id: string;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    adminEmail?: string | null;
    iban?: string | null;
    apiKey?: string | null;
    test?: boolean | null;
    status?: AccountStatus | null;
    promoCode?: string | null;
    allowedIPs?: Array<string> | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    webhookEmails?: Array<string> | null;
    churnedEmails?: Array<string> | null;
    allowedDomains?: Array<string> | null;
    accountCallbackUrl?: string | null;
    requireExternalId?: boolean | null;
    contractTemplateId?: string | null;
    autoApprove?: boolean | null;
    blocked?: boolean | null;
    note?: string | null;
    allowCreateApiKey?: boolean | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    accountDefaults?: {
      __typename?: 'AccountDefaults';
      billingPlan?: BillingPlans | null;
      language?: string | null;
      fees?: {
        __typename?: 'AccountFees';
        trxFee?: number | null;
        trxFlatFee?: number | null;
        highRiskFee?: number | null;
        dailyPlatformFee?: number | null;
        dailyExtraSeatsFee?: number | null;
        steps?: Array<{
          __typename?: 'AccountSteps';
          trxFee: number;
          bizumTrxFee?: number | null;
          bizumTrxFlatFee?: number | null;
          trxFlatFee: number;
          from: number;
        }> | null;
        extra?: Array<{
          __typename?: 'AccountExtraFee';
          name: string;
          amount: number;
          type: AccountExtraFeeType;
          region?: AccountExtraFeeRegion | null;
          masterAccountFee?: boolean | null;
          paymentMethods?: Array<PaymentMethods> | null;
        }> | null;
      } | null;
      business?: {
        __typename?: 'BusinessDefault';
        mcc?: string | null;
        website?: string | null;
        servicesDescription?: string | null;
      } | null;
    } | null;
    business?: {
      __typename?: 'BusinessData';
      mcc?: string | null;
      legalName?: string | null;
      website?: string | null;
      documentNumber?: string | null;
      servicesDescription?: string | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
  };
};

export type UpdateUserMutationVariables = Exact<{
  input: UserInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'User';
    id: string;
    email: string;
    emailVerified?: boolean | null;
    phoneNumber?: string | null;
    phoneNumberVerified?: boolean | null;
    smsMfaEnabled?: boolean | null;
    status: UserStatus;
    enabled: boolean;
    accountId?: string | null;
    testAccountId?: string | null;
    referralCode?: string | null;
    promoCode?: string | null;
    createdAt: string;
  };
};

export type UpdateAffiliateTierMutationVariables = Exact<{
  input: UpdateAffiliateTierInput;
}>;

export type UpdateAffiliateTierMutation = {
  __typename?: 'Mutation';
  updateAffiliateTier: {
    __typename?: 'Affiliate';
    id: string;
    meta_data?: {__typename?: 'AffiliateMetaData'; tier?: string | null} | null;
  };
};

export type EnableAffiliateProcessingMutationVariables = Exact<{
  affiliateId: Scalars['ID']['input'];
}>;

export type EnableAffiliateProcessingMutation = {
  __typename?: 'Mutation';
  enableAffiliateProcessing: {
    __typename?: 'Affiliate';
    id: string;
    affiliate_group_id?: string | null;
  };
};

export type DisableAffiliateProcessingMutationVariables = Exact<{
  affiliateId: Scalars['ID']['input'];
}>;

export type DisableAffiliateProcessingMutation = {
  __typename?: 'Mutation';
  disableAffiliateProcessing: {
    __typename?: 'Affiliate';
    id: string;
    affiliate_group_id?: string | null;
  };
};

export type UpdateAffiliatePayoutMethodMutationVariables = Exact<{
  input: UpdateAffiliatePayoutMethodInput;
}>;

export type UpdateAffiliatePayoutMethodMutation = {
  __typename?: 'Mutation';
  updateAffiliatePayoutMethod: {
    __typename?: 'Affiliate';
    id: string;
    payout_methods?: Array<{
      __typename?: 'AffiliatePayoutMethod';
      id?: string | null;
      title?: string | null;
      details?: {
        __typename?: 'AffiliatePayoutMethodDetails';
        iban?: string | null;
        nif?: string | null;
      } | null;
    }> | null;
  };
};

export type RetrieveAffiliateHistoryMutationVariables = Exact<{
  affiliateId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;

export type RetrieveAffiliateHistoryMutation = {
  __typename?: 'Mutation';
  retrieveAffiliateHistory?: boolean | null;
};

export type DownloadAffiliateInvoiceMutationVariables = Exact<{
  invoiceNumber: Scalars['String']['input'];
  affiliateId: Scalars['String']['input'];
  year: Scalars['String']['input'];
}>;

export type DownloadAffiliateInvoiceMutation = {
  __typename?: 'Mutation';
  downloadAffiliateInvoice: {__typename?: 'DownloadFile'; downloadUrl: string; expiresAt: number};
};

export type AddBlacklistItemMutationVariables = Exact<{
  input: BlacklistItemInput;
}>;

export type AddBlacklistItemMutation = {
  __typename?: 'Mutation';
  addBlacklistItem: {
    __typename?: 'BlacklistItem';
    value: string;
    type: BlacklistItemType;
    note?: string | null;
    accountId?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    validUntil?: number | null;
  };
};

export type DeleteBlacklistItemMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
}>;

export type DeleteBlacklistItemMutation = {__typename?: 'Mutation'; deleteBlacklistItem: boolean};

export type CreatePointOfSaleMutationVariables = Exact<{
  input: CreatePointOfSaleInput;
}>;

export type CreatePointOfSaleMutation = {
  __typename?: 'Mutation';
  createPointOfSale: {
    __typename?: 'PointOfSale';
    id: string;
    accountId: string;
    storeId?: string | null;
    number: number;
    name?: string | null;
    currentPaymentId?: string | null;
    manualAmount?: boolean | null;
    type?: PointOfSaleType | null;
    deviceId?: string | null;
    terminalId?: string | null;
    description?: string | null;
    requireEmail?: boolean | null;
    requireTaxId?: boolean | null;
    includeQRCode?: boolean | null;
    qrCodeText?: string | null;
    fixedAmount?: number | null;
    fixedCurrency?: Currencies | null;
    transactionType?: TransactionTypes | null;
    paymentMethods?: Array<PaymentMethods> | null;
    enabled?: boolean | null;
    pendingSetup?: boolean | null;
    paymentCallbackUrl?: string | null;
  };
};

export type UpdatePointOfSaleMutationVariables = Exact<{
  input: UpdatePointOfSaleInput;
}>;

export type UpdatePointOfSaleMutation = {
  __typename?: 'Mutation';
  updatePointOfSale: {
    __typename?: 'PointOfSale';
    id: string;
    accountId: string;
    storeId?: string | null;
    number: number;
    name?: string | null;
    currentPaymentId?: string | null;
    manualAmount?: boolean | null;
    type?: PointOfSaleType | null;
    deviceId?: string | null;
    terminalId?: string | null;
    description?: string | null;
    requireEmail?: boolean | null;
    requireTaxId?: boolean | null;
    includeQRCode?: boolean | null;
    qrCodeText?: string | null;
    fixedAmount?: number | null;
    fixedCurrency?: Currencies | null;
    transactionType?: TransactionTypes | null;
    paymentMethods?: Array<PaymentMethods> | null;
    enabled?: boolean | null;
    pendingSetup?: boolean | null;
    paymentCallbackUrl?: string | null;
  };
};

export type DeletePointOfSaleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  accountId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DeletePointOfSaleMutation = {__typename?: 'Mutation'; deletePointOfSale: boolean};

export type GenerateOffersByAccountMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type GenerateOffersByAccountMutation = {
  __typename?: 'Mutation';
  generateOffersByAccount?: {
    __typename?: 'CapitalOffer';
    currencyISOCode: Currencies;
    fee: number;
    fundedAmount: number;
    loanAmount: number;
  } | null;
};

export type CreateExportSftpConfigMutationVariables = Exact<{
  input: CreateExportSftpConfigInput;
}>;

export type CreateExportSftpConfigMutation = {
  __typename?: 'Mutation';
  createExportSftpConfig: {
    __typename?: 'SftpConfigExport';
    id: string;
    accountId: string;
    host: string;
    port: number;
    username: string;
    path: string;
    columns?: Array<string> | null;
    timezone?: string | null;
    enabled?: boolean | null;
  };
};

export type UpdateExportSftpConfigMutationVariables = Exact<{
  input: UpdateExportSftpConfigInput;
}>;

export type UpdateExportSftpConfigMutation = {
  __typename?: 'Mutation';
  updateExportSftpConfig: {
    __typename?: 'SftpConfigExport';
    id: string;
    accountId: string;
    host: string;
    port: number;
    username: string;
    path: string;
    columns?: Array<string> | null;
    timezone?: string | null;
    enabled?: boolean | null;
  };
};

export type DeleteExportSftpConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  accountId: Scalars['ID']['input'];
}>;

export type DeleteExportSftpConfigMutation = {
  __typename?: 'Mutation';
  deleteExportSftpConfig: boolean;
};

export type ActivateMasterAccountMutationVariables = Exact<{[key: string]: never}>;

export type ActivateMasterAccountMutation = {
  __typename?: 'Mutation';
  activateMasterAccount: {
    __typename?: 'MasterAccount';
    id: string;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    adminEmail?: string | null;
    iban?: string | null;
    apiKey?: string | null;
    test?: boolean | null;
    status?: AccountStatus | null;
    promoCode?: string | null;
    allowedIPs?: Array<string> | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    webhookEmails?: Array<string> | null;
    churnedEmails?: Array<string> | null;
    allowedDomains?: Array<string> | null;
    accountCallbackUrl?: string | null;
    requireExternalId?: boolean | null;
    contractTemplateId?: string | null;
    autoApprove?: boolean | null;
    blocked?: boolean | null;
    note?: string | null;
    allowCreateApiKey?: boolean | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    accountDefaults?: {
      __typename?: 'AccountDefaults';
      billingPlan?: BillingPlans | null;
      language?: string | null;
      fees?: {
        __typename?: 'AccountFees';
        trxFee?: number | null;
        trxFlatFee?: number | null;
        highRiskFee?: number | null;
        dailyPlatformFee?: number | null;
        dailyExtraSeatsFee?: number | null;
        steps?: Array<{
          __typename?: 'AccountSteps';
          trxFee: number;
          bizumTrxFee?: number | null;
          bizumTrxFlatFee?: number | null;
          trxFlatFee: number;
          from: number;
        }> | null;
        extra?: Array<{
          __typename?: 'AccountExtraFee';
          name: string;
          amount: number;
          type: AccountExtraFeeType;
          region?: AccountExtraFeeRegion | null;
          masterAccountFee?: boolean | null;
          paymentMethods?: Array<PaymentMethods> | null;
        }> | null;
      } | null;
      business?: {
        __typename?: 'BusinessDefault';
        mcc?: string | null;
        website?: string | null;
        servicesDescription?: string | null;
      } | null;
    } | null;
    business?: {
      __typename?: 'BusinessData';
      mcc?: string | null;
      legalName?: string | null;
      website?: string | null;
      documentNumber?: string | null;
      servicesDescription?: string | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
  };
};

export type CreateCodeMutationVariables = Exact<{
  input: CreateCodeInput;
}>;

export type CreateCodeMutation = {
  __typename?: 'Mutation';
  createCode: {
    __typename?: 'Code';
    id: string;
    type: CodeTypes;
    enabled?: boolean | null;
    pointOfSaleId?: string | null;
  };
};

export type UpdateCodeMutationVariables = Exact<{
  input: UpdateCodeInput;
}>;

export type UpdateCodeMutation = {
  __typename?: 'Mutation';
  updateCode: {
    __typename?: 'Code';
    id: string;
    type: CodeTypes;
    enabled?: boolean | null;
    pointOfSaleId?: string | null;
  };
};

export type DeleteCodeMutationVariables = Exact<{
  input: DeleteCodeInput;
}>;

export type DeleteCodeMutation = {__typename?: 'Mutation'; deleteCode: boolean};

export type UpdatePibisiStatusMutationVariables = Exact<{
  input: UpdatePibisiStatusInput;
}>;

export type UpdatePibisiStatusMutation = {
  __typename?: 'Mutation';
  updatePibisiStatus: {
    __typename?: 'Pibisi';
    id?: string | null;
    entityId?: string | null;
    status?: PibisiStatus | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
  };
};

export type CreateShortLinkMutationVariables = Exact<{
  input: CreateShortLinkInput;
}>;

export type CreateShortLinkMutation = {
  __typename?: 'Mutation';
  createShortLink: {
    __typename?: 'ShortLink';
    id: string;
    url: string;
    openCount?: number | null;
    createdAt: string;
  };
};

export type DeleteShortLinkMutationVariables = Exact<{
  input: DeleteShortLinkInput;
}>;

export type DeleteShortLinkMutation = {__typename?: 'Mutation'; deleteShortLink: boolean};

export type AccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type AccountQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    id: string;
    refAccountId?: string | null;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    status: AccountStatus;
    note?: string | null;
    userNote?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    allowCreateApiKey?: boolean | null;
    allowRefunds?: boolean | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    referralCode?: string | null;
    promoCode?: string | null;
    language?: string | null;
    reviewConfirmed?: boolean | null;
    progressiveBilling?: boolean | null;
    billingEmail?: string | null;
    billingPlan?: BillingPlans | null;
    riskScore?: number | null;
    riskProfile?: RiskProfile | null;
    riskProcessing?: boolean | null;
    riskProfileNote?: string | null;
    riskIgnoredKeywords?: Array<string> | null;
    riskUpdatedAt?: string | null;
    iban?: string | null;
    dynamicBilling?: boolean | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    sepblacId?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    accountExecutive?: SalesExecutive | null;
    billingVatPercent?: number | null;
    churned?: boolean | null;
    blocked?: boolean | null;
    statusReason?: StatusReason | null;
    statusNote?: string | null;
    churnReason?: ChurnReason | null;
    churnReasonOption?: string | null;
    churnNote?: string | null;
    previewFeatures?: Array<string> | null;
    tags?: Array<string> | null;
    masterAccountId?: string | null;
    accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null;
    customAccountInvoiceNotes?: Array<string> | null;
    groupInvoicesByStore?: boolean | null;
    fraudDetectorEnabled?: boolean | null;
    fraudDetectorThreshold?: number | null;
    fraudRulesEnabled?: boolean | null;
    contactPerson?: {
      __typename?: 'ContactPerson';
      name: string;
      email: string;
      phone?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    tokenizationMethods?: {
      __typename?: 'AccountTokenizationMethods';
      googlePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      applePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
      clickToPay?: {
        __typename?: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
      } | null;
    } | null;
    notifications?: {
      __typename?: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
      emailCustomerOnSubscription?: boolean | null;
      emailAdminOnSubscription?: boolean | null;
      emailOnAccountInvoice?: boolean | null;
    } | null;
    fees?: {
      __typename?: 'AccountFees';
      highRiskFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      dailyPlatformFee?: number | null;
      weeklyCustomDomainFee?: number | null;
      fraudDetectorTrxFlatFee?: number | null;
      cardPresentTrxFee?: number | null;
      cardPresentTrxFlatFee?: number | null;
      steps?: Array<{
        __typename?: 'AccountSteps';
        trxFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        trxFlatFee: number;
        from: number;
      }> | null;
      extra?: Array<{
        __typename?: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        masterAccountFee?: boolean | null;
        paymentMethods?: Array<PaymentMethods> | null;
      }> | null;
    } | null;
    riskLabels?: Array<{
      __typename?: 'RiskLabel';
      label?: string | null;
      category?: string | null;
      riskScore?: number | null;
    }> | null;
    business?: {
      __typename?: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      mcc?: string | null;
      documentNumber?: string | null;
      status?: BusinessStatus | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      servicesDescription?: string | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      capital?: any | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      registryRecords?: Array<{
        __typename?: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename?: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    representatives?: Array<{
      __typename?: 'RepresentativeData';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      citizenship?: string | null;
      dateOfBirth?: string | null;
      nationality?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      idSession?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusCode?: number | null;
      hasNoPublicActivity?: boolean | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      document?: {
        __typename?: 'IdDocument';
        type?: IdDocumentType | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      riskLabels?: Array<{
        __typename?: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      pibisi?: {
        __typename?: 'Pibisi';
        id?: string | null;
        entityId?: string | null;
        status?: PibisiStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    }> | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      period?: number | null;
      firstPeriod?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
      settleGross?: boolean | null;
      bankTransferConceptPrefix?: string | null;
      settleToStores?: boolean | null;
    } | null;
    publicBusinessDetails?: {
      __typename?: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      supportWebsite?: string | null;
      supportPhone?: string | null;
      supportEmail?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    upsell?: {
      __typename?: 'Upsell';
      executive?: SalesExecutive | null;
      paymentMethods?: Array<PaymentMethods> | null;
      date?: string | null;
      note?: string | null;
    } | null;
  } | null;
};

export type AccountsQueryVariables = Exact<{
  filter?: InputMaybe<SearchableAccountFilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AccountsQuery = {
  __typename?: 'Query';
  accounts: {
    __typename?: 'AccountsConnection';
    total: number;
    items: Array<{
      __typename?: 'Account';
      id: string;
      refAccountId?: string | null;
      testAccountId?: string | null;
      prodAccountId?: string | null;
      name?: string | null;
      status: AccountStatus;
      note?: string | null;
      userNote?: string | null;
      partner?: Partner | null;
      acquirer?: Acquirer | null;
      adminEmail?: string | null;
      allowCreateApiKey?: boolean | null;
      allowRefunds?: boolean | null;
      defaultCurrency?: Currencies | null;
      defaultTransactionType?: TransactionTypes | null;
      referralCode?: string | null;
      promoCode?: string | null;
      language?: string | null;
      reviewConfirmed?: boolean | null;
      progressiveBilling?: boolean | null;
      billingEmail?: string | null;
      billingPlan?: BillingPlans | null;
      riskScore?: number | null;
      riskProfile?: RiskProfile | null;
      riskProcessing?: boolean | null;
      riskProfileNote?: string | null;
      riskIgnoredKeywords?: Array<string> | null;
      riskUpdatedAt?: string | null;
      iban?: string | null;
      dynamicBilling?: boolean | null;
      test?: boolean | null;
      secret?: string | null;
      apiKey?: string | null;
      customDomain?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      deletedAt?: string | null;
      approvedAt?: string | null;
      rejectedAt?: string | null;
      activatedAt?: string | null;
      sepblacId?: string | null;
      approvalRequestedAt?: string | null;
      suspendedAt?: string | null;
      dataUpdatedAt?: string | null;
      accountExecutive?: SalesExecutive | null;
      billingVatPercent?: number | null;
      churned?: boolean | null;
      blocked?: boolean | null;
      statusReason?: StatusReason | null;
      statusNote?: string | null;
      churnReason?: ChurnReason | null;
      churnReasonOption?: string | null;
      churnNote?: string | null;
      previewFeatures?: Array<string> | null;
      tags?: Array<string> | null;
      masterAccountId?: string | null;
      accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null;
      customAccountInvoiceNotes?: Array<string> | null;
      groupInvoicesByStore?: boolean | null;
      fraudDetectorEnabled?: boolean | null;
      fraudDetectorThreshold?: number | null;
      fraudRulesEnabled?: boolean | null;
      contactPerson?: {
        __typename?: 'ContactPerson';
        name: string;
        email: string;
        phone?: string | null;
      } | null;
      branding?: {
        __typename?: 'AccountBranding';
        accentColor?: string | null;
        bgColor?: string | null;
        logoUrl?: string | null;
        iconUrl?: string | null;
      } | null;
      tokenizationMethods?: {
        __typename?: 'AccountTokenizationMethods';
        googlePay?: {
          __typename?: 'AccountTokenizationMethodsItem';
          enabled?: boolean | null;
        } | null;
        applePay?: {__typename?: 'AccountTokenizationMethodsItem'; enabled?: boolean | null} | null;
        clickToPay?: {
          __typename?: 'AccountTokenizationMethodsClickToPayItem';
          enabled?: boolean | null;
        } | null;
      } | null;
      notifications?: {
        __typename?: 'AccountNotifications';
        emailCustomerOnRefund?: boolean | null;
        emailCustomerOnSuccess?: boolean | null;
        emailAdminOnSuccess?: boolean | null;
        emailCustomerOnSubscription?: boolean | null;
        emailAdminOnSubscription?: boolean | null;
        emailOnAccountInvoice?: boolean | null;
      } | null;
      fees?: {
        __typename?: 'AccountFees';
        highRiskFee?: number | null;
        dailyExtraSeatsFee?: number | null;
        dailyPlatformFee?: number | null;
        weeklyCustomDomainFee?: number | null;
        fraudDetectorTrxFlatFee?: number | null;
        cardPresentTrxFee?: number | null;
        cardPresentTrxFlatFee?: number | null;
        steps?: Array<{
          __typename?: 'AccountSteps';
          trxFee: number;
          bizumTrxFee?: number | null;
          bizumTrxFlatFee?: number | null;
          trxFlatFee: number;
          from: number;
        }> | null;
        extra?: Array<{
          __typename?: 'AccountExtraFee';
          name: string;
          amount: number;
          type: AccountExtraFeeType;
          masterAccountFee?: boolean | null;
          paymentMethods?: Array<PaymentMethods> | null;
        }> | null;
      } | null;
      riskLabels?: Array<{
        __typename?: 'RiskLabel';
        label?: string | null;
        category?: string | null;
        riskScore?: number | null;
      }> | null;
      business?: {
        __typename?: 'BusinessData';
        country?: string | null;
        legalForm?: LegalForm | null;
        legalName?: string | null;
        companyName?: string | null;
        mcc?: string | null;
        documentNumber?: string | null;
        status?: BusinessStatus | null;
        email?: string | null;
        phone?: string | null;
        website?: string | null;
        monthlyVolume?: number | null;
        confirmWebsite?: boolean | null;
        industry?: Industries | null;
        servicesDescription?: string | null;
        confirmServicesDescription?: boolean | null;
        legalAddress?: string | null;
        legalDescription?: string | null;
        creationDate?: string | null;
        lastUpdateDate?: string | null;
        startActivityDate?: string | null;
        capital?: any | null;
        previousNames?: Array<string | null> | null;
        verificationAttempts?: number | null;
        address?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        registryRecords?: Array<{
          __typename?: 'RegistryRecord';
          name?: string | null;
          url?: string | null;
          province?: string | null;
          date?: string | null;
        }> | null;
        positions?: Array<{
          __typename?: 'BusinessPosition';
          fromDate?: string | null;
          role?: string | null;
          name?: string | null;
        }> | null;
        pibisi?: {
          __typename?: 'Pibisi';
          id?: string | null;
          entityId?: string | null;
          status?: PibisiStatus | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      representatives?: Array<{
        __typename?: 'RepresentativeData';
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phone?: string | null;
        documentNumber?: string | null;
        stocksPercentage?: number | null;
        gender?: Gender | null;
        citizenship?: string | null;
        dateOfBirth?: string | null;
        nationality?: string | null;
        yearOfBirth?: string | null;
        placeOfBirth?: string | null;
        idSession?: string | null;
        interventionType?: Array<InterventionType> | null;
        status?: IdVerificationStatus | null;
        statusCode?: number | null;
        hasNoPublicActivity?: boolean | null;
        address?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        document?: {
          __typename?: 'IdDocument';
          type?: IdDocumentType | null;
          number?: string | null;
          country?: string | null;
          validFrom?: string | null;
          validUntil?: string | null;
        } | null;
        riskLabels?: Array<{
          __typename?: 'RiskLabel';
          label?: string | null;
          category?: string | null;
        }> | null;
        pibisi?: {
          __typename?: 'Pibisi';
          id?: string | null;
          entityId?: string | null;
          status?: PibisiStatus | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }> | null;
      payoutTerms?: {
        __typename?: 'AccountPayoutTerms';
        iban?: string | null;
        period?: number | null;
        firstPeriod?: number | null;
        reservePercent?: number | null;
        suspended?: boolean | null;
        releaseReserve?: boolean | null;
        settleGross?: boolean | null;
        bankTransferConceptPrefix?: string | null;
        settleToStores?: boolean | null;
      } | null;
      publicBusinessDetails?: {
        __typename?: 'AccountPublicBusinessDetails';
        companyName?: string | null;
        website?: string | null;
        phone?: string | null;
        supportWebsite?: string | null;
        supportPhone?: string | null;
        supportEmail?: string | null;
        address?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      contract?: {
        __typename?: 'AccountContract';
        envelopeId?: string | null;
        status: ContractStatus;
        path?: string | null;
        signedDate?: string | null;
      } | null;
      upsell?: {
        __typename?: 'Upsell';
        executive?: SalesExecutive | null;
        paymentMethods?: Array<PaymentMethods> | null;
        date?: string | null;
        note?: string | null;
      } | null;
    }>;
  };
};

export type AuthorizedUsersQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type AuthorizedUsersQuery = {
  __typename?: 'Query';
  authorizedUsers: {
    __typename?: 'AuthorizedUsersConnection';
    items: Array<{
      __typename?: 'AuthorizedUser';
      id?: string | null;
      accountId?: string | null;
      userEmail: string;
      accessLevel: AuthorizedUserAccessLevel;
      storeId?: string | null;
      pointOfSaleId?: string | null;
      status?: AuthorizedUserStatus | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      lastLoginAt?: string | null;
    }>;
  };
};

export type AvailablePaymentMethodsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type AvailablePaymentMethodsQuery = {
  __typename?: 'Query';
  availablePaymentMethods?: Array<{
    __typename?: 'AvailablePaymentMethod';
    paymentMethod?: PaymentMethods | null;
    configured?: boolean | null;
    enabled?: boolean | null;
  }> | null;
};

export type AvailableProcessorsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  paymentMethod: PaymentMethods;
}>;

export type AvailableProcessorsQuery = {
  __typename?: 'Query';
  availableProcessors?: Array<{
    __typename?: 'AvailableProcessor';
    paymentMethod?: PaymentMethods | null;
    processor?: Processor | null;
    configured?: boolean | null;
    enabled?: boolean | null;
  }> | null;
};

export type ProviderConfigQueryVariables = Exact<{
  paymentMethod: PaymentMethods;
  processor: Processor;
}>;

export type ProviderConfigQuery = {
  __typename?: 'Query';
  providerConfig?: {
    __typename?: 'ProviderConfig';
    paymentMethod?: PaymentMethods | null;
    processor?: Processor | null;
    acquirers?: Array<Acquirer> | null;
    metadataConfig?: Array<{
      __typename?: 'MetadataConfigItem';
      key: string;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      default?: string | null;
      regex?: string | null;
      secret?: boolean | null;
      example?: string | null;
    }> | null;
  } | null;
};

export type ProviderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ProviderQuery = {
  __typename?: 'Query';
  provider?: {
    __typename?: 'Provider';
    id: string;
    processor?: Processor | null;
    enabled?: boolean | null;
    test?: boolean | null;
    paymentMethod?: PaymentMethods | null;
    acquirer?: Acquirer | null;
    currencies?: Array<Currencies> | null;
    nativeHostedPayment?: boolean | null;
    metadata?: Array<{
      __typename?: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      example?: string | null;
      secret?: boolean | null;
    }> | null;
    rules?: {
      __typename?: 'ProviderRules';
      minAmount?: number | null;
      maxAmount?: number | null;
      shopNameLike?: string | null;
      descriptionLike?: string | null;
    } | null;
  } | null;
};

export type ProvidersQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type ProvidersQuery = {
  __typename?: 'Query';
  providers?: Array<{
    __typename?: 'Provider';
    id: string;
    processor?: Processor | null;
    enabled?: boolean | null;
    test?: boolean | null;
    paymentMethod?: PaymentMethods | null;
    acquirer?: Acquirer | null;
    currencies?: Array<Currencies> | null;
    nativeHostedPayment?: boolean | null;
    metadata?: Array<{
      __typename?: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      example?: string | null;
      secret?: boolean | null;
    }> | null;
    rules?: {
      __typename?: 'ProviderRules';
      minAmount?: number | null;
      maxAmount?: number | null;
      shopNameLike?: string | null;
      descriptionLike?: string | null;
    } | null;
  }> | null;
};

export type ChargesQueryVariables = Exact<{
  filter?: InputMaybe<SearchableChargeFilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ChargesQuery = {
  __typename?: 'Query';
  charges: {
    __typename?: 'ChargesConnection';
    total: number;
    items: Array<{
      __typename?: 'Charge';
      id: string;
      accountId: string;
      providerId?: string | null;
      checkoutId: string;
      sequenceId?: string | null;
      processor?: Processor | null;
      subscriptionId?: string | null;
      pointOfSaleId?: string | null;
      providerReferenceId?: string | null;
      providerInternalId?: string | null;
      masterAccountId?: string | null;
      billingPlan?: BillingPlans | null;
      createdAt: number;
      updatedAt?: number | null;
      amount?: number | null;
      acquirer?: Acquirer | null;
      authorizationCode?: string | null;
      storeId?: string | null;
      currency: string;
      description?: string | null;
      descriptor?: string | null;
      livemode?: boolean | null;
      orderId?: string | null;
      refundedAmount?: number | null;
      lastRefundAmount?: number | null;
      lastRefundReason?: RefundReason | null;
      cancellationReason?: CancellationReason | null;
      status: ChargeStatus;
      statusCode?: string | null;
      statusMessage?: string | null;
      providerStatusCode?: string | null;
      providerStatusMessage?: string | null;
      issuerStatusCode?: string | null;
      issuerStatusMessage?: string | null;
      fraudDetectorScore?: number | null;
      callbackUrl?: string | null;
      completeUrl?: string | null;
      failUrl?: string | null;
      cancelUrl?: string | null;
      billingDetails?: {
        __typename?: 'ContactDetails';
        email?: string | null;
        name?: string | null;
        company?: string | null;
        phone?: string | null;
        taxId?: string | null;
        address?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      customer?: {
        __typename?: 'Customer';
        email?: string | null;
        name?: string | null;
        phone?: string | null;
      } | null;
      paymentMethod?: {
        __typename?: 'PaymentMethod';
        method?: PaymentMethods | null;
        bizum?: {
          __typename?: 'PaymentMethodBizum';
          phoneNumber?: string | null;
          integrationType?: string | null;
          ibanLast4?: string | null;
          idBizum?: string | null;
        } | null;
        card?: {
          __typename?: 'PaymentMethodCard';
          brand?: CardBrand | null;
          country?: string | null;
          type?: CardType | null;
          threeDSecure?: boolean | null;
          threeDSecureVersion?: string | null;
          threeDSecureFlow?: ThreeDSecureFlow | null;
          threeDSecureStatus?: ThreeDsStatus | null;
          last4?: string | null;
          fingerprint?: string | null;
          cardholderName?: string | null;
          cardholderEmail?: string | null;
          expiration?: any | null;
          bank?: string | null;
          tokenizationMethod?: TokenizationMethods | null;
          srcCorrelationId?: string | null;
          srciTransactionId?: string | null;
          srcDpaId?: string | null;
        } | null;
        cardPresent?: {
          __typename?: 'PaymentMethodCardPresent';
          bin?: string | null;
          brand?: CardBrand | null;
          cardholderEmail?: string | null;
          cardholderName?: string | null;
          country?: string | null;
          expiration?: any | null;
          last4?: string | null;
          fingerprint?: string | null;
          type?: CardType | null;
          verificationMethod?: VerificationMethod | null;
        } | null;
        mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
        paypal?: {
          __typename?: 'PaymentMethodPaypal';
          orderId?: string | null;
          payerId?: string | null;
          email?: string | null;
          name?: string | null;
        } | null;
        sepa?: {
          __typename?: 'PaymentMethodSepa';
          accountholderEmail?: string | null;
          accountholderName?: string | null;
          countryCode?: string | null;
          bankAddress?: string | null;
          bankCode?: string | null;
          bankName?: string | null;
          bic?: string | null;
          last4?: string | null;
          fingerprint?: string | null;
          accountholderAddress?: {
            __typename?: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
        } | null;
        trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
        klarna?: {
          __typename?: 'PaymentMethodKlarna';
          billingCategory?: BillingCategoryKlarna | null;
          authPaymentMethod?: AuthPaymentMethodKlarna | null;
        } | null;
      } | null;
      shippingDetails?: {
        __typename?: 'ContactDetails';
        email?: string | null;
        name?: string | null;
        company?: string | null;
        phone?: string | null;
        taxId?: string | null;
        address?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      shop?: {__typename?: 'Shop'; name?: string | null; country?: string | null} | null;
      sessionDetails?: {
        __typename?: 'SessionDetails';
        ip?: string | null;
        fingerprint?: string | null;
        userAgent?: string | null;
        countryCode?: string | null;
        lang?: string | null;
        deviceType?: DeviceType | null;
        deviceModel?: string | null;
        browser?: string | null;
        browserVersion?: string | null;
        browserAccept?: string | null;
        browserColorDepth?: string | null;
        browserScreenHeight?: string | null;
        browserScreenWidth?: string | null;
        browserTimezoneOffset?: string | null;
        os?: string | null;
        osVersion?: string | null;
        source?: string | null;
        sourceVersion?: string | null;
      } | null;
      traceDetails?: {
        __typename?: 'TraceDetails';
        ip?: string | null;
        userAgent?: string | null;
        countryCode?: string | null;
        lang?: string | null;
        deviceType?: DeviceType | null;
        deviceModel?: string | null;
        browser?: string | null;
        browserVersion?: string | null;
        browserAccept?: string | null;
        os?: string | null;
        osVersion?: string | null;
        source?: string | null;
        sourceVersion?: string | null;
        userId?: string | null;
        userEmail?: string | null;
        userName?: string | null;
      } | null;
      metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
    }>;
  };
};

export type ChargesExportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ChargesExportQuery = {
  __typename?: 'Query';
  chargesExport?: {
    __typename?: 'ChargesExport';
    id: string;
    accountId: string;
    status: ExportStatus;
    expireAt?: string | null;
    statusCode?: string | null;
    statusMessage?: string | null;
  } | null;
};

export type ChargeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ChargeQuery = {
  __typename?: 'Query';
  charge?: {
    __typename?: 'Charge';
    id: string;
    accountId: string;
    providerId?: string | null;
    checkoutId: string;
    sequenceId?: string | null;
    processor?: Processor | null;
    subscriptionId?: string | null;
    pointOfSaleId?: string | null;
    providerReferenceId?: string | null;
    providerInternalId?: string | null;
    masterAccountId?: string | null;
    billingPlan?: BillingPlans | null;
    createdAt: number;
    updatedAt?: number | null;
    amount?: number | null;
    acquirer?: Acquirer | null;
    authorizationCode?: string | null;
    storeId?: string | null;
    currency: string;
    description?: string | null;
    descriptor?: string | null;
    livemode?: boolean | null;
    orderId?: string | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    status: ChargeStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    providerStatusCode?: string | null;
    providerStatusMessage?: string | null;
    issuerStatusCode?: string | null;
    issuerStatusMessage?: string | null;
    fraudDetectorScore?: number | null;
    callbackUrl?: string | null;
    completeUrl?: string | null;
    failUrl?: string | null;
    cancelUrl?: string | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      taxId?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shop?: {__typename?: 'Shop'; name?: string | null; country?: string | null} | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
  } | null;
};

export type SucceededDateRangeKpiQueryVariables = Exact<{
  start?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['Int']['input']>;
  interval?: InputMaybe<Interval>;
  accountId?: InputMaybe<Scalars['ID']['input']>;
  acquirer?: InputMaybe<Acquirer>;
  masterAccountId?: InputMaybe<Scalars['ID']['input']>;
  billingPlan?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethods>;
  source?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currencies>;
}>;

export type SucceededDateRangeKpiQuery = {
  __typename?: 'Query';
  chargesDateRangeKPI: {
    __typename?: 'ChargesDateRangeKPI';
    currency: Currencies;
    total: {__typename?: 'ChargesDateRangeKPITotal'; succeededAmount: any; succeededCount: any};
    data: Array<{
      __typename?: 'ChargesDateRangeKPIRow';
      timestamp: number;
      cuSucceededAmount: any;
      cuSucceededCount: any;
    }>;
  };
};

export type ChargesDateRangeKpiQueryVariables = Exact<{
  start?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['Int']['input']>;
  interval?: InputMaybe<Interval>;
  accountId?: InputMaybe<Scalars['ID']['input']>;
  acquirer?: InputMaybe<Acquirer>;
  masterAccountId?: InputMaybe<Scalars['ID']['input']>;
  billingPlan?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethods>;
  source?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currencies>;
}>;

export type ChargesDateRangeKpiQuery = {
  __typename?: 'Query';
  chargesDateRangeKPI: {
    __typename?: 'ChargesDateRangeKPI';
    currency: Currencies;
    total: {
      __typename?: 'ChargesDateRangeKPITotal';
      succeededAmount: any;
      succeededCount: any;
      refundedAmount: any;
      refundedCount: any;
      failedCount: any;
    };
    data: Array<{
      __typename?: 'ChargesDateRangeKPIRow';
      timestamp: number;
      succeededAmount: any;
      succeededCount: any;
      refundedAmount: any;
      refundedCount: any;
      failedCount: any;
    }>;
  };
};

export type ChargeEventsQueryVariables = Exact<{
  chargeId: Scalars['ID']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ChargeEventsQuery = {
  __typename?: 'Query';
  chargeEvents: {
    __typename?: 'ChargeEventsConnection';
    total: number;
    items: Array<{
      __typename?: 'ChargeEvent';
      id: string;
      type: string;
      accountId: string;
      livemode?: boolean | null;
      objectId: string;
      objectType: string;
      createdAt?: number | null;
      object: {
        __typename?: 'ChargeEventObject';
        id: string;
        accountId: string;
        providerId?: string | null;
        checkoutId: string;
        sequenceId?: string | null;
        billingPlan?: BillingPlans | null;
        subscriptionId?: string | null;
        storeId?: string | null;
        pointOfSaleId?: string | null;
        providerReferenceId?: string | null;
        providerInternalId?: string | null;
        createdAt?: number | null;
        updatedAt?: number | null;
        amount?: number | null;
        amountEUR?: number | null;
        authorizationCode?: string | null;
        currency: string;
        description?: string | null;
        descriptor?: string | null;
        livemode?: boolean | null;
        orderId?: string | null;
        terminalId?: string | null;
        masterAccountId?: string | null;
        refundedAmount?: number | null;
        lastRefundAmount?: number | null;
        lastRefundReason?: RefundReason | null;
        cancellationReason?: CancellationReason | null;
        status: ChargeStatus;
        statusCode?: string | null;
        statusMessage?: string | null;
        providerStatusCode?: string | null;
        providerStatusMessage?: string | null;
        issuerStatusCode?: string | null;
        issuerStatusMessage?: string | null;
        pageOpenedAt?: number | null;
        fraudDetectorScore?: number | null;
        callbackUrl?: string | null;
        completeUrl?: string | null;
        failUrl?: string | null;
        cancelUrl?: string | null;
        billingDetails?: {
          __typename?: 'ContactDetails';
          email?: string | null;
          name?: string | null;
          company?: string | null;
          phone?: string | null;
          taxId?: string | null;
          address?: {
            __typename?: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
        } | null;
        customer?: {
          __typename?: 'Customer';
          email?: string | null;
          name?: string | null;
          phone?: string | null;
        } | null;
        paymentMethod?: {
          __typename?: 'PaymentMethod';
          method?: PaymentMethods | null;
          bizum?: {
            __typename?: 'PaymentMethodBizum';
            phoneNumber?: string | null;
            integrationType?: string | null;
            ibanLast4?: string | null;
            idBizum?: string | null;
          } | null;
          card?: {
            __typename?: 'PaymentMethodCard';
            brand?: CardBrand | null;
            country?: string | null;
            type?: CardType | null;
            threeDSecure?: boolean | null;
            threeDSecureVersion?: string | null;
            threeDSecureFlow?: ThreeDSecureFlow | null;
            threeDSecureStatus?: ThreeDsStatus | null;
            last4?: string | null;
            fingerprint?: string | null;
            cardholderName?: string | null;
            cardholderEmail?: string | null;
            expiration?: any | null;
            bank?: string | null;
            tokenizationMethod?: TokenizationMethods | null;
            srcCorrelationId?: string | null;
            srciTransactionId?: string | null;
            srcDpaId?: string | null;
          } | null;
          cardPresent?: {
            __typename?: 'PaymentMethodCardPresent';
            bin?: string | null;
            brand?: CardBrand | null;
            cardholderEmail?: string | null;
            cardholderName?: string | null;
            country?: string | null;
            expiration?: any | null;
            last4?: string | null;
            fingerprint?: string | null;
            type?: CardType | null;
            verificationMethod?: VerificationMethod | null;
          } | null;
          mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
          paypal?: {
            __typename?: 'PaymentMethodPaypal';
            orderId?: string | null;
            payerId?: string | null;
            email?: string | null;
            name?: string | null;
          } | null;
          sepa?: {
            __typename?: 'PaymentMethodSepa';
            accountholderEmail?: string | null;
            accountholderName?: string | null;
            countryCode?: string | null;
            bankAddress?: string | null;
            bankCode?: string | null;
            bankName?: string | null;
            bic?: string | null;
            last4?: string | null;
            fingerprint?: string | null;
            accountholderAddress?: {
              __typename?: 'Address';
              city?: string | null;
              country?: string | null;
              line1?: string | null;
              line2?: string | null;
              zip?: string | null;
              state?: string | null;
            } | null;
          } | null;
          trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
          klarna?: {
            __typename?: 'PaymentMethodKlarna';
            billingCategory?: BillingCategoryKlarna | null;
            authPaymentMethod?: AuthPaymentMethodKlarna | null;
          } | null;
        } | null;
        shippingDetails?: {
          __typename?: 'ContactDetails';
          email?: string | null;
          name?: string | null;
          company?: string | null;
          taxId?: string | null;
          phone?: string | null;
          address?: {
            __typename?: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
        } | null;
        shop?: {__typename?: 'Shop'; name?: string | null; country?: string | null} | null;
        sessionDetails?: {
          __typename?: 'SessionDetails';
          ip?: string | null;
          fingerprint?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          browserColorDepth?: string | null;
          browserScreenHeight?: string | null;
          browserScreenWidth?: string | null;
          browserTimezoneOffset?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
        } | null;
        traceDetails?: {
          __typename?: 'TraceDetails';
          ip?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
          userId?: string | null;
          userEmail?: string | null;
          userName?: string | null;
        } | null;
        metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
      };
    }>;
  };
};

export type EventsQueryVariables = Exact<{
  filter?: InputMaybe<SearchableEventFilterInput>;
  size?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
}>;

export type EventsQuery = {
  __typename?: 'Query';
  events: {
    __typename?: 'ChargeEventsConnection';
    total: number;
    items: Array<{
      __typename?: 'ChargeEvent';
      id: string;
      type: string;
      accountId: string;
      livemode?: boolean | null;
      objectId: string;
      objectType: string;
      createdAt?: number | null;
      object: {
        __typename?: 'ChargeEventObject';
        id: string;
        accountId: string;
        providerId?: string | null;
        checkoutId: string;
        sequenceId?: string | null;
        billingPlan?: BillingPlans | null;
        subscriptionId?: string | null;
        storeId?: string | null;
        pointOfSaleId?: string | null;
        providerReferenceId?: string | null;
        providerInternalId?: string | null;
        createdAt?: number | null;
        updatedAt?: number | null;
        amount?: number | null;
        amountEUR?: number | null;
        authorizationCode?: string | null;
        currency: string;
        description?: string | null;
        descriptor?: string | null;
        livemode?: boolean | null;
        orderId?: string | null;
        terminalId?: string | null;
        masterAccountId?: string | null;
        refundedAmount?: number | null;
        lastRefundAmount?: number | null;
        lastRefundReason?: RefundReason | null;
        cancellationReason?: CancellationReason | null;
        status: ChargeStatus;
        statusCode?: string | null;
        statusMessage?: string | null;
        providerStatusCode?: string | null;
        providerStatusMessage?: string | null;
        issuerStatusCode?: string | null;
        issuerStatusMessage?: string | null;
        pageOpenedAt?: number | null;
        fraudDetectorScore?: number | null;
        callbackUrl?: string | null;
        completeUrl?: string | null;
        failUrl?: string | null;
        cancelUrl?: string | null;
        billingDetails?: {
          __typename?: 'ContactDetails';
          email?: string | null;
          name?: string | null;
          company?: string | null;
          phone?: string | null;
          taxId?: string | null;
          address?: {
            __typename?: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
        } | null;
        customer?: {
          __typename?: 'Customer';
          email?: string | null;
          name?: string | null;
          phone?: string | null;
        } | null;
        paymentMethod?: {
          __typename?: 'PaymentMethod';
          method?: PaymentMethods | null;
          bizum?: {
            __typename?: 'PaymentMethodBizum';
            phoneNumber?: string | null;
            integrationType?: string | null;
            ibanLast4?: string | null;
            idBizum?: string | null;
          } | null;
          card?: {
            __typename?: 'PaymentMethodCard';
            brand?: CardBrand | null;
            country?: string | null;
            type?: CardType | null;
            threeDSecure?: boolean | null;
            threeDSecureVersion?: string | null;
            threeDSecureFlow?: ThreeDSecureFlow | null;
            threeDSecureStatus?: ThreeDsStatus | null;
            last4?: string | null;
            fingerprint?: string | null;
            cardholderName?: string | null;
            cardholderEmail?: string | null;
            expiration?: any | null;
            bank?: string | null;
            tokenizationMethod?: TokenizationMethods | null;
            srcCorrelationId?: string | null;
            srciTransactionId?: string | null;
            srcDpaId?: string | null;
          } | null;
          cardPresent?: {
            __typename?: 'PaymentMethodCardPresent';
            bin?: string | null;
            brand?: CardBrand | null;
            cardholderEmail?: string | null;
            cardholderName?: string | null;
            country?: string | null;
            expiration?: any | null;
            last4?: string | null;
            fingerprint?: string | null;
            type?: CardType | null;
            verificationMethod?: VerificationMethod | null;
          } | null;
          mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
          paypal?: {
            __typename?: 'PaymentMethodPaypal';
            orderId?: string | null;
            payerId?: string | null;
            email?: string | null;
            name?: string | null;
          } | null;
          sepa?: {
            __typename?: 'PaymentMethodSepa';
            accountholderEmail?: string | null;
            accountholderName?: string | null;
            countryCode?: string | null;
            bankAddress?: string | null;
            bankCode?: string | null;
            bankName?: string | null;
            bic?: string | null;
            last4?: string | null;
            fingerprint?: string | null;
            accountholderAddress?: {
              __typename?: 'Address';
              city?: string | null;
              country?: string | null;
              line1?: string | null;
              line2?: string | null;
              zip?: string | null;
              state?: string | null;
            } | null;
          } | null;
          trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
          klarna?: {
            __typename?: 'PaymentMethodKlarna';
            billingCategory?: BillingCategoryKlarna | null;
            authPaymentMethod?: AuthPaymentMethodKlarna | null;
          } | null;
        } | null;
        shippingDetails?: {
          __typename?: 'ContactDetails';
          email?: string | null;
          name?: string | null;
          company?: string | null;
          taxId?: string | null;
          phone?: string | null;
          address?: {
            __typename?: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
        } | null;
        shop?: {__typename?: 'Shop'; name?: string | null; country?: string | null} | null;
        sessionDetails?: {
          __typename?: 'SessionDetails';
          ip?: string | null;
          fingerprint?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          browserColorDepth?: string | null;
          browserScreenHeight?: string | null;
          browserScreenWidth?: string | null;
          browserTimezoneOffset?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
        } | null;
        traceDetails?: {
          __typename?: 'TraceDetails';
          ip?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
          userId?: string | null;
          userEmail?: string | null;
          userName?: string | null;
        } | null;
        metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
      };
    }>;
  };
};

export type UserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type UserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    email: string;
    emailVerified?: boolean | null;
    phoneNumber?: string | null;
    phoneNumberVerified?: boolean | null;
    smsMfaEnabled?: boolean | null;
    status: UserStatus;
    enabled: boolean;
    accountId?: string | null;
    testAccountId?: string | null;
    referralCode?: string | null;
    promoCode?: string | null;
    createdAt: string;
  } | null;
};

export type UsersQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UsersQuery = {
  __typename?: 'Query';
  users: {
    __typename?: 'UsersConnection';
    nextToken?: string | null;
    items: Array<{
      __typename?: 'User';
      id: string;
      email: string;
      emailVerified?: boolean | null;
      phoneNumber?: string | null;
      phoneNumberVerified?: boolean | null;
      smsMfaEnabled?: boolean | null;
      status: UserStatus;
      enabled: boolean;
      accountId?: string | null;
      testAccountId?: string | null;
      referralCode?: string | null;
      promoCode?: string | null;
      createdAt: string;
    }>;
  };
};

export type CountriesQueryVariables = Exact<{[key: string]: never}>;

export type CountriesQuery = {
  __typename?: 'Query';
  countries: {
    __typename?: 'Countries';
    currentCountryCode?: string | null;
    isSupported: boolean;
    supportedCountries: Array<{
      __typename?: 'Country';
      name: string;
      phoneCode: string;
      code: string;
    }>;
    currentCountry?: {__typename?: 'Country'; name: string; phoneCode: string; code: string} | null;
  };
};

export type AccountActualFeesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type AccountActualFeesQuery = {
  __typename?: 'Query';
  accountActualFees?: {
    __typename?: 'AccountActualFees';
    highRiskFee: number;
    dailyPlatformFee: number;
    dailyExtraSeatsFee: number;
    weeklyCustomDomainFee: number;
    weeklySftpConfigUnitFee: number;
    fraudDetectorTrxFlatFee: number;
    cardPresentTrxFee: number;
    cardPresentTrxFlatFee: number;
    extra?: Array<{
      __typename?: 'AccountExtraFee';
      name: string;
      amount: number;
      type: AccountExtraFeeType;
      region?: AccountExtraFeeRegion | null;
      masterAccountFee?: boolean | null;
      paymentMethods?: Array<PaymentMethods> | null;
    }> | null;
    steps: Array<{
      __typename?: 'AccountSteps';
      from: number;
      trxFee: number;
      trxFlatFee: number;
      bizumTrxFlatFee?: number | null;
      bizumTrxFee?: number | null;
    }>;
  } | null;
};

export type AccountEventsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AccountEventsQuery = {
  __typename?: 'Query';
  accountEvents: {
    __typename?: 'AccountEventsConnection';
    total: number;
    items: Array<{
      __typename?: 'AccountEvent';
      id: string;
      type: string;
      accountId: string;
      livemode?: boolean | null;
      objectId: string;
      objectType: string;
      createdAt?: number | null;
      object: {
        __typename?: 'AccountEventObject';
        id: string;
        refAccountId?: string | null;
        name?: string | null;
        status: AccountStatus;
        note?: string | null;
        userNote?: string | null;
        partner?: Partner | null;
        acquirer?: Acquirer | null;
        adminEmail?: string | null;
        defaultCurrency?: Currencies | null;
        tags?: Array<string> | null;
        defaultTransactionType?: TransactionTypes | null;
        referralCode?: string | null;
        promoCode?: string | null;
        reviewConfirmed?: boolean | null;
        billingPlan?: BillingPlans | null;
        riskScore?: number | null;
        iban?: string | null;
        dynamicBilling?: boolean | null;
        test?: boolean | null;
        customDomain?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
        approvedAt?: string | null;
        rejectedAt?: string | null;
        activatedAt?: string | null;
        approvalRequestedAt?: string | null;
        riskProfile?: RiskProfile | null;
        riskProfileNote?: string | null;
        riskIgnoredKeywords?: Array<string> | null;
        riskUpdatedAt?: string | null;
        suspendedAt?: string | null;
        dataUpdatedAt?: string | null;
        fraudDetectorEnabled?: boolean | null;
        fraudDetectorThreshold?: number | null;
        fraudRulesEnabled?: boolean | null;
        churnReason?: ChurnReason | null;
        churnReasonOption?: string | null;
        churnNote?: string | null;
        statusReason?: StatusReason | null;
        statusNote?: string | null;
        accountExecutive?: string | null;
        tokenizationMethods?: {
          __typename?: 'AccountTokenizationMethods';
          googlePay?: {
            __typename?: 'AccountTokenizationMethodsItem';
            enabled?: boolean | null;
          } | null;
          applePay?: {
            __typename?: 'AccountTokenizationMethodsItem';
            enabled?: boolean | null;
          } | null;
          clickToPay?: {
            __typename?: 'AccountTokenizationMethodsClickToPayItem';
            enabled?: boolean | null;
          } | null;
        } | null;
        notifications?: {
          __typename?: 'AccountNotifications';
          emailCustomerOnRefund?: boolean | null;
          emailCustomerOnSuccess?: boolean | null;
          emailAdminOnSuccess?: boolean | null;
        } | null;
        fees?: {
          __typename?: 'AccountFees';
          highRiskFee?: number | null;
          dailyExtraSeatsFee?: number | null;
          dailyPlatformFee?: number | null;
          weeklyCustomDomainFee?: number | null;
          fraudDetectorTrxFlatFee?: number | null;
          cardPresentTrxFee?: number | null;
          cardPresentTrxFlatFee?: number | null;
          steps?: Array<{
            __typename?: 'AccountSteps';
            trxFee: number;
            bizumTrxFee?: number | null;
            bizumTrxFlatFee?: number | null;
            trxFlatFee: number;
            from: number;
          }> | null;
          extra?: Array<{
            __typename?: 'AccountExtraFee';
            name: string;
            amount: number;
            type: AccountExtraFeeType;
            paymentMethods?: Array<PaymentMethods> | null;
            region?: AccountExtraFeeRegion | null;
          }> | null;
        } | null;
        business?: {
          __typename?: 'BusinessData';
          country?: string | null;
          legalForm?: LegalForm | null;
          legalName?: string | null;
          companyName?: string | null;
          mcc?: string | null;
          documentNumber?: string | null;
          status?: BusinessStatus | null;
          email?: string | null;
          phone?: string | null;
          website?: string | null;
          monthlyVolume?: number | null;
          confirmWebsite?: boolean | null;
          industry?: Industries | null;
          servicesDescription?: string | null;
          confirmServicesDescription?: boolean | null;
          legalAddress?: string | null;
          legalDescription?: string | null;
          creationDate?: string | null;
          lastUpdateDate?: string | null;
          startActivityDate?: string | null;
          capital?: any | null;
          previousNames?: Array<string | null> | null;
          verificationAttempts?: number | null;
          address?: {
            __typename?: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
          registryRecords?: Array<{
            __typename?: 'RegistryRecord';
            name?: string | null;
            url?: string | null;
            province?: string | null;
            date?: string | null;
          }> | null;
          positions?: Array<{
            __typename?: 'BusinessPosition';
            fromDate?: string | null;
            role?: string | null;
            name?: string | null;
          }> | null;
        } | null;
        representatives?: Array<{
          __typename?: 'RepresentativeData';
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phone?: string | null;
          documentNumber?: string | null;
          stocksPercentage?: number | null;
          gender?: Gender | null;
          citizenship?: string | null;
          dateOfBirth?: string | null;
          nationality?: string | null;
          yearOfBirth?: string | null;
          placeOfBirth?: string | null;
          idSession?: string | null;
          interventionType?: Array<InterventionType> | null;
          status?: IdVerificationStatus | null;
          statusCode?: number | null;
          hasNoPublicActivity?: boolean | null;
          address?: {
            __typename?: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
          document?: {
            __typename?: 'IdDocument';
            type?: IdDocumentType | null;
            number?: string | null;
            country?: string | null;
            validFrom?: string | null;
            validUntil?: string | null;
          } | null;
          riskLabels?: Array<{
            __typename?: 'RiskLabel';
            label?: string | null;
            category?: string | null;
          }> | null;
        }> | null;
        payoutTerms?: {
          __typename?: 'AccountPayoutTerms';
          iban?: string | null;
          period?: number | null;
          firstPeriod?: number | null;
          reservePercent?: number | null;
          suspended?: boolean | null;
          releaseReserve?: boolean | null;
        } | null;
        publicBusinessDetails?: {
          __typename?: 'AccountPublicBusinessDetails';
          companyName?: string | null;
          website?: string | null;
          phone?: string | null;
          supportWebsite?: string | null;
          supportPhone?: string | null;
          supportEmail?: string | null;
          address?: {
            __typename?: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
        } | null;
        branding?: {
          __typename?: 'AccountBranding';
          accentColor?: string | null;
          bgColor?: string | null;
          logoUrl?: string | null;
          iconUrl?: string | null;
        } | null;
        contract?: {
          __typename?: 'AccountContract';
          envelopeId?: string | null;
          status: ContractStatus;
          path?: string | null;
          signedDate?: string | null;
        } | null;
        riskLabels?: Array<{
          __typename?: 'RiskLabel';
          label?: string | null;
          category?: string | null;
          riskScore?: number | null;
        }> | null;
        traceDetails?: {
          __typename?: 'TraceDetails';
          ip?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
          userId?: string | null;
          userEmail?: string | null;
          userName?: string | null;
        } | null;
        upsell?: {
          __typename?: 'Upsell';
          executive?: SalesExecutive | null;
          paymentMethods?: Array<PaymentMethods> | null;
          date?: string | null;
          note?: string | null;
        } | null;
      };
    }>;
  };
};

export type SettlementsQueryVariables = Exact<{
  filter?: InputMaybe<SearchableSettlementFilterInput>;
  size?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SettlementsQuery = {
  __typename?: 'Query';
  settlements: {
    __typename?: 'SettlementsConnection';
    total: number;
    items: Array<{
      __typename?: 'Settlement';
      accountId: string;
      acquirer: SettlementAcquirer;
      acquirerFees: number;
      grossVolume: number;
      iban?: string | null;
      id: string;
      payMethod?: SettlementPayMethods | null;
      netVolume: number;
      periodEndAt: number;
      periodStartAt: number;
      releasedAmount?: number | null;
      reservedAmount?: number | null;
      scheduledAt: number;
      status: SettlementStatus;
      legalName?: string | null;
      storeId?: string | null;
      settleGross?: boolean | null;
      currency?: string | null;
    }>;
  };
};

export type AccountInvoicesQueryVariables = Exact<{
  filter?: InputMaybe<SearchableInvoiceFilterInput>;
  size?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AccountInvoicesQuery = {
  __typename?: 'Query';
  accountInvoices: {
    __typename?: 'InvoicesConnection';
    total: number;
    items: Array<{
      __typename?: 'AccountInvoice';
      id?: string | null;
      number?: string | null;
      accountId: string;
      currency: string;
      amount: number;
      tax: number;
      totalAmount: number;
      status?: AccountInvoiceStatus | null;
      paymentMethod?: AccountInvoicePaymentMethod | null;
      period: {__typename?: 'AccountInvoicePeriod'; from?: number | null; to?: number | null};
      lineItems: Array<{
        __typename?: 'AccountInvoiceLineItem';
        name: string;
        quantity: number;
        unitAmount: number;
        unitType: InvoiceLineItemUnitType;
        currency: string;
        amount: number;
      }>;
      business?: {__typename?: 'InvoiceBusinessData'; iban?: string | null} | null;
    }>;
  };
};

export type PreviewPaymentEmailQueryVariables = Exact<{
  paymentId: Scalars['ID']['input'];
  emailType?: InputMaybe<PaymentEmailType>;
  language?: InputMaybe<Scalars['String']['input']>;
  accountId: Scalars['ID']['input'];
}>;

export type PreviewPaymentEmailQuery = {__typename?: 'Query'; previewPaymentEmail?: string | null};

export type AccountStatsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type AccountStatsQuery = {
  __typename?: 'Query';
  accountStats: {
    __typename?: 'AccountStats';
    stats?: {
      __typename?: 'Stats';
      firstTransactionAt?: any | null;
      activeMonths?: number | null;
      avgMonthlyTransactions?: number | null;
      avgMonthlyVolume?: number | null;
      churned?: boolean | null;
      totalSucceededCount?: number | null;
      lastTransactionAt?: any | null;
      totalSucceededAmount?: number | null;
    } | null;
  };
};

export type MasterAccountsQueryVariables = Exact<{
  filter?: InputMaybe<SearchableMasterAccountFilterInput>;
  size?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
}>;

export type MasterAccountsQuery = {
  __typename?: 'Query';
  masterAccounts: {
    __typename?: 'MasterAccountsConnection';
    total: number;
    items: Array<{
      __typename?: 'MasterAccount';
      id: string;
      testAccountId?: string | null;
      prodAccountId?: string | null;
      name?: string | null;
      adminEmail?: string | null;
      iban?: string | null;
      apiKey?: string | null;
      test?: boolean | null;
      status?: AccountStatus | null;
      promoCode?: string | null;
      allowedIPs?: Array<string> | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      webhookEmails?: Array<string> | null;
      churnedEmails?: Array<string> | null;
      allowedDomains?: Array<string> | null;
      accountCallbackUrl?: string | null;
      requireExternalId?: boolean | null;
      contractTemplateId?: string | null;
      autoApprove?: boolean | null;
      blocked?: boolean | null;
      note?: string | null;
      allowCreateApiKey?: boolean | null;
      payoutTerms?: {
        __typename?: 'AccountPayoutTerms';
        iban?: string | null;
        firstPeriod?: number | null;
        period?: number | null;
        reservePercent?: number | null;
        suspended?: boolean | null;
        releaseReserve?: boolean | null;
      } | null;
      accountDefaults?: {
        __typename?: 'AccountDefaults';
        billingPlan?: BillingPlans | null;
        language?: string | null;
        fees?: {
          __typename?: 'AccountFees';
          trxFee?: number | null;
          trxFlatFee?: number | null;
          highRiskFee?: number | null;
          dailyPlatformFee?: number | null;
          dailyExtraSeatsFee?: number | null;
          steps?: Array<{
            __typename?: 'AccountSteps';
            trxFee: number;
            bizumTrxFee?: number | null;
            bizumTrxFlatFee?: number | null;
            trxFlatFee: number;
            from: number;
          }> | null;
          extra?: Array<{
            __typename?: 'AccountExtraFee';
            name: string;
            amount: number;
            type: AccountExtraFeeType;
            region?: AccountExtraFeeRegion | null;
            masterAccountFee?: boolean | null;
            paymentMethods?: Array<PaymentMethods> | null;
          }> | null;
        } | null;
        business?: {
          __typename?: 'BusinessDefault';
          mcc?: string | null;
          website?: string | null;
          servicesDescription?: string | null;
        } | null;
      } | null;
      business?: {
        __typename?: 'BusinessData';
        mcc?: string | null;
        legalName?: string | null;
        website?: string | null;
        documentNumber?: string | null;
        servicesDescription?: string | null;
      } | null;
      contract?: {
        __typename?: 'AccountContract';
        envelopeId?: string | null;
        status: ContractStatus;
        path?: string | null;
        signedDate?: string | null;
      } | null;
      branding?: {
        __typename?: 'AccountBranding';
        accentColor?: string | null;
        bgColor?: string | null;
        logoUrl?: string | null;
        iconUrl?: string | null;
      } | null;
    }>;
  };
};

export type StoresQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
}>;

export type StoresQuery = {
  __typename?: 'Query';
  stores: {
    __typename?: 'StoresConnection';
    nextToken?: string | null;
    items: Array<{
      __typename?: 'Store';
      id: string;
      accountId: string;
      name?: string | null;
      email?: string | null;
      iban?: string | null;
      phone?: string | null;
      website?: string | null;
      documentNumber?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    }>;
  };
};

export type StoreQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  accountId: Scalars['ID']['input'];
}>;

export type StoreQuery = {
  __typename?: 'Query';
  store?: {
    __typename?: 'Store';
    blocked?: boolean | null;
    id: string;
    accountId: string;
    name?: string | null;
    email?: string | null;
    iban?: string | null;
    phone?: string | null;
    website?: string | null;
    documentNumber?: string | null;
    metadata?: Array<{__typename?: 'MetadataItem'; key: string; value?: string | null}> | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      country?: string | null;
      line1?: string | null;
      line2?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  } | null;
};

export type StoreEventsQueryVariables = Exact<{
  storeId: Scalars['ID']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
}>;

export type StoreEventsQuery = {
  __typename?: 'Query';
  storeEvents: {
    __typename?: 'StoreEventsConnection';
    total: number;
    items: Array<{
      __typename?: 'StoreEvent';
      id: string;
      type: string;
      accountId: string;
      objectId: string;
      objectType: string;
      createdAt: number;
      object: {
        __typename?: 'StoreEventObject';
        id: string;
        accountId: string;
        name?: string | null;
        email?: string | null;
        phone?: string | null;
        website?: string | null;
        iban?: string | null;
        documentNumber?: string | null;
        blocked?: boolean | null;
        address?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        traceDetails?: {
          __typename?: 'TraceDetails';
          ip?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
          userId?: string | null;
          userEmail?: string | null;
          userName?: string | null;
        } | null;
      };
    }>;
  };
};

export type DocumentsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type DocumentsQuery = {
  __typename?: 'Query';
  documents: {
    __typename?: 'DocumentsConnection';
    items: Array<{
      __typename?: 'Document';
      id: string;
      accountId: string;
      type: DocumentType;
      status: DocumentStatus;
      statusMessage?: string | null;
      statusCode?: string | null;
      contentType?: string | null;
      createdAt: string;
      updatedAt?: string | null;
      name?: string | null;
      note?: string | null;
      internal?: boolean | null;
      metadata?: Array<{
        __typename?: 'DocumentMetadataItem';
        key: string;
        value?: Array<string> | null;
      }> | null;
      traceDetails?: {
        __typename?: 'TraceDetails';
        ip?: string | null;
        userAgent?: string | null;
        countryCode?: string | null;
        lang?: string | null;
        deviceType?: DeviceType | null;
        deviceModel?: string | null;
        browser?: string | null;
        browserVersion?: string | null;
        browserAccept?: string | null;
        os?: string | null;
        osVersion?: string | null;
        source?: string | null;
        sourceVersion?: string | null;
        userId?: string | null;
        userEmail?: string | null;
        userName?: string | null;
      } | null;
    }>;
  };
};

export type DocumentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  accountId: Scalars['ID']['input'];
}>;

export type DocumentQuery = {
  __typename?: 'Query';
  document?: {
    __typename?: 'Document';
    id: string;
    accountId: string;
    type: DocumentType;
    status: DocumentStatus;
    statusMessage?: string | null;
    statusCode?: string | null;
    contentType?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    name?: string | null;
    note?: string | null;
    internal?: boolean | null;
    metadata?: Array<{
      __typename?: 'DocumentMetadataItem';
      key: string;
      value?: Array<string> | null;
    }> | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
  } | null;
};

export type DocumentEventsQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;

export type DocumentEventsQuery = {
  __typename?: 'Query';
  documentEvents: {
    __typename?: 'DocumentEventsConnection';
    total: number;
    items: Array<{
      __typename?: 'DocumentEvent';
      id: string;
      type: string;
      accountId: string;
      objectId: string;
      objectType: string;
      createdAt: number;
      object: {
        __typename?: 'DocumentEventObject';
        id: string;
        accountId: string;
        type: DocumentType;
        status: DocumentStatus;
        statusCode?: string | null;
        statusMessage?: string | null;
        contentType?: string | null;
        createdAt: number;
        updatedAt?: number | null;
        note?: string | null;
        name?: string | null;
        internal?: boolean | null;
        metadata?: Array<{
          __typename?: 'DocumentMetadataItem';
          key: string;
          value?: Array<string> | null;
        }> | null;
        traceDetails?: {
          __typename?: 'TraceDetails';
          ip?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
          userId?: string | null;
          userEmail?: string | null;
          userName?: string | null;
        } | null;
      };
    }>;
  };
};

export type SubscriptionsQueryVariables = Exact<{
  filter?: InputMaybe<SearchableSubscriptionFilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SubscriptionsQuery = {
  __typename?: 'Query';
  subscriptions: {
    __typename?: 'SubscriptionsConnection';
    total: number;
    items: Array<{
      __typename?: 'Subscription';
      id: string;
      accountId: string;
      livemode: boolean;
      amount: number;
      currency?: Currencies | null;
      description?: string | null;
      planVariantId?: string | null;
      productId?: string | null;
      cancelAtPeriodEnd?: boolean | null;
      pauseIntervalCount?: number | null;
      pauseAtPeriodEnd?: boolean | null;
      skipIntervalCount?: number | null;
      currentPeriodStart?: number | null;
      currentPeriodEnd?: number | null;
      trialPeriodDays?: number | null;
      trialPeriodEnd?: number | null;
      customerId?: string | null;
      defaultTokenId?: string | null;
      sequenceId?: string | null;
      lastInvoiceId?: string | null;
      lastOrderId?: string | null;
      nextPaymentAt?: number | null;
      createdAt?: number | null;
      updatedAt?: number | null;
      interval: Interval;
      intervalCount: number;
      retryCount?: number | null;
      status: SubscriptionStatus;
      callbackUrl?: string | null;
      paymentCallbackUrl?: string | null;
      storeId?: string | null;
      masterAccountId?: string | null;
      allowedPaymentMethods?: Array<SubscriptionPaymentMethods | null> | null;
      customer?: {
        __typename?: 'Customer';
        email?: string | null;
        name?: string | null;
        phone?: string | null;
      } | null;
      billingDetails?: {
        __typename?: 'ContactDetails';
        email?: string | null;
        name?: string | null;
        company?: string | null;
        phone?: string | null;
        address?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      shippingDetails?: {
        __typename?: 'ContactDetails';
        email?: string | null;
        name?: string | null;
        company?: string | null;
        phone?: string | null;
        address?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      lastPayment?: {
        __typename?: 'LastPayment';
        id: string;
        status: PaymentStatus;
        statusMessage?: string | null;
        statusCode?: string | null;
      } | null;
      paymentMethod?: {
        __typename?: 'PaymentMethod';
        method?: PaymentMethods | null;
        bizum?: {
          __typename?: 'PaymentMethodBizum';
          phoneNumber?: string | null;
          integrationType?: string | null;
          ibanLast4?: string | null;
          idBizum?: string | null;
        } | null;
        card?: {
          __typename?: 'PaymentMethodCard';
          brand?: CardBrand | null;
          country?: string | null;
          type?: CardType | null;
          threeDSecure?: boolean | null;
          threeDSecureVersion?: string | null;
          threeDSecureFlow?: ThreeDSecureFlow | null;
          threeDSecureStatus?: ThreeDsStatus | null;
          last4?: string | null;
          fingerprint?: string | null;
          cardholderName?: string | null;
          cardholderEmail?: string | null;
          expiration?: any | null;
          bank?: string | null;
          tokenizationMethod?: TokenizationMethods | null;
          srcCorrelationId?: string | null;
          srciTransactionId?: string | null;
          srcDpaId?: string | null;
        } | null;
        cardPresent?: {
          __typename?: 'PaymentMethodCardPresent';
          bin?: string | null;
          brand?: CardBrand | null;
          cardholderEmail?: string | null;
          cardholderName?: string | null;
          country?: string | null;
          expiration?: any | null;
          last4?: string | null;
          fingerprint?: string | null;
          type?: CardType | null;
          verificationMethod?: VerificationMethod | null;
        } | null;
        mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
        paypal?: {
          __typename?: 'PaymentMethodPaypal';
          orderId?: string | null;
          payerId?: string | null;
          email?: string | null;
          name?: string | null;
        } | null;
        sepa?: {
          __typename?: 'PaymentMethodSepa';
          accountholderEmail?: string | null;
          accountholderName?: string | null;
          countryCode?: string | null;
          bankAddress?: string | null;
          bankCode?: string | null;
          bankName?: string | null;
          bic?: string | null;
          last4?: string | null;
          fingerprint?: string | null;
          accountholderAddress?: {
            __typename?: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
        } | null;
        trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
        klarna?: {
          __typename?: 'PaymentMethodKlarna';
          billingCategory?: BillingCategoryKlarna | null;
          authPaymentMethod?: AuthPaymentMethodKlarna | null;
        } | null;
      } | null;
      metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
      sessionDetails?: {
        __typename?: 'SessionDetails';
        ip?: string | null;
        fingerprint?: string | null;
        userAgent?: string | null;
        countryCode?: string | null;
        lang?: string | null;
        deviceType?: DeviceType | null;
        deviceModel?: string | null;
        browser?: string | null;
        browserVersion?: string | null;
        browserAccept?: string | null;
        browserColorDepth?: string | null;
        browserScreenHeight?: string | null;
        browserScreenWidth?: string | null;
        browserTimezoneOffset?: string | null;
        os?: string | null;
        osVersion?: string | null;
        source?: string | null;
        sourceVersion?: string | null;
      } | null;
      traceDetails?: {
        __typename?: 'TraceDetails';
        ip?: string | null;
        userAgent?: string | null;
        countryCode?: string | null;
        lang?: string | null;
        deviceType?: DeviceType | null;
        deviceModel?: string | null;
        browser?: string | null;
        browserVersion?: string | null;
        browserAccept?: string | null;
        os?: string | null;
        osVersion?: string | null;
        source?: string | null;
        sourceVersion?: string | null;
        userId?: string | null;
        userEmail?: string | null;
        userName?: string | null;
      } | null;
    }>;
  };
};

export type SubscriptionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type SubscriptionQuery = {
  __typename?: 'Query';
  subscription?: {
    __typename?: 'Subscription';
    id: string;
    accountId: string;
    livemode: boolean;
    amount: number;
    currency?: Currencies | null;
    description?: string | null;
    planVariantId?: string | null;
    productId?: string | null;
    cancelAtPeriodEnd?: boolean | null;
    pauseIntervalCount?: number | null;
    pauseAtPeriodEnd?: boolean | null;
    skipIntervalCount?: number | null;
    currentPeriodStart?: number | null;
    currentPeriodEnd?: number | null;
    trialPeriodDays?: number | null;
    trialPeriodEnd?: number | null;
    customerId?: string | null;
    defaultTokenId?: string | null;
    sequenceId?: string | null;
    lastInvoiceId?: string | null;
    lastOrderId?: string | null;
    nextPaymentAt?: number | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    interval: Interval;
    intervalCount: number;
    retryCount?: number | null;
    status: SubscriptionStatus;
    callbackUrl?: string | null;
    paymentCallbackUrl?: string | null;
    storeId?: string | null;
    masterAccountId?: string | null;
    allowedPaymentMethods?: Array<SubscriptionPaymentMethods | null> | null;
    customer?: {
      __typename?: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    billingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename?: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    lastPayment?: {
      __typename?: 'LastPayment';
      id: string;
      status: PaymentStatus;
      statusMessage?: string | null;
      statusCode?: string | null;
    } | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename?: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
        ibanLast4?: string | null;
        idBizum?: string | null;
      } | null;
      card?: {
        __typename?: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        threeDSecureStatus?: ThreeDsStatus | null;
        last4?: string | null;
        fingerprint?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: any | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cardPresent?: {
        __typename?: 'PaymentMethodCardPresent';
        bin?: string | null;
        brand?: CardBrand | null;
        cardholderEmail?: string | null;
        cardholderName?: string | null;
        country?: string | null;
        expiration?: any | null;
        last4?: string | null;
        fingerprint?: string | null;
        type?: CardType | null;
        verificationMethod?: VerificationMethod | null;
      } | null;
      mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
      paypal?: {
        __typename?: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename?: 'PaymentMethodSepa';
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
        fingerprint?: string | null;
        accountholderAddress?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
      klarna?: {
        __typename?: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
    sessionDetails?: {
      __typename?: 'SessionDetails';
      ip?: string | null;
      fingerprint?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename?: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
  } | null;
};

export type SubscriptionEventsQueryVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
}>;

export type SubscriptionEventsQuery = {
  __typename?: 'Query';
  subscriptionEvents: {
    __typename?: 'SubscriptionEventsConnection';
    total: number;
    items: Array<{
      __typename?: 'SubscriptionEvent';
      id: string;
      type: string;
      accountId: string;
      objectId: string;
      objectType: string;
      createdAt: number;
      object: {
        __typename?: 'SubscriptionEventObject';
        id: string;
        accountId: string;
        amount?: number | null;
        cancelAtPeriodEnd?: boolean | null;
        createdAt?: number | null;
        currency: string;
        currentPeriodEnd?: number | null;
        currentPeriodStart?: number | null;
        description?: string | null;
        interval: Interval;
        intervalCount: number;
        lastOrderId?: string | null;
        livemode?: boolean | null;
        pauseAtPeriodEnd?: boolean | null;
        pauseIntervalCount?: number | null;
        pointOfSaleId?: string | null;
        retryCount?: number | null;
        sequenceId?: string | null;
        status: SubscriptionStatus;
        storeId?: string | null;
        trialPeriodDays?: number | null;
        trialPeriodEnd?: number | null;
        updatedAt?: number | null;
        billingDetails?: {
          __typename?: 'ContactDetails';
          email?: string | null;
          name?: string | null;
          company?: string | null;
          phone?: string | null;
          address?: {
            __typename?: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
        } | null;
        customer?: {
          __typename?: 'Customer';
          email?: string | null;
          name?: string | null;
          phone?: string | null;
        } | null;
        lastPayment?: {
          __typename?: 'LastPayment';
          id: string;
          status: PaymentStatus;
          statusMessage?: string | null;
          statusCode?: string | null;
        } | null;
        paymentMethod?: {
          __typename?: 'PaymentMethod';
          method?: PaymentMethods | null;
          bizum?: {
            __typename?: 'PaymentMethodBizum';
            phoneNumber?: string | null;
            integrationType?: string | null;
            ibanLast4?: string | null;
            idBizum?: string | null;
          } | null;
          card?: {
            __typename?: 'PaymentMethodCard';
            brand?: CardBrand | null;
            country?: string | null;
            type?: CardType | null;
            threeDSecure?: boolean | null;
            threeDSecureVersion?: string | null;
            threeDSecureFlow?: ThreeDSecureFlow | null;
            threeDSecureStatus?: ThreeDsStatus | null;
            last4?: string | null;
            fingerprint?: string | null;
            cardholderName?: string | null;
            cardholderEmail?: string | null;
            expiration?: any | null;
            bank?: string | null;
            tokenizationMethod?: TokenizationMethods | null;
            srcCorrelationId?: string | null;
            srciTransactionId?: string | null;
            srcDpaId?: string | null;
          } | null;
          cardPresent?: {
            __typename?: 'PaymentMethodCardPresent';
            bin?: string | null;
            brand?: CardBrand | null;
            cardholderEmail?: string | null;
            cardholderName?: string | null;
            country?: string | null;
            expiration?: any | null;
            last4?: string | null;
            fingerprint?: string | null;
            type?: CardType | null;
            verificationMethod?: VerificationMethod | null;
          } | null;
          mbway?: {__typename?: 'PaymentMethodMBWay'; phoneNumber?: string | null} | null;
          paypal?: {
            __typename?: 'PaymentMethodPaypal';
            orderId?: string | null;
            payerId?: string | null;
            email?: string | null;
            name?: string | null;
          } | null;
          sepa?: {
            __typename?: 'PaymentMethodSepa';
            accountholderEmail?: string | null;
            accountholderName?: string | null;
            countryCode?: string | null;
            bankAddress?: string | null;
            bankCode?: string | null;
            bankName?: string | null;
            bic?: string | null;
            last4?: string | null;
            fingerprint?: string | null;
            accountholderAddress?: {
              __typename?: 'Address';
              city?: string | null;
              country?: string | null;
              line1?: string | null;
              line2?: string | null;
              zip?: string | null;
              state?: string | null;
            } | null;
          } | null;
          trustly?: {__typename?: 'PaymentMethodTrustly'; customerId?: string | null} | null;
          klarna?: {
            __typename?: 'PaymentMethodKlarna';
            billingCategory?: BillingCategoryKlarna | null;
            authPaymentMethod?: AuthPaymentMethodKlarna | null;
          } | null;
        } | null;
        shippingDetails?: {
          __typename?: 'ContactDetails';
          email?: string | null;
          name?: string | null;
          company?: string | null;
          phone?: string | null;
          address?: {
            __typename?: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
        } | null;
        traceDetails?: {
          __typename?: 'TraceDetails';
          ip?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
          userId?: string | null;
          userEmail?: string | null;
          userName?: string | null;
        } | null;
      };
    }>;
  };
};

export type PreviewSubscriptionEmailQueryVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
  emailType?: InputMaybe<SubscriptionEmailType>;
  language?: InputMaybe<Scalars['String']['input']>;
  accountId: Scalars['ID']['input'];
}>;

export type PreviewSubscriptionEmailQuery = {
  __typename?: 'Query';
  previewSubscriptionEmail?: string | null;
};

export type ProviderEventsQueryVariables = Exact<{
  providerId?: InputMaybe<Scalars['ID']['input']>;
  accountId: Scalars['ID']['input'];
}>;

export type ProviderEventsQuery = {
  __typename?: 'Query';
  providerEvents: {
    __typename?: 'ProviderEventsConnection';
    total: number;
    items: Array<{
      __typename?: 'ProviderEvent';
      id: string;
      type: string;
      accountId: string;
      objectId: string;
      objectType: string;
      createdAt: number;
      object: {
        __typename?: 'ProviderEventObject';
        id: string;
        internalId?: string | null;
        processor?: Processor | null;
        enabled?: boolean | null;
        test?: boolean | null;
        paymentMethod?: PaymentMethods | null;
        acquirer?: Acquirer | null;
        configurable?: boolean | null;
        nativeHostedPayment?: boolean | null;
        metadata?: Array<{
          __typename?: 'ProviderMetadataItem';
          key: string;
          value?: Array<string> | null;
        }> | null;
        rules?: {
          __typename?: 'ProviderRules';
          minAmount?: number | null;
          maxAmount?: number | null;
          shopNameLike?: string | null;
          descriptionLike?: string | null;
        } | null;
        traceDetails?: {
          __typename?: 'TraceDetails';
          ip?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
          userId?: string | null;
          userEmail?: string | null;
          userName?: string | null;
        } | null;
      };
    }>;
  };
};

export type AccountTagsQueryVariables = Exact<{[key: string]: never}>;

export type AccountTagsQuery = {__typename?: 'Query'; accountTags: Array<string>};

export type ChargeSourcesQueryVariables = Exact<{[key: string]: never}>;

export type ChargeSourcesQuery = {__typename?: 'Query'; chargeSources: Array<string>};

export type MasterAccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type MasterAccountQuery = {
  __typename?: 'Query';
  masterAccount?: {
    __typename?: 'MasterAccount';
    id: string;
    testAccountId?: string | null;
    prodAccountId?: string | null;
    name?: string | null;
    adminEmail?: string | null;
    iban?: string | null;
    apiKey?: string | null;
    test?: boolean | null;
    status?: AccountStatus | null;
    promoCode?: string | null;
    allowedIPs?: Array<string> | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    webhookEmails?: Array<string> | null;
    churnedEmails?: Array<string> | null;
    allowedDomains?: Array<string> | null;
    accountCallbackUrl?: string | null;
    requireExternalId?: boolean | null;
    contractTemplateId?: string | null;
    autoApprove?: boolean | null;
    blocked?: boolean | null;
    note?: string | null;
    allowCreateApiKey?: boolean | null;
    payoutTerms?: {
      __typename?: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    accountDefaults?: {
      __typename?: 'AccountDefaults';
      billingPlan?: BillingPlans | null;
      language?: string | null;
      fees?: {
        __typename?: 'AccountFees';
        trxFee?: number | null;
        trxFlatFee?: number | null;
        highRiskFee?: number | null;
        dailyPlatformFee?: number | null;
        dailyExtraSeatsFee?: number | null;
        steps?: Array<{
          __typename?: 'AccountSteps';
          trxFee: number;
          bizumTrxFee?: number | null;
          bizumTrxFlatFee?: number | null;
          trxFlatFee: number;
          from: number;
        }> | null;
        extra?: Array<{
          __typename?: 'AccountExtraFee';
          name: string;
          amount: number;
          type: AccountExtraFeeType;
          region?: AccountExtraFeeRegion | null;
          masterAccountFee?: boolean | null;
          paymentMethods?: Array<PaymentMethods> | null;
        }> | null;
      } | null;
      business?: {
        __typename?: 'BusinessDefault';
        mcc?: string | null;
        website?: string | null;
        servicesDescription?: string | null;
      } | null;
    } | null;
    business?: {
      __typename?: 'BusinessData';
      mcc?: string | null;
      legalName?: string | null;
      website?: string | null;
      documentNumber?: string | null;
      servicesDescription?: string | null;
    } | null;
    contract?: {
      __typename?: 'AccountContract';
      envelopeId?: string | null;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
  } | null;
};

export type UserMasterAccountQueryVariables = Exact<{[key: string]: never}>;

export type UserMasterAccountQuery = {
  __typename?: 'Query';
  userMasterAccount?: {
    __typename?: 'MasterAccount';
    id: string;
    name?: string | null;
    status?: AccountStatus | null;
    promoCode?: string | null;
    allowedIPs?: Array<string> | null;
    webhookEmails?: Array<string> | null;
    churnedEmails?: Array<string> | null;
    allowedDomains?: Array<string> | null;
    accountCallbackUrl?: string | null;
    requireExternalId?: boolean | null;
    apiKey?: string | null;
    test?: boolean | null;
    publicBusinessDetails?: {
      __typename?: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      supportWebsite?: string | null;
      supportPhone?: string | null;
      supportEmail?: string | null;
      address?: {
        __typename?: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    branding?: {
      __typename?: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
  } | null;
};

export type NotificationsPortalUrlQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type NotificationsPortalUrlQuery = {
  __typename?: 'Query';
  notificationsPortalUrl?: {__typename?: 'Redirect'; redirectUrl: string} | null;
};

export type WebhooksQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  accountId: Scalars['ID']['input'];
}>;

export type WebhooksQuery = {
  __typename?: 'Query';
  webhooks: {
    __typename?: 'WebhooksConnection';
    nextToken?: string | null;
    items: Array<{
      __typename?: 'Webhook';
      id: string;
      accountId: string;
      createdAt: string;
      url: string;
      eventTypes: Array<WebhookEventType>;
      enabled: boolean;
      updatedAt?: string | null;
    } | null>;
  };
};

export type RestrictedKeywordsQueryVariables = Exact<{[key: string]: never}>;

export type RestrictedKeywordsQuery = {
  __typename?: 'Query';
  restrictedKeywords?: Array<string> | null;
};

export type WebReportQueryVariables = Exact<{
  baseUrl: Scalars['String']['input'];
}>;

export type WebReportQuery = {
  __typename?: 'Query';
  webReport?: {
    __typename?: 'WebReport';
    title?: string | null;
    description?: string | null;
    summary?: string | null;
    pageCount?: number | null;
    failedPageCount?: number | null;
    uncheckedPageCount?: number | null;
    legalDetailsUrl?: string | null;
    status?: WebReportStatus | null;
    statusCode?: string | null;
    statusMessage?: string | null;
    riskCategory?: string | null;
    platform?: WebReportPlatform | null;
  } | null;
};

export type WebKeywordsQueryVariables = Exact<{
  baseUrl: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
}>;

export type WebKeywordsQuery = {
  __typename?: 'Query';
  webKeywords: {
    __typename?: 'WebKeywordsConnection';
    nextToken?: string | null;
    items: Array<{
      __typename?: 'WebKeyword';
      accountId: string;
      url: string;
      createdAt?: number | null;
      expiresAt: number;
      urlKeyword: string;
      baseUrl: string;
      keyword: string;
      description?: string | null;
      updatedAt?: number | null;
      title?: string | null;
      context?: string | null;
      confirmed?: boolean | null;
      explanation?: string | null;
      incorrect?: boolean | null;
    }>;
  };
};

export type AccountBalancesQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type AccountBalancesQuery = {
  __typename?: 'Query';
  accountBalances: {
    __typename?: 'AccountBalancesConnection';
    items: Array<{
      __typename?: 'AccountBalances';
      accountId?: string | null;
      currency: string;
      clearedAmount: number;
      createdAt: string;
      outstandingAmount: number;
      totalAmount: number;
      updatedAt?: string | null;
    }>;
  };
};

export type AffiliatesQueryVariables = Exact<{
  input?: InputMaybe<AffiliateInput>;
}>;

export type AffiliatesQuery = {
  __typename?: 'Query';
  affiliates: {
    __typename?: 'AffiliateConnection';
    links?: string | null;
    items: Array<{
      __typename?: 'Affiliate';
      id: string;
      firstname?: string | null;
      lastname?: string | null;
      email?: string | null;
      affiliate_group_id?: string | null;
      created_at?: string | null;
      company?: {
        __typename?: 'AffiliateCompany';
        name?: string | null;
        description?: string | null;
      } | null;
      address?: {
        __typename?: 'AffiliateAddress';
        address?: string | null;
        postal_code?: string | null;
        city?: string | null;
        state?: string | null;
        country?: {
          __typename?: 'AffiliateCountry';
          name?: string | null;
          code?: string | null;
        } | null;
      } | null;
      meta_data?: {__typename?: 'AffiliateMetaData'; tier?: string | null} | null;
      referral_link?: {__typename?: 'AffiliateReferralLink'; link?: string | null} | null;
      payout_methods?: Array<{
        __typename?: 'AffiliatePayoutMethod';
        id?: string | null;
        title?: string | null;
        details?: {
          __typename?: 'AffiliatePayoutMethodDetails';
          iban?: string | null;
          nif?: string | null;
        } | null;
      }> | null;
    }>;
  };
};

export type AffiliateQueryVariables = Exact<{
  affiliateId: Scalars['ID']['input'];
}>;

export type AffiliateQuery = {
  __typename?: 'Query';
  affiliate: {
    __typename?: 'Affiliate';
    id: string;
    firstname?: string | null;
    lastname?: string | null;
    email?: string | null;
    affiliate_group_id?: string | null;
    created_at?: string | null;
    company?: {
      __typename?: 'AffiliateCompany';
      name?: string | null;
      description?: string | null;
    } | null;
    address?: {
      __typename?: 'AffiliateAddress';
      address?: string | null;
      postal_code?: string | null;
      city?: string | null;
      state?: string | null;
      country?: {
        __typename?: 'AffiliateCountry';
        name?: string | null;
        code?: string | null;
      } | null;
    } | null;
    meta_data?: {__typename?: 'AffiliateMetaData'; tier?: string | null} | null;
    referral_link?: {__typename?: 'AffiliateReferralLink'; link?: string | null} | null;
    payout_methods?: Array<{
      __typename?: 'AffiliatePayoutMethod';
      id?: string | null;
      title?: string | null;
      details?: {
        __typename?: 'AffiliatePayoutMethodDetails';
        iban?: string | null;
        nif?: string | null;
      } | null;
    }> | null;
  };
};

export type AffiliatePayoutMethodsQueryVariables = Exact<{
  affiliateId: Scalars['ID']['input'];
}>;

export type AffiliatePayoutMethodsQuery = {
  __typename?: 'Query';
  affiliatePayoutMethods: Array<{
    __typename?: 'AffiliatePayoutMethod';
    id?: string | null;
    title?: string | null;
    details?: {
      __typename?: 'AffiliatePayoutMethodDetails';
      iban?: string | null;
      nif?: string | null;
    } | null;
  }>;
};

export type AffiliateMerchantsQueryVariables = Exact<{
  input?: InputMaybe<AffiliateMerchantInput>;
}>;

export type AffiliateMerchantsQuery = {
  __typename?: 'Query';
  affiliateMerchants: {
    __typename?: 'AffiliateMerchantConnection';
    links?: string | null;
    items: Array<{
      __typename?: 'AffiliateMerchant';
      id: string;
      status?: string | null;
      created_at?: string | null;
      meta_data?: {
        __typename?: 'AffiliateMerchantMetaData';
        account_id?: string | null;
        account_status?: string | null;
        company_name?: string | null;
        website?: string | null;
        first_conversion_date?: string | null;
      } | null;
    }>;
  };
};

export type AffiliateInvoicesQueryVariables = Exact<{
  taxId: Scalars['String']['input'];
}>;

export type AffiliateInvoicesQuery = {
  __typename?: 'Query';
  affiliateInvoices: {
    __typename?: 'AffiliateInvoiceConnection';
    total?: number | null;
    items: Array<{
      __typename?: 'AffiliateInvoice';
      id: string;
      number?: string | null;
      amount?: number | null;
      issuedAt?: string | null;
      status?: string | null;
      dueAt?: string | null;
    }>;
  };
};

export type MasterAccountEventsQueryVariables = Exact<{
  masterAccountId: Scalars['ID']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
}>;

export type MasterAccountEventsQuery = {
  __typename?: 'Query';
  masterAccountEvents: {
    __typename?: 'MasterAccountEventsConnection';
    total: number;
    items: Array<{
      __typename?: 'MasterAccountEvent';
      id: string;
      type: string;
      accountId: string;
      livemode?: boolean | null;
      objectId: string;
      objectType: string;
      createdAt?: number | null;
      object: {
        __typename?: 'MasterAccountEventObject';
        id: string;
        accountCallbackUrl?: string | null;
        apiKey?: string | null;
        adminEmail?: string | null;
        test: boolean;
        testAccountId?: string | null;
        prodAccountId?: string | null;
        contractTemplateId?: string | null;
        churnedEmails?: Array<string> | null;
        allowedDomains?: Array<string> | null;
        allowedIPs?: Array<string> | null;
        blocked?: boolean | null;
        iban?: string | null;
        note?: string | null;
        name?: string | null;
        promoCode?: string | null;
        status?: AccountStatus | null;
        updatedAt?: string | null;
        webhookEmails?: Array<string> | null;
        business?: {
          __typename?: 'BusinessData';
          mcc?: string | null;
          legalName?: string | null;
          website?: string | null;
          documentNumber?: string | null;
          servicesDescription?: string | null;
        } | null;
        contract?: {
          __typename?: 'AccountContract';
          envelopeId?: string | null;
          status: ContractStatus;
          path?: string | null;
          signedDate?: string | null;
        } | null;
        payoutTerms?: {
          __typename?: 'AccountPayoutTerms';
          iban?: string | null;
          period?: number | null;
          firstPeriod?: number | null;
          reservePercent?: number | null;
          suspended?: boolean | null;
          releaseReserve?: boolean | null;
        } | null;
        traceDetails?: {
          __typename?: 'TraceDetails';
          ip?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
          userId?: string | null;
          userEmail?: string | null;
          userName?: string | null;
        } | null;
      };
    }>;
  };
};

export type PointsOfSaleQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  storeId?: InputMaybe<Scalars['ID']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
}>;

export type PointsOfSaleQuery = {
  __typename?: 'Query';
  pointsOfSale: {
    __typename?: 'PointsOfSaleConnection';
    nextToken?: string | null;
    items: Array<{
      __typename?: 'PointOfSale';
      id: string;
      accountId: string;
      storeId?: string | null;
      number: number;
      name?: string | null;
      currentPaymentId?: string | null;
      manualAmount?: boolean | null;
      type?: PointOfSaleType | null;
      deviceId?: string | null;
      terminalId?: string | null;
      description?: string | null;
      requireEmail?: boolean | null;
      requireTaxId?: boolean | null;
      includeQRCode?: boolean | null;
      qrCodeText?: string | null;
      fixedAmount?: number | null;
      fixedCurrency?: Currencies | null;
      transactionType?: TransactionTypes | null;
      paymentMethods?: Array<PaymentMethods> | null;
      enabled?: boolean | null;
      pendingSetup?: boolean | null;
      paymentCallbackUrl?: string | null;
    }>;
  };
};

export type PointOfSaleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  accountId: Scalars['ID']['input'];
}>;

export type PointOfSaleQuery = {
  __typename?: 'Query';
  pointOfSale?: {
    __typename?: 'PointOfSale';
    id: string;
    accountId: string;
    storeId?: string | null;
    number: number;
    name?: string | null;
    currentPaymentId?: string | null;
    manualAmount?: boolean | null;
    type?: PointOfSaleType | null;
    deviceId?: string | null;
    terminalId?: string | null;
    description?: string | null;
    requireEmail?: boolean | null;
    requireTaxId?: boolean | null;
    includeQRCode?: boolean | null;
    qrCodeText?: string | null;
    fixedAmount?: number | null;
    fixedCurrency?: Currencies | null;
    transactionType?: TransactionTypes | null;
    paymentMethods?: Array<PaymentMethods> | null;
    enabled?: boolean | null;
    pendingSetup?: boolean | null;
    paymentCallbackUrl?: string | null;
  } | null;
};

export type BlacklistItemsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BlacklistItemType>;
}>;

export type BlacklistItemsQuery = {
  __typename?: 'Query';
  blacklistItems: {
    __typename?: 'BlacklistItemsConnection';
    nextToken?: string | null;
    items: Array<{
      __typename?: 'BlacklistItem';
      value: string;
      type: BlacklistItemType;
      note?: string | null;
      accountId?: string | null;
      createdAt: string;
      updatedAt?: string | null;
      validUntil?: number | null;
    }>;
  };
};

export type BlacklistItemQueryVariables = Exact<{
  value: Scalars['String']['input'];
  accountId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type BlacklistItemQuery = {
  __typename?: 'Query';
  blacklistItem?: {
    __typename?: 'BlacklistItem';
    value: string;
    type: BlacklistItemType;
    note?: string | null;
    accountId?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    validUntil?: number | null;
  } | null;
};

export type AdminUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type AdminUserQuery = {
  __typename?: 'Query';
  adminUser: {
    __typename?: 'AdminUser';
    id: string;
    email: string;
    name?: string | null;
    phoneNumber?: string | null;
  };
};

export type AdminUsersQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AdminUsersQuery = {
  __typename?: 'Query';
  adminUsers: {
    __typename?: 'AdminUsersConnection';
    nextToken?: string | null;
    items: Array<{
      __typename?: 'AdminUser';
      id: string;
      email: string;
      name?: string | null;
      phoneNumber?: string | null;
    }>;
  };
};

export type AdminUserEventsQueryVariables = Exact<{
  input: AdminUserEventsInput;
}>;

export type AdminUserEventsQuery = {
  __typename?: 'Query';
  adminUserEvents: {
    __typename?: 'AdminUserEventsConnection';
    nextToken?: string | null;
    items: Array<{
      __typename?: 'AdminUserEvent';
      id: string;
      type: string;
      objectType: string;
      accountId?: string | null;
      objectId?: string | null;
      createdAt: number;
      metadata?: Array<{__typename?: 'KeyValueItem'; key: string; value?: string | null}> | null;
      sessionDetails?: {
        __typename?: 'SessionDetails';
        ip?: string | null;
        fingerprint?: string | null;
        userAgent?: string | null;
        countryCode?: string | null;
        lang?: string | null;
        deviceType?: DeviceType | null;
        deviceModel?: string | null;
        browser?: string | null;
        browserVersion?: string | null;
        browserAccept?: string | null;
        browserColorDepth?: string | null;
        browserScreenHeight?: string | null;
        browserScreenWidth?: string | null;
        browserTimezoneOffset?: string | null;
        os?: string | null;
        osVersion?: string | null;
        source?: string | null;
        sourceVersion?: string | null;
      } | null;
    }>;
  };
};

export type ChargesExportsQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ChargesExportsQuery = {
  __typename?: 'Query';
  chargesExports: {
    __typename?: 'ChargesExportsConnection';
    nextToken?: string | null;
    items: Array<{
      __typename?: 'ChargesExport';
      id: string;
      accountId: string;
      status: ExportStatus;
      expireAt?: string | null;
      statusCode?: string | null;
      statusMessage?: string | null;
    }>;
  };
};

export type ExportSftpConfigQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  accountId: Scalars['ID']['input'];
}>;

export type ExportSftpConfigQuery = {
  __typename?: 'Query';
  exportSftpConfig: {
    __typename?: 'SftpConfigExport';
    id: string;
    accountId: string;
    host: string;
    port: number;
    username: string;
    path: string;
    columns?: Array<string> | null;
    timezone?: string | null;
    enabled?: boolean | null;
  };
};

export type ExportSftpConfigsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type ExportSftpConfigsQuery = {
  __typename?: 'Query';
  exportSftpConfigs: {
    __typename?: 'SftpConfigExportsConnection';
    items: Array<{
      __typename?: 'SftpConfigExport';
      id: string;
      accountId: string;
      host: string;
      port: number;
      username: string;
      path: string;
      columns?: Array<string> | null;
      timezone?: string | null;
      enabled?: boolean | null;
    }>;
  };
};

export type CodesQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  pointOfSaleId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CodesQuery = {
  __typename?: 'Query';
  codes: Array<{
    __typename?: 'Code';
    id: string;
    type: CodeTypes;
    enabled?: boolean | null;
    pointOfSaleId?: string | null;
  }>;
};

export type PibisiUsersQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type PibisiUsersQuery = {
  __typename?: 'Query';
  pibisiUsers: Array<{
    __typename?: 'PibisiAccount';
    id?: string | null;
    entityId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    deleted?: boolean | null;
    status?: PibisiStatus | null;
    customerId?: string | null;
    legalName?: string | null;
    alertsId?: string | null;
    alertsStatus?: PibisiMatchStatus | null;
    matches?: Array<{
      __typename?: 'PibisiMatch';
      id: string;
      status: PibisiMatchStatus;
      adverseInfo?: Array<{
        __typename?: 'PibisiFlag';
        id?: string | null;
        content?: {
          __typename?: 'PibisiContent';
          action?: string | null;
          charge?: string | null;
          country?: string | null;
          from?: string | null;
          issue?: string | null;
          issuer?: string | null;
          organization?: string | null;
          reason?: string | null;
          scope?: string | null;
          to?: string | null;
          types?: Array<string | null> | null;
          url?: string | null;
        } | null;
      } | null> | null;
      highRisk?: Array<{
        __typename?: 'PibisiFlag';
        id?: string | null;
        content?: {
          __typename?: 'PibisiContent';
          action?: string | null;
          charge?: string | null;
          country?: string | null;
          from?: string | null;
          issue?: string | null;
          issuer?: string | null;
          organization?: string | null;
          reason?: string | null;
          scope?: string | null;
          to?: string | null;
          types?: Array<string | null> | null;
          url?: string | null;
        } | null;
      } | null> | null;
      media?: Array<{
        __typename?: 'PibisiFlag';
        id?: string | null;
        content?: {
          __typename?: 'PibisiContent';
          action?: string | null;
          charge?: string | null;
          country?: string | null;
          from?: string | null;
          issue?: string | null;
          issuer?: string | null;
          organization?: string | null;
          reason?: string | null;
          scope?: string | null;
          to?: string | null;
          types?: Array<string | null> | null;
          url?: string | null;
        } | null;
      } | null> | null;
      pep?: Array<{
        __typename?: 'PibisiFlag';
        id?: string | null;
        content?: {
          __typename?: 'PibisiContent';
          action?: string | null;
          charge?: string | null;
          country?: string | null;
          from?: string | null;
          issue?: string | null;
          issuer?: string | null;
          organization?: string | null;
          reason?: string | null;
          scope?: string | null;
          to?: string | null;
          types?: Array<string | null> | null;
          url?: string | null;
        } | null;
      } | null> | null;
      sanctioned?: Array<{
        __typename?: 'PibisiFlag';
        id?: string | null;
        content?: {
          __typename?: 'PibisiContent';
          action?: string | null;
          charge?: string | null;
          country?: string | null;
          from?: string | null;
          issue?: string | null;
          issuer?: string | null;
          organization?: string | null;
          reason?: string | null;
          scope?: string | null;
          to?: string | null;
          types?: Array<string | null> | null;
          url?: string | null;
        } | null;
      } | null> | null;
      terrorist?: Array<{
        __typename?: 'PibisiFlag';
        id?: string | null;
        content?: {
          __typename?: 'PibisiContent';
          action?: string | null;
          charge?: string | null;
          country?: string | null;
          from?: string | null;
          issue?: string | null;
          issuer?: string | null;
          organization?: string | null;
          reason?: string | null;
          scope?: string | null;
          to?: string | null;
          types?: Array<string | null> | null;
          url?: string | null;
        } | null;
      } | null> | null;
      matches?: Array<{
        __typename?: 'PibisiFlag';
        id?: string | null;
        content?: {
          __typename?: 'PibisiContent';
          action?: string | null;
          charge?: string | null;
          country?: string | null;
          from?: string | null;
          issue?: string | null;
          issuer?: string | null;
          organization?: string | null;
          reason?: string | null;
          scope?: string | null;
          to?: string | null;
          types?: Array<string | null> | null;
          url?: string | null;
        } | null;
      } | null> | null;
    } | null> | null;
    alerts?: Array<{
      __typename?: 'PibisiAlert';
      id: string;
      status: PibisiAlertStatus;
      type?: PibisiAlertTypes | null;
      note?: string | null;
    } | null> | null;
  }>;
};

export type PibisiEventsQueryVariables = Exact<{
  pibisiId: Scalars['ID']['input'];
}>;

export type PibisiEventsQuery = {
  __typename?: 'Query';
  pibisiEvents: {
    __typename?: 'PibisiEventsConnection';
    total: number;
    items: Array<{
      __typename?: 'PibisiEvent';
      id: string;
      type: string;
      objectId: string;
      objectType: string;
      createdAt: number;
      object: {
        __typename?: 'PibisiEventObject';
        id: string;
        entityId?: string | null;
        status: PibisiStatus;
        customerId?: string | null;
        createdAt: number;
        updatedAt?: number | null;
        traceDetails?: {
          __typename?: 'TraceDetails';
          ip?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
          userId?: string | null;
          userEmail?: string | null;
          userName?: string | null;
        } | null;
      };
    }>;
  };
};

export type ShortLinkQueryVariables = Exact<{
  url: Scalars['String']['input'];
  accountId: Scalars['ID']['input'];
}>;

export type ShortLinkQuery = {
  __typename?: 'Query';
  shortLink?: {
    __typename?: 'ShortLink';
    id: string;
    url: string;
    openCount?: number | null;
    createdAt: string;
  } | null;
};

export type CapitalDataByAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type CapitalDataByAccountQuery = {
  __typename?: 'Query';
  capitalDataByAccount?: {
    __typename?: 'CapitalAccountData';
    offer?: {
      __typename?: 'CapitalOffer';
      loanAmount: number;
      fundedAmount: number;
      currencyISOCode: Currencies;
      fee: number;
    } | null;
    lead?: {
      __typename?: 'CapitalLead';
      onboardingStatus: CapitalOnboardingStatus;
      signUpUrl: string;
    } | null;
  } | null;
};

export type GetCapitalOnboardingDetailsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type GetCapitalOnboardingDetailsQuery = {
  __typename?: 'Query';
  capitalOnboardingDetails?: {
    __typename?: 'CapitalOnboardingDetailsDashboard';
    leadId: string;
    status?: string | null;
    onboardingStateReason?: string | null;
    organisationDetailsStepComplete: boolean;
    paymentDataStepComplete: boolean;
    offerStepComplete: boolean;
    kycDocumentsStepComplete: boolean;
    companyName?: string | null;
    stateUpdated?: string | null;
  } | null;
};

export type CapitalLoansQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type CapitalLoansQuery = {
  __typename?: 'Query';
  capitalLoans: {
    __typename?: 'CapitalLoansConnection';
    items: Array<{
      __typename?: 'CapitalLoan';
      id: string;
      loanNumber: number;
      status: CapitalLoanStatus;
      fundedAmount: number;
      currentAmount: number;
      originalAmount: number;
      currencyISOCode: Currencies;
      sweep: number;
      fundingDate: string;
      maturityDate: string;
      loanType: CapitalLoanType;
      aheadBehindValue: number;
      aheadBehindPercentage: number;
    }>;
  };
};

export type CapitalLoanQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  loanId: Scalars['ID']['input'];
}>;

export type CapitalLoanQuery = {
  __typename?: 'Query';
  capitalLoan?: {
    __typename?: 'CapitalLoanDetails';
    id: string;
    loanNumber: number;
    borrowerName?: string | null;
    status?: CapitalLoanStatus | null;
    loanType?: CapitalLoanType | null;
    originalAmount: number;
    currentAmount: number;
    currencyISOCode?: Currencies | null;
    sweep: number;
    discount: number;
    expectedRepayment: number;
    approvalDate?: string | null;
    maturityDate: string;
    projectedRepaymentDate: string;
    repaymentMethod?: string | null;
    repaymentFrequency?: string | null;
    fundingDetails?: {
      __typename?: 'CapitalLoanFundingDetails';
      fundingAmount: number;
      fundingDate: string;
      amountFunded: number;
    } | null;
    documents?: Array<{
      __typename?: 'CapitalLoanDocumentItem';
      documentType?: string | null;
      document: {
        __typename?: 'CapitalLoanDocumentReference';
        documentId: string;
        documentName?: string | null;
        documentType?: string | null;
        dateUploaded: string;
      };
    }> | null;
  } | null;
};

export type CapitalLoanRepaymentsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  loanId: Scalars['ID']['input'];
}>;

export type CapitalLoanRepaymentsQuery = {
  __typename?: 'Query';
  capitalLoanRepayments: {
    __typename?: 'CapitalLoanRepaymentsConnection';
    items: Array<{
      __typename?: 'CapitalLoanRepayment';
      paymentDate: string;
      repaymentAmount: number;
      loanBalance: number;
      totalCardTransactions?: number | null;
      sweep?: number | null;
    }>;
  };
};

export type DownloadCapitalLoanDocumentMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  loanId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
}>;

export type DownloadCapitalLoanDocumentMutation = {
  __typename?: 'Mutation';
  downloadCapitalLoanDocument: {
    __typename?: 'DownloadFile';
    downloadUrl: string;
    expiresAt: number;
  };
};

export type OnUpdateAnalyticsSubscriptionVariables = Exact<{[key: string]: never}>;

export type OnUpdateAnalyticsSubscription = {
  __typename?: 'Subscriptions';
  onUpdateAnalytics?: {__typename?: 'AnalyticsChange'; all?: boolean | null} | null;
};

export type OnUpdateEventsSubscriptionVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type OnUpdateEventsSubscription = {
  __typename?: 'Subscriptions';
  onUpdateEvents?: {__typename?: 'AccountLevelUpdate'; accountId?: string | null} | null;
};

export type OnUpdateDocumentsSubscriptionVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type OnUpdateDocumentsSubscription = {
  __typename?: 'Subscriptions';
  onUpdateDocuments?: {__typename?: 'AccountLevelUpdate'; accountId?: string | null} | null;
};

export type OnUpdateAccountSubscriptionVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type OnUpdateAccountSubscription = {
  __typename?: 'Subscriptions';
  onUpdateAccount?: {__typename?: 'AccountLevelUpdate'; accountId?: string | null} | null;
};

export const PibisiFlagFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFlagFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PibisiFlag'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'content'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'action'}},
                {kind: 'Field', name: {kind: 'Name', value: 'charge'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'from'}},
                {kind: 'Field', name: {kind: 'Name', value: 'issue'}},
                {kind: 'Field', name: {kind: 'Name', value: 'issuer'}},
                {kind: 'Field', name: {kind: 'Name', value: 'organization'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reason'}},
                {kind: 'Field', name: {kind: 'Name', value: 'scope'}},
                {kind: 'Field', name: {kind: 'Name', value: 'to'}},
                {kind: 'Field', name: {kind: 'Name', value: 'types'}},
                {kind: 'Field', name: {kind: 'Name', value: 'url'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const PibisiAccountFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiAccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PibisiAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deleted'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customerId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'alertsId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'alertsStatus'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'matches'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adverseInfo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFlagFields'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'highRisk'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFlagFields'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'media'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFlagFields'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pep'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFlagFields'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'sanctioned'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFlagFields'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'terrorist'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFlagFields'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'matches'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFlagFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'alerts'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFlagFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PibisiFlag'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'content'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'action'}},
                {kind: 'Field', name: {kind: 'Name', value: 'charge'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'from'}},
                {kind: 'Field', name: {kind: 'Name', value: 'issue'}},
                {kind: 'Field', name: {kind: 'Name', value: 'issuer'}},
                {kind: 'Field', name: {kind: 'Name', value: 'organization'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reason'}},
                {kind: 'Field', name: {kind: 'Name', value: 'scope'}},
                {kind: 'Field', name: {kind: 'Name', value: 'to'}},
                {kind: 'Field', name: {kind: 'Name', value: 'types'}},
                {kind: 'Field', name: {kind: 'Name', value: 'url'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const ProviderFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ProviderFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Provider'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'processor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currencies'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'possibleValues'}},
                {kind: 'Field', name: {kind: 'Name', value: 'regex'}},
                {kind: 'Field', name: {kind: 'Name', value: 'example'}},
                {kind: 'Field', name: {kind: 'Name', value: 'secret'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'rules'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'minAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'maxAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'shopNameLike'}},
                {kind: 'Field', name: {kind: 'Name', value: 'descriptionLike'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nativeHostedPayment'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const AddressFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const PaymentMethodFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const SessionDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const TraceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const ChargeFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ChargeFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Charge'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'checkoutId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'processor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'subscriptionId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerReferenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerInternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'authorizationCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'descriptor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationReason'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shop'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerStatusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerStatusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'issuerStatusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'issuerStatusMessage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'callbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'completeUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'failUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancelUrl'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const ChargeEventObjectFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ChargeEventObjectFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ChargeEventObject'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'checkoutId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {kind: 'Field', name: {kind: 'Name', value: 'subscriptionId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerReferenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerInternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amountEUR'}},
          {kind: 'Field', name: {kind: 'Name', value: 'authorizationCode'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'descriptor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'terminalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationReason'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shop'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerStatusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerStatusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'issuerStatusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'issuerStatusMessage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'pageOpenedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'callbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'completeUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'failUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancelUrl'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const UserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'UserFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'User'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'emailVerified'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phoneNumberVerified'}},
          {kind: 'Field', name: {kind: 'Name', value: 'smsMfaEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const PibisiFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const AccountFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Account'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowRefunds'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'language'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'progressiveBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contactPerson'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingEmail'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailOnAccountInvoice'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProcessing'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankTransferConceptPrefix'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleToStores'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sepblacId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingVatPercent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churned'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'previewFeatures'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountInvoicePaymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customAccountInvoiceNotes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'groupInvoicesByStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const AuthorizedUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AuthorizedUserFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AuthorizedUser'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accessLevel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastLoginAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const AccountEventObjectFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountEventObjectFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AccountEventObject'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'region'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const MasterAccountEventObjectFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MasterAccountEventObjectFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MasterAccountEventObject'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'contractTemplateId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'churnedEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedDomains'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedIPs'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'webhookEmails'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const SettlementFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SettlementFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Settlement'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirerFees'}},
          {kind: 'Field', name: {kind: 'Name', value: 'grossVolume'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'payMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'netVolume'}},
          {kind: 'Field', name: {kind: 'Name', value: 'periodEndAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'periodStartAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'releasedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reservedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'scheduledAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const AccountInvoiceFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountInvoiceFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AccountInvoice'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'number'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'period'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'from'}},
                {kind: 'Field', name: {kind: 'Name', value: 'to'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tax'}},
          {kind: 'Field', name: {kind: 'Name', value: 'totalAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'unitAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'unitType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'amount'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'iban'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethod'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const PaymentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Payment'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'subscriptionId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'authorizationCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'descriptor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationReason'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shop'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'nextAction'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'redirectUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mustRedirect'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const MasterAccountFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MasterAccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MasterAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedIPs'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'accountDefaults'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
                {kind: 'Field', name: {kind: 'Name', value: 'language'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fees'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'steps'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'extra'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'region'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'business'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'webhookEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnedEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedDomains'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireExternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'contractTemplateId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'autoApprove'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const UserMasterAccountFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'UserMasterAccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MasterAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedIPs'}},
          {kind: 'Field', name: {kind: 'Name', value: 'webhookEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnedEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedDomains'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireExternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const DocumentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DocumentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Document'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'contentType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'internal'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const DocumentEventFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DocumentEventFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'DocumentEvent'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'objectId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'objectType'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'object'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'contentType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'internal'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'metadata'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'value'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'traceDetails'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const ContactFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContactFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ContactDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'company'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const SubscriptionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SubscriptionFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Subscription'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'planVariantId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'productId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancelAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'skipIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodStart'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodDays'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customerId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTokenId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastInvoiceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lastPayment'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nextPaymentAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'interval'}},
          {kind: 'Field', name: {kind: 'Name', value: 'intervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'retryCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'callbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'allowedPaymentMethods'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContactFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ContactDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'company'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const LastPaymentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'LastPaymentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'LastPayment'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const SubscriptionEventObjectFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SubscriptionEventObjectFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SubscriptionEventObject'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cancelAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodStart'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'interval'}},
          {kind: 'Field', name: {kind: 'Name', value: 'intervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lastPayment'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'LastPaymentFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseIntervalCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'retryCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodDays'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'LastPaymentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'LastPayment'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const ProviderEventObjectFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ProviderEventObjectFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ProviderEventObject'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'internalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'processor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'configurable'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nativeHostedPayment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'rules'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'minAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'maxAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'shopNameLike'}},
                {kind: 'Field', name: {kind: 'Name', value: 'descriptionLike'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const WebhookFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'WebhookFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Webhook'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'url'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventTypes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const ChargesExportFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ChargesExportFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ChargesExport'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'expireAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const SftpConfigExportFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SftpConfigExportFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SftpConfigExport'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'host'}},
          {kind: 'Field', name: {kind: 'Name', value: 'port'}},
          {kind: 'Field', name: {kind: 'Name', value: 'username'}},
          {kind: 'Field', name: {kind: 'Name', value: 'path'}},
          {kind: 'Field', name: {kind: 'Name', value: 'columns'}},
          {kind: 'Field', name: {kind: 'Name', value: 'timezone'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const StoreFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'StoreFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Store'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
          {kind: 'Field', name: {kind: 'Name', value: 'website'}},
          {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const AccountBalancesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountBalancesFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AccountBalances'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'clearedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'outstandingAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'totalAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const AdminUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AdminUserFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AdminUser'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const PayoutMethodsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PayoutMethodsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AffiliatePayoutMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'title'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'details'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nif'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const AffiliateFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AffiliateFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Affiliate'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'firstname'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastname'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'company'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'description'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'address'}},
                {kind: 'Field', name: {kind: 'Name', value: 'postal_code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'country'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'meta_data'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'tier'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'referral_link'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'link'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'affiliate_group_id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'created_at'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payout_methods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PayoutMethodsFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PayoutMethodsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AffiliatePayoutMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'title'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'details'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nif'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const AffiliateMerchantFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AffiliateMerchantFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AffiliateMerchant'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'created_at'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'meta_data'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'account_id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'account_status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company_name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'first_conversion_date'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const AffiliateInvoiceFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AffiliateInvoiceFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AffiliateInvoice'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'number'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'issuedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dueAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const BlacklistItemFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'BlacklistItemFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'BlacklistItem'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'value'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const PointOfSaleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PointOfSaleFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PointOfSale'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'number'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPaymentId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'manualAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'terminalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireTaxId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'includeQRCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'qrCodeText'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fixedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fixedCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'transactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pendingSetup'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentCallbackUrl'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const AdminUserEventFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AdminUserEventFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AdminUserEvent'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'objectType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'objectId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const CodeFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CodeFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Code'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const PibisiEventFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiEventFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PibisiEvent'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'objectId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'objectType'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'object'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'customerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'traceDetails'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;
export const ExportChargesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ExportCharges'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'SearchableChargeFilterInput'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'columns'}},
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'timezone'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'exportCharges'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'columns'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'columns'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'timezone'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'timezone'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'downloadUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiresAt'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useExportChargesMutation__
 *
 * To run a mutation, you first call `useExportChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportChargesMutation, { data, loading, error }] = useExportChargesMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      columns: // value for 'columns'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useExportChargesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ExportChargesMutation,
    ExportChargesMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<ExportChargesMutation, ExportChargesMutationVariables>(
    ExportChargesDocument,
    options
  );
}
export type ExportChargesMutationHookResult = ReturnType<typeof useExportChargesMutation>;
export type ExportChargesMutationResult = Apollo.MutationResult<ExportChargesMutation>;
export type ExportChargesMutationOptions = Apollo.BaseMutationOptions<
  ExportChargesMutation,
  ExportChargesMutationVariables
>;
export const UpdateAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateAccount'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UpdateAccountInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Account'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowRefunds'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'language'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'progressiveBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contactPerson'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingEmail'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailOnAccountInvoice'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProcessing'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankTransferConceptPrefix'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleToStores'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sepblacId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingVatPercent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churned'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'previewFeatures'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountInvoicePaymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customAccountInvoiceNotes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'groupInvoicesByStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateAccountMutation,
    UpdateAccountMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(
    UpdateAccountDocument,
    options
  );
}
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<
  UpdateAccountMutation,
  UpdateAccountMutationVariables
>;
export const UpdateMasterAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateMasterAccount'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UpdateMasterAccountInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateMasterAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'MasterAccountFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MasterAccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MasterAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedIPs'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'accountDefaults'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
                {kind: 'Field', name: {kind: 'Name', value: 'language'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fees'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'steps'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'extra'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'region'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'business'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'webhookEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnedEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedDomains'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireExternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'contractTemplateId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'autoApprove'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdateMasterAccountMutation__
 *
 * To run a mutation, you first call `useUpdateMasterAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMasterAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMasterAccountMutation, { data, loading, error }] = useUpdateMasterAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMasterAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateMasterAccountMutation,
    UpdateMasterAccountMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    UpdateMasterAccountMutation,
    UpdateMasterAccountMutationVariables
  >(UpdateMasterAccountDocument, options);
}
export type UpdateMasterAccountMutationHookResult = ReturnType<
  typeof useUpdateMasterAccountMutation
>;
export type UpdateMasterAccountMutationResult = Apollo.MutationResult<UpdateMasterAccountMutation>;
export type UpdateMasterAccountMutationOptions = Apollo.BaseMutationOptions<
  UpdateMasterAccountMutation,
  UpdateMasterAccountMutationVariables
>;
export const UpdateUserMasterAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateUserMasterAccount'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UpdateUserMasterAccountInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateUserMasterAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'UserMasterAccountFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'UserMasterAccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MasterAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedIPs'}},
          {kind: 'Field', name: {kind: 'Name', value: 'webhookEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnedEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedDomains'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireExternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdateUserMasterAccountMutation__
 *
 * To run a mutation, you first call `useUpdateUserMasterAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMasterAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMasterAccountMutation, { data, loading, error }] = useUpdateUserMasterAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMasterAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateUserMasterAccountMutation,
    UpdateUserMasterAccountMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    UpdateUserMasterAccountMutation,
    UpdateUserMasterAccountMutationVariables
  >(UpdateUserMasterAccountDocument, options);
}
export type UpdateUserMasterAccountMutationHookResult = ReturnType<
  typeof useUpdateUserMasterAccountMutation
>;
export type UpdateUserMasterAccountMutationResult =
  Apollo.MutationResult<UpdateUserMasterAccountMutation>;
export type UpdateUserMasterAccountMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMasterAccountMutation,
  UpdateUserMasterAccountMutationVariables
>;
export const UpdateProviderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateProvider'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UpdateProviderInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateProvider'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ProviderFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ProviderFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Provider'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'processor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currencies'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'possibleValues'}},
                {kind: 'Field', name: {kind: 'Name', value: 'regex'}},
                {kind: 'Field', name: {kind: 'Name', value: 'example'}},
                {kind: 'Field', name: {kind: 'Name', value: 'secret'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'rules'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'minAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'maxAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'shopNameLike'}},
                {kind: 'Field', name: {kind: 'Name', value: 'descriptionLike'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nativeHostedPayment'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdateProviderMutation__
 *
 * To run a mutation, you first call `useUpdateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderMutation, { data, loading, error }] = useUpdateProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateProviderMutation,
    UpdateProviderMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<UpdateProviderMutation, UpdateProviderMutationVariables>(
    UpdateProviderDocument,
    options
  );
}
export type UpdateProviderMutationHookResult = ReturnType<typeof useUpdateProviderMutation>;
export type UpdateProviderMutationResult = Apollo.MutationResult<UpdateProviderMutation>;
export type UpdateProviderMutationOptions = Apollo.BaseMutationOptions<
  UpdateProviderMutation,
  UpdateProviderMutationVariables
>;
export const CreateProviderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreateProvider'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CreateProviderInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createProvider'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ProviderFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ProviderFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Provider'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'processor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currencies'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'possibleValues'}},
                {kind: 'Field', name: {kind: 'Name', value: 'regex'}},
                {kind: 'Field', name: {kind: 'Name', value: 'example'}},
                {kind: 'Field', name: {kind: 'Name', value: 'secret'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'rules'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'minAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'maxAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'shopNameLike'}},
                {kind: 'Field', name: {kind: 'Name', value: 'descriptionLike'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nativeHostedPayment'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCreateProviderMutation__
 *
 * To run a mutation, you first call `useCreateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderMutation, { data, loading, error }] = useCreateProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProviderMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateProviderMutation,
    CreateProviderMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<CreateProviderMutation, CreateProviderMutationVariables>(
    CreateProviderDocument,
    options
  );
}
export type CreateProviderMutationHookResult = ReturnType<typeof useCreateProviderMutation>;
export type CreateProviderMutationResult = Apollo.MutationResult<CreateProviderMutation>;
export type CreateProviderMutationOptions = Apollo.BaseMutationOptions<
  CreateProviderMutation,
  CreateProviderMutationVariables
>;
export const DeleteProviderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DeleteProvider'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteProvider'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ProviderFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ProviderFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Provider'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'processor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currencies'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'possibleValues'}},
                {kind: 'Field', name: {kind: 'Name', value: 'regex'}},
                {kind: 'Field', name: {kind: 'Name', value: 'example'}},
                {kind: 'Field', name: {kind: 'Name', value: 'secret'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'rules'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'minAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'maxAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'shopNameLike'}},
                {kind: 'Field', name: {kind: 'Name', value: 'descriptionLike'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nativeHostedPayment'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDeleteProviderMutation__
 *
 * To run a mutation, you first call `useDeleteProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderMutation, { data, loading, error }] = useDeleteProviderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProviderMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteProviderMutation,
    DeleteProviderMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<DeleteProviderMutation, DeleteProviderMutationVariables>(
    DeleteProviderDocument,
    options
  );
}
export type DeleteProviderMutationHookResult = ReturnType<typeof useDeleteProviderMutation>;
export type DeleteProviderMutationResult = Apollo.MutationResult<DeleteProviderMutation>;
export type DeleteProviderMutationOptions = Apollo.BaseMutationOptions<
  DeleteProviderMutation,
  DeleteProviderMutationVariables
>;
export const ImpersonateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'Impersonate'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ImpersonateInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'impersonate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useImpersonateMutation__
 *
 * To run a mutation, you first call `useImpersonateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImpersonateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [impersonateMutation, { data, loading, error }] = useImpersonateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImpersonateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ImpersonateMutation,
    ImpersonateMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<ImpersonateMutation, ImpersonateMutationVariables>(
    ImpersonateDocument,
    options
  );
}
export type ImpersonateMutationHookResult = ReturnType<typeof useImpersonateMutation>;
export type ImpersonateMutationResult = Apollo.MutationResult<ImpersonateMutation>;
export type ImpersonateMutationOptions = Apollo.BaseMutationOptions<
  ImpersonateMutation,
  ImpersonateMutationVariables
>;
export const ResetUserPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ResetUserPassword'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'userId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'temporalPassword'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'resetUserPassword'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'userId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'userId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'temporalPassword'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'temporalPassword'}}
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      temporalPassword: // value for 'temporalPassword'
 *   },
 * });
 */
export function useResetUserPasswordMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ResetUserPasswordMutation,
    ResetUserPasswordMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    ResetUserPasswordMutation,
    ResetUserPasswordMutationVariables
  >(ResetUserPasswordDocument, options);
}
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetUserPasswordMutation,
  ResetUserPasswordMutationVariables
>;
export const DisableUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DisableUser'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'disableUser'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'UserFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'UserFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'User'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'emailVerified'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phoneNumberVerified'}},
          {kind: 'Field', name: {kind: 'Name', value: 'smsMfaEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDisableUserMutation__
 *
 * To run a mutation, you first call `useDisableUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableUserMutation, { data, loading, error }] = useDisableUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DisableUserMutation,
    DisableUserMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<DisableUserMutation, DisableUserMutationVariables>(
    DisableUserDocument,
    options
  );
}
export type DisableUserMutationHookResult = ReturnType<typeof useDisableUserMutation>;
export type DisableUserMutationResult = Apollo.MutationResult<DisableUserMutation>;
export type DisableUserMutationOptions = Apollo.BaseMutationOptions<
  DisableUserMutation,
  DisableUserMutationVariables
>;
export const EnableUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'EnableUser'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'enableUser'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'UserFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'UserFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'User'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'emailVerified'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phoneNumberVerified'}},
          {kind: 'Field', name: {kind: 'Name', value: 'smsMfaEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useEnableUserMutation__
 *
 * To run a mutation, you first call `useEnableUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableUserMutation, { data, loading, error }] = useEnableUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnableUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EnableUserMutation,
    EnableUserMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<EnableUserMutation, EnableUserMutationVariables>(
    EnableUserDocument,
    options
  );
}
export type EnableUserMutationHookResult = ReturnType<typeof useEnableUserMutation>;
export type EnableUserMutationResult = Apollo.MutationResult<EnableUserMutation>;
export type EnableUserMutationOptions = Apollo.BaseMutationOptions<
  EnableUserMutation,
  EnableUserMutationVariables
>;
export const DeleteAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DeleteAccount'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Account'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowRefunds'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'language'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'progressiveBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contactPerson'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingEmail'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailOnAccountInvoice'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProcessing'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankTransferConceptPrefix'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleToStores'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sepblacId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingVatPercent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churned'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'previewFeatures'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountInvoicePaymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customAccountInvoiceNotes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'groupInvoicesByStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteAccountMutation,
    DeleteAccountMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(
    DeleteAccountDocument,
    options
  );
}
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<
  DeleteAccountMutation,
  DeleteAccountMutationVariables
>;
export const RestoreAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'RestoreAccount'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'restoreAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Account'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowRefunds'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'language'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'progressiveBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contactPerson'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingEmail'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailOnAccountInvoice'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProcessing'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankTransferConceptPrefix'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleToStores'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sepblacId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingVatPercent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churned'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'previewFeatures'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountInvoicePaymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customAccountInvoiceNotes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'groupInvoicesByStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useRestoreAccountMutation__
 *
 * To run a mutation, you first call `useRestoreAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreAccountMutation, { data, loading, error }] = useRestoreAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RestoreAccountMutation,
    RestoreAccountMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<RestoreAccountMutation, RestoreAccountMutationVariables>(
    RestoreAccountDocument,
    options
  );
}
export type RestoreAccountMutationHookResult = ReturnType<typeof useRestoreAccountMutation>;
export type RestoreAccountMutationResult = Apollo.MutationResult<RestoreAccountMutation>;
export type RestoreAccountMutationOptions = Apollo.BaseMutationOptions<
  RestoreAccountMutation,
  RestoreAccountMutationVariables
>;
export const GenerateSettlementReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'GenerateSettlementReport'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'GenerateSettlementReportInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'generateSettlementReport'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'downloadUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiresAt'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useGenerateSettlementReportMutation__
 *
 * To run a mutation, you first call `useGenerateSettlementReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSettlementReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSettlementReportMutation, { data, loading, error }] = useGenerateSettlementReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSettlementReportMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    GenerateSettlementReportMutation,
    GenerateSettlementReportMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    GenerateSettlementReportMutation,
    GenerateSettlementReportMutationVariables
  >(GenerateSettlementReportDocument, options);
}
export type GenerateSettlementReportMutationHookResult = ReturnType<
  typeof useGenerateSettlementReportMutation
>;
export type GenerateSettlementReportMutationResult =
  Apollo.MutationResult<GenerateSettlementReportMutation>;
export type GenerateSettlementReportMutationOptions = Apollo.BaseMutationOptions<
  GenerateSettlementReportMutation,
  GenerateSettlementReportMutationVariables
>;
export const CreateAccountInvoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreateAccountInvoice'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'AccountInvoiceInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createAccountInvoice'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountInvoiceFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountInvoiceFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AccountInvoice'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'number'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'period'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'from'}},
                {kind: 'Field', name: {kind: 'Name', value: 'to'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tax'}},
          {kind: 'Field', name: {kind: 'Name', value: 'totalAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'unitAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'unitType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'amount'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'iban'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethod'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCreateAccountInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateAccountInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountInvoiceMutation, { data, loading, error }] = useCreateAccountInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountInvoiceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateAccountInvoiceMutation,
    CreateAccountInvoiceMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    CreateAccountInvoiceMutation,
    CreateAccountInvoiceMutationVariables
  >(CreateAccountInvoiceDocument, options);
}
export type CreateAccountInvoiceMutationHookResult = ReturnType<
  typeof useCreateAccountInvoiceMutation
>;
export type CreateAccountInvoiceMutationResult =
  Apollo.MutationResult<CreateAccountInvoiceMutation>;
export type CreateAccountInvoiceMutationOptions = Apollo.BaseMutationOptions<
  CreateAccountInvoiceMutation,
  CreateAccountInvoiceMutationVariables
>;
export const DisableTokenizationMethodDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DisableTokenizationMethod'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'method'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'TokenizationMethods'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'disableTokenizationMethod'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'method'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'method'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Account'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowRefunds'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'language'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'progressiveBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contactPerson'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingEmail'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailOnAccountInvoice'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProcessing'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankTransferConceptPrefix'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleToStores'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sepblacId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingVatPercent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churned'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'previewFeatures'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountInvoicePaymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customAccountInvoiceNotes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'groupInvoicesByStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDisableTokenizationMethodMutation__
 *
 * To run a mutation, you first call `useDisableTokenizationMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableTokenizationMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableTokenizationMethodMutation, { data, loading, error }] = useDisableTokenizationMethodMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      method: // value for 'method'
 *   },
 * });
 */
export function useDisableTokenizationMethodMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DisableTokenizationMethodMutation,
    DisableTokenizationMethodMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    DisableTokenizationMethodMutation,
    DisableTokenizationMethodMutationVariables
  >(DisableTokenizationMethodDocument, options);
}
export type DisableTokenizationMethodMutationHookResult = ReturnType<
  typeof useDisableTokenizationMethodMutation
>;
export type DisableTokenizationMethodMutationResult =
  Apollo.MutationResult<DisableTokenizationMethodMutation>;
export type DisableTokenizationMethodMutationOptions = Apollo.BaseMutationOptions<
  DisableTokenizationMethodMutation,
  DisableTokenizationMethodMutationVariables
>;
export const EnableTokenizationMethodDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'EnableTokenizationMethod'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'method'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'TokenizationMethods'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'enableTokenizationMethod'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'method'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'method'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Account'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowRefunds'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'language'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'progressiveBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contactPerson'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingEmail'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailOnAccountInvoice'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProcessing'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankTransferConceptPrefix'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleToStores'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sepblacId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingVatPercent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churned'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'previewFeatures'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountInvoicePaymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customAccountInvoiceNotes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'groupInvoicesByStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useEnableTokenizationMethodMutation__
 *
 * To run a mutation, you first call `useEnableTokenizationMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableTokenizationMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableTokenizationMethodMutation, { data, loading, error }] = useEnableTokenizationMethodMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      method: // value for 'method'
 *   },
 * });
 */
export function useEnableTokenizationMethodMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EnableTokenizationMethodMutation,
    EnableTokenizationMethodMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    EnableTokenizationMethodMutation,
    EnableTokenizationMethodMutationVariables
  >(EnableTokenizationMethodDocument, options);
}
export type EnableTokenizationMethodMutationHookResult = ReturnType<
  typeof useEnableTokenizationMethodMutation
>;
export type EnableTokenizationMethodMutationResult =
  Apollo.MutationResult<EnableTokenizationMethodMutation>;
export type EnableTokenizationMethodMutationOptions = Apollo.BaseMutationOptions<
  EnableTokenizationMethodMutation,
  EnableTokenizationMethodMutationVariables
>;
export const DownloadContractDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DownloadContract'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'downloadContract'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'downloadUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiresAt'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDownloadContractMutation__
 *
 * To run a mutation, you first call `useDownloadContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadContractMutation, { data, loading, error }] = useDownloadContractMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDownloadContractMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadContractMutation,
    DownloadContractMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<DownloadContractMutation, DownloadContractMutationVariables>(
    DownloadContractDocument,
    options
  );
}
export type DownloadContractMutationHookResult = ReturnType<typeof useDownloadContractMutation>;
export type DownloadContractMutationResult = Apollo.MutationResult<DownloadContractMutation>;
export type DownloadContractMutationOptions = Apollo.BaseMutationOptions<
  DownloadContractMutation,
  DownloadContractMutationVariables
>;
export const ApproveAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ApproveAccount'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'processor'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Processor'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'approveAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'processor'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'processor'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Account'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowRefunds'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'language'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'progressiveBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contactPerson'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingEmail'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailOnAccountInvoice'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProcessing'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankTransferConceptPrefix'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleToStores'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sepblacId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingVatPercent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churned'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'previewFeatures'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountInvoicePaymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customAccountInvoiceNotes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'groupInvoicesByStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useApproveAccountMutation__
 *
 * To run a mutation, you first call `useApproveAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveAccountMutation, { data, loading, error }] = useApproveAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      processor: // value for 'processor'
 *   },
 * });
 */
export function useApproveAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ApproveAccountMutation,
    ApproveAccountMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<ApproveAccountMutation, ApproveAccountMutationVariables>(
    ApproveAccountDocument,
    options
  );
}
export type ApproveAccountMutationHookResult = ReturnType<typeof useApproveAccountMutation>;
export type ApproveAccountMutationResult = Apollo.MutationResult<ApproveAccountMutation>;
export type ApproveAccountMutationOptions = Apollo.BaseMutationOptions<
  ApproveAccountMutation,
  ApproveAccountMutationVariables
>;
export const RegisterMoneiXMerchantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'RegisterMoneiXMerchant'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'cardPresent'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'registerMoneiXMerchant'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'cardPresent'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'cardPresent'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useRegisterMoneiXMerchantMutation__
 *
 * To run a mutation, you first call `useRegisterMoneiXMerchantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMoneiXMerchantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMoneiXMerchantMutation, { data, loading, error }] = useRegisterMoneiXMerchantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cardPresent: // value for 'cardPresent'
 *   },
 * });
 */
export function useRegisterMoneiXMerchantMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RegisterMoneiXMerchantMutation,
    RegisterMoneiXMerchantMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    RegisterMoneiXMerchantMutation,
    RegisterMoneiXMerchantMutationVariables
  >(RegisterMoneiXMerchantDocument, options);
}
export type RegisterMoneiXMerchantMutationHookResult = ReturnType<
  typeof useRegisterMoneiXMerchantMutation
>;
export type RegisterMoneiXMerchantMutationResult =
  Apollo.MutationResult<RegisterMoneiXMerchantMutation>;
export type RegisterMoneiXMerchantMutationOptions = Apollo.BaseMutationOptions<
  RegisterMoneiXMerchantMutation,
  RegisterMoneiXMerchantMutationVariables
>;
export const VerifyIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'VerifyId'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'verifyId'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Account'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowRefunds'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'language'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'progressiveBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contactPerson'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingEmail'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailOnAccountInvoice'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProcessing'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankTransferConceptPrefix'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleToStores'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sepblacId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingVatPercent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churned'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'previewFeatures'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountInvoicePaymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customAccountInvoiceNotes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'groupInvoicesByStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useVerifyIdMutation__
 *
 * To run a mutation, you first call `useVerifyIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyIdMutation, { data, loading, error }] = useVerifyIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useVerifyIdMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyIdMutation, VerifyIdMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<VerifyIdMutation, VerifyIdMutationVariables>(
    VerifyIdDocument,
    options
  );
}
export type VerifyIdMutationHookResult = ReturnType<typeof useVerifyIdMutation>;
export type VerifyIdMutationResult = Apollo.MutationResult<VerifyIdMutation>;
export type VerifyIdMutationOptions = Apollo.BaseMutationOptions<
  VerifyIdMutation,
  VerifyIdMutationVariables
>;
export const CreateAuthorizedUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreateAuthorizedUser'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CreateAuthorizedUserInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createAuthorizedUser'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AuthorizedUserFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AuthorizedUserFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AuthorizedUser'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accessLevel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastLoginAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCreateAuthorizedUserMutation__
 *
 * To run a mutation, you first call `useCreateAuthorizedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthorizedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthorizedUserMutation, { data, loading, error }] = useCreateAuthorizedUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAuthorizedUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateAuthorizedUserMutation,
    CreateAuthorizedUserMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    CreateAuthorizedUserMutation,
    CreateAuthorizedUserMutationVariables
  >(CreateAuthorizedUserDocument, options);
}
export type CreateAuthorizedUserMutationHookResult = ReturnType<
  typeof useCreateAuthorizedUserMutation
>;
export type CreateAuthorizedUserMutationResult =
  Apollo.MutationResult<CreateAuthorizedUserMutation>;
export type CreateAuthorizedUserMutationOptions = Apollo.BaseMutationOptions<
  CreateAuthorizedUserMutation,
  CreateAuthorizedUserMutationVariables
>;
export const CreateMasterAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreateMasterAccount'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CreateMasterAccountInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createMasterAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'MasterAccountFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MasterAccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MasterAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedIPs'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'accountDefaults'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
                {kind: 'Field', name: {kind: 'Name', value: 'language'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fees'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'steps'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'extra'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'region'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'business'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'webhookEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnedEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedDomains'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireExternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'contractTemplateId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'autoApprove'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCreateMasterAccountMutation__
 *
 * To run a mutation, you first call `useCreateMasterAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterAccountMutation, { data, loading, error }] = useCreateMasterAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMasterAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateMasterAccountMutation,
    CreateMasterAccountMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    CreateMasterAccountMutation,
    CreateMasterAccountMutationVariables
  >(CreateMasterAccountDocument, options);
}
export type CreateMasterAccountMutationHookResult = ReturnType<
  typeof useCreateMasterAccountMutation
>;
export type CreateMasterAccountMutationResult = Apollo.MutationResult<CreateMasterAccountMutation>;
export type CreateMasterAccountMutationOptions = Apollo.BaseMutationOptions<
  CreateMasterAccountMutation,
  CreateMasterAccountMutationVariables
>;
export const CreateMasterAccountUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreateMasterAccountUser'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CreateMasterAccountUserInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createMasterAccountUser'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AuthorizedUserFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AuthorizedUserFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AuthorizedUser'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accessLevel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastLoginAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCreateMasterAccountUserMutation__
 *
 * To run a mutation, you first call `useCreateMasterAccountUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterAccountUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterAccountUserMutation, { data, loading, error }] = useCreateMasterAccountUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMasterAccountUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateMasterAccountUserMutation,
    CreateMasterAccountUserMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    CreateMasterAccountUserMutation,
    CreateMasterAccountUserMutationVariables
  >(CreateMasterAccountUserDocument, options);
}
export type CreateMasterAccountUserMutationHookResult = ReturnType<
  typeof useCreateMasterAccountUserMutation
>;
export type CreateMasterAccountUserMutationResult =
  Apollo.MutationResult<CreateMasterAccountUserMutation>;
export type CreateMasterAccountUserMutationOptions = Apollo.BaseMutationOptions<
  CreateMasterAccountUserMutation,
  CreateMasterAccountUserMutationVariables
>;
export const DeleteMasterAccountUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DeleteMasterAccountUser'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'userEmail'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteMasterAccountUser'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'userEmail'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'userEmail'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDeleteMasterAccountUserMutation__
 *
 * To run a mutation, you first call `useDeleteMasterAccountUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMasterAccountUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMasterAccountUserMutation, { data, loading, error }] = useDeleteMasterAccountUserMutation({
 *   variables: {
 *      userEmail: // value for 'userEmail'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteMasterAccountUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteMasterAccountUserMutation,
    DeleteMasterAccountUserMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    DeleteMasterAccountUserMutation,
    DeleteMasterAccountUserMutationVariables
  >(DeleteMasterAccountUserDocument, options);
}
export type DeleteMasterAccountUserMutationHookResult = ReturnType<
  typeof useDeleteMasterAccountUserMutation
>;
export type DeleteMasterAccountUserMutationResult =
  Apollo.MutationResult<DeleteMasterAccountUserMutation>;
export type DeleteMasterAccountUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteMasterAccountUserMutation,
  DeleteMasterAccountUserMutationVariables
>;
export const DeleteAuthorizedUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DeleteAuthorizedUser'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'userEmail'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteAuthorizedUser'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'userEmail'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'userEmail'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDeleteAuthorizedUserMutation__
 *
 * To run a mutation, you first call `useDeleteAuthorizedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAuthorizedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAuthorizedUserMutation, { data, loading, error }] = useDeleteAuthorizedUserMutation({
 *   variables: {
 *      userEmail: // value for 'userEmail'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteAuthorizedUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteAuthorizedUserMutation,
    DeleteAuthorizedUserMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    DeleteAuthorizedUserMutation,
    DeleteAuthorizedUserMutationVariables
  >(DeleteAuthorizedUserDocument, options);
}
export type DeleteAuthorizedUserMutationHookResult = ReturnType<
  typeof useDeleteAuthorizedUserMutation
>;
export type DeleteAuthorizedUserMutationResult =
  Apollo.MutationResult<DeleteAuthorizedUserMutation>;
export type DeleteAuthorizedUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteAuthorizedUserMutation,
  DeleteAuthorizedUserMutationVariables
>;
export const UpdateAuthorizedUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateAuthorizedUser'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UpdateAuthorizedUserInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateAuthorizedUser'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AuthorizedUserFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AuthorizedUserFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AuthorizedUser'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accessLevel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastLoginAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdateAuthorizedUserMutation__
 *
 * To run a mutation, you first call `useUpdateAuthorizedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorizedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthorizedUserMutation, { data, loading, error }] = useUpdateAuthorizedUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAuthorizedUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateAuthorizedUserMutation,
    UpdateAuthorizedUserMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    UpdateAuthorizedUserMutation,
    UpdateAuthorizedUserMutationVariables
  >(UpdateAuthorizedUserDocument, options);
}
export type UpdateAuthorizedUserMutationHookResult = ReturnType<
  typeof useUpdateAuthorizedUserMutation
>;
export type UpdateAuthorizedUserMutationResult =
  Apollo.MutationResult<UpdateAuthorizedUserMutation>;
export type UpdateAuthorizedUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateAuthorizedUserMutation,
  UpdateAuthorizedUserMutationVariables
>;
export const SendPaymentLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SendPaymentLink'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'SendPaymentMessageInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sendPaymentLink'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Payment'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'subscriptionId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'authorizationCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'descriptor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationReason'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shop'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'nextAction'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'redirectUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mustRedirect'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useSendPaymentLinkMutation__
 *
 * To run a mutation, you first call `useSendPaymentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPaymentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPaymentLinkMutation, { data, loading, error }] = useSendPaymentLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPaymentLinkMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendPaymentLinkMutation,
    SendPaymentLinkMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<SendPaymentLinkMutation, SendPaymentLinkMutationVariables>(
    SendPaymentLinkDocument,
    options
  );
}
export type SendPaymentLinkMutationHookResult = ReturnType<typeof useSendPaymentLinkMutation>;
export type SendPaymentLinkMutationResult = Apollo.MutationResult<SendPaymentLinkMutation>;
export type SendPaymentLinkMutationOptions = Apollo.BaseMutationOptions<
  SendPaymentLinkMutation,
  SendPaymentLinkMutationVariables
>;
export const SendPaymentRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SendPaymentRequest'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'SendPaymentRequestInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sendPaymentRequest'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Payment'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'subscriptionId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'authorizationCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'descriptor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationReason'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shop'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'nextAction'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'redirectUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mustRedirect'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useSendPaymentRequestMutation__
 *
 * To run a mutation, you first call `useSendPaymentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPaymentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPaymentRequestMutation, { data, loading, error }] = useSendPaymentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPaymentRequestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendPaymentRequestMutation,
    SendPaymentRequestMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    SendPaymentRequestMutation,
    SendPaymentRequestMutationVariables
  >(SendPaymentRequestDocument, options);
}
export type SendPaymentRequestMutationHookResult = ReturnType<typeof useSendPaymentRequestMutation>;
export type SendPaymentRequestMutationResult = Apollo.MutationResult<SendPaymentRequestMutation>;
export type SendPaymentRequestMutationOptions = Apollo.BaseMutationOptions<
  SendPaymentRequestMutation,
  SendPaymentRequestMutationVariables
>;
export const CreatePaymentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreatePayment'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CreatePaymentInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createPayment'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Payment'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'subscriptionId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'authorizationCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'descriptor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationReason'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shop'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'nextAction'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'redirectUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mustRedirect'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCreatePaymentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMutation, { data, loading, error }] = useCreatePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreatePaymentMutation,
    CreatePaymentMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<CreatePaymentMutation, CreatePaymentMutationVariables>(
    CreatePaymentDocument,
    options
  );
}
export type CreatePaymentMutationHookResult = ReturnType<typeof useCreatePaymentMutation>;
export type CreatePaymentMutationResult = Apollo.MutationResult<CreatePaymentMutation>;
export type CreatePaymentMutationOptions = Apollo.BaseMutationOptions<
  CreatePaymentMutation,
  CreatePaymentMutationVariables
>;
export const CapturePaymentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CapturePayment'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CapturePaymentInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'capturePayment'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Payment'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'subscriptionId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'authorizationCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'descriptor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationReason'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shop'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'nextAction'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'redirectUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mustRedirect'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCapturePaymentMutation__
 *
 * To run a mutation, you first call `useCapturePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCapturePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [capturePaymentMutation, { data, loading, error }] = useCapturePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCapturePaymentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CapturePaymentMutation,
    CapturePaymentMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<CapturePaymentMutation, CapturePaymentMutationVariables>(
    CapturePaymentDocument,
    options
  );
}
export type CapturePaymentMutationHookResult = ReturnType<typeof useCapturePaymentMutation>;
export type CapturePaymentMutationResult = Apollo.MutationResult<CapturePaymentMutation>;
export type CapturePaymentMutationOptions = Apollo.BaseMutationOptions<
  CapturePaymentMutation,
  CapturePaymentMutationVariables
>;
export const CancelPaymentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CancelPayment'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CancelPaymentInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cancelPayment'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Payment'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'subscriptionId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'authorizationCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'descriptor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationReason'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shop'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'nextAction'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'redirectUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mustRedirect'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCancelPaymentMutation__
 *
 * To run a mutation, you first call `useCancelPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPaymentMutation, { data, loading, error }] = useCancelPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelPaymentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CancelPaymentMutation,
    CancelPaymentMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<CancelPaymentMutation, CancelPaymentMutationVariables>(
    CancelPaymentDocument,
    options
  );
}
export type CancelPaymentMutationHookResult = ReturnType<typeof useCancelPaymentMutation>;
export type CancelPaymentMutationResult = Apollo.MutationResult<CancelPaymentMutation>;
export type CancelPaymentMutationOptions = Apollo.BaseMutationOptions<
  CancelPaymentMutation,
  CancelPaymentMutationVariables
>;
export const RefundPaymentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'RefundPayment'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'RefundPaymentInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'refundPayment'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Payment'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'subscriptionId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'authorizationCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'descriptor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationReason'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shop'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'nextAction'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'redirectUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mustRedirect'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useRefundPaymentMutation__
 *
 * To run a mutation, you first call `useRefundPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundPaymentMutation, { data, loading, error }] = useRefundPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefundPaymentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RefundPaymentMutation,
    RefundPaymentMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<RefundPaymentMutation, RefundPaymentMutationVariables>(
    RefundPaymentDocument,
    options
  );
}
export type RefundPaymentMutationHookResult = ReturnType<typeof useRefundPaymentMutation>;
export type RefundPaymentMutationResult = Apollo.MutationResult<RefundPaymentMutation>;
export type RefundPaymentMutationOptions = Apollo.BaseMutationOptions<
  RefundPaymentMutation,
  RefundPaymentMutationVariables
>;
export const SendPaymentReceiptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SendPaymentReceipt'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'SendPaymentMessageInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sendPaymentReceipt'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Payment'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'subscriptionId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'authorizationCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'descriptor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationReason'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shop'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'nextAction'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'redirectUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mustRedirect'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useSendPaymentReceiptMutation__
 *
 * To run a mutation, you first call `useSendPaymentReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPaymentReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPaymentReceiptMutation, { data, loading, error }] = useSendPaymentReceiptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPaymentReceiptMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendPaymentReceiptMutation,
    SendPaymentReceiptMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    SendPaymentReceiptMutation,
    SendPaymentReceiptMutationVariables
  >(SendPaymentReceiptDocument, options);
}
export type SendPaymentReceiptMutationHookResult = ReturnType<typeof useSendPaymentReceiptMutation>;
export type SendPaymentReceiptMutationResult = Apollo.MutationResult<SendPaymentReceiptMutation>;
export type SendPaymentReceiptMutationOptions = Apollo.BaseMutationOptions<
  SendPaymentReceiptMutation,
  SendPaymentReceiptMutationVariables
>;
export const DeleteDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DeleteDocument'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteDocument'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteDocumentMutation,
    DeleteDocumentMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(
    DeleteDocumentDocument,
    options
  );
}
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<
  DeleteDocumentMutation,
  DeleteDocumentMutationVariables
>;
export const DownloadDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DownloadDocument'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'downloadDocument'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'downloadUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiresAt'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDownloadDocumentMutation__
 *
 * To run a mutation, you first call `useDownloadDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadDocumentMutation, { data, loading, error }] = useDownloadDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDownloadDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadDocumentMutation,
    DownloadDocumentMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<DownloadDocumentMutation, DownloadDocumentMutationVariables>(
    DownloadDocumentDocument,
    options
  );
}
export type DownloadDocumentMutationHookResult = ReturnType<typeof useDownloadDocumentMutation>;
export type DownloadDocumentMutationResult = Apollo.MutationResult<DownloadDocumentMutation>;
export type DownloadDocumentMutationOptions = Apollo.BaseMutationOptions<
  DownloadDocumentMutation,
  DownloadDocumentMutationVariables
>;
export const UpdateDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateDocument'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UpdateDocumentInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateDocument'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'DocumentFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DocumentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Document'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'contentType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'internal'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateDocumentMutation,
    UpdateDocumentMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>(
    UpdateDocumentDocument,
    options
  );
}
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>;
export type UpdateDocumentMutationResult = Apollo.MutationResult<UpdateDocumentMutation>;
export type UpdateDocumentMutationOptions = Apollo.BaseMutationOptions<
  UpdateDocumentMutation,
  UpdateDocumentMutationVariables
>;
export const UploadDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UploadDocument'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'contentType'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'uploadDocument'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'contentType'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'contentType'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'uploadUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiresAt'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUploadDocumentMutation__
 *
 * To run a mutation, you first call `useUploadDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentMutation, { data, loading, error }] = useUploadDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contentType: // value for 'contentType'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useUploadDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UploadDocumentMutation,
    UploadDocumentMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<UploadDocumentMutation, UploadDocumentMutationVariables>(
    UploadDocumentDocument,
    options
  );
}
export type UploadDocumentMutationHookResult = ReturnType<typeof useUploadDocumentMutation>;
export type UploadDocumentMutationResult = Apollo.MutationResult<UploadDocumentMutation>;
export type UploadDocumentMutationOptions = Apollo.BaseMutationOptions<
  UploadDocumentMutation,
  UploadDocumentMutationVariables
>;
export const CreateDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreateDocument'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CreateDocumentInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createDocument'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'DocumentFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DocumentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Document'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'contentType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'internal'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateDocumentMutation,
    CreateDocumentMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(
    CreateDocumentDocument,
    options
  );
}
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = Apollo.MutationResult<CreateDocumentMutation>;
export type CreateDocumentMutationOptions = Apollo.BaseMutationOptions<
  CreateDocumentMutation,
  CreateDocumentMutationVariables
>;
export const CancelSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CancelSubscription'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CancelSubscriptionInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cancelSubscription'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SubscriptionFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContactFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ContactDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'company'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SubscriptionFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Subscription'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'planVariantId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'productId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancelAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'skipIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodStart'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodDays'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customerId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTokenId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastInvoiceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lastPayment'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nextPaymentAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'interval'}},
          {kind: 'Field', name: {kind: 'Name', value: 'intervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'retryCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'callbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'allowedPaymentMethods'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CancelSubscriptionMutation,
    CancelSubscriptionMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    CancelSubscriptionMutation,
    CancelSubscriptionMutationVariables
  >(CancelSubscriptionDocument, options);
}
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  CancelSubscriptionMutation,
  CancelSubscriptionMutationVariables
>;
export const PauseSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'PauseSubscription'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'PauseSubscriptionInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pauseSubscription'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SubscriptionFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContactFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ContactDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'company'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SubscriptionFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Subscription'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'planVariantId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'productId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancelAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'skipIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodStart'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodDays'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customerId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTokenId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastInvoiceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lastPayment'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nextPaymentAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'interval'}},
          {kind: 'Field', name: {kind: 'Name', value: 'intervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'retryCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'callbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'allowedPaymentMethods'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __usePauseSubscriptionMutation__
 *
 * To run a mutation, you first call `usePauseSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseSubscriptionMutation, { data, loading, error }] = usePauseSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePauseSubscriptionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    PauseSubscriptionMutation,
    PauseSubscriptionMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    PauseSubscriptionMutation,
    PauseSubscriptionMutationVariables
  >(PauseSubscriptionDocument, options);
}
export type PauseSubscriptionMutationHookResult = ReturnType<typeof usePauseSubscriptionMutation>;
export type PauseSubscriptionMutationResult = Apollo.MutationResult<PauseSubscriptionMutation>;
export type PauseSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  PauseSubscriptionMutation,
  PauseSubscriptionMutationVariables
>;
export const ResumeSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ResumeSubscription'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ResumeSubscriptionInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'resumeSubscription'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SubscriptionFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContactFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ContactDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'company'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SubscriptionFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Subscription'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'planVariantId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'productId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancelAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'skipIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodStart'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodDays'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customerId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTokenId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastInvoiceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lastPayment'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nextPaymentAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'interval'}},
          {kind: 'Field', name: {kind: 'Name', value: 'intervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'retryCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'callbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'allowedPaymentMethods'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useResumeSubscriptionMutation__
 *
 * To run a mutation, you first call `useResumeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeSubscriptionMutation, { data, loading, error }] = useResumeSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResumeSubscriptionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ResumeSubscriptionMutation,
    ResumeSubscriptionMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    ResumeSubscriptionMutation,
    ResumeSubscriptionMutationVariables
  >(ResumeSubscriptionDocument, options);
}
export type ResumeSubscriptionMutationHookResult = ReturnType<typeof useResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationResult = Apollo.MutationResult<ResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  ResumeSubscriptionMutation,
  ResumeSubscriptionMutationVariables
>;
export const UpdateSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateSubscription'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UpdateSubscriptionInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateSubscription'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SubscriptionFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContactFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ContactDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'company'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SubscriptionFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Subscription'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'planVariantId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'productId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancelAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'skipIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodStart'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodDays'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customerId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTokenId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastInvoiceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lastPayment'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nextPaymentAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'interval'}},
          {kind: 'Field', name: {kind: 'Name', value: 'intervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'retryCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'callbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'allowedPaymentMethods'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateSubscriptionMutation,
    UpdateSubscriptionMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    UpdateSubscriptionMutation,
    UpdateSubscriptionMutationVariables
  >(UpdateSubscriptionDocument, options);
}
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  UpdateSubscriptionMutation,
  UpdateSubscriptionMutationVariables
>;
export const ActivateSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ActivateSubscription'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ActivateSubscriptionInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'activateSubscription'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Payment'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'subscriptionId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'authorizationCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'descriptor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationReason'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shop'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'nextAction'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'redirectUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mustRedirect'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useActivateSubscriptionMutation__
 *
 * To run a mutation, you first call `useActivateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateSubscriptionMutation, { data, loading, error }] = useActivateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateSubscriptionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ActivateSubscriptionMutation,
    ActivateSubscriptionMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    ActivateSubscriptionMutation,
    ActivateSubscriptionMutationVariables
  >(ActivateSubscriptionDocument, options);
}
export type ActivateSubscriptionMutationHookResult = ReturnType<
  typeof useActivateSubscriptionMutation
>;
export type ActivateSubscriptionMutationResult =
  Apollo.MutationResult<ActivateSubscriptionMutation>;
export type ActivateSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  ActivateSubscriptionMutation,
  ActivateSubscriptionMutationVariables
>;
export const CreateSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreateSubscription'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CreateSubscriptionInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createSubscription'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SubscriptionFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContactFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ContactDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'company'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SubscriptionFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Subscription'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'planVariantId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'productId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancelAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'skipIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodStart'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodDays'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customerId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTokenId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastInvoiceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lastPayment'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nextPaymentAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'interval'}},
          {kind: 'Field', name: {kind: 'Name', value: 'intervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'retryCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'callbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'allowedPaymentMethods'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateSubscriptionMutation,
    CreateSubscriptionMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    CreateSubscriptionMutation,
    CreateSubscriptionMutationVariables
  >(CreateSubscriptionDocument, options);
}
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  CreateSubscriptionMutation,
  CreateSubscriptionMutationVariables
>;
export const SendSubscriptionLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SendSubscriptionLink'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'SendSubscriptionMessageInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sendSubscriptionLink'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SubscriptionFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContactFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ContactDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'company'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SubscriptionFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Subscription'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'planVariantId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'productId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancelAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'skipIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodStart'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodDays'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customerId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTokenId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastInvoiceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lastPayment'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nextPaymentAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'interval'}},
          {kind: 'Field', name: {kind: 'Name', value: 'intervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'retryCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'callbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'allowedPaymentMethods'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useSendSubscriptionLinkMutation__
 *
 * To run a mutation, you first call `useSendSubscriptionLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSubscriptionLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSubscriptionLinkMutation, { data, loading, error }] = useSendSubscriptionLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSubscriptionLinkMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendSubscriptionLinkMutation,
    SendSubscriptionLinkMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    SendSubscriptionLinkMutation,
    SendSubscriptionLinkMutationVariables
  >(SendSubscriptionLinkDocument, options);
}
export type SendSubscriptionLinkMutationHookResult = ReturnType<
  typeof useSendSubscriptionLinkMutation
>;
export type SendSubscriptionLinkMutationResult =
  Apollo.MutationResult<SendSubscriptionLinkMutation>;
export type SendSubscriptionLinkMutationOptions = Apollo.BaseMutationOptions<
  SendSubscriptionLinkMutation,
  SendSubscriptionLinkMutationVariables
>;
export const SendSubscriptionStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SendSubscriptionStatus'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'SendSubscriptionMessageInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sendSubscriptionStatus'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SubscriptionFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContactFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ContactDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'company'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SubscriptionFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Subscription'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'planVariantId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'productId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancelAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'skipIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodStart'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodDays'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customerId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTokenId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastInvoiceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lastPayment'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nextPaymentAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'interval'}},
          {kind: 'Field', name: {kind: 'Name', value: 'intervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'retryCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'callbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'allowedPaymentMethods'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useSendSubscriptionStatusMutation__
 *
 * To run a mutation, you first call `useSendSubscriptionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSubscriptionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSubscriptionStatusMutation, { data, loading, error }] = useSendSubscriptionStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSubscriptionStatusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendSubscriptionStatusMutation,
    SendSubscriptionStatusMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    SendSubscriptionStatusMutation,
    SendSubscriptionStatusMutationVariables
  >(SendSubscriptionStatusDocument, options);
}
export type SendSubscriptionStatusMutationHookResult = ReturnType<
  typeof useSendSubscriptionStatusMutation
>;
export type SendSubscriptionStatusMutationResult =
  Apollo.MutationResult<SendSubscriptionStatusMutation>;
export type SendSubscriptionStatusMutationOptions = Apollo.BaseMutationOptions<
  SendSubscriptionStatusMutation,
  SendSubscriptionStatusMutationVariables
>;
export const StartCompanyLookupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'StartCompanyLookup'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'documentNumber'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'startCompanyLookup'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'documentNumber'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'documentNumber'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Account'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowRefunds'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'language'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'progressiveBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contactPerson'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingEmail'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailOnAccountInvoice'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProcessing'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankTransferConceptPrefix'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleToStores'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sepblacId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingVatPercent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churned'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'previewFeatures'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountInvoicePaymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customAccountInvoiceNotes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'groupInvoicesByStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useStartCompanyLookupMutation__
 *
 * To run a mutation, you first call `useStartCompanyLookupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCompanyLookupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCompanyLookupMutation, { data, loading, error }] = useStartCompanyLookupMutation({
 *   variables: {
 *      documentNumber: // value for 'documentNumber'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useStartCompanyLookupMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    StartCompanyLookupMutation,
    StartCompanyLookupMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    StartCompanyLookupMutation,
    StartCompanyLookupMutationVariables
  >(StartCompanyLookupDocument, options);
}
export type StartCompanyLookupMutationHookResult = ReturnType<typeof useStartCompanyLookupMutation>;
export type StartCompanyLookupMutationResult = Apollo.MutationResult<StartCompanyLookupMutation>;
export type StartCompanyLookupMutationOptions = Apollo.BaseMutationOptions<
  StartCompanyLookupMutation,
  StartCompanyLookupMutationVariables
>;
export const CreatePibisiUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreatePibisiUser'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'CreatePibisiUserInput'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createPibisiUser'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Account'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowRefunds'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'language'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'progressiveBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contactPerson'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingEmail'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailOnAccountInvoice'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProcessing'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankTransferConceptPrefix'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleToStores'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sepblacId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingVatPercent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churned'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'previewFeatures'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountInvoicePaymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customAccountInvoiceNotes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'groupInvoicesByStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCreatePibisiUserMutation__
 *
 * To run a mutation, you first call `useCreatePibisiUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePibisiUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPibisiUserMutation, { data, loading, error }] = useCreatePibisiUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePibisiUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreatePibisiUserMutation,
    CreatePibisiUserMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<CreatePibisiUserMutation, CreatePibisiUserMutationVariables>(
    CreatePibisiUserDocument,
    options
  );
}
export type CreatePibisiUserMutationHookResult = ReturnType<typeof useCreatePibisiUserMutation>;
export type CreatePibisiUserMutationResult = Apollo.MutationResult<CreatePibisiUserMutation>;
export type CreatePibisiUserMutationOptions = Apollo.BaseMutationOptions<
  CreatePibisiUserMutation,
  CreatePibisiUserMutationVariables
>;
export const RegisterMoneiXpMerchantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'RegisterMoneiXPMerchant'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethods'}},
          type: {
            kind: 'ListType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethods'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'registerMoneiXPMerchant'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'paymentMethods'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethods'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useRegisterMoneiXpMerchantMutation__
 *
 * To run a mutation, you first call `useRegisterMoneiXpMerchantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMoneiXpMerchantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMoneiXpMerchantMutation, { data, loading, error }] = useRegisterMoneiXpMerchantMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      paymentMethods: // value for 'paymentMethods'
 *   },
 * });
 */
export function useRegisterMoneiXpMerchantMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RegisterMoneiXpMerchantMutation,
    RegisterMoneiXpMerchantMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    RegisterMoneiXpMerchantMutation,
    RegisterMoneiXpMerchantMutationVariables
  >(RegisterMoneiXpMerchantDocument, options);
}
export type RegisterMoneiXpMerchantMutationHookResult = ReturnType<
  typeof useRegisterMoneiXpMerchantMutation
>;
export type RegisterMoneiXpMerchantMutationResult =
  Apollo.MutationResult<RegisterMoneiXpMerchantMutation>;
export type RegisterMoneiXpMerchantMutationOptions = Apollo.BaseMutationOptions<
  RegisterMoneiXpMerchantMutation,
  RegisterMoneiXpMerchantMutationVariables
>;
export const ResolvePibisiAlertDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ResolvePibisiAlert'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ResolvePibisiAlertInput'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'resolvePibisiAlert'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useResolvePibisiAlertMutation__
 *
 * To run a mutation, you first call `useResolvePibisiAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolvePibisiAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolvePibisiAlertMutation, { data, loading, error }] = useResolvePibisiAlertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolvePibisiAlertMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ResolvePibisiAlertMutation,
    ResolvePibisiAlertMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    ResolvePibisiAlertMutation,
    ResolvePibisiAlertMutationVariables
  >(ResolvePibisiAlertDocument, options);
}
export type ResolvePibisiAlertMutationHookResult = ReturnType<typeof useResolvePibisiAlertMutation>;
export type ResolvePibisiAlertMutationResult = Apollo.MutationResult<ResolvePibisiAlertMutation>;
export type ResolvePibisiAlertMutationOptions = Apollo.BaseMutationOptions<
  ResolvePibisiAlertMutation,
  ResolvePibisiAlertMutationVariables
>;
export const ResolvePibisiMatchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ResolvePibisiMatch'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ResolvePibisiMatchInput'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'resolvePibisiMatch'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useResolvePibisiMatchMutation__
 *
 * To run a mutation, you first call `useResolvePibisiMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolvePibisiMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolvePibisiMatchMutation, { data, loading, error }] = useResolvePibisiMatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolvePibisiMatchMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ResolvePibisiMatchMutation,
    ResolvePibisiMatchMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    ResolvePibisiMatchMutation,
    ResolvePibisiMatchMutationVariables
  >(ResolvePibisiMatchDocument, options);
}
export type ResolvePibisiMatchMutationHookResult = ReturnType<typeof useResolvePibisiMatchMutation>;
export type ResolvePibisiMatchMutationResult = Apollo.MutationResult<ResolvePibisiMatchMutation>;
export type ResolvePibisiMatchMutationOptions = Apollo.BaseMutationOptions<
  ResolvePibisiMatchMutation,
  ResolvePibisiMatchMutationVariables
>;
export const UpdateAccountInvoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateAccountInvoice'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UpdateAccountInvoiceInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateAccountInvoice'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountInvoiceFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountInvoiceFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AccountInvoice'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'number'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'period'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'from'}},
                {kind: 'Field', name: {kind: 'Name', value: 'to'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tax'}},
          {kind: 'Field', name: {kind: 'Name', value: 'totalAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'unitAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'unitType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'amount'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'iban'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethod'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdateAccountInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateAccountInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountInvoiceMutation, { data, loading, error }] = useUpdateAccountInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountInvoiceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateAccountInvoiceMutation,
    UpdateAccountInvoiceMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    UpdateAccountInvoiceMutation,
    UpdateAccountInvoiceMutationVariables
  >(UpdateAccountInvoiceDocument, options);
}
export type UpdateAccountInvoiceMutationHookResult = ReturnType<
  typeof useUpdateAccountInvoiceMutation
>;
export type UpdateAccountInvoiceMutationResult =
  Apollo.MutationResult<UpdateAccountInvoiceMutation>;
export type UpdateAccountInvoiceMutationOptions = Apollo.BaseMutationOptions<
  UpdateAccountInvoiceMutation,
  UpdateAccountInvoiceMutationVariables
>;
export const CalculateRiskScoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CalculateRiskScore'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CalculateRiskScoreInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'calculateRiskScore'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Account'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowRefunds'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'language'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'progressiveBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contactPerson'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingEmail'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailOnAccountInvoice'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProcessing'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankTransferConceptPrefix'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleToStores'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sepblacId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingVatPercent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churned'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'previewFeatures'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountInvoicePaymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customAccountInvoiceNotes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'groupInvoicesByStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCalculateRiskScoreMutation__
 *
 * To run a mutation, you first call `useCalculateRiskScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateRiskScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateRiskScoreMutation, { data, loading, error }] = useCalculateRiskScoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateRiskScoreMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CalculateRiskScoreMutation,
    CalculateRiskScoreMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    CalculateRiskScoreMutation,
    CalculateRiskScoreMutationVariables
  >(CalculateRiskScoreDocument, options);
}
export type CalculateRiskScoreMutationHookResult = ReturnType<typeof useCalculateRiskScoreMutation>;
export type CalculateRiskScoreMutationResult = Apollo.MutationResult<CalculateRiskScoreMutation>;
export type CalculateRiskScoreMutationOptions = Apollo.BaseMutationOptions<
  CalculateRiskScoreMutation,
  CalculateRiskScoreMutationVariables
>;
export const DeleteWebhookDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DeleteWebhook'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteWebhook'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDeleteWebhookMutation__
 *
 * To run a mutation, you first call `useDeleteWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebhookMutation, { data, loading, error }] = useDeleteWebhookMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteWebhookMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteWebhookMutation,
    DeleteWebhookMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<DeleteWebhookMutation, DeleteWebhookMutationVariables>(
    DeleteWebhookDocument,
    options
  );
}
export type DeleteWebhookMutationHookResult = ReturnType<typeof useDeleteWebhookMutation>;
export type DeleteWebhookMutationResult = Apollo.MutationResult<DeleteWebhookMutation>;
export type DeleteWebhookMutationOptions = Apollo.BaseMutationOptions<
  DeleteWebhookMutation,
  DeleteWebhookMutationVariables
>;
export const CreateWebhookDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreateWebhook'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CreateWebhookInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createWebhook'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'WebhookFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'WebhookFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Webhook'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'url'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventTypes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCreateWebhookMutation__
 *
 * To run a mutation, you first call `useCreateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebhookMutation, { data, loading, error }] = useCreateWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebhookMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateWebhookMutation,
    CreateWebhookMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<CreateWebhookMutation, CreateWebhookMutationVariables>(
    CreateWebhookDocument,
    options
  );
}
export type CreateWebhookMutationHookResult = ReturnType<typeof useCreateWebhookMutation>;
export type CreateWebhookMutationResult = Apollo.MutationResult<CreateWebhookMutation>;
export type CreateWebhookMutationOptions = Apollo.BaseMutationOptions<
  CreateWebhookMutation,
  CreateWebhookMutationVariables
>;
export const UpdateWebhookDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateWebhook'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UpdateWebhookInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateWebhook'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'WebhookFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'WebhookFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Webhook'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'url'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventTypes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdateWebhookMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookMutation, { data, loading, error }] = useUpdateWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebhookMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateWebhookMutation,
    UpdateWebhookMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<UpdateWebhookMutation, UpdateWebhookMutationVariables>(
    UpdateWebhookDocument,
    options
  );
}
export type UpdateWebhookMutationHookResult = ReturnType<typeof useUpdateWebhookMutation>;
export type UpdateWebhookMutationResult = Apollo.MutationResult<UpdateWebhookMutation>;
export type UpdateWebhookMutationOptions = Apollo.BaseMutationOptions<
  UpdateWebhookMutation,
  UpdateWebhookMutationVariables
>;
export const StartExportChargesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'StartExportCharges'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'SearchableChargeFilterInput'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'columns'}},
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'timezone'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'startExportCharges'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'columns'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'columns'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'timezone'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'timezone'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'ChargesExportFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ChargesExportFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ChargesExport'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'expireAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useStartExportChargesMutation__
 *
 * To run a mutation, you first call `useStartExportChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartExportChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startExportChargesMutation, { data, loading, error }] = useStartExportChargesMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      columns: // value for 'columns'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useStartExportChargesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    StartExportChargesMutation,
    StartExportChargesMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    StartExportChargesMutation,
    StartExportChargesMutationVariables
  >(StartExportChargesDocument, options);
}
export type StartExportChargesMutationHookResult = ReturnType<typeof useStartExportChargesMutation>;
export type StartExportChargesMutationResult = Apollo.MutationResult<StartExportChargesMutation>;
export type StartExportChargesMutationOptions = Apollo.BaseMutationOptions<
  StartExportChargesMutation,
  StartExportChargesMutationVariables
>;
export const DownloadExportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DownloadExport'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'downloadExport'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'downloadUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiresAt'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDownloadExportMutation__
 *
 * To run a mutation, you first call `useDownloadExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadExportMutation, { data, loading, error }] = useDownloadExportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadExportMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadExportMutation,
    DownloadExportMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<DownloadExportMutation, DownloadExportMutationVariables>(
    DownloadExportDocument,
    options
  );
}
export type DownloadExportMutationHookResult = ReturnType<typeof useDownloadExportMutation>;
export type DownloadExportMutationResult = Apollo.MutationResult<DownloadExportMutation>;
export type DownloadExportMutationOptions = Apollo.BaseMutationOptions<
  DownloadExportMutation,
  DownloadExportMutationVariables
>;
export const DownloadOperationsFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DownloadOperationsFile'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'settlementId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'downloadOperationsFile'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'settlementId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'settlementId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'downloadUrl'}}]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDownloadOperationsFileMutation__
 *
 * To run a mutation, you first call `useDownloadOperationsFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadOperationsFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadOperationsFileMutation, { data, loading, error }] = useDownloadOperationsFileMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      settlementId: // value for 'settlementId'
 *   },
 * });
 */
export function useDownloadOperationsFileMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadOperationsFileMutation,
    DownloadOperationsFileMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    DownloadOperationsFileMutation,
    DownloadOperationsFileMutationVariables
  >(DownloadOperationsFileDocument, options);
}
export type DownloadOperationsFileMutationHookResult = ReturnType<
  typeof useDownloadOperationsFileMutation
>;
export type DownloadOperationsFileMutationResult =
  Apollo.MutationResult<DownloadOperationsFileMutation>;
export type DownloadOperationsFileMutationOptions = Apollo.BaseMutationOptions<
  DownloadOperationsFileMutation,
  DownloadOperationsFileMutationVariables
>;
export const DownloadAccountInvoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DownloadAccountInvoice'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'invoiceId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'downloadAccountInvoice'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'invoiceId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'invoiceId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'downloadUrl'}}]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDownloadAccountInvoiceMutation__
 *
 * To run a mutation, you first call `useDownloadAccountInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAccountInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAccountInvoiceMutation, { data, loading, error }] = useDownloadAccountInvoiceMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useDownloadAccountInvoiceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadAccountInvoiceMutation,
    DownloadAccountInvoiceMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    DownloadAccountInvoiceMutation,
    DownloadAccountInvoiceMutationVariables
  >(DownloadAccountInvoiceDocument, options);
}
export type DownloadAccountInvoiceMutationHookResult = ReturnType<
  typeof useDownloadAccountInvoiceMutation
>;
export type DownloadAccountInvoiceMutationResult =
  Apollo.MutationResult<DownloadAccountInvoiceMutation>;
export type DownloadAccountInvoiceMutationOptions = Apollo.BaseMutationOptions<
  DownloadAccountInvoiceMutation,
  DownloadAccountInvoiceMutationVariables
>;
export const CreateStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreateStore'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CreateStoreInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createStore'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'StoreFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'StoreFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Store'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
          {kind: 'Field', name: {kind: 'Name', value: 'website'}},
          {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCreateStoreMutation__
 *
 * To run a mutation, you first call `useCreateStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStoreMutation, { data, loading, error }] = useCreateStoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStoreMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateStoreMutation,
    CreateStoreMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<CreateStoreMutation, CreateStoreMutationVariables>(
    CreateStoreDocument,
    options
  );
}
export type CreateStoreMutationHookResult = ReturnType<typeof useCreateStoreMutation>;
export type CreateStoreMutationResult = Apollo.MutationResult<CreateStoreMutation>;
export type CreateStoreMutationOptions = Apollo.BaseMutationOptions<
  CreateStoreMutation,
  CreateStoreMutationVariables
>;
export const UpdateStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateStore'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UpdateStoreInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateStore'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'StoreFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'StoreFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Store'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
          {kind: 'Field', name: {kind: 'Name', value: 'website'}},
          {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdateStoreMutation__
 *
 * To run a mutation, you first call `useUpdateStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStoreMutation, { data, loading, error }] = useUpdateStoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStoreMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateStoreMutation,
    UpdateStoreMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<UpdateStoreMutation, UpdateStoreMutationVariables>(
    UpdateStoreDocument,
    options
  );
}
export type UpdateStoreMutationHookResult = ReturnType<typeof useUpdateStoreMutation>;
export type UpdateStoreMutationResult = Apollo.MutationResult<UpdateStoreMutation>;
export type UpdateStoreMutationOptions = Apollo.BaseMutationOptions<
  UpdateStoreMutation,
  UpdateStoreMutationVariables
>;
export const DeleteStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DeleteStore'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteStore'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDeleteStoreMutation__
 *
 * To run a mutation, you first call `useDeleteStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStoreMutation, { data, loading, error }] = useDeleteStoreMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteStoreMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteStoreMutation,
    DeleteStoreMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<DeleteStoreMutation, DeleteStoreMutationVariables>(
    DeleteStoreDocument,
    options
  );
}
export type DeleteStoreMutationHookResult = ReturnType<typeof useDeleteStoreMutation>;
export type DeleteStoreMutationResult = Apollo.MutationResult<DeleteStoreMutation>;
export type DeleteStoreMutationOptions = Apollo.BaseMutationOptions<
  DeleteStoreMutation,
  DeleteStoreMutationVariables
>;
export const UpdateWebKeywordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateWebKeyword'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UpdateWebKeywordInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateWebKeyword'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'incorrect'}}]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdateWebKeywordMutation__
 *
 * To run a mutation, you first call `useUpdateWebKeywordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebKeywordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebKeywordMutation, { data, loading, error }] = useUpdateWebKeywordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebKeywordMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateWebKeywordMutation,
    UpdateWebKeywordMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<UpdateWebKeywordMutation, UpdateWebKeywordMutationVariables>(
    UpdateWebKeywordDocument,
    options
  );
}
export type UpdateWebKeywordMutationHookResult = ReturnType<typeof useUpdateWebKeywordMutation>;
export type UpdateWebKeywordMutationResult = Apollo.MutationResult<UpdateWebKeywordMutation>;
export type UpdateWebKeywordMutationOptions = Apollo.BaseMutationOptions<
  UpdateWebKeywordMutation,
  UpdateWebKeywordMutationVariables
>;
export const ConnectMasterAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConnectMasterAccount'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'promoCode'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'externalId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'externalHash'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'connectMasterAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'promoCode'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'promoCode'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'externalId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'externalId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'externalHash'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'externalHash'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Account'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowRefunds'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'language'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'progressiveBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contactPerson'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingEmail'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailOnAccountInvoice'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProcessing'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankTransferConceptPrefix'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleToStores'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sepblacId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingVatPercent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churned'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'previewFeatures'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountInvoicePaymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customAccountInvoiceNotes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'groupInvoicesByStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useConnectMasterAccountMutation__
 *
 * To run a mutation, you first call `useConnectMasterAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectMasterAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectMasterAccountMutation, { data, loading, error }] = useConnectMasterAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      promoCode: // value for 'promoCode'
 *      externalId: // value for 'externalId'
 *      externalHash: // value for 'externalHash'
 *   },
 * });
 */
export function useConnectMasterAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ConnectMasterAccountMutation,
    ConnectMasterAccountMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    ConnectMasterAccountMutation,
    ConnectMasterAccountMutationVariables
  >(ConnectMasterAccountDocument, options);
}
export type ConnectMasterAccountMutationHookResult = ReturnType<
  typeof useConnectMasterAccountMutation
>;
export type ConnectMasterAccountMutationResult =
  Apollo.MutationResult<ConnectMasterAccountMutation>;
export type ConnectMasterAccountMutationOptions = Apollo.BaseMutationOptions<
  ConnectMasterAccountMutation,
  ConnectMasterAccountMutationVariables
>;
export const DisconnectMasterAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DisconnectMasterAccount'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'disconnectMasterAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Account'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowRefunds'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'language'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'progressiveBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contactPerson'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingEmail'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailOnAccountInvoice'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProcessing'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankTransferConceptPrefix'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleToStores'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sepblacId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingVatPercent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churned'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'previewFeatures'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountInvoicePaymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customAccountInvoiceNotes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'groupInvoicesByStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDisconnectMasterAccountMutation__
 *
 * To run a mutation, you first call `useDisconnectMasterAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectMasterAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectMasterAccountMutation, { data, loading, error }] = useDisconnectMasterAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDisconnectMasterAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DisconnectMasterAccountMutation,
    DisconnectMasterAccountMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    DisconnectMasterAccountMutation,
    DisconnectMasterAccountMutationVariables
  >(DisconnectMasterAccountDocument, options);
}
export type DisconnectMasterAccountMutationHookResult = ReturnType<
  typeof useDisconnectMasterAccountMutation
>;
export type DisconnectMasterAccountMutationResult =
  Apollo.MutationResult<DisconnectMasterAccountMutation>;
export type DisconnectMasterAccountMutationOptions = Apollo.BaseMutationOptions<
  DisconnectMasterAccountMutation,
  DisconnectMasterAccountMutationVariables
>;
export const CreateMasterAccountApiKeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreateMasterAccountApiKey'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CreateMasterAccountApiKeyInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createMasterAccountApiKey'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'MasterAccountFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MasterAccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MasterAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedIPs'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'accountDefaults'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
                {kind: 'Field', name: {kind: 'Name', value: 'language'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fees'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'steps'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'extra'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'region'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'business'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'webhookEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnedEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedDomains'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireExternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'contractTemplateId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'autoApprove'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCreateMasterAccountApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateMasterAccountApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterAccountApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterAccountApiKeyMutation, { data, loading, error }] = useCreateMasterAccountApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMasterAccountApiKeyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateMasterAccountApiKeyMutation,
    CreateMasterAccountApiKeyMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    CreateMasterAccountApiKeyMutation,
    CreateMasterAccountApiKeyMutationVariables
  >(CreateMasterAccountApiKeyDocument, options);
}
export type CreateMasterAccountApiKeyMutationHookResult = ReturnType<
  typeof useCreateMasterAccountApiKeyMutation
>;
export type CreateMasterAccountApiKeyMutationResult =
  Apollo.MutationResult<CreateMasterAccountApiKeyMutation>;
export type CreateMasterAccountApiKeyMutationOptions = Apollo.BaseMutationOptions<
  CreateMasterAccountApiKeyMutation,
  CreateMasterAccountApiKeyMutationVariables
>;
export const DeleteMasterAccountApiKeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DeleteMasterAccountApiKey'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'DeleteMasterAccountApiKeyInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteMasterAccountApiKey'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'MasterAccountFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MasterAccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MasterAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedIPs'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'accountDefaults'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
                {kind: 'Field', name: {kind: 'Name', value: 'language'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fees'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'steps'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'extra'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'region'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'business'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'webhookEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnedEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedDomains'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireExternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'contractTemplateId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'autoApprove'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDeleteMasterAccountApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteMasterAccountApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMasterAccountApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMasterAccountApiKeyMutation, { data, loading, error }] = useDeleteMasterAccountApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMasterAccountApiKeyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteMasterAccountApiKeyMutation,
    DeleteMasterAccountApiKeyMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    DeleteMasterAccountApiKeyMutation,
    DeleteMasterAccountApiKeyMutationVariables
  >(DeleteMasterAccountApiKeyDocument, options);
}
export type DeleteMasterAccountApiKeyMutationHookResult = ReturnType<
  typeof useDeleteMasterAccountApiKeyMutation
>;
export type DeleteMasterAccountApiKeyMutationResult =
  Apollo.MutationResult<DeleteMasterAccountApiKeyMutation>;
export type DeleteMasterAccountApiKeyMutationOptions = Apollo.BaseMutationOptions<
  DeleteMasterAccountApiKeyMutation,
  DeleteMasterAccountApiKeyMutationVariables
>;
export const UpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateUser'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UserInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateUser'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'UserFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'UserFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'User'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'emailVerified'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phoneNumberVerified'}},
          {kind: 'Field', name: {kind: 'Name', value: 'smsMfaEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateUserMutation,
    UpdateUserMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(
    UpdateUserDocument,
    options
  );
}
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;
export const UpdateAffiliateTierDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateAffiliateTier'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UpdateAffiliateTierInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateAffiliateTier'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'meta_data'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'tier'}}]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdateAffiliateTierMutation__
 *
 * To run a mutation, you first call `useUpdateAffiliateTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAffiliateTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAffiliateTierMutation, { data, loading, error }] = useUpdateAffiliateTierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAffiliateTierMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateAffiliateTierMutation,
    UpdateAffiliateTierMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    UpdateAffiliateTierMutation,
    UpdateAffiliateTierMutationVariables
  >(UpdateAffiliateTierDocument, options);
}
export type UpdateAffiliateTierMutationHookResult = ReturnType<
  typeof useUpdateAffiliateTierMutation
>;
export type UpdateAffiliateTierMutationResult = Apollo.MutationResult<UpdateAffiliateTierMutation>;
export type UpdateAffiliateTierMutationOptions = Apollo.BaseMutationOptions<
  UpdateAffiliateTierMutation,
  UpdateAffiliateTierMutationVariables
>;
export const EnableAffiliateProcessingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'EnableAffiliateProcessing'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'affiliateId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'enableAffiliateProcessing'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'affiliateId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'affiliateId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'affiliate_group_id'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useEnableAffiliateProcessingMutation__
 *
 * To run a mutation, you first call `useEnableAffiliateProcessingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableAffiliateProcessingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableAffiliateProcessingMutation, { data, loading, error }] = useEnableAffiliateProcessingMutation({
 *   variables: {
 *      affiliateId: // value for 'affiliateId'
 *   },
 * });
 */
export function useEnableAffiliateProcessingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EnableAffiliateProcessingMutation,
    EnableAffiliateProcessingMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    EnableAffiliateProcessingMutation,
    EnableAffiliateProcessingMutationVariables
  >(EnableAffiliateProcessingDocument, options);
}
export type EnableAffiliateProcessingMutationHookResult = ReturnType<
  typeof useEnableAffiliateProcessingMutation
>;
export type EnableAffiliateProcessingMutationResult =
  Apollo.MutationResult<EnableAffiliateProcessingMutation>;
export type EnableAffiliateProcessingMutationOptions = Apollo.BaseMutationOptions<
  EnableAffiliateProcessingMutation,
  EnableAffiliateProcessingMutationVariables
>;
export const DisableAffiliateProcessingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DisableAffiliateProcessing'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'affiliateId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'disableAffiliateProcessing'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'affiliateId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'affiliateId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'affiliate_group_id'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDisableAffiliateProcessingMutation__
 *
 * To run a mutation, you first call `useDisableAffiliateProcessingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableAffiliateProcessingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableAffiliateProcessingMutation, { data, loading, error }] = useDisableAffiliateProcessingMutation({
 *   variables: {
 *      affiliateId: // value for 'affiliateId'
 *   },
 * });
 */
export function useDisableAffiliateProcessingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DisableAffiliateProcessingMutation,
    DisableAffiliateProcessingMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    DisableAffiliateProcessingMutation,
    DisableAffiliateProcessingMutationVariables
  >(DisableAffiliateProcessingDocument, options);
}
export type DisableAffiliateProcessingMutationHookResult = ReturnType<
  typeof useDisableAffiliateProcessingMutation
>;
export type DisableAffiliateProcessingMutationResult =
  Apollo.MutationResult<DisableAffiliateProcessingMutation>;
export type DisableAffiliateProcessingMutationOptions = Apollo.BaseMutationOptions<
  DisableAffiliateProcessingMutation,
  DisableAffiliateProcessingMutationVariables
>;
export const UpdateAffiliatePayoutMethodDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateAffiliatePayoutMethod'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {kind: 'Name', value: 'UpdateAffiliatePayoutMethodInput'}
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateAffiliatePayoutMethod'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'payout_methods'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PayoutMethodsFields'}}
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PayoutMethodsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AffiliatePayoutMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'title'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'details'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nif'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdateAffiliatePayoutMethodMutation__
 *
 * To run a mutation, you first call `useUpdateAffiliatePayoutMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAffiliatePayoutMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAffiliatePayoutMethodMutation, { data, loading, error }] = useUpdateAffiliatePayoutMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAffiliatePayoutMethodMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateAffiliatePayoutMethodMutation,
    UpdateAffiliatePayoutMethodMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    UpdateAffiliatePayoutMethodMutation,
    UpdateAffiliatePayoutMethodMutationVariables
  >(UpdateAffiliatePayoutMethodDocument, options);
}
export type UpdateAffiliatePayoutMethodMutationHookResult = ReturnType<
  typeof useUpdateAffiliatePayoutMethodMutation
>;
export type UpdateAffiliatePayoutMethodMutationResult =
  Apollo.MutationResult<UpdateAffiliatePayoutMethodMutation>;
export type UpdateAffiliatePayoutMethodMutationOptions = Apollo.BaseMutationOptions<
  UpdateAffiliatePayoutMethodMutation,
  UpdateAffiliatePayoutMethodMutationVariables
>;
export const RetrieveAffiliateHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'RetrieveAffiliateHistory'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'affiliateId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'email'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'retrieveAffiliateHistory'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'affiliateId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'affiliateId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'email'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'email'}}
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useRetrieveAffiliateHistoryMutation__
 *
 * To run a mutation, you first call `useRetrieveAffiliateHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAffiliateHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrieveAffiliateHistoryMutation, { data, loading, error }] = useRetrieveAffiliateHistoryMutation({
 *   variables: {
 *      affiliateId: // value for 'affiliateId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRetrieveAffiliateHistoryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RetrieveAffiliateHistoryMutation,
    RetrieveAffiliateHistoryMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    RetrieveAffiliateHistoryMutation,
    RetrieveAffiliateHistoryMutationVariables
  >(RetrieveAffiliateHistoryDocument, options);
}
export type RetrieveAffiliateHistoryMutationHookResult = ReturnType<
  typeof useRetrieveAffiliateHistoryMutation
>;
export type RetrieveAffiliateHistoryMutationResult =
  Apollo.MutationResult<RetrieveAffiliateHistoryMutation>;
export type RetrieveAffiliateHistoryMutationOptions = Apollo.BaseMutationOptions<
  RetrieveAffiliateHistoryMutation,
  RetrieveAffiliateHistoryMutationVariables
>;
export const DownloadAffiliateInvoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DownloadAffiliateInvoice'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'invoiceNumber'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'affiliateId'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'year'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'downloadAffiliateInvoice'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'invoiceNumber'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'invoiceNumber'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'affiliateId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'affiliateId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'year'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'year'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'downloadUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiresAt'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDownloadAffiliateInvoiceMutation__
 *
 * To run a mutation, you first call `useDownloadAffiliateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAffiliateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAffiliateInvoiceMutation, { data, loading, error }] = useDownloadAffiliateInvoiceMutation({
 *   variables: {
 *      invoiceNumber: // value for 'invoiceNumber'
 *      affiliateId: // value for 'affiliateId'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useDownloadAffiliateInvoiceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadAffiliateInvoiceMutation,
    DownloadAffiliateInvoiceMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    DownloadAffiliateInvoiceMutation,
    DownloadAffiliateInvoiceMutationVariables
  >(DownloadAffiliateInvoiceDocument, options);
}
export type DownloadAffiliateInvoiceMutationHookResult = ReturnType<
  typeof useDownloadAffiliateInvoiceMutation
>;
export type DownloadAffiliateInvoiceMutationResult =
  Apollo.MutationResult<DownloadAffiliateInvoiceMutation>;
export type DownloadAffiliateInvoiceMutationOptions = Apollo.BaseMutationOptions<
  DownloadAffiliateInvoiceMutation,
  DownloadAffiliateInvoiceMutationVariables
>;
export const AddBlacklistItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'AddBlacklistItem'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'BlacklistItemInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'addBlacklistItem'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'BlacklistItemFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'BlacklistItemFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'BlacklistItem'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'value'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAddBlacklistItemMutation__
 *
 * To run a mutation, you first call `useAddBlacklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBlacklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBlacklistItemMutation, { data, loading, error }] = useAddBlacklistItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBlacklistItemMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddBlacklistItemMutation,
    AddBlacklistItemMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<AddBlacklistItemMutation, AddBlacklistItemMutationVariables>(
    AddBlacklistItemDocument,
    options
  );
}
export type AddBlacklistItemMutationHookResult = ReturnType<typeof useAddBlacklistItemMutation>;
export type AddBlacklistItemMutationResult = Apollo.MutationResult<AddBlacklistItemMutation>;
export type AddBlacklistItemMutationOptions = Apollo.BaseMutationOptions<
  AddBlacklistItemMutation,
  AddBlacklistItemMutationVariables
>;
export const DeleteBlacklistItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DeleteBlacklistItem'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'value'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteBlacklistItem'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'value'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'value'}}
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDeleteBlacklistItemMutation__
 *
 * To run a mutation, you first call `useDeleteBlacklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBlacklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBlacklistItemMutation, { data, loading, error }] = useDeleteBlacklistItemMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useDeleteBlacklistItemMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteBlacklistItemMutation,
    DeleteBlacklistItemMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    DeleteBlacklistItemMutation,
    DeleteBlacklistItemMutationVariables
  >(DeleteBlacklistItemDocument, options);
}
export type DeleteBlacklistItemMutationHookResult = ReturnType<
  typeof useDeleteBlacklistItemMutation
>;
export type DeleteBlacklistItemMutationResult = Apollo.MutationResult<DeleteBlacklistItemMutation>;
export type DeleteBlacklistItemMutationOptions = Apollo.BaseMutationOptions<
  DeleteBlacklistItemMutation,
  DeleteBlacklistItemMutationVariables
>;
export const CreatePointOfSaleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreatePointOfSale'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CreatePointOfSaleInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createPointOfSale'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PointOfSaleFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PointOfSaleFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PointOfSale'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'number'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPaymentId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'manualAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'terminalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireTaxId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'includeQRCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'qrCodeText'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fixedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fixedCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'transactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pendingSetup'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentCallbackUrl'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCreatePointOfSaleMutation__
 *
 * To run a mutation, you first call `useCreatePointOfSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePointOfSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPointOfSaleMutation, { data, loading, error }] = useCreatePointOfSaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePointOfSaleMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreatePointOfSaleMutation,
    CreatePointOfSaleMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    CreatePointOfSaleMutation,
    CreatePointOfSaleMutationVariables
  >(CreatePointOfSaleDocument, options);
}
export type CreatePointOfSaleMutationHookResult = ReturnType<typeof useCreatePointOfSaleMutation>;
export type CreatePointOfSaleMutationResult = Apollo.MutationResult<CreatePointOfSaleMutation>;
export type CreatePointOfSaleMutationOptions = Apollo.BaseMutationOptions<
  CreatePointOfSaleMutation,
  CreatePointOfSaleMutationVariables
>;
export const UpdatePointOfSaleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdatePointOfSale'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UpdatePointOfSaleInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updatePointOfSale'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PointOfSaleFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PointOfSaleFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PointOfSale'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'number'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPaymentId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'manualAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'terminalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireTaxId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'includeQRCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'qrCodeText'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fixedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fixedCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'transactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pendingSetup'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentCallbackUrl'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdatePointOfSaleMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfSaleMutation, { data, loading, error }] = useUpdatePointOfSaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePointOfSaleMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdatePointOfSaleMutation,
    UpdatePointOfSaleMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    UpdatePointOfSaleMutation,
    UpdatePointOfSaleMutationVariables
  >(UpdatePointOfSaleDocument, options);
}
export type UpdatePointOfSaleMutationHookResult = ReturnType<typeof useUpdatePointOfSaleMutation>;
export type UpdatePointOfSaleMutationResult = Apollo.MutationResult<UpdatePointOfSaleMutation>;
export type UpdatePointOfSaleMutationOptions = Apollo.BaseMutationOptions<
  UpdatePointOfSaleMutation,
  UpdatePointOfSaleMutationVariables
>;
export const DeletePointOfSaleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DeletePointOfSale'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deletePointOfSale'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDeletePointOfSaleMutation__
 *
 * To run a mutation, you first call `useDeletePointOfSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePointOfSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePointOfSaleMutation, { data, loading, error }] = useDeletePointOfSaleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeletePointOfSaleMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeletePointOfSaleMutation,
    DeletePointOfSaleMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    DeletePointOfSaleMutation,
    DeletePointOfSaleMutationVariables
  >(DeletePointOfSaleDocument, options);
}
export type DeletePointOfSaleMutationHookResult = ReturnType<typeof useDeletePointOfSaleMutation>;
export type DeletePointOfSaleMutationResult = Apollo.MutationResult<DeletePointOfSaleMutation>;
export type DeletePointOfSaleMutationOptions = Apollo.BaseMutationOptions<
  DeletePointOfSaleMutation,
  DeletePointOfSaleMutationVariables
>;
export const GenerateOffersByAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'GenerateOffersByAccount'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'generateOffersByAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currencyISOCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fundedAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'loanAmount'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useGenerateOffersByAccountMutation__
 *
 * To run a mutation, you first call `useGenerateOffersByAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOffersByAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOffersByAccountMutation, { data, loading, error }] = useGenerateOffersByAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGenerateOffersByAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    GenerateOffersByAccountMutation,
    GenerateOffersByAccountMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    GenerateOffersByAccountMutation,
    GenerateOffersByAccountMutationVariables
  >(GenerateOffersByAccountDocument, options);
}
export type GenerateOffersByAccountMutationHookResult = ReturnType<
  typeof useGenerateOffersByAccountMutation
>;
export type GenerateOffersByAccountMutationResult =
  Apollo.MutationResult<GenerateOffersByAccountMutation>;
export type GenerateOffersByAccountMutationOptions = Apollo.BaseMutationOptions<
  GenerateOffersByAccountMutation,
  GenerateOffersByAccountMutationVariables
>;
export const CreateExportSftpConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreateExportSftpConfig'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CreateExportSftpConfigInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createExportSftpConfig'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SftpConfigExportFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SftpConfigExportFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SftpConfigExport'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'host'}},
          {kind: 'Field', name: {kind: 'Name', value: 'port'}},
          {kind: 'Field', name: {kind: 'Name', value: 'username'}},
          {kind: 'Field', name: {kind: 'Name', value: 'path'}},
          {kind: 'Field', name: {kind: 'Name', value: 'columns'}},
          {kind: 'Field', name: {kind: 'Name', value: 'timezone'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCreateExportSftpConfigMutation__
 *
 * To run a mutation, you first call `useCreateExportSftpConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExportSftpConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExportSftpConfigMutation, { data, loading, error }] = useCreateExportSftpConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExportSftpConfigMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateExportSftpConfigMutation,
    CreateExportSftpConfigMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    CreateExportSftpConfigMutation,
    CreateExportSftpConfigMutationVariables
  >(CreateExportSftpConfigDocument, options);
}
export type CreateExportSftpConfigMutationHookResult = ReturnType<
  typeof useCreateExportSftpConfigMutation
>;
export type CreateExportSftpConfigMutationResult =
  Apollo.MutationResult<CreateExportSftpConfigMutation>;
export type CreateExportSftpConfigMutationOptions = Apollo.BaseMutationOptions<
  CreateExportSftpConfigMutation,
  CreateExportSftpConfigMutationVariables
>;
export const UpdateExportSftpConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateExportSftpConfig'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UpdateExportSftpConfigInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateExportSftpConfig'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SftpConfigExportFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SftpConfigExportFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SftpConfigExport'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'host'}},
          {kind: 'Field', name: {kind: 'Name', value: 'port'}},
          {kind: 'Field', name: {kind: 'Name', value: 'username'}},
          {kind: 'Field', name: {kind: 'Name', value: 'path'}},
          {kind: 'Field', name: {kind: 'Name', value: 'columns'}},
          {kind: 'Field', name: {kind: 'Name', value: 'timezone'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdateExportSftpConfigMutation__
 *
 * To run a mutation, you first call `useUpdateExportSftpConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExportSftpConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExportSftpConfigMutation, { data, loading, error }] = useUpdateExportSftpConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExportSftpConfigMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateExportSftpConfigMutation,
    UpdateExportSftpConfigMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    UpdateExportSftpConfigMutation,
    UpdateExportSftpConfigMutationVariables
  >(UpdateExportSftpConfigDocument, options);
}
export type UpdateExportSftpConfigMutationHookResult = ReturnType<
  typeof useUpdateExportSftpConfigMutation
>;
export type UpdateExportSftpConfigMutationResult =
  Apollo.MutationResult<UpdateExportSftpConfigMutation>;
export type UpdateExportSftpConfigMutationOptions = Apollo.BaseMutationOptions<
  UpdateExportSftpConfigMutation,
  UpdateExportSftpConfigMutationVariables
>;
export const DeleteExportSftpConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DeleteExportSftpConfig'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteExportSftpConfig'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDeleteExportSftpConfigMutation__
 *
 * To run a mutation, you first call `useDeleteExportSftpConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExportSftpConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExportSftpConfigMutation, { data, loading, error }] = useDeleteExportSftpConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteExportSftpConfigMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteExportSftpConfigMutation,
    DeleteExportSftpConfigMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    DeleteExportSftpConfigMutation,
    DeleteExportSftpConfigMutationVariables
  >(DeleteExportSftpConfigDocument, options);
}
export type DeleteExportSftpConfigMutationHookResult = ReturnType<
  typeof useDeleteExportSftpConfigMutation
>;
export type DeleteExportSftpConfigMutationResult =
  Apollo.MutationResult<DeleteExportSftpConfigMutation>;
export type DeleteExportSftpConfigMutationOptions = Apollo.BaseMutationOptions<
  DeleteExportSftpConfigMutation,
  DeleteExportSftpConfigMutationVariables
>;
export const ActivateMasterAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ActivateMasterAccount'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'activateMasterAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'MasterAccountFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MasterAccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MasterAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedIPs'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'accountDefaults'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
                {kind: 'Field', name: {kind: 'Name', value: 'language'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fees'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'steps'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'extra'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'region'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'business'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'webhookEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnedEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedDomains'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireExternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'contractTemplateId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'autoApprove'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useActivateMasterAccountMutation__
 *
 * To run a mutation, you first call `useActivateMasterAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateMasterAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateMasterAccountMutation, { data, loading, error }] = useActivateMasterAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useActivateMasterAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ActivateMasterAccountMutation,
    ActivateMasterAccountMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    ActivateMasterAccountMutation,
    ActivateMasterAccountMutationVariables
  >(ActivateMasterAccountDocument, options);
}
export type ActivateMasterAccountMutationHookResult = ReturnType<
  typeof useActivateMasterAccountMutation
>;
export type ActivateMasterAccountMutationResult =
  Apollo.MutationResult<ActivateMasterAccountMutation>;
export type ActivateMasterAccountMutationOptions = Apollo.BaseMutationOptions<
  ActivateMasterAccountMutation,
  ActivateMasterAccountMutationVariables
>;
export const CreateCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreateCode'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CreateCodeInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createCode'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'CodeFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CodeFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Code'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCreateCodeMutation__
 *
 * To run a mutation, you first call `useCreateCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCodeMutation, { data, loading, error }] = useCreateCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCodeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateCodeMutation,
    CreateCodeMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<CreateCodeMutation, CreateCodeMutationVariables>(
    CreateCodeDocument,
    options
  );
}
export type CreateCodeMutationHookResult = ReturnType<typeof useCreateCodeMutation>;
export type CreateCodeMutationResult = Apollo.MutationResult<CreateCodeMutation>;
export type CreateCodeMutationOptions = Apollo.BaseMutationOptions<
  CreateCodeMutation,
  CreateCodeMutationVariables
>;
export const UpdateCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateCode'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UpdateCodeInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateCode'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'CodeFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CodeFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Code'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdateCodeMutation__
 *
 * To run a mutation, you first call `useUpdateCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCodeMutation, { data, loading, error }] = useUpdateCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCodeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateCodeMutation,
    UpdateCodeMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<UpdateCodeMutation, UpdateCodeMutationVariables>(
    UpdateCodeDocument,
    options
  );
}
export type UpdateCodeMutationHookResult = ReturnType<typeof useUpdateCodeMutation>;
export type UpdateCodeMutationResult = Apollo.MutationResult<UpdateCodeMutation>;
export type UpdateCodeMutationOptions = Apollo.BaseMutationOptions<
  UpdateCodeMutation,
  UpdateCodeMutationVariables
>;
export const DeleteCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DeleteCode'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'DeleteCodeInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteCode'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDeleteCodeMutation__
 *
 * To run a mutation, you first call `useDeleteCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCodeMutation, { data, loading, error }] = useDeleteCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCodeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteCodeMutation,
    DeleteCodeMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<DeleteCodeMutation, DeleteCodeMutationVariables>(
    DeleteCodeDocument,
    options
  );
}
export type DeleteCodeMutationHookResult = ReturnType<typeof useDeleteCodeMutation>;
export type DeleteCodeMutationResult = Apollo.MutationResult<DeleteCodeMutation>;
export type DeleteCodeMutationOptions = Apollo.BaseMutationOptions<
  DeleteCodeMutation,
  DeleteCodeMutationVariables
>;
export const UpdatePibisiStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdatePibisiStatus'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UpdatePibisiStatusInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updatePibisiStatus'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUpdatePibisiStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePibisiStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePibisiStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePibisiStatusMutation, { data, loading, error }] = useUpdatePibisiStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePibisiStatusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdatePibisiStatusMutation,
    UpdatePibisiStatusMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    UpdatePibisiStatusMutation,
    UpdatePibisiStatusMutationVariables
  >(UpdatePibisiStatusDocument, options);
}
export type UpdatePibisiStatusMutationHookResult = ReturnType<typeof useUpdatePibisiStatusMutation>;
export type UpdatePibisiStatusMutationResult = Apollo.MutationResult<UpdatePibisiStatusMutation>;
export type UpdatePibisiStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdatePibisiStatusMutation,
  UpdatePibisiStatusMutationVariables
>;
export const CreateShortLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreateShortLink'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CreateShortLinkInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createShortLink'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                {kind: 'Field', name: {kind: 'Name', value: 'openCount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCreateShortLinkMutation__
 *
 * To run a mutation, you first call `useCreateShortLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShortLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShortLinkMutation, { data, loading, error }] = useCreateShortLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShortLinkMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateShortLinkMutation,
    CreateShortLinkMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<CreateShortLinkMutation, CreateShortLinkMutationVariables>(
    CreateShortLinkDocument,
    options
  );
}
export type CreateShortLinkMutationHookResult = ReturnType<typeof useCreateShortLinkMutation>;
export type CreateShortLinkMutationResult = Apollo.MutationResult<CreateShortLinkMutation>;
export type CreateShortLinkMutationOptions = Apollo.BaseMutationOptions<
  CreateShortLinkMutation,
  CreateShortLinkMutationVariables
>;
export const DeleteShortLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DeleteShortLink'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'DeleteShortLinkInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteShortLink'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDeleteShortLinkMutation__
 *
 * To run a mutation, you first call `useDeleteShortLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShortLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShortLinkMutation, { data, loading, error }] = useDeleteShortLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteShortLinkMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteShortLinkMutation,
    DeleteShortLinkMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<DeleteShortLinkMutation, DeleteShortLinkMutationVariables>(
    DeleteShortLinkDocument,
    options
  );
}
export type DeleteShortLinkMutationHookResult = ReturnType<typeof useDeleteShortLinkMutation>;
export type DeleteShortLinkMutationResult = Apollo.MutationResult<DeleteShortLinkMutation>;
export type DeleteShortLinkMutationOptions = Apollo.BaseMutationOptions<
  DeleteShortLinkMutation,
  DeleteShortLinkMutationVariables
>;
export const AccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Account'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'account'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Account'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowRefunds'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'language'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'progressiveBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contactPerson'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingEmail'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailOnAccountInvoice'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProcessing'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankTransferConceptPrefix'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleToStores'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sepblacId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingVatPercent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churned'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'previewFeatures'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountInvoicePaymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customAccountInvoiceNotes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'groupInvoicesByStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<AccountQuery, AccountQueryVariables> &
    ({variables: AccountQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
}
export function useAccountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountQuery, AccountQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AccountQuery, AccountQueryVariables>(
    AccountDocument,
    options
  );
}
// @ts-ignore
export function useAccountSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountQuery, AccountQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<AccountQuery, AccountQueryVariables>;
export function useAccountSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AccountQuery, AccountQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<AccountQuery | undefined, AccountQueryVariables>;
export function useAccountSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AccountQuery, AccountQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<AccountQuery, AccountQueryVariables>(
    AccountDocument,
    options
  );
}
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>;
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>;
export type AccountSuspenseQueryHookResult = ReturnType<typeof useAccountSuspenseQuery>;
export type AccountQueryResult = Apollo.QueryResult<AccountQuery, AccountQueryVariables>;
export function refetchAccountQuery(variables: AccountQueryVariables) {
  return {query: AccountDocument, variables: variables};
}
export const AccountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Accounts'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'SearchableAccountFilterInput'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'search'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'size'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'from'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'accounts'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'search'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'search'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'size'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'size'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'from'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'from'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'total'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Pibisi'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Account'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowRefunds'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'language'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'progressiveBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contactPerson'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingEmail'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSubscription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailOnAccountInvoice'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProcessing'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pibisi'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankTransferConceptPrefix'}},
                {kind: 'Field', name: {kind: 'Name', value: 'settleToStores'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sepblacId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingVatPercent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churned'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'previewFeatures'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountInvoicePaymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customAccountInvoiceNotes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'groupInvoicesByStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAccountsQuery__
 *
 * To run a query within a React component, call `useAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useAccountsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<AccountsQuery, AccountsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AccountsQuery, AccountsQueryVariables>(
    AccountsDocument,
    options
  );
}
export function useAccountsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountsQuery, AccountsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AccountsQuery, AccountsQueryVariables>(
    AccountsDocument,
    options
  );
}
// @ts-ignore
export function useAccountsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountsQuery, AccountsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<AccountsQuery, AccountsQueryVariables>;
export function useAccountsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AccountsQuery, AccountsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<AccountsQuery | undefined, AccountsQueryVariables>;
export function useAccountsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AccountsQuery, AccountsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<AccountsQuery, AccountsQueryVariables>(
    AccountsDocument,
    options
  );
}
export type AccountsQueryHookResult = ReturnType<typeof useAccountsQuery>;
export type AccountsLazyQueryHookResult = ReturnType<typeof useAccountsLazyQuery>;
export type AccountsSuspenseQueryHookResult = ReturnType<typeof useAccountsSuspenseQuery>;
export type AccountsQueryResult = Apollo.QueryResult<AccountsQuery, AccountsQueryVariables>;
export function refetchAccountsQuery(variables?: AccountsQueryVariables) {
  return {query: AccountsDocument, variables: variables};
}
export const AuthorizedUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AuthorizedUsers'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AuthorizedUserFields'}}
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AuthorizedUserFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AuthorizedUser'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accessLevel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastLoginAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAuthorizedUsersQuery__
 *
 * To run a query within a React component, call `useAuthorizedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorizedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorizedUsersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAuthorizedUsersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    AuthorizedUsersQuery,
    AuthorizedUsersQueryVariables
  > &
    ({variables: AuthorizedUsersQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AuthorizedUsersQuery, AuthorizedUsersQueryVariables>(
    AuthorizedUsersDocument,
    options
  );
}
export function useAuthorizedUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AuthorizedUsersQuery,
    AuthorizedUsersQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AuthorizedUsersQuery, AuthorizedUsersQueryVariables>(
    AuthorizedUsersDocument,
    options
  );
}
// @ts-ignore
export function useAuthorizedUsersSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AuthorizedUsersQuery,
    AuthorizedUsersQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<AuthorizedUsersQuery, AuthorizedUsersQueryVariables>;
export function useAuthorizedUsersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AuthorizedUsersQuery, AuthorizedUsersQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  AuthorizedUsersQuery | undefined,
  AuthorizedUsersQueryVariables
>;
export function useAuthorizedUsersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AuthorizedUsersQuery, AuthorizedUsersQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<AuthorizedUsersQuery, AuthorizedUsersQueryVariables>(
    AuthorizedUsersDocument,
    options
  );
}
export type AuthorizedUsersQueryHookResult = ReturnType<typeof useAuthorizedUsersQuery>;
export type AuthorizedUsersLazyQueryHookResult = ReturnType<typeof useAuthorizedUsersLazyQuery>;
export type AuthorizedUsersSuspenseQueryHookResult = ReturnType<
  typeof useAuthorizedUsersSuspenseQuery
>;
export type AuthorizedUsersQueryResult = Apollo.QueryResult<
  AuthorizedUsersQuery,
  AuthorizedUsersQueryVariables
>;
export function refetchAuthorizedUsersQuery(variables: AuthorizedUsersQueryVariables) {
  return {query: AuthorizedUsersDocument, variables: variables};
}
export const AvailablePaymentMethodsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AvailablePaymentMethods'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'availablePaymentMethods'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'configured'}},
                {kind: 'Field', name: {kind: 'Name', value: 'enabled'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAvailablePaymentMethodsQuery__
 *
 * To run a query within a React component, call `useAvailablePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailablePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailablePaymentMethodsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAvailablePaymentMethodsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    AvailablePaymentMethodsQuery,
    AvailablePaymentMethodsQueryVariables
  > &
    ({variables: AvailablePaymentMethodsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<
    AvailablePaymentMethodsQuery,
    AvailablePaymentMethodsQueryVariables
  >(AvailablePaymentMethodsDocument, options);
}
export function useAvailablePaymentMethodsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AvailablePaymentMethodsQuery,
    AvailablePaymentMethodsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<
    AvailablePaymentMethodsQuery,
    AvailablePaymentMethodsQueryVariables
  >(AvailablePaymentMethodsDocument, options);
}
// @ts-ignore
export function useAvailablePaymentMethodsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AvailablePaymentMethodsQuery,
    AvailablePaymentMethodsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  AvailablePaymentMethodsQuery,
  AvailablePaymentMethodsQueryVariables
>;
export function useAvailablePaymentMethodsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AvailablePaymentMethodsQuery,
        AvailablePaymentMethodsQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  AvailablePaymentMethodsQuery | undefined,
  AvailablePaymentMethodsQueryVariables
>;
export function useAvailablePaymentMethodsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AvailablePaymentMethodsQuery,
        AvailablePaymentMethodsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<
    AvailablePaymentMethodsQuery,
    AvailablePaymentMethodsQueryVariables
  >(AvailablePaymentMethodsDocument, options);
}
export type AvailablePaymentMethodsQueryHookResult = ReturnType<
  typeof useAvailablePaymentMethodsQuery
>;
export type AvailablePaymentMethodsLazyQueryHookResult = ReturnType<
  typeof useAvailablePaymentMethodsLazyQuery
>;
export type AvailablePaymentMethodsSuspenseQueryHookResult = ReturnType<
  typeof useAvailablePaymentMethodsSuspenseQuery
>;
export type AvailablePaymentMethodsQueryResult = Apollo.QueryResult<
  AvailablePaymentMethodsQuery,
  AvailablePaymentMethodsQueryVariables
>;
export function refetchAvailablePaymentMethodsQuery(
  variables: AvailablePaymentMethodsQueryVariables
) {
  return {query: AvailablePaymentMethodsDocument, variables: variables};
}
export const AvailableProcessorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AvailableProcessors'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethod'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethods'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'availableProcessors'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'paymentMethod'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethod'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'processor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'configured'}},
                {kind: 'Field', name: {kind: 'Name', value: 'enabled'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAvailableProcessorsQuery__
 *
 * To run a query within a React component, call `useAvailableProcessorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableProcessorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableProcessorsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useAvailableProcessorsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    AvailableProcessorsQuery,
    AvailableProcessorsQueryVariables
  > &
    ({variables: AvailableProcessorsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AvailableProcessorsQuery, AvailableProcessorsQueryVariables>(
    AvailableProcessorsDocument,
    options
  );
}
export function useAvailableProcessorsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AvailableProcessorsQuery,
    AvailableProcessorsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AvailableProcessorsQuery, AvailableProcessorsQueryVariables>(
    AvailableProcessorsDocument,
    options
  );
}
// @ts-ignore
export function useAvailableProcessorsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AvailableProcessorsQuery,
    AvailableProcessorsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  AvailableProcessorsQuery,
  AvailableProcessorsQueryVariables
>;
export function useAvailableProcessorsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AvailableProcessorsQuery,
        AvailableProcessorsQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  AvailableProcessorsQuery | undefined,
  AvailableProcessorsQueryVariables
>;
export function useAvailableProcessorsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AvailableProcessorsQuery,
        AvailableProcessorsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<
    AvailableProcessorsQuery,
    AvailableProcessorsQueryVariables
  >(AvailableProcessorsDocument, options);
}
export type AvailableProcessorsQueryHookResult = ReturnType<typeof useAvailableProcessorsQuery>;
export type AvailableProcessorsLazyQueryHookResult = ReturnType<
  typeof useAvailableProcessorsLazyQuery
>;
export type AvailableProcessorsSuspenseQueryHookResult = ReturnType<
  typeof useAvailableProcessorsSuspenseQuery
>;
export type AvailableProcessorsQueryResult = Apollo.QueryResult<
  AvailableProcessorsQuery,
  AvailableProcessorsQueryVariables
>;
export function refetchAvailableProcessorsQuery(variables: AvailableProcessorsQueryVariables) {
  return {query: AvailableProcessorsDocument, variables: variables};
}
export const ProviderConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ProviderConfig'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethod'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethods'}}
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'processor'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Processor'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'providerConfig'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'paymentMethod'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethod'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'processor'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'processor'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'processor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'acquirers'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'metadataConfig'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'possibleValues'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'default'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'regex'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'secret'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'example'}}
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useProviderConfigQuery__
 *
 * To run a query within a React component, call `useProviderConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderConfigQuery({
 *   variables: {
 *      paymentMethod: // value for 'paymentMethod'
 *      processor: // value for 'processor'
 *   },
 * });
 */
export function useProviderConfigQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ProviderConfigQuery,
    ProviderConfigQueryVariables
  > &
    ({variables: ProviderConfigQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<ProviderConfigQuery, ProviderConfigQueryVariables>(
    ProviderConfigDocument,
    options
  );
}
export function useProviderConfigLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ProviderConfigQuery,
    ProviderConfigQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<ProviderConfigQuery, ProviderConfigQueryVariables>(
    ProviderConfigDocument,
    options
  );
}
// @ts-ignore
export function useProviderConfigSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    ProviderConfigQuery,
    ProviderConfigQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<ProviderConfigQuery, ProviderConfigQueryVariables>;
export function useProviderConfigSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ProviderConfigQuery, ProviderConfigQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  ProviderConfigQuery | undefined,
  ProviderConfigQueryVariables
>;
export function useProviderConfigSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ProviderConfigQuery, ProviderConfigQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<ProviderConfigQuery, ProviderConfigQueryVariables>(
    ProviderConfigDocument,
    options
  );
}
export type ProviderConfigQueryHookResult = ReturnType<typeof useProviderConfigQuery>;
export type ProviderConfigLazyQueryHookResult = ReturnType<typeof useProviderConfigLazyQuery>;
export type ProviderConfigSuspenseQueryHookResult = ReturnType<
  typeof useProviderConfigSuspenseQuery
>;
export type ProviderConfigQueryResult = Apollo.QueryResult<
  ProviderConfigQuery,
  ProviderConfigQueryVariables
>;
export function refetchProviderConfigQuery(variables: ProviderConfigQueryVariables) {
  return {query: ProviderConfigDocument, variables: variables};
}
export const ProviderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Provider'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'provider'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ProviderFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ProviderFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Provider'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'processor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currencies'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'possibleValues'}},
                {kind: 'Field', name: {kind: 'Name', value: 'regex'}},
                {kind: 'Field', name: {kind: 'Name', value: 'example'}},
                {kind: 'Field', name: {kind: 'Name', value: 'secret'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'rules'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'minAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'maxAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'shopNameLike'}},
                {kind: 'Field', name: {kind: 'Name', value: 'descriptionLike'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nativeHostedPayment'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useProviderQuery__
 *
 * To run a query within a React component, call `useProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProviderQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<ProviderQuery, ProviderQueryVariables> &
    ({variables: ProviderQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<ProviderQuery, ProviderQueryVariables>(
    ProviderDocument,
    options
  );
}
export function useProviderLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProviderQuery, ProviderQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<ProviderQuery, ProviderQueryVariables>(
    ProviderDocument,
    options
  );
}
// @ts-ignore
export function useProviderSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProviderQuery, ProviderQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<ProviderQuery, ProviderQueryVariables>;
export function useProviderSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ProviderQuery, ProviderQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<ProviderQuery | undefined, ProviderQueryVariables>;
export function useProviderSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ProviderQuery, ProviderQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<ProviderQuery, ProviderQueryVariables>(
    ProviderDocument,
    options
  );
}
export type ProviderQueryHookResult = ReturnType<typeof useProviderQuery>;
export type ProviderLazyQueryHookResult = ReturnType<typeof useProviderLazyQuery>;
export type ProviderSuspenseQueryHookResult = ReturnType<typeof useProviderSuspenseQuery>;
export type ProviderQueryResult = Apollo.QueryResult<ProviderQuery, ProviderQueryVariables>;
export function refetchProviderQuery(variables: ProviderQueryVariables) {
  return {query: ProviderDocument, variables: variables};
}
export const ProvidersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Providers'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'providers'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ProviderFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ProviderFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Provider'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'processor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currencies'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'possibleValues'}},
                {kind: 'Field', name: {kind: 'Name', value: 'regex'}},
                {kind: 'Field', name: {kind: 'Name', value: 'example'}},
                {kind: 'Field', name: {kind: 'Name', value: 'secret'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'rules'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'minAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'maxAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'shopNameLike'}},
                {kind: 'Field', name: {kind: 'Name', value: 'descriptionLike'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nativeHostedPayment'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useProvidersQuery__
 *
 * To run a query within a React component, call `useProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProvidersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useProvidersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<ProvidersQuery, ProvidersQueryVariables> &
    ({variables: ProvidersQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<ProvidersQuery, ProvidersQueryVariables>(
    ProvidersDocument,
    options
  );
}
export function useProvidersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProvidersQuery, ProvidersQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<ProvidersQuery, ProvidersQueryVariables>(
    ProvidersDocument,
    options
  );
}
// @ts-ignore
export function useProvidersSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProvidersQuery, ProvidersQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<ProvidersQuery, ProvidersQueryVariables>;
export function useProvidersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ProvidersQuery, ProvidersQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<ProvidersQuery | undefined, ProvidersQueryVariables>;
export function useProvidersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ProvidersQuery, ProvidersQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<ProvidersQuery, ProvidersQueryVariables>(
    ProvidersDocument,
    options
  );
}
export type ProvidersQueryHookResult = ReturnType<typeof useProvidersQuery>;
export type ProvidersLazyQueryHookResult = ReturnType<typeof useProvidersLazyQuery>;
export type ProvidersSuspenseQueryHookResult = ReturnType<typeof useProvidersSuspenseQuery>;
export type ProvidersQueryResult = Apollo.QueryResult<ProvidersQuery, ProvidersQueryVariables>;
export function refetchProvidersQuery(variables: ProvidersQueryVariables) {
  return {query: ProvidersDocument, variables: variables};
}
export const ChargesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Charges'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'SearchableChargeFilterInput'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'search'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'size'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'from'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'charges'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'search'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'search'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'size'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'size'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'from'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'from'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'ChargeFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'total'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ChargeFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Charge'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'checkoutId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'processor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'subscriptionId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerReferenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerInternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'authorizationCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'descriptor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationReason'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shop'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerStatusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerStatusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'issuerStatusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'issuerStatusMessage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'callbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'completeUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'failUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancelUrl'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useChargesQuery__
 *
 * To run a query within a React component, call `useChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useChargesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<ChargesQuery, ChargesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<ChargesQuery, ChargesQueryVariables>(ChargesDocument, options);
}
export function useChargesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChargesQuery, ChargesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<ChargesQuery, ChargesQueryVariables>(
    ChargesDocument,
    options
  );
}
// @ts-ignore
export function useChargesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChargesQuery, ChargesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<ChargesQuery, ChargesQueryVariables>;
export function useChargesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ChargesQuery, ChargesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<ChargesQuery | undefined, ChargesQueryVariables>;
export function useChargesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ChargesQuery, ChargesQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<ChargesQuery, ChargesQueryVariables>(
    ChargesDocument,
    options
  );
}
export type ChargesQueryHookResult = ReturnType<typeof useChargesQuery>;
export type ChargesLazyQueryHookResult = ReturnType<typeof useChargesLazyQuery>;
export type ChargesSuspenseQueryHookResult = ReturnType<typeof useChargesSuspenseQuery>;
export type ChargesQueryResult = Apollo.QueryResult<ChargesQuery, ChargesQueryVariables>;
export function refetchChargesQuery(variables?: ChargesQueryVariables) {
  return {query: ChargesDocument, variables: variables};
}
export const ChargesExportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ChargesExport'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'chargesExport'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'ChargesExportFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ChargesExportFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ChargesExport'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'expireAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useChargesExportQuery__
 *
 * To run a query within a React component, call `useChargesExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargesExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargesExportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChargesExportQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<ChargesExportQuery, ChargesExportQueryVariables> &
    ({variables: ChargesExportQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<ChargesExportQuery, ChargesExportQueryVariables>(
    ChargesExportDocument,
    options
  );
}
export function useChargesExportLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ChargesExportQuery,
    ChargesExportQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<ChargesExportQuery, ChargesExportQueryVariables>(
    ChargesExportDocument,
    options
  );
}
// @ts-ignore
export function useChargesExportSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    ChargesExportQuery,
    ChargesExportQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<ChargesExportQuery, ChargesExportQueryVariables>;
export function useChargesExportSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ChargesExportQuery, ChargesExportQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  ChargesExportQuery | undefined,
  ChargesExportQueryVariables
>;
export function useChargesExportSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ChargesExportQuery, ChargesExportQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<ChargesExportQuery, ChargesExportQueryVariables>(
    ChargesExportDocument,
    options
  );
}
export type ChargesExportQueryHookResult = ReturnType<typeof useChargesExportQuery>;
export type ChargesExportLazyQueryHookResult = ReturnType<typeof useChargesExportLazyQuery>;
export type ChargesExportSuspenseQueryHookResult = ReturnType<typeof useChargesExportSuspenseQuery>;
export type ChargesExportQueryResult = Apollo.QueryResult<
  ChargesExportQuery,
  ChargesExportQueryVariables
>;
export function refetchChargesExportQuery(variables: ChargesExportQueryVariables) {
  return {query: ChargesExportDocument, variables: variables};
}
export const ChargeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Charge'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'charge'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ChargeFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ChargeFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Charge'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'checkoutId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'processor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'subscriptionId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerReferenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerInternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'authorizationCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'descriptor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationReason'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shop'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerStatusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerStatusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'issuerStatusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'issuerStatusMessage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'callbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'completeUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'failUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancelUrl'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useChargeQuery__
 *
 * To run a query within a React component, call `useChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChargeQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<ChargeQuery, ChargeQueryVariables> &
    ({variables: ChargeQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<ChargeQuery, ChargeQueryVariables>(ChargeDocument, options);
}
export function useChargeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChargeQuery, ChargeQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<ChargeQuery, ChargeQueryVariables>(ChargeDocument, options);
}
// @ts-ignore
export function useChargeSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChargeQuery, ChargeQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<ChargeQuery, ChargeQueryVariables>;
export function useChargeSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ChargeQuery, ChargeQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<ChargeQuery | undefined, ChargeQueryVariables>;
export function useChargeSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ChargeQuery, ChargeQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<ChargeQuery, ChargeQueryVariables>(
    ChargeDocument,
    options
  );
}
export type ChargeQueryHookResult = ReturnType<typeof useChargeQuery>;
export type ChargeLazyQueryHookResult = ReturnType<typeof useChargeLazyQuery>;
export type ChargeSuspenseQueryHookResult = ReturnType<typeof useChargeSuspenseQuery>;
export type ChargeQueryResult = Apollo.QueryResult<ChargeQuery, ChargeQueryVariables>;
export function refetchChargeQuery(variables: ChargeQueryVariables) {
  return {query: ChargeDocument, variables: variables};
}
export const SucceededDateRangeKpiDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'SucceededDateRangeKpi'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'start'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'end'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'interval'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Interval'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'acquirer'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Acquirer'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'masterAccountId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'billingPlan'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethod'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethods'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'source'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'timezone'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'currency'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Currencies'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'chargesDateRangeKPI'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'start'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'start'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'end'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'end'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'interval'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'interval'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'acquirer'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'acquirer'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'masterAccountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'masterAccountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'billingPlan'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'billingPlan'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'paymentMethod'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethod'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'source'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'source'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'timezone'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'timezone'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'currency'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'currency'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'succeededAmount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'succeededCount'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'data'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'cuSucceededAmount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'cuSucceededCount'}}
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useSucceededDateRangeKpiQuery__
 *
 * To run a query within a React component, call `useSucceededDateRangeKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useSucceededDateRangeKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSucceededDateRangeKpiQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      interval: // value for 'interval'
 *      accountId: // value for 'accountId'
 *      acquirer: // value for 'acquirer'
 *      masterAccountId: // value for 'masterAccountId'
 *      billingPlan: // value for 'billingPlan'
 *      paymentMethod: // value for 'paymentMethod'
 *      source: // value for 'source'
 *      timezone: // value for 'timezone'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useSucceededDateRangeKpiQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SucceededDateRangeKpiQuery,
    SucceededDateRangeKpiQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<SucceededDateRangeKpiQuery, SucceededDateRangeKpiQueryVariables>(
    SucceededDateRangeKpiDocument,
    options
  );
}
export function useSucceededDateRangeKpiLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SucceededDateRangeKpiQuery,
    SucceededDateRangeKpiQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<
    SucceededDateRangeKpiQuery,
    SucceededDateRangeKpiQueryVariables
  >(SucceededDateRangeKpiDocument, options);
}
// @ts-ignore
export function useSucceededDateRangeKpiSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    SucceededDateRangeKpiQuery,
    SucceededDateRangeKpiQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  SucceededDateRangeKpiQuery,
  SucceededDateRangeKpiQueryVariables
>;
export function useSucceededDateRangeKpiSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        SucceededDateRangeKpiQuery,
        SucceededDateRangeKpiQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  SucceededDateRangeKpiQuery | undefined,
  SucceededDateRangeKpiQueryVariables
>;
export function useSucceededDateRangeKpiSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        SucceededDateRangeKpiQuery,
        SucceededDateRangeKpiQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<
    SucceededDateRangeKpiQuery,
    SucceededDateRangeKpiQueryVariables
  >(SucceededDateRangeKpiDocument, options);
}
export type SucceededDateRangeKpiQueryHookResult = ReturnType<typeof useSucceededDateRangeKpiQuery>;
export type SucceededDateRangeKpiLazyQueryHookResult = ReturnType<
  typeof useSucceededDateRangeKpiLazyQuery
>;
export type SucceededDateRangeKpiSuspenseQueryHookResult = ReturnType<
  typeof useSucceededDateRangeKpiSuspenseQuery
>;
export type SucceededDateRangeKpiQueryResult = Apollo.QueryResult<
  SucceededDateRangeKpiQuery,
  SucceededDateRangeKpiQueryVariables
>;
export function refetchSucceededDateRangeKpiQuery(variables?: SucceededDateRangeKpiQueryVariables) {
  return {query: SucceededDateRangeKpiDocument, variables: variables};
}
export const ChargesDateRangeKpiDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ChargesDateRangeKpi'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'start'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'end'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'interval'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Interval'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'acquirer'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Acquirer'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'masterAccountId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'billingPlan'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethod'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethods'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'source'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'timezone'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'currency'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Currencies'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'chargesDateRangeKPI'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'start'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'start'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'end'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'end'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'interval'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'interval'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'acquirer'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'acquirer'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'masterAccountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'masterAccountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'billingPlan'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'billingPlan'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'paymentMethod'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethod'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'source'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'source'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'timezone'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'timezone'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'currency'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'currency'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'succeededAmount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'succeededCount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'refundedCount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'failedCount'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'data'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'succeededAmount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'succeededCount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'refundedCount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'failedCount'}}
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useChargesDateRangeKpiQuery__
 *
 * To run a query within a React component, call `useChargesDateRangeKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargesDateRangeKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargesDateRangeKpiQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      interval: // value for 'interval'
 *      accountId: // value for 'accountId'
 *      acquirer: // value for 'acquirer'
 *      masterAccountId: // value for 'masterAccountId'
 *      billingPlan: // value for 'billingPlan'
 *      paymentMethod: // value for 'paymentMethod'
 *      source: // value for 'source'
 *      timezone: // value for 'timezone'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useChargesDateRangeKpiQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ChargesDateRangeKpiQuery,
    ChargesDateRangeKpiQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<ChargesDateRangeKpiQuery, ChargesDateRangeKpiQueryVariables>(
    ChargesDateRangeKpiDocument,
    options
  );
}
export function useChargesDateRangeKpiLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ChargesDateRangeKpiQuery,
    ChargesDateRangeKpiQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<ChargesDateRangeKpiQuery, ChargesDateRangeKpiQueryVariables>(
    ChargesDateRangeKpiDocument,
    options
  );
}
// @ts-ignore
export function useChargesDateRangeKpiSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    ChargesDateRangeKpiQuery,
    ChargesDateRangeKpiQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  ChargesDateRangeKpiQuery,
  ChargesDateRangeKpiQueryVariables
>;
export function useChargesDateRangeKpiSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        ChargesDateRangeKpiQuery,
        ChargesDateRangeKpiQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  ChargesDateRangeKpiQuery | undefined,
  ChargesDateRangeKpiQueryVariables
>;
export function useChargesDateRangeKpiSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        ChargesDateRangeKpiQuery,
        ChargesDateRangeKpiQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<
    ChargesDateRangeKpiQuery,
    ChargesDateRangeKpiQueryVariables
  >(ChargesDateRangeKpiDocument, options);
}
export type ChargesDateRangeKpiQueryHookResult = ReturnType<typeof useChargesDateRangeKpiQuery>;
export type ChargesDateRangeKpiLazyQueryHookResult = ReturnType<
  typeof useChargesDateRangeKpiLazyQuery
>;
export type ChargesDateRangeKpiSuspenseQueryHookResult = ReturnType<
  typeof useChargesDateRangeKpiSuspenseQuery
>;
export type ChargesDateRangeKpiQueryResult = Apollo.QueryResult<
  ChargesDateRangeKpiQuery,
  ChargesDateRangeKpiQueryVariables
>;
export function refetchChargesDateRangeKpiQuery(variables?: ChargesDateRangeKpiQueryVariables) {
  return {query: ChargesDateRangeKpiDocument, variables: variables};
}
export const ChargeEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ChargeEvents'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'chargeId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'size'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'from'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'chargeEvents'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'chargeId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'chargeId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'size'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'size'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'from'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'from'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'objectId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'objectType'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'object'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ChargeEventObjectFields'}
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'total'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ChargeEventObjectFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ChargeEventObject'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'checkoutId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {kind: 'Field', name: {kind: 'Name', value: 'subscriptionId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerReferenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerInternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amountEUR'}},
          {kind: 'Field', name: {kind: 'Name', value: 'authorizationCode'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'descriptor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'terminalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationReason'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shop'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerStatusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerStatusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'issuerStatusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'issuerStatusMessage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'pageOpenedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'callbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'completeUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'failUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancelUrl'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useChargeEventsQuery__
 *
 * To run a query within a React component, call `useChargeEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargeEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargeEventsQuery({
 *   variables: {
 *      chargeId: // value for 'chargeId'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useChargeEventsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<ChargeEventsQuery, ChargeEventsQueryVariables> &
    ({variables: ChargeEventsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<ChargeEventsQuery, ChargeEventsQueryVariables>(
    ChargeEventsDocument,
    options
  );
}
export function useChargeEventsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChargeEventsQuery, ChargeEventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<ChargeEventsQuery, ChargeEventsQueryVariables>(
    ChargeEventsDocument,
    options
  );
}
// @ts-ignore
export function useChargeEventsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    ChargeEventsQuery,
    ChargeEventsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<ChargeEventsQuery, ChargeEventsQueryVariables>;
export function useChargeEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ChargeEventsQuery, ChargeEventsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  ChargeEventsQuery | undefined,
  ChargeEventsQueryVariables
>;
export function useChargeEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ChargeEventsQuery, ChargeEventsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<ChargeEventsQuery, ChargeEventsQueryVariables>(
    ChargeEventsDocument,
    options
  );
}
export type ChargeEventsQueryHookResult = ReturnType<typeof useChargeEventsQuery>;
export type ChargeEventsLazyQueryHookResult = ReturnType<typeof useChargeEventsLazyQuery>;
export type ChargeEventsSuspenseQueryHookResult = ReturnType<typeof useChargeEventsSuspenseQuery>;
export type ChargeEventsQueryResult = Apollo.QueryResult<
  ChargeEventsQuery,
  ChargeEventsQueryVariables
>;
export function refetchChargeEventsQuery(variables: ChargeEventsQueryVariables) {
  return {query: ChargeEventsDocument, variables: variables};
}
export const EventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Events'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'SearchableEventFilterInput'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'size'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'from'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'events'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'size'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'size'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'from'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'from'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'objectId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'objectType'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'object'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ChargeEventObjectFields'}
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'total'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ChargeEventObjectFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ChargeEventObject'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'checkoutId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {kind: 'Field', name: {kind: 'Name', value: 'subscriptionId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerReferenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerInternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amountEUR'}},
          {kind: 'Field', name: {kind: 'Name', value: 'authorizationCode'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'descriptor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'terminalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'refundedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastRefundReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationReason'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shop'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerStatusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'providerStatusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'issuerStatusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'issuerStatusMessage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'pageOpenedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'callbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'completeUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'failUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancelUrl'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useEventsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<EventsQuery, EventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
}
export function useEventsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventsQuery, EventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
}
// @ts-ignore
export function useEventsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EventsQuery, EventsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<EventsQuery, EventsQueryVariables>;
export function useEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<EventsQuery, EventsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<EventsQuery | undefined, EventsQueryVariables>;
export function useEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<EventsQuery, EventsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<EventsQuery, EventsQueryVariables>(
    EventsDocument,
    options
  );
}
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>;
export type EventsLazyQueryHookResult = ReturnType<typeof useEventsLazyQuery>;
export type EventsSuspenseQueryHookResult = ReturnType<typeof useEventsSuspenseQuery>;
export type EventsQueryResult = Apollo.QueryResult<EventsQuery, EventsQueryVariables>;
export function refetchEventsQuery(variables?: EventsQueryVariables) {
  return {query: EventsDocument, variables: variables};
}
export const UserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'User'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'user'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'UserFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'UserFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'User'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'emailVerified'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phoneNumberVerified'}},
          {kind: 'Field', name: {kind: 'Name', value: 'smsMfaEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<UserQuery, UserQueryVariables> &
    ({variables: UserQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
}
export function useUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserQuery, UserQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
}
// @ts-ignore
export function useUserSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<UserQuery, UserQueryVariables>;
export function useUserSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<UserQuery | undefined, UserQueryVariables>;
export function useUserSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
}
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export function refetchUserQuery(variables: UserQueryVariables) {
  return {query: UserDocument, variables: variables};
}
export const UsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Users'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'token'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'users'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'token'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'token'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'UserFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'nextToken'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'UserFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'User'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'emailVerified'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phoneNumberVerified'}},
          {kind: 'Field', name: {kind: 'Name', value: 'smsMfaEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      token: // value for 'token'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUsersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<UsersQuery, UsersQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
}
export function useUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
}
// @ts-ignore
export function useUsersSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<UsersQuery, UsersQueryVariables>;
export function useUsersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<UsersQuery | undefined, UsersQueryVariables>;
export function useUsersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
}
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export function refetchUsersQuery(variables?: UsersQueryVariables) {
  return {query: UsersDocument, variables: variables};
}
export const CountriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Countries'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'countries'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'supportedCountries'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'phoneCode'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'currentCountry'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'phoneCode'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'currentCountryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSupported'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<CountriesQuery, CountriesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<CountriesQuery, CountriesQueryVariables>(
    CountriesDocument,
    options
  );
}
export function useCountriesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<CountriesQuery, CountriesQueryVariables>(
    CountriesDocument,
    options
  );
}
// @ts-ignore
export function useCountriesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<CountriesQuery, CountriesQueryVariables>;
export function useCountriesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<CountriesQuery | undefined, CountriesQueryVariables>;
export function useCountriesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<CountriesQuery, CountriesQueryVariables>(
    CountriesDocument,
    options
  );
}
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesSuspenseQueryHookResult = ReturnType<typeof useCountriesSuspenseQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export function refetchCountriesQuery(variables?: CountriesQueryVariables) {
  return {query: CountriesDocument, variables: variables};
}
export const AccountActualFeesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AccountActualFees'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'accountActualFees'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklySftpConfigUnitFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'region'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}}
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAccountActualFeesQuery__
 *
 * To run a query within a React component, call `useAccountActualFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountActualFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountActualFeesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountActualFeesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    AccountActualFeesQuery,
    AccountActualFeesQueryVariables
  > &
    ({variables: AccountActualFeesQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AccountActualFeesQuery, AccountActualFeesQueryVariables>(
    AccountActualFeesDocument,
    options
  );
}
export function useAccountActualFeesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AccountActualFeesQuery,
    AccountActualFeesQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AccountActualFeesQuery, AccountActualFeesQueryVariables>(
    AccountActualFeesDocument,
    options
  );
}
// @ts-ignore
export function useAccountActualFeesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AccountActualFeesQuery,
    AccountActualFeesQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<AccountActualFeesQuery, AccountActualFeesQueryVariables>;
export function useAccountActualFeesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AccountActualFeesQuery,
        AccountActualFeesQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  AccountActualFeesQuery | undefined,
  AccountActualFeesQueryVariables
>;
export function useAccountActualFeesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AccountActualFeesQuery,
        AccountActualFeesQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<AccountActualFeesQuery, AccountActualFeesQueryVariables>(
    AccountActualFeesDocument,
    options
  );
}
export type AccountActualFeesQueryHookResult = ReturnType<typeof useAccountActualFeesQuery>;
export type AccountActualFeesLazyQueryHookResult = ReturnType<typeof useAccountActualFeesLazyQuery>;
export type AccountActualFeesSuspenseQueryHookResult = ReturnType<
  typeof useAccountActualFeesSuspenseQuery
>;
export type AccountActualFeesQueryResult = Apollo.QueryResult<
  AccountActualFeesQuery,
  AccountActualFeesQueryVariables
>;
export function refetchAccountActualFeesQuery(variables: AccountActualFeesQueryVariables) {
  return {query: AccountActualFeesDocument, variables: variables};
}
export const AccountEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AccountEvents'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'size'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'from'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'accountEvents'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'size'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'size'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'from'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'from'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'objectId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'objectType'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'object'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'AccountEventObjectFields'}
                            }
                          ]
                        }
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'total'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountEventObjectFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AccountEventObject'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'refAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'partner'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTransactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewConfirmed'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tokenizationMethods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googlePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'applePay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'clickToPay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enabled'}}]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifications'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnRefund'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailCustomerOnSuccess'}},
                {kind: 'Field', name: {kind: 'Name', value: 'emailAdminOnSuccess'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fees'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weeklyCustomDomainFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorTrxFlatFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFee'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardPresentTrxFlatFee'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'steps'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'extra'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'region'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalForm'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'monthlyVolume'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'confirmServicesDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDescription'}},
                {kind: 'Field', name: {kind: 'Name', value: 'creationDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastUpdateDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startActivityDate'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'registryRecords'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'province'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'date'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'positions'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fromDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'role'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'capital'}},
                {kind: 'Field', name: {kind: 'Name', value: 'previousNames'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationAttempts'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'representatives'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stocksPercentage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                {kind: 'Field', name: {kind: 'Name', value: 'citizenship'}},
                {kind: 'Field', name: {kind: 'Name', value: 'dateOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nationality'}},
                {kind: 'Field', name: {kind: 'Name', value: 'yearOfBirth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'placeOfBirth'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'document'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'number'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validFrom'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'idSession'}},
                {kind: 'Field', name: {kind: 'Name', value: 'interventionType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasNoPublicActivity'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'riskLabels'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'category'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dynamicBilling'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customDomain'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rejectedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalRequestedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfile'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskProfileNote'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'riskLabels'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'label'}},
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskScore'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'riskIgnoredKeywords'}},
          {kind: 'Field', name: {kind: 'Name', value: 'riskUpdatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'suspendedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dataUpdatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorEnabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudDetectorThreshold'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fraudRulesEnabled'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'churnReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnReasonOption'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusReason'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusNote'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountExecutive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upsell'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'executive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
                {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAccountEventsQuery__
 *
 * To run a query within a React component, call `useAccountEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountEventsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useAccountEventsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<AccountEventsQuery, AccountEventsQueryVariables> &
    ({variables: AccountEventsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AccountEventsQuery, AccountEventsQueryVariables>(
    AccountEventsDocument,
    options
  );
}
export function useAccountEventsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AccountEventsQuery,
    AccountEventsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AccountEventsQuery, AccountEventsQueryVariables>(
    AccountEventsDocument,
    options
  );
}
// @ts-ignore
export function useAccountEventsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AccountEventsQuery,
    AccountEventsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<AccountEventsQuery, AccountEventsQueryVariables>;
export function useAccountEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AccountEventsQuery, AccountEventsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  AccountEventsQuery | undefined,
  AccountEventsQueryVariables
>;
export function useAccountEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AccountEventsQuery, AccountEventsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<AccountEventsQuery, AccountEventsQueryVariables>(
    AccountEventsDocument,
    options
  );
}
export type AccountEventsQueryHookResult = ReturnType<typeof useAccountEventsQuery>;
export type AccountEventsLazyQueryHookResult = ReturnType<typeof useAccountEventsLazyQuery>;
export type AccountEventsSuspenseQueryHookResult = ReturnType<typeof useAccountEventsSuspenseQuery>;
export type AccountEventsQueryResult = Apollo.QueryResult<
  AccountEventsQuery,
  AccountEventsQueryVariables
>;
export function refetchAccountEventsQuery(variables: AccountEventsQueryVariables) {
  return {query: AccountEventsDocument, variables: variables};
}
export const SettlementsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Settlements'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'SearchableSettlementFilterInput'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'size'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'from'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'settlements'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'size'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'size'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'from'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'from'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SettlementFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'total'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SettlementFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Settlement'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirerFees'}},
          {kind: 'Field', name: {kind: 'Name', value: 'grossVolume'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'payMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'netVolume'}},
          {kind: 'Field', name: {kind: 'Name', value: 'periodEndAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'periodStartAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'releasedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reservedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'scheduledAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'settleGross'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useSettlementsQuery__
 *
 * To run a query within a React component, call `useSettlementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettlementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettlementsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useSettlementsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<SettlementsQuery, SettlementsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<SettlementsQuery, SettlementsQueryVariables>(
    SettlementsDocument,
    options
  );
}
export function useSettlementsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SettlementsQuery, SettlementsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<SettlementsQuery, SettlementsQueryVariables>(
    SettlementsDocument,
    options
  );
}
// @ts-ignore
export function useSettlementsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    SettlementsQuery,
    SettlementsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<SettlementsQuery, SettlementsQueryVariables>;
export function useSettlementsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<SettlementsQuery, SettlementsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<SettlementsQuery | undefined, SettlementsQueryVariables>;
export function useSettlementsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<SettlementsQuery, SettlementsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<SettlementsQuery, SettlementsQueryVariables>(
    SettlementsDocument,
    options
  );
}
export type SettlementsQueryHookResult = ReturnType<typeof useSettlementsQuery>;
export type SettlementsLazyQueryHookResult = ReturnType<typeof useSettlementsLazyQuery>;
export type SettlementsSuspenseQueryHookResult = ReturnType<typeof useSettlementsSuspenseQuery>;
export type SettlementsQueryResult = Apollo.QueryResult<
  SettlementsQuery,
  SettlementsQueryVariables
>;
export function refetchSettlementsQuery(variables?: SettlementsQueryVariables) {
  return {query: SettlementsDocument, variables: variables};
}
export const AccountInvoicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AccountInvoices'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'SearchableInvoiceFilterInput'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'size'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'from'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'accountInvoices'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'size'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'size'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'from'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'from'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountInvoiceFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'total'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountInvoiceFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AccountInvoice'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'number'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'period'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'from'}},
                {kind: 'Field', name: {kind: 'Name', value: 'to'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'tax'}},
          {kind: 'Field', name: {kind: 'Name', value: 'totalAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'unitAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'unitType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'amount'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'iban'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethod'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAccountInvoicesQuery__
 *
 * To run a query within a React component, call `useAccountInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountInvoicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useAccountInvoicesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AccountInvoicesQuery,
    AccountInvoicesQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AccountInvoicesQuery, AccountInvoicesQueryVariables>(
    AccountInvoicesDocument,
    options
  );
}
export function useAccountInvoicesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AccountInvoicesQuery,
    AccountInvoicesQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AccountInvoicesQuery, AccountInvoicesQueryVariables>(
    AccountInvoicesDocument,
    options
  );
}
// @ts-ignore
export function useAccountInvoicesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AccountInvoicesQuery,
    AccountInvoicesQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<AccountInvoicesQuery, AccountInvoicesQueryVariables>;
export function useAccountInvoicesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AccountInvoicesQuery, AccountInvoicesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  AccountInvoicesQuery | undefined,
  AccountInvoicesQueryVariables
>;
export function useAccountInvoicesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AccountInvoicesQuery, AccountInvoicesQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<AccountInvoicesQuery, AccountInvoicesQueryVariables>(
    AccountInvoicesDocument,
    options
  );
}
export type AccountInvoicesQueryHookResult = ReturnType<typeof useAccountInvoicesQuery>;
export type AccountInvoicesLazyQueryHookResult = ReturnType<typeof useAccountInvoicesLazyQuery>;
export type AccountInvoicesSuspenseQueryHookResult = ReturnType<
  typeof useAccountInvoicesSuspenseQuery
>;
export type AccountInvoicesQueryResult = Apollo.QueryResult<
  AccountInvoicesQuery,
  AccountInvoicesQueryVariables
>;
export function refetchAccountInvoicesQuery(variables?: AccountInvoicesQueryVariables) {
  return {query: AccountInvoicesDocument, variables: variables};
}
export const PreviewPaymentEmailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'PreviewPaymentEmail'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'paymentId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'emailType'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentEmailType'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'language'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'previewPaymentEmail'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'paymentId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'paymentId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'emailType'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'emailType'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'language'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'language'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __usePreviewPaymentEmailQuery__
 *
 * To run a query within a React component, call `usePreviewPaymentEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewPaymentEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewPaymentEmailQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      emailType: // value for 'emailType'
 *      language: // value for 'language'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function usePreviewPaymentEmailQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    PreviewPaymentEmailQuery,
    PreviewPaymentEmailQueryVariables
  > &
    ({variables: PreviewPaymentEmailQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<PreviewPaymentEmailQuery, PreviewPaymentEmailQueryVariables>(
    PreviewPaymentEmailDocument,
    options
  );
}
export function usePreviewPaymentEmailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PreviewPaymentEmailQuery,
    PreviewPaymentEmailQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<PreviewPaymentEmailQuery, PreviewPaymentEmailQueryVariables>(
    PreviewPaymentEmailDocument,
    options
  );
}
// @ts-ignore
export function usePreviewPaymentEmailSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    PreviewPaymentEmailQuery,
    PreviewPaymentEmailQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  PreviewPaymentEmailQuery,
  PreviewPaymentEmailQueryVariables
>;
export function usePreviewPaymentEmailSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        PreviewPaymentEmailQuery,
        PreviewPaymentEmailQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  PreviewPaymentEmailQuery | undefined,
  PreviewPaymentEmailQueryVariables
>;
export function usePreviewPaymentEmailSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        PreviewPaymentEmailQuery,
        PreviewPaymentEmailQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<
    PreviewPaymentEmailQuery,
    PreviewPaymentEmailQueryVariables
  >(PreviewPaymentEmailDocument, options);
}
export type PreviewPaymentEmailQueryHookResult = ReturnType<typeof usePreviewPaymentEmailQuery>;
export type PreviewPaymentEmailLazyQueryHookResult = ReturnType<
  typeof usePreviewPaymentEmailLazyQuery
>;
export type PreviewPaymentEmailSuspenseQueryHookResult = ReturnType<
  typeof usePreviewPaymentEmailSuspenseQuery
>;
export type PreviewPaymentEmailQueryResult = Apollo.QueryResult<
  PreviewPaymentEmailQuery,
  PreviewPaymentEmailQueryVariables
>;
export function refetchPreviewPaymentEmailQuery(variables: PreviewPaymentEmailQueryVariables) {
  return {query: PreviewPaymentEmailDocument, variables: variables};
}
export const AccountStatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AccountStats'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'accountStats'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'stats'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'firstTransactionAt'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'activeMonths'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'avgMonthlyTransactions'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'avgMonthlyVolume'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'churned'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'totalSucceededCount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'lastTransactionAt'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'totalSucceededAmount'}}
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAccountStatsQuery__
 *
 * To run a query within a React component, call `useAccountStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountStatsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountStatsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<AccountStatsQuery, AccountStatsQueryVariables> &
    ({variables: AccountStatsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AccountStatsQuery, AccountStatsQueryVariables>(
    AccountStatsDocument,
    options
  );
}
export function useAccountStatsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountStatsQuery, AccountStatsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AccountStatsQuery, AccountStatsQueryVariables>(
    AccountStatsDocument,
    options
  );
}
// @ts-ignore
export function useAccountStatsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AccountStatsQuery,
    AccountStatsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<AccountStatsQuery, AccountStatsQueryVariables>;
export function useAccountStatsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AccountStatsQuery, AccountStatsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  AccountStatsQuery | undefined,
  AccountStatsQueryVariables
>;
export function useAccountStatsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AccountStatsQuery, AccountStatsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<AccountStatsQuery, AccountStatsQueryVariables>(
    AccountStatsDocument,
    options
  );
}
export type AccountStatsQueryHookResult = ReturnType<typeof useAccountStatsQuery>;
export type AccountStatsLazyQueryHookResult = ReturnType<typeof useAccountStatsLazyQuery>;
export type AccountStatsSuspenseQueryHookResult = ReturnType<typeof useAccountStatsSuspenseQuery>;
export type AccountStatsQueryResult = Apollo.QueryResult<
  AccountStatsQuery,
  AccountStatsQueryVariables
>;
export function refetchAccountStatsQuery(variables: AccountStatsQueryVariables) {
  return {query: AccountStatsDocument, variables: variables};
}
export const MasterAccountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'MasterAccounts'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
          type: {
            kind: 'NamedType',
            name: {kind: 'Name', value: 'SearchableMasterAccountFilterInput'}
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'size'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'from'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'masterAccounts'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'size'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'size'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'from'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'from'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'MasterAccountFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'total'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MasterAccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MasterAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedIPs'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'accountDefaults'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
                {kind: 'Field', name: {kind: 'Name', value: 'language'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fees'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'steps'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'extra'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'region'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'business'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'webhookEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnedEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedDomains'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireExternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'contractTemplateId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'autoApprove'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useMasterAccountsQuery__
 *
 * To run a query within a React component, call `useMasterAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterAccountsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useMasterAccountsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<MasterAccountsQuery, MasterAccountsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<MasterAccountsQuery, MasterAccountsQueryVariables>(
    MasterAccountsDocument,
    options
  );
}
export function useMasterAccountsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MasterAccountsQuery,
    MasterAccountsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<MasterAccountsQuery, MasterAccountsQueryVariables>(
    MasterAccountsDocument,
    options
  );
}
// @ts-ignore
export function useMasterAccountsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    MasterAccountsQuery,
    MasterAccountsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<MasterAccountsQuery, MasterAccountsQueryVariables>;
export function useMasterAccountsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<MasterAccountsQuery, MasterAccountsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  MasterAccountsQuery | undefined,
  MasterAccountsQueryVariables
>;
export function useMasterAccountsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<MasterAccountsQuery, MasterAccountsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<MasterAccountsQuery, MasterAccountsQueryVariables>(
    MasterAccountsDocument,
    options
  );
}
export type MasterAccountsQueryHookResult = ReturnType<typeof useMasterAccountsQuery>;
export type MasterAccountsLazyQueryHookResult = ReturnType<typeof useMasterAccountsLazyQuery>;
export type MasterAccountsSuspenseQueryHookResult = ReturnType<
  typeof useMasterAccountsSuspenseQuery
>;
export type MasterAccountsQueryResult = Apollo.QueryResult<
  MasterAccountsQuery,
  MasterAccountsQueryVariables
>;
export function refetchMasterAccountsQuery(variables?: MasterAccountsQueryVariables) {
  return {query: MasterAccountsDocument, variables: variables};
}
export const StoresDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Stores'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'pageSize'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'token'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'stores'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'pageSize'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'pageSize'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'token'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'token'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'StoreFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'nextToken'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'StoreFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Store'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
          {kind: 'Field', name: {kind: 'Name', value: 'website'}},
          {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useStoresQuery__
 *
 * To run a query within a React component, call `useStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoresQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      pageSize: // value for 'pageSize'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useStoresQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<StoresQuery, StoresQueryVariables> &
    ({variables: StoresQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<StoresQuery, StoresQueryVariables>(StoresDocument, options);
}
export function useStoresLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StoresQuery, StoresQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<StoresQuery, StoresQueryVariables>(StoresDocument, options);
}
// @ts-ignore
export function useStoresSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StoresQuery, StoresQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<StoresQuery, StoresQueryVariables>;
export function useStoresSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<StoresQuery, StoresQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<StoresQuery | undefined, StoresQueryVariables>;
export function useStoresSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<StoresQuery, StoresQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<StoresQuery, StoresQueryVariables>(
    StoresDocument,
    options
  );
}
export type StoresQueryHookResult = ReturnType<typeof useStoresQuery>;
export type StoresLazyQueryHookResult = ReturnType<typeof useStoresLazyQuery>;
export type StoresSuspenseQueryHookResult = ReturnType<typeof useStoresSuspenseQuery>;
export type StoresQueryResult = Apollo.QueryResult<StoresQuery, StoresQueryVariables>;
export function refetchStoresQuery(variables: StoresQueryVariables) {
  return {query: StoresDocument, variables: variables};
}
export const StoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Store'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'store'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'StoreFields'}},
                {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'metadata'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'value'}}
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'StoreFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Store'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
          {kind: 'Field', name: {kind: 'Name', value: 'website'}},
          {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useStoreQuery__
 *
 * To run a query within a React component, call `useStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreQuery({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useStoreQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<StoreQuery, StoreQueryVariables> &
    ({variables: StoreQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<StoreQuery, StoreQueryVariables>(StoreDocument, options);
}
export function useStoreLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StoreQuery, StoreQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<StoreQuery, StoreQueryVariables>(StoreDocument, options);
}
// @ts-ignore
export function useStoreSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StoreQuery, StoreQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<StoreQuery, StoreQueryVariables>;
export function useStoreSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<StoreQuery, StoreQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<StoreQuery | undefined, StoreQueryVariables>;
export function useStoreSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<StoreQuery, StoreQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<StoreQuery, StoreQueryVariables>(StoreDocument, options);
}
export type StoreQueryHookResult = ReturnType<typeof useStoreQuery>;
export type StoreLazyQueryHookResult = ReturnType<typeof useStoreLazyQuery>;
export type StoreSuspenseQueryHookResult = ReturnType<typeof useStoreSuspenseQuery>;
export type StoreQueryResult = Apollo.QueryResult<StoreQuery, StoreQueryVariables>;
export function refetchStoreQuery(variables: StoreQueryVariables) {
  return {query: StoreDocument, variables: variables};
}
export const StoreEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'StoreEvents'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'storeId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'size'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'from'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'storeEvents'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'storeId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'storeId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'size'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'size'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'from'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'from'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'objectId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'objectType'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'object'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'address'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'AddressFields'}
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'traceDetails'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'TraceDetailsFields'}
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'total'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useStoreEventsQuery__
 *
 * To run a query within a React component, call `useStoreEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreEventsQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useStoreEventsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<StoreEventsQuery, StoreEventsQueryVariables> &
    ({variables: StoreEventsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<StoreEventsQuery, StoreEventsQueryVariables>(
    StoreEventsDocument,
    options
  );
}
export function useStoreEventsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StoreEventsQuery, StoreEventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<StoreEventsQuery, StoreEventsQueryVariables>(
    StoreEventsDocument,
    options
  );
}
// @ts-ignore
export function useStoreEventsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    StoreEventsQuery,
    StoreEventsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<StoreEventsQuery, StoreEventsQueryVariables>;
export function useStoreEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<StoreEventsQuery, StoreEventsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<StoreEventsQuery | undefined, StoreEventsQueryVariables>;
export function useStoreEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<StoreEventsQuery, StoreEventsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<StoreEventsQuery, StoreEventsQueryVariables>(
    StoreEventsDocument,
    options
  );
}
export type StoreEventsQueryHookResult = ReturnType<typeof useStoreEventsQuery>;
export type StoreEventsLazyQueryHookResult = ReturnType<typeof useStoreEventsLazyQuery>;
export type StoreEventsSuspenseQueryHookResult = ReturnType<typeof useStoreEventsSuspenseQuery>;
export type StoreEventsQueryResult = Apollo.QueryResult<
  StoreEventsQuery,
  StoreEventsQueryVariables
>;
export function refetchStoreEventsQuery(variables: StoreEventsQueryVariables) {
  return {query: StoreEventsDocument, variables: variables};
}
export const DocumentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Documents'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'documents'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'DocumentFields'}}
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DocumentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Document'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'contentType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'internal'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDocumentsQuery__
 *
 * To run a query within a React component, call `useDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDocumentsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<DocumentsQuery, DocumentsQueryVariables> &
    ({variables: DocumentsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<DocumentsQuery, DocumentsQueryVariables>(
    DocumentsDocument,
    options
  );
}
export function useDocumentsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentsQuery, DocumentsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<DocumentsQuery, DocumentsQueryVariables>(
    DocumentsDocument,
    options
  );
}
// @ts-ignore
export function useDocumentsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentsQuery, DocumentsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<DocumentsQuery, DocumentsQueryVariables>;
export function useDocumentsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<DocumentsQuery, DocumentsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<DocumentsQuery | undefined, DocumentsQueryVariables>;
export function useDocumentsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<DocumentsQuery, DocumentsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<DocumentsQuery, DocumentsQueryVariables>(
    DocumentsDocument,
    options
  );
}
export type DocumentsQueryHookResult = ReturnType<typeof useDocumentsQuery>;
export type DocumentsLazyQueryHookResult = ReturnType<typeof useDocumentsLazyQuery>;
export type DocumentsSuspenseQueryHookResult = ReturnType<typeof useDocumentsSuspenseQuery>;
export type DocumentsQueryResult = Apollo.QueryResult<DocumentsQuery, DocumentsQueryVariables>;
export function refetchDocumentsQuery(variables: DocumentsQueryVariables) {
  return {query: DocumentsDocument, variables: variables};
}
export const DocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Document'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'document'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'DocumentFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DocumentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Document'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'contentType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'internal'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDocumentQuery__
 *
 * To run a query within a React component, call `useDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDocumentQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<DocumentQuery, DocumentQueryVariables> &
    ({variables: DocumentQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<DocumentQuery, DocumentQueryVariables>(
    DocumentDocument,
    options
  );
}
export function useDocumentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentQuery, DocumentQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<DocumentQuery, DocumentQueryVariables>(
    DocumentDocument,
    options
  );
}
// @ts-ignore
export function useDocumentSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentQuery, DocumentQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<DocumentQuery, DocumentQueryVariables>;
export function useDocumentSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<DocumentQuery, DocumentQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<DocumentQuery | undefined, DocumentQueryVariables>;
export function useDocumentSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<DocumentQuery, DocumentQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<DocumentQuery, DocumentQueryVariables>(
    DocumentDocument,
    options
  );
}
export type DocumentQueryHookResult = ReturnType<typeof useDocumentQuery>;
export type DocumentLazyQueryHookResult = ReturnType<typeof useDocumentLazyQuery>;
export type DocumentSuspenseQueryHookResult = ReturnType<typeof useDocumentSuspenseQuery>;
export type DocumentQueryResult = Apollo.QueryResult<DocumentQuery, DocumentQueryVariables>;
export function refetchDocumentQuery(variables: DocumentQueryVariables) {
  return {query: DocumentDocument, variables: variables};
}
export const DocumentEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'DocumentEvents'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'documentId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'documentEvents'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'documentId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'documentId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'DocumentEventFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'total'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DocumentEventFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'DocumentEvent'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'objectId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'objectType'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'object'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'contentType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'internal'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'metadata'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'value'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'traceDetails'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDocumentEventsQuery__
 *
 * To run a query within a React component, call `useDocumentEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentEventsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDocumentEventsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    DocumentEventsQuery,
    DocumentEventsQueryVariables
  > &
    ({variables: DocumentEventsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<DocumentEventsQuery, DocumentEventsQueryVariables>(
    DocumentEventsDocument,
    options
  );
}
export function useDocumentEventsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    DocumentEventsQuery,
    DocumentEventsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<DocumentEventsQuery, DocumentEventsQueryVariables>(
    DocumentEventsDocument,
    options
  );
}
// @ts-ignore
export function useDocumentEventsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    DocumentEventsQuery,
    DocumentEventsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<DocumentEventsQuery, DocumentEventsQueryVariables>;
export function useDocumentEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<DocumentEventsQuery, DocumentEventsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  DocumentEventsQuery | undefined,
  DocumentEventsQueryVariables
>;
export function useDocumentEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<DocumentEventsQuery, DocumentEventsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<DocumentEventsQuery, DocumentEventsQueryVariables>(
    DocumentEventsDocument,
    options
  );
}
export type DocumentEventsQueryHookResult = ReturnType<typeof useDocumentEventsQuery>;
export type DocumentEventsLazyQueryHookResult = ReturnType<typeof useDocumentEventsLazyQuery>;
export type DocumentEventsSuspenseQueryHookResult = ReturnType<
  typeof useDocumentEventsSuspenseQuery
>;
export type DocumentEventsQueryResult = Apollo.QueryResult<
  DocumentEventsQuery,
  DocumentEventsQueryVariables
>;
export function refetchDocumentEventsQuery(variables: DocumentEventsQueryVariables) {
  return {query: DocumentEventsDocument, variables: variables};
}
export const SubscriptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Subscriptions'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
          type: {
            kind: 'NamedType',
            name: {kind: 'Name', value: 'SearchableSubscriptionFilterInput'}
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'search'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'size'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'from'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subscriptions'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'search'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'search'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'size'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'size'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'from'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'from'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SubscriptionFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'total'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContactFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ContactDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'company'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SubscriptionFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Subscription'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'planVariantId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'productId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancelAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'skipIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodStart'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodDays'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customerId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTokenId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastInvoiceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lastPayment'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nextPaymentAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'interval'}},
          {kind: 'Field', name: {kind: 'Name', value: 'intervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'retryCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'callbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'allowedPaymentMethods'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useSubscriptionsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(
    SubscriptionsDocument,
    options
  );
}
export function useSubscriptionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SubscriptionsQuery,
    SubscriptionsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(
    SubscriptionsDocument,
    options
  );
}
// @ts-ignore
export function useSubscriptionsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    SubscriptionsQuery,
    SubscriptionsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<SubscriptionsQuery, SubscriptionsQueryVariables>;
export function useSubscriptionsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  SubscriptionsQuery | undefined,
  SubscriptionsQueryVariables
>;
export function useSubscriptionsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(
    SubscriptionsDocument,
    options
  );
}
export type SubscriptionsQueryHookResult = ReturnType<typeof useSubscriptionsQuery>;
export type SubscriptionsLazyQueryHookResult = ReturnType<typeof useSubscriptionsLazyQuery>;
export type SubscriptionsSuspenseQueryHookResult = ReturnType<typeof useSubscriptionsSuspenseQuery>;
export type SubscriptionsQueryResult = Apollo.QueryResult<
  SubscriptionsQuery,
  SubscriptionsQueryVariables
>;
export function refetchSubscriptionsQuery(variables?: SubscriptionsQueryVariables) {
  return {query: SubscriptionsDocument, variables: variables};
}
export const SubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Subscription'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subscription'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SubscriptionFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContactFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ContactDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'company'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SubscriptionFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Subscription'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'planVariantId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'productId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancelAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'skipIntervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodStart'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodDays'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customerId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContactFields'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTokenId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastInvoiceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lastPayment'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nextPaymentAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'interval'}},
          {kind: 'Field', name: {kind: 'Name', value: 'intervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'retryCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'callbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'masterAccountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'allowedPaymentMethods'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useSubscriptionQuery__
 *
 * To run a query within a React component, call `useSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscriptionQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables> &
    ({variables: SubscriptionQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<SubscriptionQuery, SubscriptionQueryVariables>(
    SubscriptionDocument,
    options
  );
}
export function useSubscriptionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<SubscriptionQuery, SubscriptionQueryVariables>(
    SubscriptionDocument,
    options
  );
}
// @ts-ignore
export function useSubscriptionSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    SubscriptionQuery,
    SubscriptionQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<SubscriptionQuery, SubscriptionQueryVariables>;
export function useSubscriptionSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  SubscriptionQuery | undefined,
  SubscriptionQueryVariables
>;
export function useSubscriptionSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<SubscriptionQuery, SubscriptionQueryVariables>(
    SubscriptionDocument,
    options
  );
}
export type SubscriptionQueryHookResult = ReturnType<typeof useSubscriptionQuery>;
export type SubscriptionLazyQueryHookResult = ReturnType<typeof useSubscriptionLazyQuery>;
export type SubscriptionSuspenseQueryHookResult = ReturnType<typeof useSubscriptionSuspenseQuery>;
export type SubscriptionQueryResult = Apollo.QueryResult<
  SubscriptionQuery,
  SubscriptionQueryVariables
>;
export function refetchSubscriptionQuery(variables: SubscriptionQueryVariables) {
  return {query: SubscriptionDocument, variables: variables};
}
export const SubscriptionEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'SubscriptionEvents'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'subscriptionId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subscriptionEvents'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'subscriptionId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'subscriptionId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'objectId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'objectType'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'object'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'SubscriptionEventObjectFields'}
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'total'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'method'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'bizum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'integrationType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ibanLast4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'idBizum'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'card'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecure'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureVersion'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureFlow'}},
                {kind: 'Field', name: {kind: 'Name', value: 'threeDSecureStatus'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bank'}},
                {kind: 'Field', name: {kind: 'Name', value: 'tokenizationMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcCorrelationId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srciTransactionId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'srcDpaId'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cardPresent'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bin'}},
                {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiration'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'verificationMethod'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mbway'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paypal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'orderId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'payerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sepa'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'accountholderAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderEmail'}},
                {kind: 'Field', name: {kind: 'Name', value: 'accountholderName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bankName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bic'}},
                {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trustly'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'customerId'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'klarna'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'authPaymentMethod'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'LastPaymentFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'LastPayment'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SubscriptionEventObjectFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SubscriptionEventObject'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'billingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cancelAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPeriodStart'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'interval'}},
          {kind: 'Field', name: {kind: 'Name', value: 'intervalCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lastPayment'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'LastPaymentFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseAtPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pauseIntervalCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'retryCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sequenceId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shippingDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodDays'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trialPeriodEnd'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useSubscriptionEventsQuery__
 *
 * To run a query within a React component, call `useSubscriptionEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionEventsQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useSubscriptionEventsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SubscriptionEventsQuery,
    SubscriptionEventsQueryVariables
  > &
    ({variables: SubscriptionEventsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<SubscriptionEventsQuery, SubscriptionEventsQueryVariables>(
    SubscriptionEventsDocument,
    options
  );
}
export function useSubscriptionEventsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SubscriptionEventsQuery,
    SubscriptionEventsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<SubscriptionEventsQuery, SubscriptionEventsQueryVariables>(
    SubscriptionEventsDocument,
    options
  );
}
// @ts-ignore
export function useSubscriptionEventsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    SubscriptionEventsQuery,
    SubscriptionEventsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  SubscriptionEventsQuery,
  SubscriptionEventsQueryVariables
>;
export function useSubscriptionEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        SubscriptionEventsQuery,
        SubscriptionEventsQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  SubscriptionEventsQuery | undefined,
  SubscriptionEventsQueryVariables
>;
export function useSubscriptionEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        SubscriptionEventsQuery,
        SubscriptionEventsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<
    SubscriptionEventsQuery,
    SubscriptionEventsQueryVariables
  >(SubscriptionEventsDocument, options);
}
export type SubscriptionEventsQueryHookResult = ReturnType<typeof useSubscriptionEventsQuery>;
export type SubscriptionEventsLazyQueryHookResult = ReturnType<
  typeof useSubscriptionEventsLazyQuery
>;
export type SubscriptionEventsSuspenseQueryHookResult = ReturnType<
  typeof useSubscriptionEventsSuspenseQuery
>;
export type SubscriptionEventsQueryResult = Apollo.QueryResult<
  SubscriptionEventsQuery,
  SubscriptionEventsQueryVariables
>;
export function refetchSubscriptionEventsQuery(variables: SubscriptionEventsQueryVariables) {
  return {query: SubscriptionEventsDocument, variables: variables};
}
export const PreviewSubscriptionEmailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'PreviewSubscriptionEmail'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'subscriptionId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'emailType'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'SubscriptionEmailType'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'language'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'previewSubscriptionEmail'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'subscriptionId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'subscriptionId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'emailType'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'emailType'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'language'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'language'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __usePreviewSubscriptionEmailQuery__
 *
 * To run a query within a React component, call `usePreviewSubscriptionEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewSubscriptionEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewSubscriptionEmailQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      emailType: // value for 'emailType'
 *      language: // value for 'language'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function usePreviewSubscriptionEmailQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    PreviewSubscriptionEmailQuery,
    PreviewSubscriptionEmailQueryVariables
  > &
    ({variables: PreviewSubscriptionEmailQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<
    PreviewSubscriptionEmailQuery,
    PreviewSubscriptionEmailQueryVariables
  >(PreviewSubscriptionEmailDocument, options);
}
export function usePreviewSubscriptionEmailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PreviewSubscriptionEmailQuery,
    PreviewSubscriptionEmailQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<
    PreviewSubscriptionEmailQuery,
    PreviewSubscriptionEmailQueryVariables
  >(PreviewSubscriptionEmailDocument, options);
}
// @ts-ignore
export function usePreviewSubscriptionEmailSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    PreviewSubscriptionEmailQuery,
    PreviewSubscriptionEmailQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  PreviewSubscriptionEmailQuery,
  PreviewSubscriptionEmailQueryVariables
>;
export function usePreviewSubscriptionEmailSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        PreviewSubscriptionEmailQuery,
        PreviewSubscriptionEmailQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  PreviewSubscriptionEmailQuery | undefined,
  PreviewSubscriptionEmailQueryVariables
>;
export function usePreviewSubscriptionEmailSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        PreviewSubscriptionEmailQuery,
        PreviewSubscriptionEmailQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<
    PreviewSubscriptionEmailQuery,
    PreviewSubscriptionEmailQueryVariables
  >(PreviewSubscriptionEmailDocument, options);
}
export type PreviewSubscriptionEmailQueryHookResult = ReturnType<
  typeof usePreviewSubscriptionEmailQuery
>;
export type PreviewSubscriptionEmailLazyQueryHookResult = ReturnType<
  typeof usePreviewSubscriptionEmailLazyQuery
>;
export type PreviewSubscriptionEmailSuspenseQueryHookResult = ReturnType<
  typeof usePreviewSubscriptionEmailSuspenseQuery
>;
export type PreviewSubscriptionEmailQueryResult = Apollo.QueryResult<
  PreviewSubscriptionEmailQuery,
  PreviewSubscriptionEmailQueryVariables
>;
export function refetchPreviewSubscriptionEmailQuery(
  variables: PreviewSubscriptionEmailQueryVariables
) {
  return {query: PreviewSubscriptionEmailDocument, variables: variables};
}
export const ProviderEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ProviderEvents'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'providerId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'providerEvents'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'providerId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'providerId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'objectId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'objectType'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'object'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ProviderEventObjectFields'}
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'total'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ProviderEventObjectFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ProviderEventObject'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'internalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'processor'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethod'}},
          {kind: 'Field', name: {kind: 'Name', value: 'acquirer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'configurable'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nativeHostedPayment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'rules'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'minAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'maxAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'shopNameLike'}},
                {kind: 'Field', name: {kind: 'Name', value: 'descriptionLike'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useProviderEventsQuery__
 *
 * To run a query within a React component, call `useProviderEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderEventsQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useProviderEventsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ProviderEventsQuery,
    ProviderEventsQueryVariables
  > &
    ({variables: ProviderEventsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<ProviderEventsQuery, ProviderEventsQueryVariables>(
    ProviderEventsDocument,
    options
  );
}
export function useProviderEventsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ProviderEventsQuery,
    ProviderEventsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<ProviderEventsQuery, ProviderEventsQueryVariables>(
    ProviderEventsDocument,
    options
  );
}
// @ts-ignore
export function useProviderEventsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    ProviderEventsQuery,
    ProviderEventsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<ProviderEventsQuery, ProviderEventsQueryVariables>;
export function useProviderEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ProviderEventsQuery, ProviderEventsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  ProviderEventsQuery | undefined,
  ProviderEventsQueryVariables
>;
export function useProviderEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ProviderEventsQuery, ProviderEventsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<ProviderEventsQuery, ProviderEventsQueryVariables>(
    ProviderEventsDocument,
    options
  );
}
export type ProviderEventsQueryHookResult = ReturnType<typeof useProviderEventsQuery>;
export type ProviderEventsLazyQueryHookResult = ReturnType<typeof useProviderEventsLazyQuery>;
export type ProviderEventsSuspenseQueryHookResult = ReturnType<
  typeof useProviderEventsSuspenseQuery
>;
export type ProviderEventsQueryResult = Apollo.QueryResult<
  ProviderEventsQuery,
  ProviderEventsQueryVariables
>;
export function refetchProviderEventsQuery(variables: ProviderEventsQueryVariables) {
  return {query: ProviderEventsDocument, variables: variables};
}
export const AccountTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AccountTags'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{kind: 'Field', name: {kind: 'Name', value: 'accountTags'}}]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAccountTagsQuery__
 *
 * To run a query within a React component, call `useAccountTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountTagsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<AccountTagsQuery, AccountTagsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AccountTagsQuery, AccountTagsQueryVariables>(
    AccountTagsDocument,
    options
  );
}
export function useAccountTagsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountTagsQuery, AccountTagsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AccountTagsQuery, AccountTagsQueryVariables>(
    AccountTagsDocument,
    options
  );
}
// @ts-ignore
export function useAccountTagsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AccountTagsQuery,
    AccountTagsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<AccountTagsQuery, AccountTagsQueryVariables>;
export function useAccountTagsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AccountTagsQuery, AccountTagsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<AccountTagsQuery | undefined, AccountTagsQueryVariables>;
export function useAccountTagsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AccountTagsQuery, AccountTagsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<AccountTagsQuery, AccountTagsQueryVariables>(
    AccountTagsDocument,
    options
  );
}
export type AccountTagsQueryHookResult = ReturnType<typeof useAccountTagsQuery>;
export type AccountTagsLazyQueryHookResult = ReturnType<typeof useAccountTagsLazyQuery>;
export type AccountTagsSuspenseQueryHookResult = ReturnType<typeof useAccountTagsSuspenseQuery>;
export type AccountTagsQueryResult = Apollo.QueryResult<
  AccountTagsQuery,
  AccountTagsQueryVariables
>;
export function refetchAccountTagsQuery(variables?: AccountTagsQueryVariables) {
  return {query: AccountTagsDocument, variables: variables};
}
export const ChargeSourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ChargeSources'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{kind: 'Field', name: {kind: 'Name', value: 'chargeSources'}}]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useChargeSourcesQuery__
 *
 * To run a query within a React component, call `useChargeSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargeSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargeSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useChargeSourcesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<ChargeSourcesQuery, ChargeSourcesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<ChargeSourcesQuery, ChargeSourcesQueryVariables>(
    ChargeSourcesDocument,
    options
  );
}
export function useChargeSourcesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ChargeSourcesQuery,
    ChargeSourcesQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<ChargeSourcesQuery, ChargeSourcesQueryVariables>(
    ChargeSourcesDocument,
    options
  );
}
// @ts-ignore
export function useChargeSourcesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    ChargeSourcesQuery,
    ChargeSourcesQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<ChargeSourcesQuery, ChargeSourcesQueryVariables>;
export function useChargeSourcesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ChargeSourcesQuery, ChargeSourcesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  ChargeSourcesQuery | undefined,
  ChargeSourcesQueryVariables
>;
export function useChargeSourcesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ChargeSourcesQuery, ChargeSourcesQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<ChargeSourcesQuery, ChargeSourcesQueryVariables>(
    ChargeSourcesDocument,
    options
  );
}
export type ChargeSourcesQueryHookResult = ReturnType<typeof useChargeSourcesQuery>;
export type ChargeSourcesLazyQueryHookResult = ReturnType<typeof useChargeSourcesLazyQuery>;
export type ChargeSourcesSuspenseQueryHookResult = ReturnType<typeof useChargeSourcesSuspenseQuery>;
export type ChargeSourcesQueryResult = Apollo.QueryResult<
  ChargeSourcesQuery,
  ChargeSourcesQueryVariables
>;
export function refetchChargeSourcesQuery(variables?: ChargeSourcesQueryVariables) {
  return {query: ChargeSourcesDocument, variables: variables};
}
export const MasterAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'MasterAccount'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'masterAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'MasterAccountFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MasterAccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MasterAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedIPs'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'accountDefaults'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'billingPlan'}},
                {kind: 'Field', name: {kind: 'Name', value: 'language'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fees'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'highRiskFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dailyPlatformFee'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dailyExtraSeatsFee'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'steps'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'trxFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'bizumTrxFlatFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'trxFlatFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'from'}}
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'extra'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'region'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'masterAccountFee'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}}
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'business'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'webhookEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnedEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedDomains'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireExternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'contractTemplateId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'autoApprove'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowCreateApiKey'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useMasterAccountQuery__
 *
 * To run a query within a React component, call `useMasterAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMasterAccountQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<MasterAccountQuery, MasterAccountQueryVariables> &
    ({variables: MasterAccountQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<MasterAccountQuery, MasterAccountQueryVariables>(
    MasterAccountDocument,
    options
  );
}
export function useMasterAccountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MasterAccountQuery,
    MasterAccountQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<MasterAccountQuery, MasterAccountQueryVariables>(
    MasterAccountDocument,
    options
  );
}
// @ts-ignore
export function useMasterAccountSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    MasterAccountQuery,
    MasterAccountQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<MasterAccountQuery, MasterAccountQueryVariables>;
export function useMasterAccountSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<MasterAccountQuery, MasterAccountQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  MasterAccountQuery | undefined,
  MasterAccountQueryVariables
>;
export function useMasterAccountSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<MasterAccountQuery, MasterAccountQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<MasterAccountQuery, MasterAccountQueryVariables>(
    MasterAccountDocument,
    options
  );
}
export type MasterAccountQueryHookResult = ReturnType<typeof useMasterAccountQuery>;
export type MasterAccountLazyQueryHookResult = ReturnType<typeof useMasterAccountLazyQuery>;
export type MasterAccountSuspenseQueryHookResult = ReturnType<typeof useMasterAccountSuspenseQuery>;
export type MasterAccountQueryResult = Apollo.QueryResult<
  MasterAccountQuery,
  MasterAccountQueryVariables
>;
export function refetchMasterAccountQuery(variables: MasterAccountQueryVariables) {
  return {query: MasterAccountDocument, variables: variables};
}
export const UserMasterAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'UserMasterAccount'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'userMasterAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'UserMasterAccountFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'country'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line1'}},
          {kind: 'Field', name: {kind: 'Name', value: 'line2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'UserMasterAccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MasterAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedIPs'}},
          {kind: 'Field', name: {kind: 'Name', value: 'webhookEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'churnedEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedDomains'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireExternalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicBusinessDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AddressFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'supportWebsite'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportPhone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'supportEmail'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'branding'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'accentColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'bgColor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'iconUrl'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useUserMasterAccountQuery__
 *
 * To run a query within a React component, call `useUserMasterAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMasterAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMasterAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserMasterAccountQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserMasterAccountQuery,
    UserMasterAccountQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<UserMasterAccountQuery, UserMasterAccountQueryVariables>(
    UserMasterAccountDocument,
    options
  );
}
export function useUserMasterAccountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserMasterAccountQuery,
    UserMasterAccountQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<UserMasterAccountQuery, UserMasterAccountQueryVariables>(
    UserMasterAccountDocument,
    options
  );
}
// @ts-ignore
export function useUserMasterAccountSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    UserMasterAccountQuery,
    UserMasterAccountQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<UserMasterAccountQuery, UserMasterAccountQueryVariables>;
export function useUserMasterAccountSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserMasterAccountQuery,
        UserMasterAccountQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserMasterAccountQuery | undefined,
  UserMasterAccountQueryVariables
>;
export function useUserMasterAccountSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserMasterAccountQuery,
        UserMasterAccountQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<UserMasterAccountQuery, UserMasterAccountQueryVariables>(
    UserMasterAccountDocument,
    options
  );
}
export type UserMasterAccountQueryHookResult = ReturnType<typeof useUserMasterAccountQuery>;
export type UserMasterAccountLazyQueryHookResult = ReturnType<typeof useUserMasterAccountLazyQuery>;
export type UserMasterAccountSuspenseQueryHookResult = ReturnType<
  typeof useUserMasterAccountSuspenseQuery
>;
export type UserMasterAccountQueryResult = Apollo.QueryResult<
  UserMasterAccountQuery,
  UserMasterAccountQueryVariables
>;
export function refetchUserMasterAccountQuery(variables?: UserMasterAccountQueryVariables) {
  return {query: UserMasterAccountDocument, variables: variables};
}
export const NotificationsPortalUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'NotificationsPortalUrl'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notificationsPortalUrl'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'redirectUrl'}}]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useNotificationsPortalUrlQuery__
 *
 * To run a query within a React component, call `useNotificationsPortalUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsPortalUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsPortalUrlQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useNotificationsPortalUrlQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    NotificationsPortalUrlQuery,
    NotificationsPortalUrlQueryVariables
  > &
    ({variables: NotificationsPortalUrlQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<
    NotificationsPortalUrlQuery,
    NotificationsPortalUrlQueryVariables
  >(NotificationsPortalUrlDocument, options);
}
export function useNotificationsPortalUrlLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    NotificationsPortalUrlQuery,
    NotificationsPortalUrlQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<
    NotificationsPortalUrlQuery,
    NotificationsPortalUrlQueryVariables
  >(NotificationsPortalUrlDocument, options);
}
// @ts-ignore
export function useNotificationsPortalUrlSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    NotificationsPortalUrlQuery,
    NotificationsPortalUrlQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  NotificationsPortalUrlQuery,
  NotificationsPortalUrlQueryVariables
>;
export function useNotificationsPortalUrlSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        NotificationsPortalUrlQuery,
        NotificationsPortalUrlQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  NotificationsPortalUrlQuery | undefined,
  NotificationsPortalUrlQueryVariables
>;
export function useNotificationsPortalUrlSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        NotificationsPortalUrlQuery,
        NotificationsPortalUrlQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<
    NotificationsPortalUrlQuery,
    NotificationsPortalUrlQueryVariables
  >(NotificationsPortalUrlDocument, options);
}
export type NotificationsPortalUrlQueryHookResult = ReturnType<
  typeof useNotificationsPortalUrlQuery
>;
export type NotificationsPortalUrlLazyQueryHookResult = ReturnType<
  typeof useNotificationsPortalUrlLazyQuery
>;
export type NotificationsPortalUrlSuspenseQueryHookResult = ReturnType<
  typeof useNotificationsPortalUrlSuspenseQuery
>;
export type NotificationsPortalUrlQueryResult = Apollo.QueryResult<
  NotificationsPortalUrlQuery,
  NotificationsPortalUrlQueryVariables
>;
export function refetchNotificationsPortalUrlQuery(
  variables: NotificationsPortalUrlQueryVariables
) {
  return {query: NotificationsPortalUrlDocument, variables: variables};
}
export const WebhooksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Webhooks'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'token'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'pageSize'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'webhooks'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'token'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'token'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'pageSize'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'pageSize'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'eventTypes'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'nextToken'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useWebhooksQuery__
 *
 * To run a query within a React component, call `useWebhooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebhooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebhooksQuery({
 *   variables: {
 *      token: // value for 'token'
 *      pageSize: // value for 'pageSize'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useWebhooksQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<WebhooksQuery, WebhooksQueryVariables> &
    ({variables: WebhooksQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<WebhooksQuery, WebhooksQueryVariables>(
    WebhooksDocument,
    options
  );
}
export function useWebhooksLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebhooksQuery, WebhooksQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<WebhooksQuery, WebhooksQueryVariables>(
    WebhooksDocument,
    options
  );
}
// @ts-ignore
export function useWebhooksSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WebhooksQuery, WebhooksQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<WebhooksQuery, WebhooksQueryVariables>;
export function useWebhooksSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<WebhooksQuery, WebhooksQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<WebhooksQuery | undefined, WebhooksQueryVariables>;
export function useWebhooksSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<WebhooksQuery, WebhooksQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<WebhooksQuery, WebhooksQueryVariables>(
    WebhooksDocument,
    options
  );
}
export type WebhooksQueryHookResult = ReturnType<typeof useWebhooksQuery>;
export type WebhooksLazyQueryHookResult = ReturnType<typeof useWebhooksLazyQuery>;
export type WebhooksSuspenseQueryHookResult = ReturnType<typeof useWebhooksSuspenseQuery>;
export type WebhooksQueryResult = Apollo.QueryResult<WebhooksQuery, WebhooksQueryVariables>;
export function refetchWebhooksQuery(variables: WebhooksQueryVariables) {
  return {query: WebhooksDocument, variables: variables};
}
export const RestrictedKeywordsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'RestrictedKeywords'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{kind: 'Field', name: {kind: 'Name', value: 'restrictedKeywords'}}]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useRestrictedKeywordsQuery__
 *
 * To run a query within a React component, call `useRestrictedKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestrictedKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestrictedKeywordsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRestrictedKeywordsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RestrictedKeywordsQuery,
    RestrictedKeywordsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<RestrictedKeywordsQuery, RestrictedKeywordsQueryVariables>(
    RestrictedKeywordsDocument,
    options
  );
}
export function useRestrictedKeywordsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RestrictedKeywordsQuery,
    RestrictedKeywordsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<RestrictedKeywordsQuery, RestrictedKeywordsQueryVariables>(
    RestrictedKeywordsDocument,
    options
  );
}
// @ts-ignore
export function useRestrictedKeywordsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    RestrictedKeywordsQuery,
    RestrictedKeywordsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  RestrictedKeywordsQuery,
  RestrictedKeywordsQueryVariables
>;
export function useRestrictedKeywordsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        RestrictedKeywordsQuery,
        RestrictedKeywordsQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  RestrictedKeywordsQuery | undefined,
  RestrictedKeywordsQueryVariables
>;
export function useRestrictedKeywordsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        RestrictedKeywordsQuery,
        RestrictedKeywordsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<
    RestrictedKeywordsQuery,
    RestrictedKeywordsQueryVariables
  >(RestrictedKeywordsDocument, options);
}
export type RestrictedKeywordsQueryHookResult = ReturnType<typeof useRestrictedKeywordsQuery>;
export type RestrictedKeywordsLazyQueryHookResult = ReturnType<
  typeof useRestrictedKeywordsLazyQuery
>;
export type RestrictedKeywordsSuspenseQueryHookResult = ReturnType<
  typeof useRestrictedKeywordsSuspenseQuery
>;
export type RestrictedKeywordsQueryResult = Apollo.QueryResult<
  RestrictedKeywordsQuery,
  RestrictedKeywordsQueryVariables
>;
export function refetchRestrictedKeywordsQuery(variables?: RestrictedKeywordsQueryVariables) {
  return {query: RestrictedKeywordsDocument, variables: variables};
}
export const WebReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'WebReport'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'baseUrl'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'webReport'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'baseUrl'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'baseUrl'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                {kind: 'Field', name: {kind: 'Name', value: 'summary'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pageCount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'failedPageCount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uncheckedPageCount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalDetailsUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}},
                {kind: 'Field', name: {kind: 'Name', value: 'riskCategory'}},
                {kind: 'Field', name: {kind: 'Name', value: 'platform'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useWebReportQuery__
 *
 * To run a query within a React component, call `useWebReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebReportQuery({
 *   variables: {
 *      baseUrl: // value for 'baseUrl'
 *   },
 * });
 */
export function useWebReportQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<WebReportQuery, WebReportQueryVariables> &
    ({variables: WebReportQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<WebReportQuery, WebReportQueryVariables>(
    WebReportDocument,
    options
  );
}
export function useWebReportLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebReportQuery, WebReportQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<WebReportQuery, WebReportQueryVariables>(
    WebReportDocument,
    options
  );
}
// @ts-ignore
export function useWebReportSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WebReportQuery, WebReportQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<WebReportQuery, WebReportQueryVariables>;
export function useWebReportSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<WebReportQuery, WebReportQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<WebReportQuery | undefined, WebReportQueryVariables>;
export function useWebReportSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<WebReportQuery, WebReportQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<WebReportQuery, WebReportQueryVariables>(
    WebReportDocument,
    options
  );
}
export type WebReportQueryHookResult = ReturnType<typeof useWebReportQuery>;
export type WebReportLazyQueryHookResult = ReturnType<typeof useWebReportLazyQuery>;
export type WebReportSuspenseQueryHookResult = ReturnType<typeof useWebReportSuspenseQuery>;
export type WebReportQueryResult = Apollo.QueryResult<WebReportQuery, WebReportQueryVariables>;
export function refetchWebReportQuery(variables: WebReportQueryVariables) {
  return {query: WebReportDocument, variables: variables};
}
export const WebKeywordsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'WebKeywords'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'baseUrl'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'pageSize'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'token'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'webKeywords'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'baseUrl'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'baseUrl'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'pageSize'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'pageSize'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'token'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'token'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'expiresAt'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'urlKeyword'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'baseUrl'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'keyword'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'context'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'confirmed'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'explanation'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'incorrect'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'nextToken'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useWebKeywordsQuery__
 *
 * To run a query within a React component, call `useWebKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebKeywordsQuery({
 *   variables: {
 *      baseUrl: // value for 'baseUrl'
 *      pageSize: // value for 'pageSize'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useWebKeywordsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<WebKeywordsQuery, WebKeywordsQueryVariables> &
    ({variables: WebKeywordsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<WebKeywordsQuery, WebKeywordsQueryVariables>(
    WebKeywordsDocument,
    options
  );
}
export function useWebKeywordsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebKeywordsQuery, WebKeywordsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<WebKeywordsQuery, WebKeywordsQueryVariables>(
    WebKeywordsDocument,
    options
  );
}
// @ts-ignore
export function useWebKeywordsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    WebKeywordsQuery,
    WebKeywordsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<WebKeywordsQuery, WebKeywordsQueryVariables>;
export function useWebKeywordsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<WebKeywordsQuery, WebKeywordsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<WebKeywordsQuery | undefined, WebKeywordsQueryVariables>;
export function useWebKeywordsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<WebKeywordsQuery, WebKeywordsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<WebKeywordsQuery, WebKeywordsQueryVariables>(
    WebKeywordsDocument,
    options
  );
}
export type WebKeywordsQueryHookResult = ReturnType<typeof useWebKeywordsQuery>;
export type WebKeywordsLazyQueryHookResult = ReturnType<typeof useWebKeywordsLazyQuery>;
export type WebKeywordsSuspenseQueryHookResult = ReturnType<typeof useWebKeywordsSuspenseQuery>;
export type WebKeywordsQueryResult = Apollo.QueryResult<
  WebKeywordsQuery,
  WebKeywordsQueryVariables
>;
export function refetchWebKeywordsQuery(variables: WebKeywordsQueryVariables) {
  return {query: WebKeywordsDocument, variables: variables};
}
export const AccountBalancesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AccountBalances'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'accountBalances'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AccountBalancesFields'}}
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AccountBalancesFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AccountBalances'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'clearedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'outstandingAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'totalAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAccountBalancesQuery__
 *
 * To run a query within a React component, call `useAccountBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountBalancesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountBalancesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    AccountBalancesQuery,
    AccountBalancesQueryVariables
  > &
    ({variables: AccountBalancesQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AccountBalancesQuery, AccountBalancesQueryVariables>(
    AccountBalancesDocument,
    options
  );
}
export function useAccountBalancesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AccountBalancesQuery,
    AccountBalancesQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AccountBalancesQuery, AccountBalancesQueryVariables>(
    AccountBalancesDocument,
    options
  );
}
// @ts-ignore
export function useAccountBalancesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AccountBalancesQuery,
    AccountBalancesQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<AccountBalancesQuery, AccountBalancesQueryVariables>;
export function useAccountBalancesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AccountBalancesQuery, AccountBalancesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  AccountBalancesQuery | undefined,
  AccountBalancesQueryVariables
>;
export function useAccountBalancesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AccountBalancesQuery, AccountBalancesQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<AccountBalancesQuery, AccountBalancesQueryVariables>(
    AccountBalancesDocument,
    options
  );
}
export type AccountBalancesQueryHookResult = ReturnType<typeof useAccountBalancesQuery>;
export type AccountBalancesLazyQueryHookResult = ReturnType<typeof useAccountBalancesLazyQuery>;
export type AccountBalancesSuspenseQueryHookResult = ReturnType<
  typeof useAccountBalancesSuspenseQuery
>;
export type AccountBalancesQueryResult = Apollo.QueryResult<
  AccountBalancesQuery,
  AccountBalancesQueryVariables
>;
export function refetchAccountBalancesQuery(variables: AccountBalancesQueryVariables) {
  return {query: AccountBalancesDocument, variables: variables};
}
export const AffiliatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Affiliates'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'AffiliateInput'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'affiliates'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AffiliateFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'links'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PayoutMethodsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AffiliatePayoutMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'title'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'details'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nif'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AffiliateFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Affiliate'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'firstname'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastname'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'company'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'description'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'address'}},
                {kind: 'Field', name: {kind: 'Name', value: 'postal_code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'country'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'meta_data'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'tier'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'referral_link'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'link'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'affiliate_group_id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'created_at'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payout_methods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PayoutMethodsFields'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAffiliatesQuery__
 *
 * To run a query within a React component, call `useAffiliatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAffiliatesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<AffiliatesQuery, AffiliatesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AffiliatesQuery, AffiliatesQueryVariables>(
    AffiliatesDocument,
    options
  );
}
export function useAffiliatesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AffiliatesQuery, AffiliatesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AffiliatesQuery, AffiliatesQueryVariables>(
    AffiliatesDocument,
    options
  );
}
// @ts-ignore
export function useAffiliatesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AffiliatesQuery, AffiliatesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<AffiliatesQuery, AffiliatesQueryVariables>;
export function useAffiliatesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AffiliatesQuery, AffiliatesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<AffiliatesQuery | undefined, AffiliatesQueryVariables>;
export function useAffiliatesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AffiliatesQuery, AffiliatesQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<AffiliatesQuery, AffiliatesQueryVariables>(
    AffiliatesDocument,
    options
  );
}
export type AffiliatesQueryHookResult = ReturnType<typeof useAffiliatesQuery>;
export type AffiliatesLazyQueryHookResult = ReturnType<typeof useAffiliatesLazyQuery>;
export type AffiliatesSuspenseQueryHookResult = ReturnType<typeof useAffiliatesSuspenseQuery>;
export type AffiliatesQueryResult = Apollo.QueryResult<AffiliatesQuery, AffiliatesQueryVariables>;
export function refetchAffiliatesQuery(variables?: AffiliatesQueryVariables) {
  return {query: AffiliatesDocument, variables: variables};
}
export const AffiliateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Affiliate'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'affiliateId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'affiliate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'affiliateId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'affiliateId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AffiliateFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PayoutMethodsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AffiliatePayoutMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'title'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'details'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nif'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AffiliateFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Affiliate'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'firstname'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastname'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'company'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'description'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'address'}},
                {kind: 'Field', name: {kind: 'Name', value: 'postal_code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'country'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'meta_data'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'tier'}}]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'referral_link'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'link'}}]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'affiliate_group_id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'created_at'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payout_methods'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PayoutMethodsFields'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAffiliateQuery__
 *
 * To run a query within a React component, call `useAffiliateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliateQuery({
 *   variables: {
 *      affiliateId: // value for 'affiliateId'
 *   },
 * });
 */
export function useAffiliateQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<AffiliateQuery, AffiliateQueryVariables> &
    ({variables: AffiliateQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AffiliateQuery, AffiliateQueryVariables>(
    AffiliateDocument,
    options
  );
}
export function useAffiliateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AffiliateQuery, AffiliateQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AffiliateQuery, AffiliateQueryVariables>(
    AffiliateDocument,
    options
  );
}
// @ts-ignore
export function useAffiliateSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AffiliateQuery, AffiliateQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<AffiliateQuery, AffiliateQueryVariables>;
export function useAffiliateSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AffiliateQuery, AffiliateQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<AffiliateQuery | undefined, AffiliateQueryVariables>;
export function useAffiliateSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AffiliateQuery, AffiliateQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<AffiliateQuery, AffiliateQueryVariables>(
    AffiliateDocument,
    options
  );
}
export type AffiliateQueryHookResult = ReturnType<typeof useAffiliateQuery>;
export type AffiliateLazyQueryHookResult = ReturnType<typeof useAffiliateLazyQuery>;
export type AffiliateSuspenseQueryHookResult = ReturnType<typeof useAffiliateSuspenseQuery>;
export type AffiliateQueryResult = Apollo.QueryResult<AffiliateQuery, AffiliateQueryVariables>;
export function refetchAffiliateQuery(variables: AffiliateQueryVariables) {
  return {query: AffiliateDocument, variables: variables};
}
export const AffiliatePayoutMethodsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AffiliatePayoutMethods'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'affiliateId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'affiliatePayoutMethods'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'affiliateId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'affiliateId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PayoutMethodsFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PayoutMethodsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AffiliatePayoutMethod'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'title'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'details'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nif'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAffiliatePayoutMethodsQuery__
 *
 * To run a query within a React component, call `useAffiliatePayoutMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliatePayoutMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliatePayoutMethodsQuery({
 *   variables: {
 *      affiliateId: // value for 'affiliateId'
 *   },
 * });
 */
export function useAffiliatePayoutMethodsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    AffiliatePayoutMethodsQuery,
    AffiliatePayoutMethodsQueryVariables
  > &
    ({variables: AffiliatePayoutMethodsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<
    AffiliatePayoutMethodsQuery,
    AffiliatePayoutMethodsQueryVariables
  >(AffiliatePayoutMethodsDocument, options);
}
export function useAffiliatePayoutMethodsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AffiliatePayoutMethodsQuery,
    AffiliatePayoutMethodsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<
    AffiliatePayoutMethodsQuery,
    AffiliatePayoutMethodsQueryVariables
  >(AffiliatePayoutMethodsDocument, options);
}
// @ts-ignore
export function useAffiliatePayoutMethodsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AffiliatePayoutMethodsQuery,
    AffiliatePayoutMethodsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  AffiliatePayoutMethodsQuery,
  AffiliatePayoutMethodsQueryVariables
>;
export function useAffiliatePayoutMethodsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AffiliatePayoutMethodsQuery,
        AffiliatePayoutMethodsQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  AffiliatePayoutMethodsQuery | undefined,
  AffiliatePayoutMethodsQueryVariables
>;
export function useAffiliatePayoutMethodsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AffiliatePayoutMethodsQuery,
        AffiliatePayoutMethodsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<
    AffiliatePayoutMethodsQuery,
    AffiliatePayoutMethodsQueryVariables
  >(AffiliatePayoutMethodsDocument, options);
}
export type AffiliatePayoutMethodsQueryHookResult = ReturnType<
  typeof useAffiliatePayoutMethodsQuery
>;
export type AffiliatePayoutMethodsLazyQueryHookResult = ReturnType<
  typeof useAffiliatePayoutMethodsLazyQuery
>;
export type AffiliatePayoutMethodsSuspenseQueryHookResult = ReturnType<
  typeof useAffiliatePayoutMethodsSuspenseQuery
>;
export type AffiliatePayoutMethodsQueryResult = Apollo.QueryResult<
  AffiliatePayoutMethodsQuery,
  AffiliatePayoutMethodsQueryVariables
>;
export function refetchAffiliatePayoutMethodsQuery(
  variables: AffiliatePayoutMethodsQueryVariables
) {
  return {query: AffiliatePayoutMethodsDocument, variables: variables};
}
export const AffiliateMerchantsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AffiliateMerchants'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'AffiliateMerchantInput'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'affiliateMerchants'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'AffiliateMerchantFields'}
                      }
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'links'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AffiliateMerchantFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AffiliateMerchant'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'created_at'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'meta_data'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'account_id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'account_status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'company_name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'first_conversion_date'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAffiliateMerchantsQuery__
 *
 * To run a query within a React component, call `useAffiliateMerchantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliateMerchantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliateMerchantsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAffiliateMerchantsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AffiliateMerchantsQuery,
    AffiliateMerchantsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AffiliateMerchantsQuery, AffiliateMerchantsQueryVariables>(
    AffiliateMerchantsDocument,
    options
  );
}
export function useAffiliateMerchantsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AffiliateMerchantsQuery,
    AffiliateMerchantsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AffiliateMerchantsQuery, AffiliateMerchantsQueryVariables>(
    AffiliateMerchantsDocument,
    options
  );
}
// @ts-ignore
export function useAffiliateMerchantsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AffiliateMerchantsQuery,
    AffiliateMerchantsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  AffiliateMerchantsQuery,
  AffiliateMerchantsQueryVariables
>;
export function useAffiliateMerchantsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AffiliateMerchantsQuery,
        AffiliateMerchantsQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  AffiliateMerchantsQuery | undefined,
  AffiliateMerchantsQueryVariables
>;
export function useAffiliateMerchantsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AffiliateMerchantsQuery,
        AffiliateMerchantsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<
    AffiliateMerchantsQuery,
    AffiliateMerchantsQueryVariables
  >(AffiliateMerchantsDocument, options);
}
export type AffiliateMerchantsQueryHookResult = ReturnType<typeof useAffiliateMerchantsQuery>;
export type AffiliateMerchantsLazyQueryHookResult = ReturnType<
  typeof useAffiliateMerchantsLazyQuery
>;
export type AffiliateMerchantsSuspenseQueryHookResult = ReturnType<
  typeof useAffiliateMerchantsSuspenseQuery
>;
export type AffiliateMerchantsQueryResult = Apollo.QueryResult<
  AffiliateMerchantsQuery,
  AffiliateMerchantsQueryVariables
>;
export function refetchAffiliateMerchantsQuery(variables?: AffiliateMerchantsQueryVariables) {
  return {query: AffiliateMerchantsDocument, variables: variables};
}
export const AffiliateInvoicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AffiliateInvoices'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'taxId'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'affiliateInvoices'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'taxId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'taxId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'AffiliateInvoiceFields'}
                      }
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'total'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AffiliateInvoiceFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AffiliateInvoice'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'number'}},
          {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'issuedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'dueAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAffiliateInvoicesQuery__
 *
 * To run a query within a React component, call `useAffiliateInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliateInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliateInvoicesQuery({
 *   variables: {
 *      taxId: // value for 'taxId'
 *   },
 * });
 */
export function useAffiliateInvoicesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    AffiliateInvoicesQuery,
    AffiliateInvoicesQueryVariables
  > &
    ({variables: AffiliateInvoicesQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AffiliateInvoicesQuery, AffiliateInvoicesQueryVariables>(
    AffiliateInvoicesDocument,
    options
  );
}
export function useAffiliateInvoicesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AffiliateInvoicesQuery,
    AffiliateInvoicesQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AffiliateInvoicesQuery, AffiliateInvoicesQueryVariables>(
    AffiliateInvoicesDocument,
    options
  );
}
// @ts-ignore
export function useAffiliateInvoicesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AffiliateInvoicesQuery,
    AffiliateInvoicesQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<AffiliateInvoicesQuery, AffiliateInvoicesQueryVariables>;
export function useAffiliateInvoicesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AffiliateInvoicesQuery,
        AffiliateInvoicesQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  AffiliateInvoicesQuery | undefined,
  AffiliateInvoicesQueryVariables
>;
export function useAffiliateInvoicesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AffiliateInvoicesQuery,
        AffiliateInvoicesQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<AffiliateInvoicesQuery, AffiliateInvoicesQueryVariables>(
    AffiliateInvoicesDocument,
    options
  );
}
export type AffiliateInvoicesQueryHookResult = ReturnType<typeof useAffiliateInvoicesQuery>;
export type AffiliateInvoicesLazyQueryHookResult = ReturnType<typeof useAffiliateInvoicesLazyQuery>;
export type AffiliateInvoicesSuspenseQueryHookResult = ReturnType<
  typeof useAffiliateInvoicesSuspenseQuery
>;
export type AffiliateInvoicesQueryResult = Apollo.QueryResult<
  AffiliateInvoicesQuery,
  AffiliateInvoicesQueryVariables
>;
export function refetchAffiliateInvoicesQuery(variables: AffiliateInvoicesQueryVariables) {
  return {query: AffiliateInvoicesDocument, variables: variables};
}
export const MasterAccountEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'MasterAccountEvents'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'masterAccountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'size'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'from'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'masterAccountEvents'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'masterAccountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'masterAccountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'size'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'size'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'from'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'from'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'livemode'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'objectId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'objectType'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'object'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'MasterAccountEventObjectFields'}
                            }
                          ]
                        }
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'total'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MasterAccountEventObjectFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MasterAccountEventObject'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountCallbackUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'apiKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'adminEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'test'}},
          {kind: 'Field', name: {kind: 'Name', value: 'testAccountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'prodAccountId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'business'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'mcc'}},
                {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                {kind: 'Field', name: {kind: 'Name', value: 'documentNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'servicesDescription'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'contractTemplateId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'contract'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'envelopeId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                {kind: 'Field', name: {kind: 'Name', value: 'signedDate'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'churnedEmails'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedDomains'}},
          {kind: 'Field', name: {kind: 'Name', value: 'allowedIPs'}},
          {kind: 'Field', name: {kind: 'Name', value: 'blocked'}},
          {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'payoutTerms'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'iban'}},
                {kind: 'Field', name: {kind: 'Name', value: 'period'}},
                {kind: 'Field', name: {kind: 'Name', value: 'firstPeriod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reservePercent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'suspended'}},
                {kind: 'Field', name: {kind: 'Name', value: 'releaseReserve'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'promoCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'traceDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'webhookEmails'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useMasterAccountEventsQuery__
 *
 * To run a query within a React component, call `useMasterAccountEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterAccountEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterAccountEventsQuery({
 *   variables: {
 *      masterAccountId: // value for 'masterAccountId'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useMasterAccountEventsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    MasterAccountEventsQuery,
    MasterAccountEventsQueryVariables
  > &
    ({variables: MasterAccountEventsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<MasterAccountEventsQuery, MasterAccountEventsQueryVariables>(
    MasterAccountEventsDocument,
    options
  );
}
export function useMasterAccountEventsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MasterAccountEventsQuery,
    MasterAccountEventsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<MasterAccountEventsQuery, MasterAccountEventsQueryVariables>(
    MasterAccountEventsDocument,
    options
  );
}
// @ts-ignore
export function useMasterAccountEventsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    MasterAccountEventsQuery,
    MasterAccountEventsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  MasterAccountEventsQuery,
  MasterAccountEventsQueryVariables
>;
export function useMasterAccountEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        MasterAccountEventsQuery,
        MasterAccountEventsQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  MasterAccountEventsQuery | undefined,
  MasterAccountEventsQueryVariables
>;
export function useMasterAccountEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        MasterAccountEventsQuery,
        MasterAccountEventsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<
    MasterAccountEventsQuery,
    MasterAccountEventsQueryVariables
  >(MasterAccountEventsDocument, options);
}
export type MasterAccountEventsQueryHookResult = ReturnType<typeof useMasterAccountEventsQuery>;
export type MasterAccountEventsLazyQueryHookResult = ReturnType<
  typeof useMasterAccountEventsLazyQuery
>;
export type MasterAccountEventsSuspenseQueryHookResult = ReturnType<
  typeof useMasterAccountEventsSuspenseQuery
>;
export type MasterAccountEventsQueryResult = Apollo.QueryResult<
  MasterAccountEventsQuery,
  MasterAccountEventsQueryVariables
>;
export function refetchMasterAccountEventsQuery(variables: MasterAccountEventsQueryVariables) {
  return {query: MasterAccountEventsDocument, variables: variables};
}
export const PointsOfSaleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'PointsOfSale'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'storeId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'pageSize'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'token'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pointsOfSale'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'storeId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'storeId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'pageSize'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'pageSize'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'token'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'token'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PointOfSaleFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'nextToken'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PointOfSaleFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PointOfSale'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'number'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPaymentId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'manualAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'terminalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireTaxId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'includeQRCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'qrCodeText'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fixedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fixedCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'transactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pendingSetup'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentCallbackUrl'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __usePointsOfSaleQuery__
 *
 * To run a query within a React component, call `usePointsOfSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointsOfSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointsOfSaleQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      storeId: // value for 'storeId'
 *      pageSize: // value for 'pageSize'
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePointsOfSaleQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<PointsOfSaleQuery, PointsOfSaleQueryVariables> &
    ({variables: PointsOfSaleQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<PointsOfSaleQuery, PointsOfSaleQueryVariables>(
    PointsOfSaleDocument,
    options
  );
}
export function usePointsOfSaleLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PointsOfSaleQuery, PointsOfSaleQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<PointsOfSaleQuery, PointsOfSaleQueryVariables>(
    PointsOfSaleDocument,
    options
  );
}
// @ts-ignore
export function usePointsOfSaleSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    PointsOfSaleQuery,
    PointsOfSaleQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<PointsOfSaleQuery, PointsOfSaleQueryVariables>;
export function usePointsOfSaleSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<PointsOfSaleQuery, PointsOfSaleQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  PointsOfSaleQuery | undefined,
  PointsOfSaleQueryVariables
>;
export function usePointsOfSaleSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<PointsOfSaleQuery, PointsOfSaleQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<PointsOfSaleQuery, PointsOfSaleQueryVariables>(
    PointsOfSaleDocument,
    options
  );
}
export type PointsOfSaleQueryHookResult = ReturnType<typeof usePointsOfSaleQuery>;
export type PointsOfSaleLazyQueryHookResult = ReturnType<typeof usePointsOfSaleLazyQuery>;
export type PointsOfSaleSuspenseQueryHookResult = ReturnType<typeof usePointsOfSaleSuspenseQuery>;
export type PointsOfSaleQueryResult = Apollo.QueryResult<
  PointsOfSaleQuery,
  PointsOfSaleQueryVariables
>;
export function refetchPointsOfSaleQuery(variables: PointsOfSaleQueryVariables) {
  return {query: PointsOfSaleDocument, variables: variables};
}
export const PointOfSaleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'PointOfSale'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pointOfSale'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PointOfSaleFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PointOfSaleFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PointOfSale'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'storeId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'number'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentPaymentId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'manualAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'terminalId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requireTaxId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'includeQRCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'qrCodeText'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fixedAmount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fixedCurrency'}},
          {kind: 'Field', name: {kind: 'Name', value: 'transactionType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethods'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pendingSetup'}},
          {kind: 'Field', name: {kind: 'Name', value: 'paymentCallbackUrl'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __usePointOfSaleQuery__
 *
 * To run a query within a React component, call `usePointOfSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfSaleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function usePointOfSaleQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<PointOfSaleQuery, PointOfSaleQueryVariables> &
    ({variables: PointOfSaleQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<PointOfSaleQuery, PointOfSaleQueryVariables>(
    PointOfSaleDocument,
    options
  );
}
export function usePointOfSaleLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PointOfSaleQuery, PointOfSaleQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<PointOfSaleQuery, PointOfSaleQueryVariables>(
    PointOfSaleDocument,
    options
  );
}
// @ts-ignore
export function usePointOfSaleSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    PointOfSaleQuery,
    PointOfSaleQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<PointOfSaleQuery, PointOfSaleQueryVariables>;
export function usePointOfSaleSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<PointOfSaleQuery, PointOfSaleQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<PointOfSaleQuery | undefined, PointOfSaleQueryVariables>;
export function usePointOfSaleSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<PointOfSaleQuery, PointOfSaleQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<PointOfSaleQuery, PointOfSaleQueryVariables>(
    PointOfSaleDocument,
    options
  );
}
export type PointOfSaleQueryHookResult = ReturnType<typeof usePointOfSaleQuery>;
export type PointOfSaleLazyQueryHookResult = ReturnType<typeof usePointOfSaleLazyQuery>;
export type PointOfSaleSuspenseQueryHookResult = ReturnType<typeof usePointOfSaleSuspenseQuery>;
export type PointOfSaleQueryResult = Apollo.QueryResult<
  PointOfSaleQuery,
  PointOfSaleQueryVariables
>;
export function refetchPointOfSaleQuery(variables: PointOfSaleQueryVariables) {
  return {query: PointOfSaleDocument, variables: variables};
}
export const BlacklistItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'BlacklistItems'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'pageSize'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'token'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'type'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'BlacklistItemType'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'blacklistItems'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'pageSize'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'pageSize'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'token'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'token'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'type'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'type'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'BlacklistItemFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'nextToken'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'BlacklistItemFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'BlacklistItem'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'value'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useBlacklistItemsQuery__
 *
 * To run a query within a React component, call `useBlacklistItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlacklistItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlacklistItemsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      pageSize: // value for 'pageSize'
 *      token: // value for 'token'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useBlacklistItemsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    BlacklistItemsQuery,
    BlacklistItemsQueryVariables
  > &
    ({variables: BlacklistItemsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<BlacklistItemsQuery, BlacklistItemsQueryVariables>(
    BlacklistItemsDocument,
    options
  );
}
export function useBlacklistItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BlacklistItemsQuery,
    BlacklistItemsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<BlacklistItemsQuery, BlacklistItemsQueryVariables>(
    BlacklistItemsDocument,
    options
  );
}
// @ts-ignore
export function useBlacklistItemsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    BlacklistItemsQuery,
    BlacklistItemsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<BlacklistItemsQuery, BlacklistItemsQueryVariables>;
export function useBlacklistItemsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<BlacklistItemsQuery, BlacklistItemsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  BlacklistItemsQuery | undefined,
  BlacklistItemsQueryVariables
>;
export function useBlacklistItemsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<BlacklistItemsQuery, BlacklistItemsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<BlacklistItemsQuery, BlacklistItemsQueryVariables>(
    BlacklistItemsDocument,
    options
  );
}
export type BlacklistItemsQueryHookResult = ReturnType<typeof useBlacklistItemsQuery>;
export type BlacklistItemsLazyQueryHookResult = ReturnType<typeof useBlacklistItemsLazyQuery>;
export type BlacklistItemsSuspenseQueryHookResult = ReturnType<
  typeof useBlacklistItemsSuspenseQuery
>;
export type BlacklistItemsQueryResult = Apollo.QueryResult<
  BlacklistItemsQuery,
  BlacklistItemsQueryVariables
>;
export function refetchBlacklistItemsQuery(variables: BlacklistItemsQueryVariables) {
  return {query: BlacklistItemsDocument, variables: variables};
}
export const BlacklistItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'BlacklistItem'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'value'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'blacklistItem'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'value'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'value'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'BlacklistItemFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'BlacklistItemFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'BlacklistItem'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'value'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'note'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'validUntil'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useBlacklistItemQuery__
 *
 * To run a query within a React component, call `useBlacklistItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlacklistItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlacklistItemQuery({
 *   variables: {
 *      value: // value for 'value'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useBlacklistItemQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<BlacklistItemQuery, BlacklistItemQueryVariables> &
    ({variables: BlacklistItemQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<BlacklistItemQuery, BlacklistItemQueryVariables>(
    BlacklistItemDocument,
    options
  );
}
export function useBlacklistItemLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BlacklistItemQuery,
    BlacklistItemQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<BlacklistItemQuery, BlacklistItemQueryVariables>(
    BlacklistItemDocument,
    options
  );
}
// @ts-ignore
export function useBlacklistItemSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    BlacklistItemQuery,
    BlacklistItemQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<BlacklistItemQuery, BlacklistItemQueryVariables>;
export function useBlacklistItemSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<BlacklistItemQuery, BlacklistItemQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  BlacklistItemQuery | undefined,
  BlacklistItemQueryVariables
>;
export function useBlacklistItemSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<BlacklistItemQuery, BlacklistItemQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<BlacklistItemQuery, BlacklistItemQueryVariables>(
    BlacklistItemDocument,
    options
  );
}
export type BlacklistItemQueryHookResult = ReturnType<typeof useBlacklistItemQuery>;
export type BlacklistItemLazyQueryHookResult = ReturnType<typeof useBlacklistItemLazyQuery>;
export type BlacklistItemSuspenseQueryHookResult = ReturnType<typeof useBlacklistItemSuspenseQuery>;
export type BlacklistItemQueryResult = Apollo.QueryResult<
  BlacklistItemQuery,
  BlacklistItemQueryVariables
>;
export function refetchBlacklistItemQuery(variables: BlacklistItemQueryVariables) {
  return {query: BlacklistItemDocument, variables: variables};
}
export const AdminUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AdminUser'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'adminUser'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'AdminUserFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AdminUserFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AdminUser'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAdminUserQuery__
 *
 * To run a query within a React component, call `useAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminUserQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<AdminUserQuery, AdminUserQueryVariables> &
    ({variables: AdminUserQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AdminUserQuery, AdminUserQueryVariables>(
    AdminUserDocument,
    options
  );
}
export function useAdminUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminUserQuery, AdminUserQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AdminUserQuery, AdminUserQueryVariables>(
    AdminUserDocument,
    options
  );
}
// @ts-ignore
export function useAdminUserSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminUserQuery, AdminUserQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<AdminUserQuery, AdminUserQueryVariables>;
export function useAdminUserSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AdminUserQuery, AdminUserQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<AdminUserQuery | undefined, AdminUserQueryVariables>;
export function useAdminUserSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AdminUserQuery, AdminUserQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<AdminUserQuery, AdminUserQueryVariables>(
    AdminUserDocument,
    options
  );
}
export type AdminUserQueryHookResult = ReturnType<typeof useAdminUserQuery>;
export type AdminUserLazyQueryHookResult = ReturnType<typeof useAdminUserLazyQuery>;
export type AdminUserSuspenseQueryHookResult = ReturnType<typeof useAdminUserSuspenseQuery>;
export type AdminUserQueryResult = Apollo.QueryResult<AdminUserQuery, AdminUserQueryVariables>;
export function refetchAdminUserQuery(variables: AdminUserQueryVariables) {
  return {query: AdminUserDocument, variables: variables};
}
export const AdminUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AdminUsers'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'token'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'adminUsers'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'token'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'token'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AdminUserFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'nextToken'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AdminUserFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AdminUser'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'phoneNumber'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAdminUsersQuery__
 *
 * To run a query within a React component, call `useAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUsersQuery({
 *   variables: {
 *      token: // value for 'token'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdminUsersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AdminUsersQuery, AdminUsersQueryVariables>(
    AdminUsersDocument,
    options
  );
}
export function useAdminUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AdminUsersQuery, AdminUsersQueryVariables>(
    AdminUsersDocument,
    options
  );
}
// @ts-ignore
export function useAdminUsersSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<AdminUsersQuery, AdminUsersQueryVariables>;
export function useAdminUsersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<AdminUsersQuery | undefined, AdminUsersQueryVariables>;
export function useAdminUsersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<AdminUsersQuery, AdminUsersQueryVariables>(
    AdminUsersDocument,
    options
  );
}
export type AdminUsersQueryHookResult = ReturnType<typeof useAdminUsersQuery>;
export type AdminUsersLazyQueryHookResult = ReturnType<typeof useAdminUsersLazyQuery>;
export type AdminUsersSuspenseQueryHookResult = ReturnType<typeof useAdminUsersSuspenseQuery>;
export type AdminUsersQueryResult = Apollo.QueryResult<AdminUsersQuery, AdminUsersQueryVariables>;
export function refetchAdminUsersQuery(variables?: AdminUsersQueryVariables) {
  return {query: AdminUsersDocument, variables: variables};
}
export const AdminUserEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AdminUserEvents'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'AdminUserEventsInput'}}
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'adminUserEvents'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'AdminUserEventFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'nextToken'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SessionDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SessionDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fingerprint'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserColorDepth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenHeight'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserScreenWidth'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserTimezoneOffset'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AdminUserEventFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'AdminUserEvent'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'objectType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'objectId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'metadata'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}}
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sessionDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SessionDetailsFields'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useAdminUserEventsQuery__
 *
 * To run a query within a React component, call `useAdminUserEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUserEventsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    AdminUserEventsQuery,
    AdminUserEventsQueryVariables
  > &
    ({variables: AdminUserEventsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<AdminUserEventsQuery, AdminUserEventsQueryVariables>(
    AdminUserEventsDocument,
    options
  );
}
export function useAdminUserEventsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AdminUserEventsQuery,
    AdminUserEventsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<AdminUserEventsQuery, AdminUserEventsQueryVariables>(
    AdminUserEventsDocument,
    options
  );
}
// @ts-ignore
export function useAdminUserEventsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AdminUserEventsQuery,
    AdminUserEventsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<AdminUserEventsQuery, AdminUserEventsQueryVariables>;
export function useAdminUserEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AdminUserEventsQuery, AdminUserEventsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  AdminUserEventsQuery | undefined,
  AdminUserEventsQueryVariables
>;
export function useAdminUserEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<AdminUserEventsQuery, AdminUserEventsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<AdminUserEventsQuery, AdminUserEventsQueryVariables>(
    AdminUserEventsDocument,
    options
  );
}
export type AdminUserEventsQueryHookResult = ReturnType<typeof useAdminUserEventsQuery>;
export type AdminUserEventsLazyQueryHookResult = ReturnType<typeof useAdminUserEventsLazyQuery>;
export type AdminUserEventsSuspenseQueryHookResult = ReturnType<
  typeof useAdminUserEventsSuspenseQuery
>;
export type AdminUserEventsQueryResult = Apollo.QueryResult<
  AdminUserEventsQuery,
  AdminUserEventsQueryVariables
>;
export function refetchAdminUserEventsQuery(variables: AdminUserEventsQueryVariables) {
  return {query: AdminUserEventsDocument, variables: variables};
}
export const ChargesExportsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ChargesExports'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'token'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'pageSize'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'chargesExports'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'token'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'token'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'pageSize'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'pageSize'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'ChargesExportFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'nextToken'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ChargesExportFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ChargesExport'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'expireAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'statusMessage'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useChargesExportsQuery__
 *
 * To run a query within a React component, call `useChargesExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargesExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargesExportsQuery({
 *   variables: {
 *      token: // value for 'token'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useChargesExportsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<ChargesExportsQuery, ChargesExportsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<ChargesExportsQuery, ChargesExportsQueryVariables>(
    ChargesExportsDocument,
    options
  );
}
export function useChargesExportsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ChargesExportsQuery,
    ChargesExportsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<ChargesExportsQuery, ChargesExportsQueryVariables>(
    ChargesExportsDocument,
    options
  );
}
// @ts-ignore
export function useChargesExportsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    ChargesExportsQuery,
    ChargesExportsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<ChargesExportsQuery, ChargesExportsQueryVariables>;
export function useChargesExportsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ChargesExportsQuery, ChargesExportsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  ChargesExportsQuery | undefined,
  ChargesExportsQueryVariables
>;
export function useChargesExportsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ChargesExportsQuery, ChargesExportsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<ChargesExportsQuery, ChargesExportsQueryVariables>(
    ChargesExportsDocument,
    options
  );
}
export type ChargesExportsQueryHookResult = ReturnType<typeof useChargesExportsQuery>;
export type ChargesExportsLazyQueryHookResult = ReturnType<typeof useChargesExportsLazyQuery>;
export type ChargesExportsSuspenseQueryHookResult = ReturnType<
  typeof useChargesExportsSuspenseQuery
>;
export type ChargesExportsQueryResult = Apollo.QueryResult<
  ChargesExportsQuery,
  ChargesExportsQueryVariables
>;
export function refetchChargesExportsQuery(variables?: ChargesExportsQueryVariables) {
  return {query: ChargesExportsDocument, variables: variables};
}
export const ExportSftpConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ExportSftpConfig'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'exportSftpConfig'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SftpConfigExportFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SftpConfigExportFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SftpConfigExport'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'host'}},
          {kind: 'Field', name: {kind: 'Name', value: 'port'}},
          {kind: 'Field', name: {kind: 'Name', value: 'username'}},
          {kind: 'Field', name: {kind: 'Name', value: 'path'}},
          {kind: 'Field', name: {kind: 'Name', value: 'columns'}},
          {kind: 'Field', name: {kind: 'Name', value: 'timezone'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useExportSftpConfigQuery__
 *
 * To run a query within a React component, call `useExportSftpConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSftpConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSftpConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useExportSftpConfigQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ExportSftpConfigQuery,
    ExportSftpConfigQueryVariables
  > &
    ({variables: ExportSftpConfigQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<ExportSftpConfigQuery, ExportSftpConfigQueryVariables>(
    ExportSftpConfigDocument,
    options
  );
}
export function useExportSftpConfigLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ExportSftpConfigQuery,
    ExportSftpConfigQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<ExportSftpConfigQuery, ExportSftpConfigQueryVariables>(
    ExportSftpConfigDocument,
    options
  );
}
// @ts-ignore
export function useExportSftpConfigSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    ExportSftpConfigQuery,
    ExportSftpConfigQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<ExportSftpConfigQuery, ExportSftpConfigQueryVariables>;
export function useExportSftpConfigSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        ExportSftpConfigQuery,
        ExportSftpConfigQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  ExportSftpConfigQuery | undefined,
  ExportSftpConfigQueryVariables
>;
export function useExportSftpConfigSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        ExportSftpConfigQuery,
        ExportSftpConfigQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<ExportSftpConfigQuery, ExportSftpConfigQueryVariables>(
    ExportSftpConfigDocument,
    options
  );
}
export type ExportSftpConfigQueryHookResult = ReturnType<typeof useExportSftpConfigQuery>;
export type ExportSftpConfigLazyQueryHookResult = ReturnType<typeof useExportSftpConfigLazyQuery>;
export type ExportSftpConfigSuspenseQueryHookResult = ReturnType<
  typeof useExportSftpConfigSuspenseQuery
>;
export type ExportSftpConfigQueryResult = Apollo.QueryResult<
  ExportSftpConfigQuery,
  ExportSftpConfigQueryVariables
>;
export function refetchExportSftpConfigQuery(variables: ExportSftpConfigQueryVariables) {
  return {query: ExportSftpConfigDocument, variables: variables};
}
export const ExportSftpConfigsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ExportSftpConfigs'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'exportSftpConfigs'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'SftpConfigExportFields'}
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SftpConfigExportFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SftpConfigExport'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'accountId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'host'}},
          {kind: 'Field', name: {kind: 'Name', value: 'port'}},
          {kind: 'Field', name: {kind: 'Name', value: 'username'}},
          {kind: 'Field', name: {kind: 'Name', value: 'path'}},
          {kind: 'Field', name: {kind: 'Name', value: 'columns'}},
          {kind: 'Field', name: {kind: 'Name', value: 'timezone'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useExportSftpConfigsQuery__
 *
 * To run a query within a React component, call `useExportSftpConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSftpConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSftpConfigsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useExportSftpConfigsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ExportSftpConfigsQuery,
    ExportSftpConfigsQueryVariables
  > &
    ({variables: ExportSftpConfigsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<ExportSftpConfigsQuery, ExportSftpConfigsQueryVariables>(
    ExportSftpConfigsDocument,
    options
  );
}
export function useExportSftpConfigsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ExportSftpConfigsQuery,
    ExportSftpConfigsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<ExportSftpConfigsQuery, ExportSftpConfigsQueryVariables>(
    ExportSftpConfigsDocument,
    options
  );
}
// @ts-ignore
export function useExportSftpConfigsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    ExportSftpConfigsQuery,
    ExportSftpConfigsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<ExportSftpConfigsQuery, ExportSftpConfigsQueryVariables>;
export function useExportSftpConfigsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        ExportSftpConfigsQuery,
        ExportSftpConfigsQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  ExportSftpConfigsQuery | undefined,
  ExportSftpConfigsQueryVariables
>;
export function useExportSftpConfigsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        ExportSftpConfigsQuery,
        ExportSftpConfigsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<ExportSftpConfigsQuery, ExportSftpConfigsQueryVariables>(
    ExportSftpConfigsDocument,
    options
  );
}
export type ExportSftpConfigsQueryHookResult = ReturnType<typeof useExportSftpConfigsQuery>;
export type ExportSftpConfigsLazyQueryHookResult = ReturnType<typeof useExportSftpConfigsLazyQuery>;
export type ExportSftpConfigsSuspenseQueryHookResult = ReturnType<
  typeof useExportSftpConfigsSuspenseQuery
>;
export type ExportSftpConfigsQueryResult = Apollo.QueryResult<
  ExportSftpConfigsQuery,
  ExportSftpConfigsQueryVariables
>;
export function refetchExportSftpConfigsQuery(variables: ExportSftpConfigsQueryVariables) {
  return {query: ExportSftpConfigsDocument, variables: variables};
}
export const CodesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Codes'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'pointOfSaleId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'codes'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'pointOfSaleId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'pointOfSaleId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'FragmentSpread', name: {kind: 'Name', value: 'CodeFields'}}]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CodeFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Code'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
          {kind: 'Field', name: {kind: 'Name', value: 'pointOfSaleId'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCodesQuery__
 *
 * To run a query within a React component, call `useCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCodesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      pointOfSaleId: // value for 'pointOfSaleId'
 *   },
 * });
 */
export function useCodesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<CodesQuery, CodesQueryVariables> &
    ({variables: CodesQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<CodesQuery, CodesQueryVariables>(CodesDocument, options);
}
export function useCodesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CodesQuery, CodesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<CodesQuery, CodesQueryVariables>(CodesDocument, options);
}
// @ts-ignore
export function useCodesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CodesQuery, CodesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<CodesQuery, CodesQueryVariables>;
export function useCodesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<CodesQuery, CodesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<CodesQuery | undefined, CodesQueryVariables>;
export function useCodesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<CodesQuery, CodesQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<CodesQuery, CodesQueryVariables>(CodesDocument, options);
}
export type CodesQueryHookResult = ReturnType<typeof useCodesQuery>;
export type CodesLazyQueryHookResult = ReturnType<typeof useCodesLazyQuery>;
export type CodesSuspenseQueryHookResult = ReturnType<typeof useCodesSuspenseQuery>;
export type CodesQueryResult = Apollo.QueryResult<CodesQuery, CodesQueryVariables>;
export function refetchCodesQuery(variables: CodesQueryVariables) {
  return {query: CodesDocument, variables: variables};
}
export const PibisiUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'PibisiUsers'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pibisiUsers'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiAccountFields'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiFlagFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PibisiFlag'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'content'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'action'}},
                {kind: 'Field', name: {kind: 'Name', value: 'charge'}},
                {kind: 'Field', name: {kind: 'Name', value: 'country'}},
                {kind: 'Field', name: {kind: 'Name', value: 'from'}},
                {kind: 'Field', name: {kind: 'Name', value: 'issue'}},
                {kind: 'Field', name: {kind: 'Name', value: 'issuer'}},
                {kind: 'Field', name: {kind: 'Name', value: 'organization'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reason'}},
                {kind: 'Field', name: {kind: 'Name', value: 'scope'}},
                {kind: 'Field', name: {kind: 'Name', value: 'to'}},
                {kind: 'Field', name: {kind: 'Name', value: 'types'}},
                {kind: 'Field', name: {kind: 'Name', value: 'url'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiAccountFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PibisiAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deletedAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deleted'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'customerId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'legalName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'alertsId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'alertsStatus'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'matches'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adverseInfo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFlagFields'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'highRisk'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFlagFields'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'media'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFlagFields'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'pep'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFlagFields'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'sanctioned'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFlagFields'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'terrorist'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFlagFields'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'matches'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiFlagFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'alerts'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'note'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __usePibisiUsersQuery__
 *
 * To run a query within a React component, call `usePibisiUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePibisiUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePibisiUsersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function usePibisiUsersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<PibisiUsersQuery, PibisiUsersQueryVariables> &
    ({variables: PibisiUsersQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<PibisiUsersQuery, PibisiUsersQueryVariables>(
    PibisiUsersDocument,
    options
  );
}
export function usePibisiUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PibisiUsersQuery, PibisiUsersQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<PibisiUsersQuery, PibisiUsersQueryVariables>(
    PibisiUsersDocument,
    options
  );
}
// @ts-ignore
export function usePibisiUsersSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    PibisiUsersQuery,
    PibisiUsersQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<PibisiUsersQuery, PibisiUsersQueryVariables>;
export function usePibisiUsersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<PibisiUsersQuery, PibisiUsersQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<PibisiUsersQuery | undefined, PibisiUsersQueryVariables>;
export function usePibisiUsersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<PibisiUsersQuery, PibisiUsersQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<PibisiUsersQuery, PibisiUsersQueryVariables>(
    PibisiUsersDocument,
    options
  );
}
export type PibisiUsersQueryHookResult = ReturnType<typeof usePibisiUsersQuery>;
export type PibisiUsersLazyQueryHookResult = ReturnType<typeof usePibisiUsersLazyQuery>;
export type PibisiUsersSuspenseQueryHookResult = ReturnType<typeof usePibisiUsersSuspenseQuery>;
export type PibisiUsersQueryResult = Apollo.QueryResult<
  PibisiUsersQuery,
  PibisiUsersQueryVariables
>;
export function refetchPibisiUsersQuery(variables: PibisiUsersQueryVariables) {
  return {query: PibisiUsersDocument, variables: variables};
}
export const PibisiEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'PibisiEvents'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'pibisiId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pibisiEvents'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'pibisiId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'pibisiId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PibisiEventFields'}}
                    ]
                  }
                },
                {kind: 'Field', name: {kind: 'Name', value: 'total'}}
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TraceDetailsFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'TraceDetails'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'ip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userAgent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'countryCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lang'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deviceModel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browser'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'browserAccept'}},
          {kind: 'Field', name: {kind: 'Name', value: 'os'}},
          {kind: 'Field', name: {kind: 'Name', value: 'osVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'source'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sourceVersion'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userEmail'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userName'}}
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PibisiEventFields'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PibisiEvent'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'type'}},
          {kind: 'Field', name: {kind: 'Name', value: 'objectId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'objectType'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'object'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'entityId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'customerId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'traceDetails'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TraceDetailsFields'}}
                    ]
                  }
                }
              ]
            }
          },
          {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}}
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __usePibisiEventsQuery__
 *
 * To run a query within a React component, call `usePibisiEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePibisiEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePibisiEventsQuery({
 *   variables: {
 *      pibisiId: // value for 'pibisiId'
 *   },
 * });
 */
export function usePibisiEventsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<PibisiEventsQuery, PibisiEventsQueryVariables> &
    ({variables: PibisiEventsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<PibisiEventsQuery, PibisiEventsQueryVariables>(
    PibisiEventsDocument,
    options
  );
}
export function usePibisiEventsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PibisiEventsQuery, PibisiEventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<PibisiEventsQuery, PibisiEventsQueryVariables>(
    PibisiEventsDocument,
    options
  );
}
// @ts-ignore
export function usePibisiEventsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    PibisiEventsQuery,
    PibisiEventsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<PibisiEventsQuery, PibisiEventsQueryVariables>;
export function usePibisiEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<PibisiEventsQuery, PibisiEventsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  PibisiEventsQuery | undefined,
  PibisiEventsQueryVariables
>;
export function usePibisiEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<PibisiEventsQuery, PibisiEventsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<PibisiEventsQuery, PibisiEventsQueryVariables>(
    PibisiEventsDocument,
    options
  );
}
export type PibisiEventsQueryHookResult = ReturnType<typeof usePibisiEventsQuery>;
export type PibisiEventsLazyQueryHookResult = ReturnType<typeof usePibisiEventsLazyQuery>;
export type PibisiEventsSuspenseQueryHookResult = ReturnType<typeof usePibisiEventsSuspenseQuery>;
export type PibisiEventsQueryResult = Apollo.QueryResult<
  PibisiEventsQuery,
  PibisiEventsQueryVariables
>;
export function refetchPibisiEventsQuery(variables: PibisiEventsQueryVariables) {
  return {query: PibisiEventsDocument, variables: variables};
}
export const ShortLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ShortLink'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'url'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shortLink'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'url'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'url'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                {kind: 'Field', name: {kind: 'Name', value: 'openCount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useShortLinkQuery__
 *
 * To run a query within a React component, call `useShortLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortLinkQuery({
 *   variables: {
 *      url: // value for 'url'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useShortLinkQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<ShortLinkQuery, ShortLinkQueryVariables> &
    ({variables: ShortLinkQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<ShortLinkQuery, ShortLinkQueryVariables>(
    ShortLinkDocument,
    options
  );
}
export function useShortLinkLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShortLinkQuery, ShortLinkQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<ShortLinkQuery, ShortLinkQueryVariables>(
    ShortLinkDocument,
    options
  );
}
// @ts-ignore
export function useShortLinkSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ShortLinkQuery, ShortLinkQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<ShortLinkQuery, ShortLinkQueryVariables>;
export function useShortLinkSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ShortLinkQuery, ShortLinkQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<ShortLinkQuery | undefined, ShortLinkQueryVariables>;
export function useShortLinkSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ShortLinkQuery, ShortLinkQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<ShortLinkQuery, ShortLinkQueryVariables>(
    ShortLinkDocument,
    options
  );
}
export type ShortLinkQueryHookResult = ReturnType<typeof useShortLinkQuery>;
export type ShortLinkLazyQueryHookResult = ReturnType<typeof useShortLinkLazyQuery>;
export type ShortLinkSuspenseQueryHookResult = ReturnType<typeof useShortLinkSuspenseQuery>;
export type ShortLinkQueryResult = Apollo.QueryResult<ShortLinkQuery, ShortLinkQueryVariables>;
export function refetchShortLinkQuery(variables: ShortLinkQueryVariables) {
  return {query: ShortLinkDocument, variables: variables};
}
export const CapitalDataByAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CapitalDataByAccount'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'capitalDataByAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'offer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'loanAmount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fundedAmount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currencyISOCode'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fee'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'lead'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'onboardingStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'signUpUrl'}}
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCapitalDataByAccountQuery__
 *
 * To run a query within a React component, call `useCapitalDataByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapitalDataByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapitalDataByAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCapitalDataByAccountQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    CapitalDataByAccountQuery,
    CapitalDataByAccountQueryVariables
  > &
    ({variables: CapitalDataByAccountQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<CapitalDataByAccountQuery, CapitalDataByAccountQueryVariables>(
    CapitalDataByAccountDocument,
    options
  );
}
export function useCapitalDataByAccountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CapitalDataByAccountQuery,
    CapitalDataByAccountQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<
    CapitalDataByAccountQuery,
    CapitalDataByAccountQueryVariables
  >(CapitalDataByAccountDocument, options);
}
// @ts-ignore
export function useCapitalDataByAccountSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    CapitalDataByAccountQuery,
    CapitalDataByAccountQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  CapitalDataByAccountQuery,
  CapitalDataByAccountQueryVariables
>;
export function useCapitalDataByAccountSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        CapitalDataByAccountQuery,
        CapitalDataByAccountQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  CapitalDataByAccountQuery | undefined,
  CapitalDataByAccountQueryVariables
>;
export function useCapitalDataByAccountSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        CapitalDataByAccountQuery,
        CapitalDataByAccountQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<
    CapitalDataByAccountQuery,
    CapitalDataByAccountQueryVariables
  >(CapitalDataByAccountDocument, options);
}
export type CapitalDataByAccountQueryHookResult = ReturnType<typeof useCapitalDataByAccountQuery>;
export type CapitalDataByAccountLazyQueryHookResult = ReturnType<
  typeof useCapitalDataByAccountLazyQuery
>;
export type CapitalDataByAccountSuspenseQueryHookResult = ReturnType<
  typeof useCapitalDataByAccountSuspenseQuery
>;
export type CapitalDataByAccountQueryResult = Apollo.QueryResult<
  CapitalDataByAccountQuery,
  CapitalDataByAccountQueryVariables
>;
export function refetchCapitalDataByAccountQuery(variables: CapitalDataByAccountQueryVariables) {
  return {query: CapitalDataByAccountDocument, variables: variables};
}
export const GetCapitalOnboardingDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'GetCapitalOnboardingDetails'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'capitalOnboardingDetails'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'leadId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'onboardingStateReason'}},
                {kind: 'Field', name: {kind: 'Name', value: 'organisationDetailsStepComplete'}},
                {kind: 'Field', name: {kind: 'Name', value: 'paymentDataStepComplete'}},
                {kind: 'Field', name: {kind: 'Name', value: 'offerStepComplete'}},
                {kind: 'Field', name: {kind: 'Name', value: 'kycDocumentsStepComplete'}},
                {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stateUpdated'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useGetCapitalOnboardingDetailsQuery__
 *
 * To run a query within a React component, call `useGetCapitalOnboardingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapitalOnboardingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapitalOnboardingDetailsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetCapitalOnboardingDetailsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetCapitalOnboardingDetailsQuery,
    GetCapitalOnboardingDetailsQueryVariables
  > &
    ({variables: GetCapitalOnboardingDetailsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<
    GetCapitalOnboardingDetailsQuery,
    GetCapitalOnboardingDetailsQueryVariables
  >(GetCapitalOnboardingDetailsDocument, options);
}
export function useGetCapitalOnboardingDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetCapitalOnboardingDetailsQuery,
    GetCapitalOnboardingDetailsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<
    GetCapitalOnboardingDetailsQuery,
    GetCapitalOnboardingDetailsQueryVariables
  >(GetCapitalOnboardingDetailsDocument, options);
}
// @ts-ignore
export function useGetCapitalOnboardingDetailsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    GetCapitalOnboardingDetailsQuery,
    GetCapitalOnboardingDetailsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  GetCapitalOnboardingDetailsQuery,
  GetCapitalOnboardingDetailsQueryVariables
>;
export function useGetCapitalOnboardingDetailsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetCapitalOnboardingDetailsQuery,
        GetCapitalOnboardingDetailsQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  GetCapitalOnboardingDetailsQuery | undefined,
  GetCapitalOnboardingDetailsQueryVariables
>;
export function useGetCapitalOnboardingDetailsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetCapitalOnboardingDetailsQuery,
        GetCapitalOnboardingDetailsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<
    GetCapitalOnboardingDetailsQuery,
    GetCapitalOnboardingDetailsQueryVariables
  >(GetCapitalOnboardingDetailsDocument, options);
}
export type GetCapitalOnboardingDetailsQueryHookResult = ReturnType<
  typeof useGetCapitalOnboardingDetailsQuery
>;
export type GetCapitalOnboardingDetailsLazyQueryHookResult = ReturnType<
  typeof useGetCapitalOnboardingDetailsLazyQuery
>;
export type GetCapitalOnboardingDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetCapitalOnboardingDetailsSuspenseQuery
>;
export type GetCapitalOnboardingDetailsQueryResult = Apollo.QueryResult<
  GetCapitalOnboardingDetailsQuery,
  GetCapitalOnboardingDetailsQueryVariables
>;
export function refetchGetCapitalOnboardingDetailsQuery(
  variables: GetCapitalOnboardingDetailsQueryVariables
) {
  return {query: GetCapitalOnboardingDetailsDocument, variables: variables};
}
export const CapitalLoansDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CapitalLoans'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'capitalLoans'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'loanNumber'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fundedAmount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currentAmount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'originalAmount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currencyISOCode'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'sweep'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fundingDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'maturityDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'loanType'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'aheadBehindValue'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'aheadBehindPercentage'}}
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCapitalLoansQuery__
 *
 * To run a query within a React component, call `useCapitalLoansQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapitalLoansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapitalLoansQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCapitalLoansQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<CapitalLoansQuery, CapitalLoansQueryVariables> &
    ({variables: CapitalLoansQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<CapitalLoansQuery, CapitalLoansQueryVariables>(
    CapitalLoansDocument,
    options
  );
}
export function useCapitalLoansLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CapitalLoansQuery, CapitalLoansQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<CapitalLoansQuery, CapitalLoansQueryVariables>(
    CapitalLoansDocument,
    options
  );
}
// @ts-ignore
export function useCapitalLoansSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    CapitalLoansQuery,
    CapitalLoansQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<CapitalLoansQuery, CapitalLoansQueryVariables>;
export function useCapitalLoansSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<CapitalLoansQuery, CapitalLoansQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<
  CapitalLoansQuery | undefined,
  CapitalLoansQueryVariables
>;
export function useCapitalLoansSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<CapitalLoansQuery, CapitalLoansQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<CapitalLoansQuery, CapitalLoansQueryVariables>(
    CapitalLoansDocument,
    options
  );
}
export type CapitalLoansQueryHookResult = ReturnType<typeof useCapitalLoansQuery>;
export type CapitalLoansLazyQueryHookResult = ReturnType<typeof useCapitalLoansLazyQuery>;
export type CapitalLoansSuspenseQueryHookResult = ReturnType<typeof useCapitalLoansSuspenseQuery>;
export type CapitalLoansQueryResult = Apollo.QueryResult<
  CapitalLoansQuery,
  CapitalLoansQueryVariables
>;
export function refetchCapitalLoansQuery(variables: CapitalLoansQueryVariables) {
  return {query: CapitalLoansDocument, variables: variables};
}
export const CapitalLoanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CapitalLoan'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'loanId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'capitalLoan'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'loanId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'loanId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'loanNumber'}},
                {kind: 'Field', name: {kind: 'Name', value: 'borrowerName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'loanType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'originalAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currentAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currencyISOCode'}},
                {kind: 'Field', name: {kind: 'Name', value: 'sweep'}},
                {kind: 'Field', name: {kind: 'Name', value: 'discount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expectedRepayment'}},
                {kind: 'Field', name: {kind: 'Name', value: 'approvalDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'maturityDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'projectedRepaymentDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'repaymentMethod'}},
                {kind: 'Field', name: {kind: 'Name', value: 'repaymentFrequency'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fundingDetails'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fundingAmount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fundingDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amountFunded'}}
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'documents'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'document'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'documentId'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'documentName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'documentType'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'dateUploaded'}}
                          ]
                        }
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'documentType'}}
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCapitalLoanQuery__
 *
 * To run a query within a React component, call `useCapitalLoanQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapitalLoanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapitalLoanQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useCapitalLoanQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<CapitalLoanQuery, CapitalLoanQueryVariables> &
    ({variables: CapitalLoanQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<CapitalLoanQuery, CapitalLoanQueryVariables>(
    CapitalLoanDocument,
    options
  );
}
export function useCapitalLoanLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CapitalLoanQuery, CapitalLoanQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<CapitalLoanQuery, CapitalLoanQueryVariables>(
    CapitalLoanDocument,
    options
  );
}
// @ts-ignore
export function useCapitalLoanSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    CapitalLoanQuery,
    CapitalLoanQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<CapitalLoanQuery, CapitalLoanQueryVariables>;
export function useCapitalLoanSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<CapitalLoanQuery, CapitalLoanQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<CapitalLoanQuery | undefined, CapitalLoanQueryVariables>;
export function useCapitalLoanSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<CapitalLoanQuery, CapitalLoanQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<CapitalLoanQuery, CapitalLoanQueryVariables>(
    CapitalLoanDocument,
    options
  );
}
export type CapitalLoanQueryHookResult = ReturnType<typeof useCapitalLoanQuery>;
export type CapitalLoanLazyQueryHookResult = ReturnType<typeof useCapitalLoanLazyQuery>;
export type CapitalLoanSuspenseQueryHookResult = ReturnType<typeof useCapitalLoanSuspenseQuery>;
export type CapitalLoanQueryResult = Apollo.QueryResult<
  CapitalLoanQuery,
  CapitalLoanQueryVariables
>;
export function refetchCapitalLoanQuery(variables: CapitalLoanQueryVariables) {
  return {query: CapitalLoanDocument, variables: variables};
}
export const CapitalLoanRepaymentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CapitalLoanRepayments'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'loanId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'capitalLoanRepayments'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'loanId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'loanId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'paymentDate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'repaymentAmount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'loanBalance'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'totalCardTransactions'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'sweep'}}
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useCapitalLoanRepaymentsQuery__
 *
 * To run a query within a React component, call `useCapitalLoanRepaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapitalLoanRepaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapitalLoanRepaymentsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useCapitalLoanRepaymentsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    CapitalLoanRepaymentsQuery,
    CapitalLoanRepaymentsQueryVariables
  > &
    ({variables: CapitalLoanRepaymentsQueryVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<CapitalLoanRepaymentsQuery, CapitalLoanRepaymentsQueryVariables>(
    CapitalLoanRepaymentsDocument,
    options
  );
}
export function useCapitalLoanRepaymentsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CapitalLoanRepaymentsQuery,
    CapitalLoanRepaymentsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<
    CapitalLoanRepaymentsQuery,
    CapitalLoanRepaymentsQueryVariables
  >(CapitalLoanRepaymentsDocument, options);
}
// @ts-ignore
export function useCapitalLoanRepaymentsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    CapitalLoanRepaymentsQuery,
    CapitalLoanRepaymentsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  CapitalLoanRepaymentsQuery,
  CapitalLoanRepaymentsQueryVariables
>;
export function useCapitalLoanRepaymentsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        CapitalLoanRepaymentsQuery,
        CapitalLoanRepaymentsQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  CapitalLoanRepaymentsQuery | undefined,
  CapitalLoanRepaymentsQueryVariables
>;
export function useCapitalLoanRepaymentsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        CapitalLoanRepaymentsQuery,
        CapitalLoanRepaymentsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<
    CapitalLoanRepaymentsQuery,
    CapitalLoanRepaymentsQueryVariables
  >(CapitalLoanRepaymentsDocument, options);
}
export type CapitalLoanRepaymentsQueryHookResult = ReturnType<typeof useCapitalLoanRepaymentsQuery>;
export type CapitalLoanRepaymentsLazyQueryHookResult = ReturnType<
  typeof useCapitalLoanRepaymentsLazyQuery
>;
export type CapitalLoanRepaymentsSuspenseQueryHookResult = ReturnType<
  typeof useCapitalLoanRepaymentsSuspenseQuery
>;
export type CapitalLoanRepaymentsQueryResult = Apollo.QueryResult<
  CapitalLoanRepaymentsQuery,
  CapitalLoanRepaymentsQueryVariables
>;
export function refetchCapitalLoanRepaymentsQuery(variables: CapitalLoanRepaymentsQueryVariables) {
  return {query: CapitalLoanRepaymentsDocument, variables: variables};
}
export const DownloadCapitalLoanDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DownloadCapitalLoanDocument'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'loanId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'documentId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'downloadCapitalLoanDocument'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'loanId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'loanId'}}
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'documentId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'documentId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'downloadUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiresAt'}}
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useDownloadCapitalLoanDocumentMutation__
 *
 * To run a mutation, you first call `useDownloadCapitalLoanDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadCapitalLoanDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadCapitalLoanDocumentMutation, { data, loading, error }] = useDownloadCapitalLoanDocumentMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      loanId: // value for 'loanId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDownloadCapitalLoanDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadCapitalLoanDocumentMutation,
    DownloadCapitalLoanDocumentMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    DownloadCapitalLoanDocumentMutation,
    DownloadCapitalLoanDocumentMutationVariables
  >(DownloadCapitalLoanDocumentDocument, options);
}
export type DownloadCapitalLoanDocumentMutationHookResult = ReturnType<
  typeof useDownloadCapitalLoanDocumentMutation
>;
export type DownloadCapitalLoanDocumentMutationResult =
  Apollo.MutationResult<DownloadCapitalLoanDocumentMutation>;
export type DownloadCapitalLoanDocumentMutationOptions = Apollo.BaseMutationOptions<
  DownloadCapitalLoanDocumentMutation,
  DownloadCapitalLoanDocumentMutationVariables
>;
export const OnUpdateAnalyticsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: {kind: 'Name', value: 'OnUpdateAnalytics'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'onUpdateAnalytics'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'all'},
                value: {kind: 'BooleanValue', value: true}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'all'}}]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useOnUpdateAnalyticsSubscription__
 *
 * To run a query within a React component, call `useOnUpdateAnalyticsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateAnalyticsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateAnalyticsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnUpdateAnalyticsSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    OnUpdateAnalyticsSubscription,
    OnUpdateAnalyticsSubscriptionVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSubscription<
    OnUpdateAnalyticsSubscription,
    OnUpdateAnalyticsSubscriptionVariables
  >(OnUpdateAnalyticsDocument, options);
}
export type OnUpdateAnalyticsSubscriptionHookResult = ReturnType<
  typeof useOnUpdateAnalyticsSubscription
>;
export type OnUpdateAnalyticsSubscriptionResult =
  Apollo.SubscriptionResult<OnUpdateAnalyticsSubscription>;
export const OnUpdateEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: {kind: 'Name', value: 'OnUpdateEvents'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'onUpdateEvents'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'accountId'}}]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useOnUpdateEventsSubscription__
 *
 * To run a query within a React component, call `useOnUpdateEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateEventsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateEventsSubscription({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useOnUpdateEventsSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    OnUpdateEventsSubscription,
    OnUpdateEventsSubscriptionVariables
  > &
    ({variables: OnUpdateEventsSubscriptionVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSubscription<
    OnUpdateEventsSubscription,
    OnUpdateEventsSubscriptionVariables
  >(OnUpdateEventsDocument, options);
}
export type OnUpdateEventsSubscriptionHookResult = ReturnType<typeof useOnUpdateEventsSubscription>;
export type OnUpdateEventsSubscriptionResult =
  Apollo.SubscriptionResult<OnUpdateEventsSubscription>;
export const OnUpdateDocumentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: {kind: 'Name', value: 'OnUpdateDocuments'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'onUpdateDocuments'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'accountId'}}]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useOnUpdateDocumentsSubscription__
 *
 * To run a query within a React component, call `useOnUpdateDocumentsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateDocumentsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateDocumentsSubscription({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useOnUpdateDocumentsSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    OnUpdateDocumentsSubscription,
    OnUpdateDocumentsSubscriptionVariables
  > &
    ({variables: OnUpdateDocumentsSubscriptionVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSubscription<
    OnUpdateDocumentsSubscription,
    OnUpdateDocumentsSubscriptionVariables
  >(OnUpdateDocumentsDocument, options);
}
export type OnUpdateDocumentsSubscriptionHookResult = ReturnType<
  typeof useOnUpdateDocumentsSubscription
>;
export type OnUpdateDocumentsSubscriptionResult =
  Apollo.SubscriptionResult<OnUpdateDocumentsSubscription>;
export const OnUpdateAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: {kind: 'Name', value: 'OnUpdateAccount'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}}
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'onUpdateAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountId'}}
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'accountId'}}]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode;

/**
 * __useOnUpdateAccountSubscription__
 *
 * To run a query within a React component, call `useOnUpdateAccountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateAccountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateAccountSubscription({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useOnUpdateAccountSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    OnUpdateAccountSubscription,
    OnUpdateAccountSubscriptionVariables
  > &
    ({variables: OnUpdateAccountSubscriptionVariables; skip?: boolean} | {skip: boolean})
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSubscription<
    OnUpdateAccountSubscription,
    OnUpdateAccountSubscriptionVariables
  >(OnUpdateAccountDocument, options);
}
export type OnUpdateAccountSubscriptionHookResult = ReturnType<
  typeof useOnUpdateAccountSubscription
>;
export type OnUpdateAccountSubscriptionResult =
  Apollo.SubscriptionResult<OnUpdateAccountSubscription>;
